export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded date */
  Date: { input: any; output: any };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /**
   * The `JSON` scalar type represents (nonscalar) JSON data. The `JSON` type can be
   * any valid JSON object, including arrays, null and empty strings
   */
  JSON: { input: any; output: any };
  /** A ProseMirror document node stored as JSON */
  JSONContent: { input: import('@tiptap/core').JSONContent; output: import('@tiptap/core').JSONContent };
}

/** An object that might be accessible to the current user */
export interface Accessible {
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
}

export enum ActionTypeEnum {
  /** The `User` needs to take an action on this item */
  ACTING = 'ACTING',
  /** The `User` has yet to submit a final version of the item */
  DRAFT = 'DRAFT',
  /** The `User` is waiting for action to be taken on this item */
  OBSERVING = 'OBSERVING',
}

/** Autogenerated input type of ActivateExternalOauthConnection */
export interface ActivateExternalOauthConnectionInput {
  /** The authorization code which is needed to authorize the connection. */
  authorizationCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalOauthApplicationId: Scalars['ID']['input'];
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of ActivateExternalOauthConnection. */
export interface ActivateExternalOauthConnectionPayload {
  __typename: 'ActivateExternalOauthConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** An object that can be attached to `GoalActivities` */
export interface Activities {
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
}

/** Autogenerated input type of AddCccFormConfigSelection */
export interface AddCccFormConfigSelectionInput {
  cccFormConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
  /** Position of the selection; defaults to the last place when omitted */
  order?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of AddCccFormConfigSelection. */
export interface AddCccFormConfigSelectionPayload {
  __typename: 'AddCccFormConfigSelectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of AddCourseEditionsToUser */
export interface AddCourseEditionsToUserInput {
  /** Category of the `CourseEditions` that will be added to the `User` */
  category?: InputMaybe<UsersCourseEditionCategoryTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `CourseEdition`s to add to the `User` */
  courseEditionIds: Array<Scalars['ID']['input']>;
  /** ID of the `User` to add the `CourseEdition`s to */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of AddCourseEditionsToUser. */
export interface AddCourseEditionsToUserPayload {
  __typename: 'AddCourseEditionsToUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of AddCoursesToUser */
export interface AddCoursesToUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Course`s to add to the `User` */
  courseIds: Array<Scalars['ID']['input']>;
  /** ID of the `User` to add the `Course`s to */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of AddCoursesToUser. */
export interface AddCoursesToUserPayload {
  __typename: 'AddCoursesToUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of AddLearningResourceItemToSet */
export interface AddLearningResourceItemToSetInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  learningResourceItemId: Scalars['ID']['input'];
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of AddLearningResourceItemToSet. */
export interface AddLearningResourceItemToSetPayload {
  __typename: 'AddLearningResourceItemToSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated input type of AddMandatorySkillToPortfolios */
export interface AddMandatorySkillToPortfoliosInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Skill` to add to `Portfolio`s */
  skillId: Scalars['ID']['input'];
}

/** Autogenerated return type of AddMandatorySkillToPortfolios. */
export interface AddMandatorySkillToPortfoliosPayload {
  __typename: 'AddMandatorySkillToPortfoliosPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The added `Skill` */
  skill: Maybe<Skill>;
}

/** Autogenerated input type of AddRespondentToClinicalCompetenceCommittee */
export interface AddRespondentToClinicalCompetenceCommitteeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of AddRespondentToClinicalCompetenceCommittee. */
export interface AddRespondentToClinicalCompetenceCommitteePayload {
  __typename: 'AddRespondentToClinicalCompetenceCommitteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of AddSkillsToPortfolio */
export interface AddSkillsToPortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` to add skills to. */
  portfolioId: Scalars['ID']['input'];
  skillIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of AddSkillsToPortfolio. */
export interface AddSkillsToPortfolioPayload {
  __typename: 'AddSkillsToPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of AddSubSkillsToSkill */
export interface AddSubSkillsToSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['ID']['input'];
  subSkillIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of AddSubSkillsToSkill. */
export interface AddSubSkillsToSkillPayload {
  __typename: 'AddSubSkillsToSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of AddUserToSupportGroup */
export interface AddUserToSupportGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SupportGroup` */
  supportGroupId: Scalars['ID']['input'];
  /** ID of the `User` */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of AddUserToSupportGroup. */
export interface AddUserToSupportGroupPayload {
  __typename: 'AddUserToSupportGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  supportGroup: Maybe<SupportGroup>;
}

/** Autogenerated input type of AddWorkspaceToSecondaryDashboard */
export interface AddWorkspaceToSecondaryDashboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dashboardId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of AddWorkspaceToSecondaryDashboard. */
export interface AddWorkspaceToSecondaryDashboardPayload {
  __typename: 'AddWorkspaceToSecondaryDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboard: Maybe<Dashboard>;
  errors: Array<Error>;
}

/** Autogenerated input type of AdminDisableSecondFactor */
export interface AdminDisableSecondFactorInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SecondFactor` that needs to be disabled. */
  secondFactorId: Scalars['ID']['input'];
}

/** Autogenerated return type of AdminDisableSecondFactor. */
export interface AdminDisableSecondFactorPayload {
  __typename: 'AdminDisableSecondFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  secondFactor: Maybe<SecondFactor>;
}

export interface AdminGroup extends Node, Timestamped {
  __typename: 'AdminGroup';
  /** Whether `AdminGroup` is can manage medicines. */
  canManageMedicines: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email of this `AdminGroup`. */
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The info of this `AdminGroup`. */
  info: Maybe<Scalars['String']['output']>;
  /** The name of this `AdminGroup`. */
  name: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export enum ApplicationEnum {
  PORTFOLIO = 'PORTFOLIO',
  WORKSPACE_DASHBOARD = 'WORKSPACE_DASHBOARD',
}

/** Autogenerated input type of ArchivePortfolio */
export interface ArchivePortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** In addition to archiving the `Portfolio`, mark it as COMPLETED */
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId: Scalars['ID']['input'];
  /** Pin of the logged-in `User` */
  userPin: Scalars['String']['input'];
}

/** Autogenerated return type of ArchivePortfolio. */
export interface ArchivePortfolioPayload {
  __typename: 'ArchivePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Portfolio` that was archived */
  portfolio: Maybe<Portfolio>;
}

/** Filter for different assessment types */
export interface AssessmentFilter {
  /** Only show objects with content for this Canmed */
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show objects that occur before this date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only show objects supervisor approved on or before this date, works only for KPB, Interview and CompetenceCertificate */
  endDateOnSupervisorApprovedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Only return object of this (custom) form type */
  formTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show object related to Goal */
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only return interviews for yearly progress */
  isYearlyInterview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return `CompetenceCertificate`s that have a higher level than the previous */
  onlyMutations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show objects where the reduction changed */
  reductionWasChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show objects related to these `Skills` */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects with the same level as the number on given SkillLevelFormats works only for CompetenceCertificate */
  skillLevelFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects that occur after this date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only show objects supervisor approved on or after this date, works only for KPB, Interview and CompetenceCertificate */
  startDateOnSupervisorApprovedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Only show objects related to these sub`Skills` via `KPBSubSkillScore`  (therefore it only works for `KPB`) */
  subSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface AssessmentsStatistics {
  __typename: 'AssessmentsStatistics';
  /** Form type of assessments */
  formType: Maybe<Scalars['String']['output']>;
  /** Number of approved assessments of this form type */
  numberOfAssessments: Maybe<Scalars['Int']['output']>;
  /** GraphQL type for this assessment */
  typeName: Maybe<Scalars['String']['output']>;
}

export interface AttachedFile extends Node {
  __typename: 'AttachedFile';
  /** MD5 checksum of the file */
  checksum: Maybe<Scalars['String']['output']>;
  /** Content type of the file */
  contentType: Maybe<Scalars['String']['output']>;
  /** Time the attachment was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Original filename at the time of uploading */
  fileName: Maybe<Scalars['String']['output']>;
  /** Size of the attachment in bytes */
  fileSize: Maybe<Scalars['Int']['output']>;
  /** Formatted version of the size for easy understanding */
  humanFileSize: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Time the attachment was last changed */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL to view or download this attachment */
  url: Maybe<Scalars['String']['output']>;
}

export interface AudioTranscript extends Node, Timestamped {
  __typename: 'AudioTranscript';
  /** The audio_file of this `Ai::AudioTranscript`. */
  audioFile: Maybe<AttachedFile>;
  /** The audio_transcript_status of this `Ai::AudioTranscript`. */
  audioTranscriptStatus: AudioTranscriptStatusEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The error_message of this `Ai::AudioTranscript`. */
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The `PortfolioDocumentConfig` that this `Ai::AudioTranscript` belongs to */
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
  /** The suggestions of this `Ai::AudioTranscript`. */
  suggestions: Maybe<Scalars['JSON']['output']>;
  /** The transcript of this `Ai::AudioTranscript`. */
  transcript: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `Ai::AudioTranscript` belongs to */
  user: User;
}

export enum AudioTranscriptStatusEnum {
  /** The status of the `AudioTranscript` is created */
  CREATED = 'CREATED',
  /** The status of the `AudioTranscript` is invalid */
  INVALID = 'INVALID',
  /** The status of the `AudioTranscript` is valid */
  VALID = 'VALID',
}

export interface Badge extends Node, Timestamped {
  __typename: 'Badge';
  /** The amount_completed of this `Badge`. */
  amountCompleted: Scalars['Int']['output'];
  /** The amount_needed of this `Badge`. */
  amountNeeded: Scalars['Int']['output'];
  /** The completed at date of this `Badge`. */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The created at date of this `Badge`. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The key of this `Badge`. */
  key: BadgeKeyEnum;
  /** The localized_title of this `Badge`. */
  localizedTitle: Scalars['String']['output'];
  /** The updated at date of this `Badge`. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user of this `Badge`. */
  user: User;
}

/** Autogenerated return type of BadgeChanged. */
export interface BadgeChangedPayload {
  __typename: 'BadgeChangedPayload';
  updatedBadge: Maybe<Badge>;
}

/** The connection type for Badge. */
export interface BadgeConnection {
  __typename: 'BadgeConnection';
  /** A list of edges. */
  edges: Array<BadgeEdge>;
  /** A list of nodes. */
  nodes: Array<Badge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface BadgeEdge {
  __typename: 'BadgeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Badge>;
}

export enum BadgeKeyEnum {
  /** The key of the `Badge` is assessments_multiple_supervisors */
  ASSESSMENTS_MULTIPLE_SUPERVISORS = 'ASSESSMENTS_MULTIPLE_SUPERVISORS',
  /** The key of the `Badge` is assessments_received_1 */
  ASSESSMENTS_RECEIVED_1 = 'ASSESSMENTS_RECEIVED_1',
  /** The key of the `Badge` is assessments_received_5 */
  ASSESSMENTS_RECEIVED_5 = 'ASSESSMENTS_RECEIVED_5',
  /** The key of the `Badge` is assessments_received_10 */
  ASSESSMENTS_RECEIVED_10 = 'ASSESSMENTS_RECEIVED_10',
  /** The key of the `Badge` is assessments_received_25 */
  ASSESSMENTS_RECEIVED_25 = 'ASSESSMENTS_RECEIVED_25',
  /** The key of the `Badge` is assessments_received_50 */
  ASSESSMENTS_RECEIVED_50 = 'ASSESSMENTS_RECEIVED_50',
  /** The key of the `Badge` is assessments_supervised_1 */
  ASSESSMENTS_SUPERVISED_1 = 'ASSESSMENTS_SUPERVISED_1',
  /** The key of the `Badge` is assessments_supervised_5 */
  ASSESSMENTS_SUPERVISED_5 = 'ASSESSMENTS_SUPERVISED_5',
  /** The key of the `Badge` is assessments_supervised_10 */
  ASSESSMENTS_SUPERVISED_10 = 'ASSESSMENTS_SUPERVISED_10',
  /** The key of the `Badge` is assessments_supervised_25 */
  ASSESSMENTS_SUPERVISED_25 = 'ASSESSMENTS_SUPERVISED_25',
  /** The key of the `Badge` is assessments_supervised_50 */
  ASSESSMENTS_SUPERVISED_50 = 'ASSESSMENTS_SUPERVISED_50',
  /** The key of the `Badge` is first_competence_certificate */
  FIRST_COMPETENCE_CERTIFICATE = 'FIRST_COMPETENCE_CERTIFICATE',
  /** The key of the `Badge` is first_note_created */
  FIRST_NOTE_CREATED = 'FIRST_NOTE_CREATED',
  /** The key of the `Badge` is profile_picture_set */
  PROFILE_PICTURE_SET = 'PROFILE_PICTURE_SET',
}

/** Properties of a `BaseCard` */
export interface BaseCard {
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Use `description_json_content` instead. */
  description: Maybe<Scalars['String']['output']>;
  descriptionJsonContent: Maybe<Scalars['JSONContent']['output']>;
  endDate: Maybe<Scalars['Date']['output']>;
  startDate: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
}

/** Properties of a `BaseDomain` */
export interface BaseDomain {
  description: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
}

/** Autogenerated input type of CalculateOnboardingSteps */
export interface CalculateOnboardingStepsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of CalculateOnboardingSteps. */
export interface CalculateOnboardingStepsPayload {
  __typename: 'CalculateOnboardingStepsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of CancelPortfolioRemovalRequest */
export interface CancelPortfolioRemovalRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerPin: Scalars['String']['input'];
  /** ID of the `Portfolio` to removal */
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of CancelPortfolioRemovalRequest. */
export interface CancelPortfolioRemovalRequestPayload {
  __typename: 'CancelPortfolioRemovalRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

export interface CanmedScore {
  __typename: 'CanmedScore';
  /** Number of assessments for this Canmed that were rated as exeeding expectations */
  aboveLevel: Maybe<Scalars['Int']['output']>;
  /** Number of assessments for this Canmed that were rated as meeting expectations */
  atLevel: Maybe<Scalars['Int']['output']>;
  /** Number of assessments for this Canmed that were rated below expectations */
  belowLevel: Maybe<Scalars['Int']['output']>;
  /** Canmed this score is for */
  canmed: Maybe<Scalars['String']['output']>;
  /** Number of assessments that contributed to the score for this Canmed (including imported assessments) */
  count: Maybe<Scalars['Int']['output']>;
  /** Total number of assessments for this Canmed (within this portfolio) */
  filled: Maybe<Scalars['Int']['output']>;
  /** Average score for this Canmed */
  score: Maybe<Scalars['Float']['output']>;
}

export interface Canmeds {
  __typename: 'Canmeds';
  /** Assessment responses for the Collaborator Canmed. */
  collaborator: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Collaborator Canmed. */
  collaboratorScore: Maybe<Scalars['Float']['output']>;
  /** Assessment responses for the Communicator Canmed. */
  communicator: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Communicator Canmed. */
  communicatorScore: Maybe<Scalars['Float']['output']>;
  /** Canmeds that contain meaningful information */
  filledCanmeds: Maybe<Array<Scalars['String']['output']>>;
  /** Assessment responses for the Health Advocate Canmed. */
  healthAdvocate: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Health Advocate Canmed. */
  healthAdvocateScore: Maybe<Scalars['Float']['output']>;
  /** Assessment responses for the Leader Canmed. */
  leader: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Leader Canmed. */
  leaderScore: Maybe<Scalars['Float']['output']>;
  /** Assessment responses for the Medical Expert Canmed. */
  medicalExpert: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Medical Expert Canmed. */
  medicalExpertScore: Maybe<Scalars['Float']['output']>;
  /** Assessment responses for the Professional Canmed. */
  professional: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Professional Canmed. */
  professionalScore: Maybe<Scalars['Float']['output']>;
  /** Assessment responses for the Scholar Canmed. */
  scholar: Maybe<Scalars['JSON']['output']>;
  /** Averaged score for the Scholar Canmed. */
  scholarScore: Maybe<Scalars['Float']['output']>;
}

/** Assessment responses for different Canmeds */
export interface CanmedsInput {
  /** Assessment responses for the Collaborator Canmed. */
  collaborator?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Communicator Canmed. */
  communicator?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Health Advocate Canmed. */
  healthAdvocate?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Leader Canmed. */
  leader?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Medical Expert Canmed. */
  medicalExpert?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Professional Canmed. */
  professional?: InputMaybe<Scalars['JSON']['input']>;
  /** Assessment responses for the Scholar Canmed. */
  scholar?: InputMaybe<Scalars['JSON']['input']>;
}

export type Card = EventCard | GoalCard;

export interface CardComment extends Node, Timestamped {
  __typename: 'CardComment';
  /** Timestamp that this `CardComment` was marked archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The attached_files of this `WorkspaceDashboard::CardComment`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** `card` that is linked to this `CardComment` */
  card: EventCard | GoalCard;
  /** The card_comment_status of this `WorkspaceDashboard::CardComment`. */
  cardCommentStatus: Maybe<CardCommentStatusEnum>;
  /**
   * The comment of this `WorkspaceDashboard::CardComment`.
   * @deprecated Use `comment_json_content` instead.
   */
  comment: Maybe<Scalars['String']['output']>;
  /** The comment_json_content of this `WorkspaceDashboard::CardComment`. */
  commentJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that is linked to this `CardComment` as it's creator */
  creator: User;
  id: Scalars['ID']['output'];
  /**
   * The status of this `WorkspaceDashboard::CardComment`.
   * @deprecated Use `card_comment_status` instead, remove this field after 2025-09-01
   */
  status: Maybe<CardCommentStatusEnum>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CardComment. */
export interface CardCommentConnection {
  __typename: 'CardCommentConnection';
  /** A list of edges. */
  edges: Array<CardCommentEdge>;
  /** A list of nodes. */
  nodes: Array<CardComment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardCommentEdge {
  __typename: 'CardCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CardComment>;
}

export enum CardCommentStatusEnum {
  /** The status of the `CardComment` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `CardComment` is created */
  CREATED = 'CREATED',
}

/** The connection type for Card. */
export interface CardConnection {
  __typename: 'CardConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CardEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Card>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardEdge {
  __typename: 'CardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Card>;
}

export interface CardLog extends Node, Timestamped {
  __typename: 'CardLog';
  /** `Actor` that is linked to this `CardLog` as it's creator */
  actor: Maybe<User>;
  /** The card (`WorkspaceDashboard::BaseCard`) that this `WorkspaceDashboard::CardLog` belongs to */
  card: EventCard | GoalCard;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** JSON of the changes */
  logChanges: Maybe<Scalars['JSON']['output']>;
  /** The log_type of this `WorkspaceDashboard::CardLog`. */
  logType: CardLogLogTypeEnum;
  /** The subject of this `WorkspaceDashboard::CardLog`. */
  subject: Maybe<CardLogSubject>;
  /** The subject_user (`User`) that this `WorkspaceDashboard::CardLog` belongs to */
  subjectUser: Maybe<User>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CardLog. */
export interface CardLogConnection {
  __typename: 'CardLogConnection';
  /** A list of edges. */
  edges: Array<CardLogEdge>;
  /** A list of nodes. */
  nodes: Array<CardLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardLogEdge {
  __typename: 'CardLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CardLog>;
}

export enum CardLogLogTypeEnum {
  /** The log_type of the `CardLog` is default_create */
  DEFAULT_CREATE = 'DEFAULT_CREATE',
  /** The log_type of the `CardLog` is default_update */
  DEFAULT_UPDATE = 'DEFAULT_UPDATE',
  /** The log_type of the `CardLog` is linked_cards_create */
  LINKED_CARDS_CREATE = 'LINKED_CARDS_CREATE',
  /** The log_type of the `CardLog` is linked_cards_destroy */
  LINKED_CARDS_DESTROY = 'LINKED_CARDS_DESTROY',
  /** The log_type of the `CardLog` is linked_users_create */
  LINKED_USERS_CREATE = 'LINKED_USERS_CREATE',
  /** The log_type of the `CardLog` is linked_users_destroy */
  LINKED_USERS_DESTROY = 'LINKED_USERS_DESTROY',
  /** The log_type of the `CardLog` is severity_update */
  SEVERITY_UPDATE = 'SEVERITY_UPDATE',
  /** The log_type of the `CardLog` is status_update */
  STATUS_UPDATE = 'STATUS_UPDATE',
}

/** Object which can be the subject of an `WorkspaceDashboard::CardLog` */
export type CardLogSubject = CardComment | CardTask | EventCard | GoalCard | User;

export interface CardTask extends Node, Timestamped {
  __typename: 'CardTask';
  /** Timestamp that this `CardTask` was marked archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The card (`WorkspaceDashboard::BaseCard`) that this `WorkspaceDashboard::CardTask` belongs to */
  card: EventCard | GoalCard;
  /** Current status of this `CardTask` */
  cardTaskStatus: CardTaskStatusEnum;
  /** Timestamp that this `CardTask` was marked completed */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that is linked to this `CardTask` as it's creator */
  creator: User;
  /** The end_date of this `WorkspaceDashboard::CardTask`. */
  endDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The order of this `WorkspaceDashboard::CardTask`. */
  order: Scalars['Int']['output'];
  /**
   * Current status of this `CardTask`
   * @deprecated Use `card_task_status` instead, remove this field after 2025-09-01
   */
  status: CardTaskStatusEnum;
  /** `name` of the `CardTask` */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The users of this `WorkspaceDashboard::CardTask`. */
  users: UserConnection;
}

export interface CardTaskUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for CardTask. */
export interface CardTaskConnection {
  __typename: 'CardTaskConnection';
  /** A list of edges. */
  edges: Array<CardTaskEdge>;
  /** A list of nodes. */
  nodes: Array<CardTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardTaskEdge {
  __typename: 'CardTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CardTask>;
}

export enum CardTaskStatusEnum {
  /** The status of the `CardTask` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `CardTask` is completed */
  COMPLETED = 'COMPLETED',
  /** The status of the `CardTask` is open */
  OPEN = 'OPEN',
}

/** The configuration of a form for a clinical competence committee. */
export interface CccFormConfig extends Node, Timestamped {
  __typename: 'CccFormConfig';
  /** The ccc_form_config_status of this `CccFormConfig`. */
  cccFormConfigStatus: CccFormConfigStatusEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `CccFormConfig`. */
  description: Scalars['String']['output'];
  /** The form of this `CccFormConfig`. */
  form: Scalars['JSON']['output'];
  /** The form_type of this `CccFormConfig`. */
  formType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The name of this `CccFormConfig`. */
  name: Scalars['String']['output'];
  /** The order of this `CccFormConfig`. */
  order: Scalars['Int']['output'];
  /** The skill_type of this `CccFormConfig`. */
  skillType: SkillTypeEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CccFormConfig. */
export interface CccFormConfigConnection {
  __typename: 'CccFormConfigConnection';
  /** A list of edges. */
  edges: Array<CccFormConfigEdge>;
  /** A list of nodes. */
  nodes: Array<CccFormConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CccFormConfigEdge {
  __typename: 'CccFormConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CccFormConfig>;
}

/** The connection type for CccFormConfig. */
export interface CccFormConfigSelectionConnection {
  __typename: 'CccFormConfigSelectionConnection';
  /** A list of edges. */
  edges: Array<CccFormConfigSelectionEdge>;
  /** A list of nodes. */
  nodes: Array<CccFormConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CccFormConfigSelectionEdge {
  __typename: 'CccFormConfigSelectionEdge';
  cccFormConfigSelectionResults: CccFormConfigSelectionResultConnection;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CccFormConfig>;
  order: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CccFormConfigSelectionEdgeCccFormConfigSelectionResultsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CccFormConfigSelectionFinalReportResult extends Node, Timestamped {
  __typename: 'CccFormConfigSelectionFinalReportResult';
  /** The ccc_form_config of this `CccFormConfigSelectionFinalReportResult`. */
  cccFormConfig: CccFormConfig;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The result_competency_level of this `CccFormConfigSelectionFinalReportResult`. */
  resultCompetencyLevel: Maybe<Scalars['Int']['output']>;
  /** The `Skill` that this `CccFormConfigSelectionFinalReportResult` belongs to */
  skill: Maybe<Skill>;
  /** The topics of this `CccFormConfigSelectionFinalReportResult`. */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CccFormConfigSelectionFinalReportResult. */
export interface CccFormConfigSelectionFinalReportResultConnection {
  __typename: 'CccFormConfigSelectionFinalReportResultConnection';
  /** A list of edges. */
  edges: Array<CccFormConfigSelectionFinalReportResultEdge>;
  /** A list of nodes. */
  nodes: Array<CccFormConfigSelectionFinalReportResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CccFormConfigSelectionFinalReportResultEdge {
  __typename: 'CccFormConfigSelectionFinalReportResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CccFormConfigSelectionFinalReportResult>;
}

export interface CccFormConfigSelectionResult extends Node, Timestamped {
  __typename: 'CccFormConfigSelectionResult';
  /** The ccc_form_config of this `CccFormConfigSelectionResult`. */
  cccFormConfig: CccFormConfig;
  /** The `ClinicalCompetenceCommitteeRespondent` that this `CccFormConfigSelectionResult` belongs to */
  clinicalCompetenceCommitteeRespondent: Maybe<ClinicalCompetenceCommitteeRespondent>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The result_competency_level of this `CccFormConfigSelectionResult`. */
  resultCompetencyLevel: Maybe<Scalars['Int']['output']>;
  /** The `Skill` that this `CccFormConfigSelectionResult` belongs to */
  skill: Maybe<Skill>;
  /** The topics of this `CccFormConfigSelectionResult`. */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CccFormConfigSelectionResult. */
export interface CccFormConfigSelectionResultConnection {
  __typename: 'CccFormConfigSelectionResultConnection';
  /** A list of edges. */
  edges: Array<CccFormConfigSelectionResultEdge>;
  /** A list of nodes. */
  nodes: Array<CccFormConfigSelectionResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CccFormConfigSelectionResultEdge {
  __typename: 'CccFormConfigSelectionResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CccFormConfigSelectionResult>;
}

export interface CccFormConfigSelectionResultInput {
  cccFormConfigId: Scalars['ID']['input'];
  resultCompetencyLevel?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

export enum CccFormConfigStatusEnum {
  /** The status of the `CccFormConfig` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `CccFormConfig` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `CccFormConfig` is published */
  PUBLISHED = 'PUBLISHED',
}

export interface ClinicalCompetenceCommittee extends Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'ClinicalCompetenceCommittee';
  /** The ccc_form_configs of this `ClinicalCompetenceCommittee`. */
  cccFormConfigs: CccFormConfigSelectionConnection;
  /** The clinical_competence_committee_respondents of this `ClinicalCompetenceCommittee`. */
  clinicalCompetenceCommitteeRespondents: ClinicalCompetenceCommitteeRespondentConnection;
  /** The clinical_competence_committee_status of this `ClinicalCompetenceCommittee`. */
  clinicalCompetenceCommitteeStatus: ClinicalCompetenceCommitteeStatusEnum;
  /** The closed at date of this `ClinicalCompetenceCommittee`. */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The competence_certificates of this `ClinicalCompetenceCommittee`. */
  competenceCertificates: CompetenceCertificateConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The date of this `ClinicalCompetenceCommittee`. */
  date: Scalars['Date']['output'];
  /** The final_report_results of this `ClinicalCompetenceCommittee`. */
  finalReportResults: CccFormConfigSelectionFinalReportResultConnection;
  /**
   * The final_response_json of this `ClinicalCompetenceCommittee`.
   * @deprecated Use `finalReportResults` instead
   */
  finalResponseJson: Maybe<Scalars['JSONContent']['output']>;
  id: Scalars['ID']['output'];
  /** The instructions_json_content of this `ClinicalCompetenceCommittee`. */
  instructionsJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /** The interviews of this `ClinicalCompetenceCommittee`. */
  interviews: InterviewConnection;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The skills of this `ClinicalCompetenceCommittee`. */
  skills: SkillConnection;
  /** The supervisor (`User`) that this `ClinicalCompetenceCommittee` belongs to */
  supervisor: User;
  /** The title of this `ClinicalCompetenceCommittee`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** `ClinicalCompetenceCommitteeRespondent` for the current viewer */
  viewerClinicalCompetenceCommitteeRespondent: Maybe<ClinicalCompetenceCommitteeRespondent>;
  /** The visibility_level_owner of this `ClinicalCompetenceCommittee`. */
  visibilityLevelOwner: ClinicalCompetenceCommitteeVisibilityLevelOwnerEnum;
}

export interface ClinicalCompetenceCommitteeCccFormConfigsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ClinicalCompetenceCommitteeClinicalCompetenceCommitteeRespondentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ClinicalCompetenceCommitteeCompetenceCertificatesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ClinicalCompetenceCommitteeFinalReportResultsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ClinicalCompetenceCommitteeInterviewsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ClinicalCompetenceCommitteeSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for ClinicalCompetenceCommittee. */
export interface ClinicalCompetenceCommitteeConnection {
  __typename: 'ClinicalCompetenceCommitteeConnection';
  /** A list of edges. */
  edges: Array<ClinicalCompetenceCommitteeEdge>;
  /** A list of nodes. */
  nodes: Array<ClinicalCompetenceCommittee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ClinicalCompetenceCommitteeEdge {
  __typename: 'ClinicalCompetenceCommitteeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ClinicalCompetenceCommittee>;
}

export interface ClinicalCompetenceCommitteeRespondent extends Node, PortfolioItem, Timestamped {
  __typename: 'ClinicalCompetenceCommitteeRespondent';
  /** The ccc_form_config_selection_results of this `ClinicalCompetenceCommitteeRespondent`. */
  cccFormConfigSelectionResults: CccFormConfigSelectionResultConnection;
  /** The `ClinicalCompetenceCommittee` that this `ClinicalCompetenceCommitteeRespondent` belongs to */
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether `ClinicalCompetenceCommitteeRespondent` is self assessment. */
  isSelfAssessment: Scalars['Boolean']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /**
   * The response_json of this `ClinicalCompetenceCommitteeRespondent`.
   * @deprecated Use `cccFormConfigSelectionResults` instead
   */
  responseJson: Maybe<Scalars['JSON']['output']>;
  /** The submitted at date of this `ClinicalCompetenceCommitteeRespondent`. */
  submittedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `ClinicalCompetenceCommitteeRespondent` belongs to */
  user: Maybe<User>;
}

export interface ClinicalCompetenceCommitteeRespondentCccFormConfigSelectionResultsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for ClinicalCompetenceCommitteeRespondent. */
export interface ClinicalCompetenceCommitteeRespondentConnection {
  __typename: 'ClinicalCompetenceCommitteeRespondentConnection';
  /** A list of edges. */
  edges: Array<ClinicalCompetenceCommitteeRespondentEdge>;
  /** A list of nodes. */
  nodes: Array<ClinicalCompetenceCommitteeRespondent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ClinicalCompetenceCommitteeRespondentEdge {
  __typename: 'ClinicalCompetenceCommitteeRespondentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ClinicalCompetenceCommitteeRespondent>;
}

export enum ClinicalCompetenceCommitteeStatusEnum {
  /** The status of the `ClinicalCompetenceCommittee` is closed */
  CLOSED = 'CLOSED',
  /** The status of the `ClinicalCompetenceCommittee` is open */
  OPEN = 'OPEN',
}

export enum ClinicalCompetenceCommitteeVisibilityLevelOwnerEnum {
  /** The visibility_level_owner of the `ClinicalCompetenceCommittee` is all */
  ALL = 'ALL',
  /** The visibility_level_owner of the `ClinicalCompetenceCommittee` is all_anonymized */
  ALL_ANONYMIZED = 'ALL_ANONYMIZED',
  /** The visibility_level_owner of the `ClinicalCompetenceCommittee` is final_report */
  FINAL_REPORT = 'FINAL_REPORT',
  /** The visibility_level_owner of the `ClinicalCompetenceCommittee` is none */
  NONE = 'NONE',
}

export interface Code extends Node, Timestamped {
  __typename: 'Code';
  /** The admin_group of this `Code`. */
  adminGroup: Maybe<AdminGroup>;
  /** The change_reason of this `Code`. */
  changeReason: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `Code`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether `Code` is public. */
  public: Scalars['Boolean']['output'];
  /** The published at date of this `Code`. */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title of this `Code`. */
  title: Scalars['String']['output'];
  /** The trashed at date of this `Code`. */
  trashedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface CompetenceCertificate
  extends Accessible, Activities, Creatable, Form, Node, PortfolioItem, SubjectOfFeedbackRound, Timestamped {
  __typename: 'CompetenceCertificate';
  /** The approved_by_owner_reason of this `CompetenceCertificate`. */
  approvedByOwnerReason: Maybe<Scalars['String']['output']>;
  /** The approved_by_supervisor_reason of this `CompetenceCertificate`. */
  approvedBySupervisorReason: Maybe<Scalars['String']['output']>;
  /** The approved_reason of this `CompetenceCertificate`. */
  approvedReason: Maybe<Scalars['String']['output']>;
  /** The attached_files of this `CompetenceCertificate`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** `ClinicalCompetenceCommittee`s this `CompetenceCertificate` is linked to */
  clinicalCompetenceCommittees: ClinicalCompetenceCommitteeConnection;
  /** The comments of this `CompetenceCertificate`. */
  comments: Maybe<Scalars['String']['output']>;
  /** The `CompetenceCertificateBatch` that this `CompetenceCertificate` belongs to */
  competenceCertificateBatch: Maybe<CompetenceCertificateBatch>;
  /** The competence_certificate_level of this `CompetenceCertificate`. */
  competenceCertificateLevel: Scalars['Int']['output'];
  /** The competence_certificate_status of this `CompetenceCertificate`. */
  competenceCertificateStatus: CompetenceCertificateStatusEnum;
  /**
   * Always returns an empty array
   * @deprecated Sub-skill auto-scoring has been removed
   */
  competenceCertificateSubSkillScores: CompetenceCertificateSubSkillScoreConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The denial_reason of this `CompetenceCertificate`. */
  denialReason: Maybe<Scalars['String']['output']>;
  /** `FeedbackRequest` for this subject belonging to the current user */
  feedbackRequest: Maybe<FeedbackRequest>;
  /** `FeedbackRound` for this subject belonging to the current user */
  feedbackRound: Maybe<FeedbackRound>;
  /** Type of this form */
  formType: Maybe<Scalars['String']['output']>;
  /** Version of this form */
  formVersion: Maybe<Scalars['String']['output']>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  id: Scalars['ID']['output'];
  /**
   * The level of this `CompetenceCertificate`.
   * @deprecated Use `competence_certificate_level` instead, remove this field after 2026-10-01
   */
  level: Scalars['Int']['output'];
  /** The owner rejected at date of this `CompetenceCertificate`. */
  ownerRejectedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `PortfolioDocumentConfig` that this `CompetenceCertificate` belongs to */
  portfolioDocumentConfig: PortfolioDocumentConfig;
  /** The rejection_reason of this `CompetenceCertificate`. */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** The Skill linked to this CompetenceCertificate */
  skill: Maybe<Skill>;
  /**
   * The status of this `CompetenceCertificate`.
   * @deprecated Use `competence_certificate_status` instead, remove this field after 2025-09-01
   */
  status: CompetenceCertificateStatusEnum;
  /** The supervisor (`User`) that this `CompetenceCertificate` belongs to */
  supervisor: Maybe<User>;
  /** The supervisor approved at date of this `CompetenceCertificate`. */
  supervisorApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether `CompetenceCertificate` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `CompetenceCertificate` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** The supervisor denied at date of this `CompetenceCertificate`. */
  supervisorDeniedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The supervisor voided at date of this `CompetenceCertificate`. */
  supervisorVoidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The supervisor withdrawn at date of this `CompetenceCertificate`. */
  supervisorWithdrawnAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Multipurpose topics field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The withdrawal_reason of this `CompetenceCertificate`. */
  withdrawalReason: Maybe<Scalars['String']['output']>;
}

export interface CompetenceCertificateClinicalCompetenceCommitteesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CompetenceCertificateCompetenceCertificateSubSkillScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Attributes for creating or updating a `Competence Certificate` */
export interface CompetenceCertificateAttributes {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** ID of the `Portfolio`  this `CompetenceCertificate` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** ID of the `Skill` */
  skillId: Scalars['ID']['input'];
  status?: InputMaybe<CompetenceCertificateStatusEnum>;
  /** ID of the `User` that issues this `CompetenceCertificate` */
  supervisorId: Scalars['ID']['input'];
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  withdrawalReason?: InputMaybe<Scalars['String']['input']>;
}

export interface CompetenceCertificateBatch extends Node, PortfolioItem, Timestamped {
  __typename: 'CompetenceCertificateBatch';
  /** The competence_certificates of this `CompetenceCertificateBatch`. */
  competenceCertificates: CompetenceCertificateConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface CompetenceCertificateBatchCompetenceCertificatesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for CompetenceCertificate. */
export interface CompetenceCertificateConnection {
  __typename: 'CompetenceCertificateConnection';
  /** A list of edges. */
  edges: Array<CompetenceCertificateEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenceCertificate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CompetenceCertificateEdge {
  __typename: 'CompetenceCertificateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CompetenceCertificate>;
}

export interface CompetenceCertificateLevel {
  __typename: 'CompetenceCertificateLevel';
  displayValue: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  status: SkillLevelFormatStatusEnum;
}

export enum CompetenceCertificateStatusEnum {
  /** The status of the `CompetenceCertificate` is approved */
  APPROVED = 'APPROVED',
  /** The status of the `CompetenceCertificate` is approved_by_owner */
  APPROVED_BY_OWNER = 'APPROVED_BY_OWNER',
  /** The status of the `CompetenceCertificate` is copied */
  COPIED = 'COPIED',
  /** The status of the `CompetenceCertificate` is denied */
  DENIED = 'DENIED',
  /** The status of the `CompetenceCertificate` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `CompetenceCertificate` is imported */
  IMPORTED = 'IMPORTED',
  /** The status of the `CompetenceCertificate` is rejected */
  REJECTED = 'REJECTED',
  /** The status of the `CompetenceCertificate` is voided */
  VOIDED = 'VOIDED',
  /** The status of the `CompetenceCertificate` is withdrawn */
  WITHDRAWN = 'WITHDRAWN',
}

export interface CompetenceCertificateSubSkillScore extends Node, Timestamped {
  __typename: 'CompetenceCertificateSubSkillScore';
  /** @deprecated Sub-skill auto-scoring has been removed */
  competenceCertificate: Maybe<CompetenceCertificate>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Sub-skill auto-scoring has been removed */
  displayValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Sub-skill auto-scoring has been removed */
  label: Maybe<Scalars['String']['output']>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  number: Maybe<Scalars['Int']['output']>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  scoreSource: Maybe<Scalars['String']['output']>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  scoreStatus: Maybe<CompetenceCertificateSubSkillScoreScoreStatusEnum>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  skill: Maybe<Skill>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  subSkill: Maybe<Skill>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CompetenceCertificateSubSkillScore. */
export interface CompetenceCertificateSubSkillScoreConnection {
  __typename: 'CompetenceCertificateSubSkillScoreConnection';
  /** A list of edges. */
  edges: Array<CompetenceCertificateSubSkillScoreEdge>;
  /** A list of nodes. */
  nodes: Array<CompetenceCertificateSubSkillScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CompetenceCertificateSubSkillScoreEdge {
  __typename: 'CompetenceCertificateSubSkillScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CompetenceCertificateSubSkillScore>;
}

export enum CompetenceCertificateSubSkillScoreScoreStatusEnum {
  DONE = 'DONE',
  OPEN = 'OPEN',
  PROGRESS = 'PROGRESS',
}

export interface Contact extends Node, Timestamped {
  __typename: 'Contact';
  /** The attention of this `Billing::Contact`. */
  attention: Maybe<Scalars['String']['output']>;
  /** The company_name of this `Billing::Contact`. */
  companyName: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The moneybird_id of this `Billing::Contact`. */
  moneybirdId: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The version of this `Billing::Contact`. */
  version: Maybe<Scalars['Int']['output']>;
}

/** The connection type for Contact. */
export interface ContactConnection {
  __typename: 'ContactConnection';
  /** A list of edges. */
  edges: Array<ContactEdge>;
  /** A list of nodes. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ContactEdge {
  __typename: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Contact>;
}

/** Filter for `Contact` */
export interface ContactFilter {
  /** Only show the `Contact`s whose company name contains this query (case insensitive) */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of CopyObjectToPortfolio */
export interface CopyObjectToPortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the to copy object */
  copyableId: Scalars['ID']['input'];
  /** ID of the `Portfolio` to copy the object to */
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of CopyObjectToPortfolio. */
export interface CopyObjectToPortfolioPayload {
  __typename: 'CopyObjectToPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Copy of the original object */
  copyable: Maybe<CourseResult | Interview | Kpb>;
  errors: Array<Error>;
}

/** An object that can be copied to a new `Portfolio` */
export interface Copyable {
  /** Attributes of original object */
  sourceAttributes: Maybe<Scalars['JSON']['output']>;
}

/** A course that users can/must complete for their portfolio */
export interface Course extends Node, Timestamped {
  __typename: 'Course';
  /** Accreditation information for this `Course` */
  accreditation: Maybe<Array<CourseAccreditation>>;
  /** List of CanMEDS that apply to this `Course` */
  canmeds: Maybe<Array<Scalars['String']['output']>>;
  /** Cohorts to group the `CourseResults` for this `Course` by */
  cohorts: Maybe<Array<CourseCohort>>;
  /** Aggregation of `CourseResult`s for all `cohorts` of this `Course` */
  cohortsAverage: Maybe<Array<CourseResultAggregation>>;
  /** Aggregation of `CourseResults` for this `Course` */
  courseAverage: Maybe<CourseResultAggregation>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The `SupportGroup` that created this `Course` */
  creatorGroup: Maybe<SupportGroup>;
  /** A description for this course */
  description: Maybe<Scalars['String']['output']>;
  /** URLs for documents related to this `Course` */
  documentUrls: Maybe<Array<Scalars['String']['output']>>;
  /** `Editions` for this `Course` */
  editions: Maybe<Array<CourseEdition>>;
  /** `CourseEducator` for this `Course` */
  educator: Maybe<CourseEducator>;
  /** The fee of this `Course`. */
  fee: Maybe<Scalars['Float']['output']>;
  /** The fee_explanation of this `Course`. */
  feeExplanation: Maybe<Scalars['String']['output']>;
  /** Guideline ID of the `Course` */
  guidelineId: Maybe<Scalars['String']['output']>;
  /** A flag if one can achieve a score for this course */
  hasScore: Scalars['Boolean']['output'];
  /** A flag if time-tracking is enabled for this course */
  hasTimeSpent: Scalars['Boolean']['output'];
  /** Flag to indicate overall results can be viewed */
  hasViewableOverallResults: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Flag if the course with potential sub courses with centrally uploaded results */
  isCentralUploadCategory: Scalars['Boolean']['output'];
  /** A flag if results for the course can only be registered automatically or also by a manager */
  isCreatableByManager: Scalars['Boolean']['output'];
  /** A flag if results for the course can only be registered automatically or also by the owner */
  isCreatableByOwner: Scalars['Boolean']['output'];
  /** A flag if the course can be passed or not */
  isPassable: Scalars['Boolean']['output'];
  /** Learning environment information of this `Course` */
  learningEnvironment: CourseLearningEnvironmentTypeEnum;
  /** Maximum score attainable for this course */
  maxScore: Maybe<Scalars['Float']['output']>;
  /** Order to sort subcourses to */
  order: Maybe<Scalars['Int']['output']>;
  /** An optional parent course this course falls under */
  parentCourse: Maybe<Course>;
  /** The results achieved for this course */
  results: Array<CourseResult>;
  /** A JSON schema that outlines how the scores can be formatted */
  scoreDetailFormat: Maybe<Scalars['JSON']['output']>;
  /** Histogram of `CourseResult` scores for this `Course` */
  scoreHistogram: Maybe<Array<HistogramBucket>>;
  /** Short identifier */
  shortName: Scalars['String']['output'];
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** The external source this course is registered in */
  source: Maybe<Scalars['String']['output']>;
  /** ID for the external source */
  sourceId: Maybe<Scalars['String']['output']>;
  /** Optional courses that fall under this course */
  subCourses: Array<Course>;
  /** The title of this course */
  title: Scalars['String']['output'];
  /** The title_config of this `Course`. */
  titleConfig: Maybe<CourseTitleConfig>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** External URL for this course */
  url: Maybe<Scalars['String']['output']>;
  /** `Users` that are linkt to this `Course` */
  users: Array<User>;
}

/** A course that users can/must complete for their portfolio */
export interface CourseEditionsArgs {
  beginsAfter?: InputMaybe<Scalars['Date']['input']>;
  beginsBefore?: InputMaybe<Scalars['Date']['input']>;
}

/** A course that users can/must complete for their portfolio */
export interface CourseScoreHistogramArgs {
  part?: InputMaybe<Scalars['String']['input']>;
}

/** A course that users can/must complete for their portfolio */
export interface CourseSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CourseAccreditation {
  __typename: 'CourseAccreditation';
  categoryId: Maybe<Scalars['Int']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  points: Maybe<Scalars['Float']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
}

/** A cohort to group `CourseResults` by when aggregating */
export interface CourseCohort {
  __typename: 'CourseCohort';
  /** The display name for this cohort, when it's different from the identifier */
  name: Maybe<Scalars['String']['output']>;
  /** The passing score applicable to this cohort, if any */
  passingScore: Maybe<Scalars['Float']['output']>;
  /** The identifier used for this cohort */
  shortName: Scalars['String']['output'];
}

/** A cohort to group `CourseResults` by when aggregating */
export interface CourseCohortInput {
  /** The display name for this cohort, when it's different from the identifier */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The passing score applicable to this cohort, if any */
  passingScore?: InputMaybe<Scalars['Float']['input']>;
  /** The identifier used for this cohort */
  shortName: Scalars['String']['input'];
}

/** The connection type for Course. */
export interface CourseConnection {
  __typename: 'CourseConnection';
  /** A list of edges. */
  edges: Array<CourseEdge>;
  /** A list of nodes. */
  nodes: Array<Course>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total filtered amount of items in this connection. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CourseEdge {
  __typename: 'CourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Course>;
}

export interface CourseEdition extends Node, Timestamped {
  __typename: 'CourseEdition';
  /** `Course` this `Edition` belongs to */
  course: Maybe<Course>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End date of the `Edition` (inclusive) */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The end_time of this `CourseEdition`. */
  endTime: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The location_address of this `CourseEdition`. */
  locationAddress: Maybe<Scalars['String']['output']>;
  /** The location_latitude of this `CourseEdition`. */
  locationLatitude: Maybe<Scalars['Float']['output']>;
  /** The location_locality of this `CourseEdition`. */
  locationLocality: Maybe<Scalars['String']['output']>;
  /** The location_longitude of this `CourseEdition`. */
  locationLongitude: Maybe<Scalars['Float']['output']>;
  /** The location_name of this `CourseEdition`. */
  locationName: Maybe<Scalars['String']['output']>;
  /** The meetings of this `CourseEdition`. */
  meetings: Maybe<Array<CourseEditionMeeting>>;
  /** Start date of the `Edition` */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The start_time of this `CourseEdition`. */
  startTime: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for CourseEdition. */
export interface CourseEditionConnection {
  __typename: 'CourseEditionConnection';
  /** A list of edges. */
  edges: Array<CourseEditionEdge>;
  /** A list of nodes. */
  nodes: Array<CourseEdition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total filtered amount of items in this connection. */
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CourseEditionEdge {
  __typename: 'CourseEditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CourseEdition>;
}

export interface CourseEditionMeeting {
  __typename: 'CourseEditionMeeting';
  accreditation: Maybe<Array<CourseAccreditation>>;
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  endTime: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  startTime: Maybe<Scalars['String']['output']>;
}

/** A course educator */
export interface CourseEducator extends Node, Timestamped {
  __typename: 'CourseEducator';
  /** `Courses` this `CourseEducator` has */
  courses: Array<Course>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email of this `CourseEducator`. */
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The name of this `CourseEducator`. */
  name: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The url of this `CourseEducator`. */
  url: Maybe<Scalars['String']['output']>;
}

export enum CourseLearningEnvironmentTypeEnum {
  /** This is an online course (e-learning) */
  ONLINE = 'ONLINE',
  /** This is education with physical presence */
  PHYSICAL = 'PHYSICAL',
  /** This course's learning environment is not known */
  UNDEFINED = 'UNDEFINED',
}

/** Registration of a result for a course by a user */
export interface CourseResult extends Accessible, Activities, Copyable, Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'CourseResult';
  /** The attached_files of this `CourseResult`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** The BIG this floating `CourseResult` is for */
  big: Maybe<Scalars['String']['output']>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** True if the result was uploaded centrally */
  centralUpload: Maybe<Scalars['Boolean']['output']>;
  /** Cohort to group this `CourseResult` with */
  cohort: Maybe<Scalars['String']['output']>;
  /** The course this result is associated with */
  course: Maybe<Course>;
  /** The course_result_status of this `CourseResult`. */
  courseResultStatus: Maybe<CourseResultStatusEnum>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The `SupportGroup` that created this `CourseResult` */
  creatorGroup: Maybe<SupportGroup>;
  /** The date at which this result was achieved */
  date: Maybe<Scalars['Date']['output']>;
  /** The description of this result */
  description: Maybe<Scalars['String']['output']>;
  /** The `PortfolioFormat` this floating `CourseResult` is for */
  floatingPortfolioFormat: Maybe<PortfolioFormat>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  id: Scalars['ID']['output'];
  /** Metadata from the import process */
  importMetaData: Scalars['JSON']['output'];
  /** Source from where the CourseResult was imported */
  importSource: Maybe<Scalars['String']['output']>;
  /** True if the result was imported */
  imported: Maybe<Scalars['Boolean']['output']>;
  /** True if the result is a passed result */
  passed: Maybe<Scalars['Boolean']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** Aggregation of course results for the portfolio */
  portfolioAverage: Maybe<CourseResultAggregation>;
  /** The score associated with this result */
  score: Maybe<Scalars['Float']['output']>;
  /** JSON schema of what scores look like */
  scoreDetail: Maybe<Scalars['JSON']['output']>;
  /** `Skill`s attached to this object */
  skills: SkillConnection;
  /** Attributes of original object */
  sourceAttributes: Maybe<Scalars['JSON']['output']>;
  /**
   * The status of this `CourseResult`.
   * @deprecated Use `course_result_status` instead, remove this field after 2025-09-01
   */
  status: Maybe<CourseResultStatusEnum>;
  /** The amount of time spent to achieve this result */
  timeSpent: Maybe<Scalars['Int']['output']>;
  /** The title of this result */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Registration of a result for a course by a user */
export interface CourseResultSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CourseResultAggregation {
  __typename: 'CourseResultAggregation';
  /** Amount of results this aggregation is based on */
  count: Maybe<Scalars['Int']['output']>;
  /** Total amount of passed `CourseResults` */
  passed: Maybe<Scalars['Int']['output']>;
  /** Aggregation information about scores for these results */
  score: Maybe<ScoreAggregation>;
  /** Aggregation information about subscores */
  subScores: Maybe<Array<SubCourseResultAggregation>>;
  /** Aggregation information about time spent for these course results */
  timeSpent: Maybe<ScoreAggregation>;
  /** Total amount of results */
  total: Maybe<Scalars['Int']['output']>;
}

/** The connection type for CourseResult. */
export interface CourseResultConnection {
  __typename: 'CourseResultConnection';
  /** A list of edges. */
  edges: Array<CourseResultEdge>;
  /** A list of nodes. */
  nodes: Array<CourseResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The sums of timeSpent grouped by shortName (filtered). This is a JSON object with number values. */
  sumTimeSpentGroupedByCourseShortName: Maybe<Scalars['JSON']['output']>;
  /** The sum of timeSpent (filtered). */
  sumTotalTimeSpent: Maybe<Scalars['Int']['output']>;
  /** The total filtered amount of items in this connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
}

/** An edge in a connection. */
export interface CourseResultEdge {
  __typename: 'CourseResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CourseResult>;
}

/** Filter for `CourseResults` */
export interface CourseResultFilter {
  /** Only show objects that occur before this date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only show objects related to this `Goal` */
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects for `Courses` with this short name or objects for subcourses thereof */
  parentShortName?: InputMaybe<Scalars['String']['input']>;
  /** Only show objects for `Courses` with this short name */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Only show objects related to these `Skills` */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects that occur after this date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
}

export enum CourseResultStatusEnum {
  /** `CourseResult` was copied and is read-only */
  COPIED = 'COPIED',
  /** `CourseResult` was created normally */
  CREATED = 'CREATED',
  /** `CourseResult` was imported and is read-only */
  IMPORTED = 'IMPORTED',
}

export interface CourseTitleConfig {
  __typename: 'CourseTitleConfig';
  label: Scalars['String']['output'];
  options: Array<CourseTitleConfigOption>;
}

export interface CourseTitleConfigOption {
  __typename: 'CourseTitleConfigOption';
  hidden: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
}

/** An object that can be created by a `User` */
export interface Creatable {
  /** `User` that created this object */
  creator: Maybe<User>;
}

/** Autogenerated input type of CreateAdminGroup */
export interface CreateAdminGroupInput {
  canManageMedicines?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

/** Autogenerated return type of CreateAdminGroup. */
export interface CreateAdminGroupPayload {
  __typename: 'CreateAdminGroupPayload';
  adminGroup: Maybe<AdminGroup>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateAudioTranscript */
export interface CreateAudioTranscriptInput {
  audioFileId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId?: InputMaybe<Scalars['ID']['input']>;
  suggestions?: InputMaybe<Scalars['JSON']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateAudioTranscript. */
export interface CreateAudioTranscriptPayload {
  __typename: 'CreateAudioTranscriptPayload';
  audioTranscript: Maybe<AudioTranscript>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCardComment */
export interface CreateCardCommentInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the `Card` for this `CardComment` */
  cardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Comment for this `CardComment`
   * @deprecated Use `commentJsonContent` instead.
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Rich-text content for this `CardComment` */
  commentJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** Status of this `CardComment` */
  status?: InputMaybe<CardCommentStatusEnum>;
}

/** Autogenerated return type of CreateCardComment. */
export interface CreateCardCommentPayload {
  __typename: 'CreateCardCommentPayload';
  cardComment: Maybe<CardComment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCardTask */
export interface CreateCardTaskInput {
  /** ID of the `Card` for this `CardTask` */
  cardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End date for this `CardTask` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Order number for this `CardTask` */
  order: Scalars['Int']['input'];
  /** Status for this `CardTask` */
  status?: InputMaybe<CardTaskStatusEnum>;
  /** Title for this `CardTask` */
  title: Scalars['String']['input'];
  /** IDs of the `User`s for this `CardTask` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of CreateCardTask. */
export interface CreateCardTaskPayload {
  __typename: 'CreateCardTaskPayload';
  cardTask: Maybe<CardTask>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCccFormConfig */
export interface CreateCccFormConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  form?: InputMaybe<Scalars['JSON']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  portfolioFormatId: Scalars['ID']['input'];
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated return type of CreateCccFormConfig. */
export interface CreateCccFormConfigPayload {
  __typename: 'CreateCccFormConfigPayload';
  cccFormConfig: Maybe<CccFormConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateClinicalCompetenceCommittee */
export interface CreateClinicalCompetenceCommitteeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  instructionsJsonContent?: InputMaybe<Scalars['JSON']['input']>;
  interviewIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  portfolioId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ClinicalCompetenceCommitteeStatusEnum>;
  supervisorId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  visibilityLevelOwner?: InputMaybe<ClinicalCompetenceCommitteeVisibilityLevelOwnerEnum>;
}

/** Autogenerated return type of CreateClinicalCompetenceCommittee. */
export interface CreateClinicalCompetenceCommitteePayload {
  __typename: 'CreateClinicalCompetenceCommitteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCode */
export interface CreateCodeInput {
  adminGroupId?: InputMaybe<Scalars['ID']['input']>;
  changeReason?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  title: Scalars['String']['input'];
  trashedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of CreateCode. */
export interface CreateCodePayload {
  __typename: 'CreateCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  code: Maybe<Code>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCompetenceCertificate */
export interface CreateCompetenceCertificateInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Temporary flag to prevent creating notifications/pending actions for this `CompetenceCertificate` */
  createdInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** ID of the `Portfolio`  this `CompetenceCertificate` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** ID of the `Skill` this `CompetenceCertificate` should linked to. */
  skillId: Scalars['ID']['input'];
  status?: InputMaybe<CompetenceCertificateStatusEnum>;
  /** ID of the `User` that issues this `CompetenceCertificate` */
  supervisorId: Scalars['ID']['input'];
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
  withdrawalReason?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateCompetenceCertificate. */
export interface CreateCompetenceCertificatePayload {
  __typename: 'CreateCompetenceCertificatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  competenceCertificate: Maybe<CompetenceCertificate>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCourse */
export interface CreateCourseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohorts to group the `CourseResults` for this `Course` by */
  cohorts?: InputMaybe<Array<CourseCohortInput>>;
  /** The `SupportGroup` that manages this `Course` */
  creatorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** A description for this `Course` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Guideline ID of the `Course` */
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  /** A flag if one can achieve a score for this `Course` */
  hasScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if time-tracking is enabled for this `Course` */
  hasTimeSpent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to indicate overall results can be viewed */
  hasViewableOverallResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag if the `Course` with potential sub `Course`s with centrally uploaded results */
  isCentralUploadCategory?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if results for the `Course` can also be registered by the manager */
  isCreatableByManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if results for the `Course` can only be registered automatically or also by the owner */
  isCreatableByOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if the `Course` can be passed or not */
  isPassable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum score for this `Course` */
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  /** An optional parent `Course` this `Course` falls under */
  parentCourse?: InputMaybe<Scalars['ID']['input']>;
  /** A JSON schema that outlines how the scores can be formatted */
  scoreDetailFormat?: InputMaybe<Scalars['JSON']['input']>;
  /** The short title of this `Course` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The external source that offers this `Course` */
  source?: InputMaybe<Scalars['String']['input']>;
  /** The title of this `Course` */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateCourse. */
export interface CreateCoursePayload {
  __typename: 'CreateCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  course: Maybe<Course>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCourseResultByBigAndShortName */
export interface CreateCourseResultByBigAndShortNameInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** BIG of the `User` this `CourseResult` is attached to */
  big: Scalars['String']['input'];
  /** True if this result should be ignored if the course already has a result for this portfolio */
  blockDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the result was uploaded centrally */
  centralUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort to group this `CourseResult` with */
  cohort?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Course`  this `CourseResult` is attached to */
  courseId: Scalars['ID']['input'];
  /**
   * ID of the `SupportGroup` for this `CourseResult`
   * @deprecated This is redundant with the creator_group on the Course; Field will be romoved 21 Nov 2024
   */
  creatorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** The date at which this result was achieved */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** The description of this result */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if the result is a passed result */
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The score associated with this result */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** JSON schema of what scores look like */
  scoreDetail?: InputMaybe<Scalars['JSON']['input']>;
  /** Shortname of the `PortfolioFormat` this `CourseResult` is attached to */
  shortName: Scalars['String']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of time spent to achieve this result */
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  /** The title of this result */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateCourseResultByBigAndShortName. */
export interface CreateCourseResultByBigAndShortNamePayload {
  __typename: 'CreateCourseResultByBigAndShortNamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  courseResult: Maybe<CourseResult>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCourseResult */
export interface CreateCourseResultInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** True if this result should be ignored if the course already has a result for this portfolio */
  blockDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the result was uploaded centrally */
  centralUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort to group this `CourseResult` with */
  cohort?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Course`  this `CourseResult` is attached to */
  courseId: Scalars['ID']['input'];
  /**
   * ID of the `SupportGroup` for this `CourseResult`
   * @deprecated This is redundant with the creator_group on the Course; Field will be romoved 21 Nov 2024
   */
  creatorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** The date at which this result was achieved */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** The description of this result */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if the result is a passed result */
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Portfolio`  this `CourseResult` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** The score associated with this result */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** JSON schema of what scores look like */
  scoreDetail?: InputMaybe<Scalars['JSON']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of time spent to achieve this result */
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  /** The title of this result */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateCourseResult. */
export interface CreateCourseResultPayload {
  __typename: 'CreateCourseResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  courseResult: Maybe<CourseResult>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateCustomSkill */
export interface CreateCustomSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the custom `Skill` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the custom `Skill` */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the custom `Skill` */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order of the custom `Skill` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Portfolio of the custom `Skill` */
  portfolioId: Scalars['ID']['input'];
  /** Short name of the custom `Skill` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Skill categories of the custom `Skill` */
  skillCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Skill type of the custom `Skill` */
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated return type of CreateCustomSkill. */
export interface CreateCustomSkillPayload {
  __typename: 'CreateCustomSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of CreateDashboardFormat */
export interface CreateDashboardFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of this `Dashboard` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** shortName of this `Dashboard` */
  shortName: Scalars['String']['input'];
  /** Title of this `Dashboard` */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateDashboardFormat. */
export interface CreateDashboardFormatPayload {
  __typename: 'CreateDashboardFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboardFormat: Maybe<DashboardFormat>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateDashboard */
export interface CreateDashboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardFormat` for this `Dashboard` */
  dashboardFormatId: Scalars['ID']['input'];
  /** Description of this `Dashboard` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Title of this `Dashboard` */
  title: Scalars['String']['input'];
  /** `use_alternative_title` boolean of this `Dashboard` */
  useAlternativeTitle?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateDashboard. */
export interface CreateDashboardPayload {
  __typename: 'CreateDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboard: Maybe<Dashboard>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateDashboardRole */
export interface CreateDashboardRoleInput {
  /** access_level for this `DashboardRole` */
  accessLevel: DashboardRoleAccessLevelEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Dashboard` for this `DashboardRole` */
  dashboardId: Scalars['ID']['input'];
  /** Title for this `DashboardRole` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `User` for this `DashboardRole` */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateDashboardRole. */
export interface CreateDashboardRolePayload {
  __typename: 'CreateDashboardRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboardRole: Maybe<DashboardRole>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateDirectUpload */
export interface CreateDirectUploadInput {
  /** Size in bytes of the to-be-uploaded file */
  byteSize: Scalars['Int']['input'];
  /** MD5 checksum of the to-be-uploaded file */
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** (Suspected) content type of the to-be-uploaded file */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Name for the file */
  filename: Scalars['String']['input'];
  /** Metadata to attach to the file */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateDirectUpload. */
export interface CreateDirectUploadPayload {
  __typename: 'CreateDirectUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  directUpload: Maybe<DirectUpload>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateDraft */
export interface CreateDraftInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  object?: InputMaybe<Scalars['JSON']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateDraft. */
export interface CreateDraftPayload {
  __typename: 'CreateDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  draft: Maybe<Draft>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateEventCard */
export interface CreateEventCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description for this `EventCard`
   * @deprecated Use `descriptionJsonContent` instead.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** End date for this `EventCard` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  qualityInstrumentId?: InputMaybe<Scalars['ID']['input']>;
  /** Start date for this `EventCard` */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Status for this `EventCard` */
  status?: InputMaybe<EventCardStatusEnum>;
  /** Title for this `EventCard` */
  title: Scalars['String']['input'];
  /** IDs of the `User`s for this `EventCard` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of the `Workspace` for this `EventCard` */
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateEventCard. */
export interface CreateEventCardPayload {
  __typename: 'CreateEventCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventCard: Maybe<EventCard>;
}

/** Autogenerated input type of CreateFeedbackRequest */
export interface CreateFeedbackRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeedbackRound` to update */
  feedbackRoundId: Scalars['ID']['input'];
  /** ID of the `User` from which feedback is requested */
  requesteeId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateFeedbackRequest. */
export interface CreateFeedbackRequestPayload {
  __typename: 'CreateFeedbackRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The resulting `FeedbackRequest` */
  feedbackRequest: Maybe<FeedbackRequest>;
}

/** Autogenerated input type of CreateFeedbackRound */
export interface CreateFeedbackRoundInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Not null of the `FeedbackRound` was closed */
  closedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Comments and questions for the people giving feedback */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** Boolean that marks whether or not owner can view the gated_fields of the `FeedbackRound` */
  ownerCanViewAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of the `FeedbackRound` */
  status?: InputMaybe<FeedbackRoundStatusEnum>;
  /** ID of the `CompetenceCertificate` or `Interview` for this `FeedbackRound` */
  subjectId: Scalars['ID']['input'];
  /** Title of the `FeedbackRound` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateFeedbackRound. */
export interface CreateFeedbackRoundPayload {
  __typename: 'CreateFeedbackRoundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The created `FeedbackRound` */
  feedbackRound: Maybe<FeedbackRound>;
}

/** Autogenerated input type of CreateGeneralFeedbackFormConfig */
export interface CreateGeneralFeedbackFormConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  form: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  portfolioFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateGeneralFeedbackFormConfig. */
export interface CreateGeneralFeedbackFormConfigPayload {
  __typename: 'CreateGeneralFeedbackFormConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generalFeedbackFormConfig: Maybe<GeneralFeedbackFormConfig>;
}

/** Autogenerated input type of CreateGeneralFeedback */
export interface CreateGeneralFeedbackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalFeedbackFormConfigId: Scalars['ID']['input'];
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['ID']['input'];
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateGeneralFeedback. */
export interface CreateGeneralFeedbackPayload {
  __typename: 'CreateGeneralFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generalFeedback: Maybe<GeneralFeedback>;
}

/** Autogenerated input type of CreateGoalActivity */
export interface CreateGoalActivityInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this activity was performed */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `Goal` this `GoalActivity` is attached to */
  goalId: Scalars['ID']['input'];
  /** ID of the subject attached to this `GoalActivity` */
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  /** Mutlipurpose description field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateGoalActivity. */
export interface CreateGoalActivityPayload {
  __typename: 'CreateGoalActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goalActivity: Maybe<GoalActivity>;
}

/** Autogenerated input type of CreateGoalCard */
export interface CreateGoalCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description for this `GoalCard`
   * @deprecated Use `descriptionJsonContent` instead.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `descriptionActJsonContent` instead. */
  descriptionAct?: InputMaybe<Scalars['String']['input']>;
  descriptionActJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionCheckJsonContent` instead. */
  descriptionCheck?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `descriptionCheckIndicatorsJsonContent` instead. */
  descriptionCheckIndicators?: InputMaybe<Scalars['String']['input']>;
  descriptionCheckIndicatorsJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionCheckJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionDoJsonContent` instead. */
  descriptionDo?: InputMaybe<Scalars['String']['input']>;
  descriptionDoJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionPlanJsonContent` instead. */
  descriptionPlan?: InputMaybe<Scalars['String']['input']>;
  descriptionPlanJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** End date for this `GoalCard` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** This `GoalCard` is featured */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Severity for this `GoalCard` */
  severity?: InputMaybe<GoalCardSeverityEnum>;
  /** Start date for this `GoalCard` */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Status for this `GoalCard` */
  status?: InputMaybe<GoalCardStatusEnum>;
  /** ID of the `Subdomain` for this `GoalCard` */
  subDomainId: Scalars['ID']['input'];
  /** Title for this `GoalCard` */
  title: Scalars['String']['input'];
  /** IDs of the `User`s for this `GoalCard` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of the `Workspace` for this `GoalCard` */
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateGoalCard. */
export interface CreateGoalCardPayload {
  __typename: 'CreateGoalCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goalCard: Maybe<GoalCard>;
}

/** Autogenerated input type of CreateGoal */
export interface CreateGoalInput {
  /** Canmeds for this `Goal` */
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Category (variant) of this `Goal` */
  category?: InputMaybe<GoalCategoryTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` this `Goal` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** IDs of the `Residencies` for this `Goals` */
  residencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Current status of this `Goal` */
  status?: InputMaybe<GoalStatusEnum>;
  /** `Date` that the portfolio owner aims to achieve this goal */
  targetDate: Scalars['Date']['input'];
  /** General description of this `Goal` */
  title: Scalars['String']['input'];
  /** Mutlipurpose description field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateGoal. */
export interface CreateGoalPayload {
  __typename: 'CreateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goal: Maybe<Goal>;
}

/** Autogenerated input type of CreateGuidelineAttachment */
export interface CreateGuidelineAttachmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  guidelineId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trashedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of CreateGuidelineAttachment. */
export interface CreateGuidelineAttachmentPayload {
  __typename: 'CreateGuidelineAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  guidelineAttachment: Maybe<GuidelineAttachment>;
}

/** Autogenerated input type of CreateGuideline */
export interface CreateGuidelineInput {
  ancestry?: InputMaybe<Scalars['String']['input']>;
  ancestryDepth?: InputMaybe<Scalars['Int']['input']>;
  ancestryRootId?: InputMaybe<Scalars['Int']['input']>;
  argumentation?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  changeReason?: InputMaybe<Scalars['String']['input']>;
  childDisplayType?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Code` this `Guideline` belongs to */
  codeId?: InputMaybe<Scalars['ID']['input']>;
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  icpc?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  synonyms?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  trashedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of CreateGuideline. */
export interface CreateGuidelinePayload {
  __typename: 'CreateGuidelinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<Error>>;
  guideline: Maybe<Guideline>;
}

/** Autogenerated input type of CreateInterview */
export interface CreateInterviewInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `Interview` was performed */
  date: Scalars['Date']['input'];
  /** End date of the period considered in this `Interview` */
  endOn?: InputMaybe<Scalars['Date']['input']>;
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** ID of the `Portfolio` this `Interview` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** Total reduction in months */
  reduction?: InputMaybe<Scalars['Float']['input']>;
  /** Reason for (changing) the reduction */
  reductionReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the other interviews that this `Interview` refers to */
  refersToInterviewIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional ID of the `Residency` this `Interview` belongs to */
  residencyId?: InputMaybe<Scalars['ID']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the period considered in this `Interview` */
  startOn?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<InterviewStatusEnum>;
  /** ID of the `User` that supervised this `Interview` */
  supervisorId: Scalars['ID']['input'];
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateInterview. */
export interface CreateInterviewPayload {
  __typename: 'CreateInterviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  interview: Maybe<Interview>;
}

/** Autogenerated input type of CreateInvite */
export interface CreateInviteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the subject for this `Invite` */
  subjectId: Scalars['ID']['input'];
  /** ID of the `User` that supervised this `Invite` */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateInvite. */
export interface CreateInvitePayload {
  __typename: 'CreateInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invite: Maybe<Invite>;
}

/** Autogenerated input type of CreateInvoicePlan */
export interface CreateInvoicePlanInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Contact` for this `InvoicePlan` */
  contactId: Scalars['ID']['input'];
  /** the invoice frequency of the `InvoicePlan` */
  invoiceFrequency?: InputMaybe<InvoicePlanFrequencyEnum>;
  /** ID of the `LedgerAccount` for this `InvoicePlan` */
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** License price for this `InvoicePlan` */
  licensePrice: Scalars['Float']['input'];
  /** Whether to add a list of licenses (as PDF) as an attachment to an invoice in MoneyBird */
  moneybirdAttachSpecifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` for this `InvoicePlan` */
  organizationId: Scalars['ID']['input'];
  /** ID of the `PortfolioFormat` for this `InvoicePlan` */
  portfolioFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateInvoicePlan. */
export interface CreateInvoicePlanPayload {
  __typename: 'CreateInvoicePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoicePlan: Maybe<InvoicePlan>;
}

/** Autogenerated input type of CreateKPB */
export interface CreateKpbInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  canmeds?: InputMaybe<CanmedsInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `KPB` was performed */
  date: Scalars['Date']['input'];
  level?: InputMaybe<LevelEnum>;
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** The ID of the `Portfolio` this `KPB` is attached to. */
  portfolioId: Scalars['ID']['input'];
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<KpbStatusEnum>;
  supervisionLevel?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the `User` that supervised this `KPB`. */
  supervisorId: Scalars['ID']['input'];
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateKPB. */
export interface CreateKpbPayload {
  __typename: 'CreateKPBPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  kpb: Maybe<Kpb>;
}

/** Autogenerated input type of CreateLearningResourceArticle */
export interface CreateLearningResourceArticleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentJsonContent: Scalars['JSONContent']['input'];
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceArticle. */
export interface CreateLearningResourceArticlePayload {
  __typename: 'CreateLearningResourceArticlePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceArticle: Maybe<LearningResourceArticle>;
}

/** Autogenerated input type of CreateLearningResourceFile */
export interface CreateLearningResourceFileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the content file */
  content: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceFile. */
export interface CreateLearningResourceFilePayload {
  __typename: 'CreateLearningResourceFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceFile: Maybe<LearningResourceFile>;
}

/** Autogenerated input type of CreateLearningResourceGlobalCategory */
export interface CreateLearningResourceGlobalCategoryInput {
  application?: InputMaybe<ApplicationEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  order?: InputMaybe<Scalars['Int']['input']>;
  shortName: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceGlobalCategory. */
export interface CreateLearningResourceGlobalCategoryPayload {
  __typename: 'CreateLearningResourceGlobalCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceGlobalCategory: Maybe<LearningResourceGlobalCategory>;
}

/** Autogenerated input type of CreateLearningResourceLink */
export interface CreateLearningResourceLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ID of the `DirectUpload` of the thumbnail
   * @deprecated Use `image` instead
   */
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceLink. */
export interface CreateLearningResourceLinkPayload {
  __typename: 'CreateLearningResourceLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceLink: Maybe<LearningResourceLink>;
}

/** Autogenerated input type of CreateLearningResourceMicroLearning */
export interface CreateLearningResourceMicroLearningInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the avatar */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MicroLearningStatusEnum>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceMicroLearning. */
export interface CreateLearningResourceMicroLearningPayload {
  __typename: 'CreateLearningResourceMicroLearningPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearning: Maybe<LearningResourceMicroLearning>;
}

/** Autogenerated input type of CreateLearningResourceMicroLearningStep */
export interface CreateLearningResourceMicroLearningStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `description_json_content` instead. */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceMicroLearningId: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkButtonText?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateLearningResourceMicroLearningStep. */
export interface CreateLearningResourceMicroLearningStepPayload {
  __typename: 'CreateLearningResourceMicroLearningStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearningStep: Maybe<LearningResourceMicroLearningStep>;
}

/** Autogenerated input type of CreateLearningResourceMicroLearningUserProgress */
export interface CreateLearningResourceMicroLearningUserProgressInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  microLearningId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateLearningResourceMicroLearningUserProgress. */
export interface CreateLearningResourceMicroLearningUserProgressPayload {
  __typename: 'CreateLearningResourceMicroLearningUserProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearningUserProgress: Maybe<LearningResourceMicroLearningUserProgress>;
}

/** Autogenerated input type of CreateLearningResourceSet */
export interface CreateLearningResourceSetInput {
  betaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  learningResourceGlobalCategoryId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  visibleForRoleTypes?: InputMaybe<Array<RoleTypeEnum>>;
}

/** Autogenerated return type of CreateLearningResourceSet. */
export interface CreateLearningResourceSetPayload {
  __typename: 'CreateLearningResourceSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated input type of CreateMemo */
export interface CreateMemoInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Actual text of the `Memo` */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` */
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of CreateMemo. */
export interface CreateMemoPayload {
  __typename: 'CreateMemoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  memo: Maybe<Memo>;
}

/** Autogenerated input type of CreateMultiSource */
export interface CreateMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp this `MultiSource` was closed by the creator */
  closedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  collaborator?: InputMaybe<Scalars['JSON']['input']>;
  /** General commentary */
  comments?: InputMaybe<Scalars['String']['input']>;
  communicator?: InputMaybe<Scalars['JSON']['input']>;
  /** End date of the period this `MultiSource` describes */
  endOn: Scalars['Date']['input'];
  /** Timestamp this `MultiSource` was filled in */
  filledAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  healthAdvocate?: InputMaybe<Scalars['JSON']['input']>;
  leader?: InputMaybe<Scalars['JSON']['input']>;
  /** Extra commentary to include in e-mails */
  mailComments?: InputMaybe<Scalars['String']['input']>;
  medicalExpert?: InputMaybe<Scalars['JSON']['input']>;
  /** Things the resident needs to improve upon */
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio`  this `MultiSource` is attached to */
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** ID of the `Portfolio`  this `MultiSource` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** Things the resident did well */
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  professional?: InputMaybe<Scalars['JSON']['input']>;
  scholar?: InputMaybe<Scalars['JSON']['input']>;
  /** Start date of the period this `MultiSource` describes */
  startOn: Scalars['Date']['input'];
  /** Current status of this `MultiSource` */
  status: MultiSourceStatusEnum;
}

/** Autogenerated return type of CreateMultiSource. */
export interface CreateMultiSourcePayload {
  __typename: 'CreateMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  multiSource: Maybe<MultiSource>;
}

/** Autogenerated input type of CreateMultipleCompetenceCertificates */
export interface CreateMultipleCompetenceCertificatesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the `CompetenceCertificate` that needs to be created */
  competenceCertificateAttributes: Array<CompetenceCertificateAttributes>;
}

/** Autogenerated return type of CreateMultipleCompetenceCertificates. */
export interface CreateMultipleCompetenceCertificatesPayload {
  __typename: 'CreateMultipleCompetenceCertificatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  competenceCertificates: Maybe<Array<CompetenceCertificate>>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateMultipleRegistrations */
export interface CreateMultipleRegistrationsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['ID']['input'];
  registrationAttributes: Array<RegistrationAttributes>;
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of CreateMultipleRegistrations. */
export interface CreateMultipleRegistrationsPayload {
  __typename: 'CreateMultipleRegistrationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  registrations: Maybe<Array<Registration>>;
}

/** Autogenerated input type of CreateNote */
export interface CreateNoteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Actual note of the `Note` */
  noteText?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` */
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of CreateNote. */
export interface CreateNotePayload {
  __typename: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  note: Maybe<Note>;
}

/** Autogenerated input type of CreateOrUpdateFeatureToggle */
export interface CreateOrUpdateFeatureToggleInput {
  /** The date the feature toggle will be activated, null is a valid value. */
  activateOn?: InputMaybe<Scalars['Date']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
}

/** Autogenerated return type of CreateOrUpdateFeatureToggle. */
export interface CreateOrUpdateFeatureTogglePayload {
  __typename: 'CreateOrUpdateFeatureTogglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  featureToggle: Maybe<FeatureToggle>;
}

/** Autogenerated input type of CreateOrUpdateKPBSubSkillScore */
export interface CreateOrUpdateKpbSubSkillScoreInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kpbId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
  skillSubSkillId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateOrUpdateKPBSubSkillScore. */
export interface CreateOrUpdateKpbSubSkillScorePayload {
  __typename: 'CreateOrUpdateKPBSubSkillScorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  kpbSubSkillScore: Maybe<KpbSubSkillScore>;
}

/** Autogenerated input type of CreateOrUpdatePortfolioFormatSpecialtyConfig */
export interface CreateOrUpdatePortfolioFormatSpecialtyConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Leave out to keep the linked `GaiaCategory`s as they are */
  cpdCalendarGaiaCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  portfolioFormatId: Scalars['ID']['input'];
  specialty: Scalars['String']['input'];
  usesCpdCalendar: Scalars['Boolean']['input'];
}

/** Autogenerated return type of CreateOrUpdatePortfolioFormatSpecialtyConfig. */
export interface CreateOrUpdatePortfolioFormatSpecialtyConfigPayload {
  __typename: 'CreateOrUpdatePortfolioFormatSpecialtyConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioFormatSpecialtyConfig: Maybe<PortfolioFormatSpecialtyConfig>;
}

/** Autogenerated input type of CreateOrUpdatePortfolioFormatTerminology */
export interface CreateOrUpdatePortfolioFormatTerminologyInput {
  advancedResidencySupervisors?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  competenceCertificate?: InputMaybe<Scalars['String']['input']>;
  competenceCertificateLevel?: InputMaybe<Scalars['String']['input']>;
  competenceCertificateLevels?: InputMaybe<Scalars['String']['input']>;
  competenceCertificates?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025 */
  courseResultsEpaDetailTableTitle?: InputMaybe<Scalars['String']['input']>;
  educationView?: InputMaybe<Scalars['String']['input']>;
  epa?: InputMaybe<Scalars['String']['input']>;
  epas?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedbackPlural?: InputMaybe<Scalars['String']['input']>;
  feedbackRound?: InputMaybe<Scalars['String']['input']>;
  generalSkill?: InputMaybe<Scalars['String']['input']>;
  generalSkills?: InputMaybe<Scalars['String']['input']>;
  /** iop refers to the actual IOP form (type) */
  iop?: InputMaybe<Scalars['String']['input']>;
  medicalTheme?: InputMaybe<Scalars['String']['input']>;
  medicalThemes?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Scalars['String']['input']>;
  operationsView?: InputMaybe<Scalars['String']['input']>;
  /** personalProfiling refers to the collection of settings related to personalisation of the educational program */
  personalProfiling?: InputMaybe<Scalars['String']['input']>;
  /** planningView refers to the main menu item that includes timeline, personal profiling and IOP */
  planningView?: InputMaybe<Scalars['String']['input']>;
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  portfolioFormatId: Scalars['ID']['input'];
  portfolioOwner?: InputMaybe<Scalars['String']['input']>;
  /** portfolioProfile is the label for the single property portfolio.profile, a string value */
  portfolioProfile?: InputMaybe<Scalars['String']['input']>;
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  principal?: InputMaybe<Scalars['String']['input']>;
  principals?: InputMaybe<Scalars['String']['input']>;
  /**
   * profileGoal is the label for dynamic goal objects that can be used to define
   * multiple differentiating subjects in a portfolio
   */
  profileGoal?: InputMaybe<Scalars['String']['input']>;
  profileGoals?: InputMaybe<Scalars['String']['input']>;
  residencies?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['String']['input']>;
  residencySupervisors?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025 */
  supervisor?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025 */
  supervisors?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreateOrUpdatePortfolioFormatTerminology. */
export interface CreateOrUpdatePortfolioFormatTerminologyPayload {
  __typename: 'CreateOrUpdatePortfolioFormatTerminologyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioFormatTerminology: Maybe<PortfolioFormatTerminology>;
}

/** Autogenerated input type of CreateOrUpdatePortfolioRole */
export interface CreateOrUpdatePortfolioRoleInput {
  /** active of the `PortfolioRole` */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** `RoleFormat` that is the active Roleformat for the `PortfolioRole` */
  activeRoleFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The excluding_end_date to indicate until when the `PortfolioRole` is active. */
  excludingEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** The including_start_date to indicate from when the `PortfolioRole` is active. */
  includingStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `Portfolio` the new `PortfolioRole` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** `ProgramRole` that belongs to `PortfolioRole` */
  programRoleId: Scalars['ID']['input'];
  /** read_access_level of the `PortfolioRole` */
  readAccessLevel?: InputMaybe<ReadAccessLevelEnum>;
  /**
   * whether the read_access_level of the PortfolioRole is customized. If passed in
   * as false read_access_level should be omitted.
   */
  readAccessLevelCustomized?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateOrUpdatePortfolioRole. */
export interface CreateOrUpdatePortfolioRolePayload {
  __typename: 'CreateOrUpdatePortfolioRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRole: Maybe<PortfolioRole>;
}

/** Autogenerated input type of CreateOrUpdatePortfolioRoleSync */
export interface CreateOrUpdatePortfolioRoleSyncInput {
  /** active of the `PortfolioRoleSync` */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` the new `PortfolioRoleSync` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** `Program` that belongs to `PortfolioRoleSync` */
  programId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateOrUpdatePortfolioRoleSync. */
export interface CreateOrUpdatePortfolioRoleSyncPayload {
  __typename: 'CreateOrUpdatePortfolioRoleSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRoleSync: Maybe<PortfolioRoleSync>;
}

/** Autogenerated input type of CreateOrUpdateSkillLevelFormatDescription */
export interface CreateOrUpdateSkillLevelFormatDescriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['ID']['input'];
  skillLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateOrUpdateSkillLevelFormatDescription. */
export interface CreateOrUpdateSkillLevelFormatDescriptionPayload {
  __typename: 'CreateOrUpdateSkillLevelFormatDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skillLevelFormatDescription: Maybe<SkillLevelFormatDescription>;
}

/** Autogenerated input type of CreateOrganization */
export interface CreateOrganizationInput {
  /** ID of the `DirectUpload` of the avatar */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the `Organization`. */
  name: Scalars['String']['input'];
  /** The ID of the parent organization for this `Organization`. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of CreateOrganization. */
export interface CreateOrganizationPayload {
  __typename: 'CreateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The `Organization` that was created. */
  organization: Maybe<Organization>;
}

/** Autogenerated input type of CreateOrganizationUserRole */
export interface CreateOrganizationUserRoleInput {
  canManageRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canViewReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateOrganizationUserRole. */
export interface CreateOrganizationUserRolePayload {
  __typename: 'CreateOrganizationUserRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationUserRole: Maybe<OrganizationUserRole>;
}

/** Autogenerated input type of CreateParentDomain */
export interface CreateParentDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardFormat` for this `ParentDomain` */
  dashboardFormatId: Scalars['ID']['input'];
  /** Description for this `ParentDomain` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Order number for this `ParentDomain` */
  order: Scalars['Int']['input'];
  /** Title for this `ParentDomain` */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateParentDomain. */
export interface CreateParentDomainPayload {
  __typename: 'CreateParentDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  parentDomain: Maybe<ParentDomain>;
}

/** Autogenerated input type of CreateParticipationLevelFormat */
export interface CreateParticipationLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  rootSkillCategoryConfigId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateParticipationLevelFormat. */
export interface CreateParticipationLevelFormatPayload {
  __typename: 'CreateParticipationLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  participationLevelFormat: Maybe<ParticipationLevelFormat>;
}

/** Autogenerated input type of CreatePeriodFormat */
export interface CreatePeriodFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  monthDuration: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  portfolioFormatId: Scalars['ID']['input'];
  shortLabel: Scalars['String']['input'];
}

/** Autogenerated return type of CreatePeriodFormat. */
export interface CreatePeriodFormatPayload {
  __typename: 'CreatePeriodFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  periodFormat: Maybe<PeriodFormat>;
}

/** Autogenerated input type of CreatePeriodRequiredSkillLevel */
export interface CreatePeriodRequiredSkillLevelInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  periodFormatId: Scalars['ID']['input'];
  skillId: Scalars['ID']['input'];
  skillLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePeriodRequiredSkillLevel. */
export interface CreatePeriodRequiredSkillLevelPayload {
  __typename: 'CreatePeriodRequiredSkillLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  periodRequiredSkillLevel: Maybe<PeriodRequiredSkillLevel>;
}

/** Autogenerated input type of CreatePortfolioDocumentConfig */
export interface CreatePortfolioDocumentConfigInput {
  aiContext?: InputMaybe<Scalars['String']['input']>;
  allowBatch?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentIsEssential?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveAttachedFiles?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveFeedbackRound?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, all document will be connectable to goals */
  canHaveGoalActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, all document will be connectable to profile goals */
  canHaveProfileGoalActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, reduction will be determined by the presence of REDUCTION group, november 2024 */
  canHaveReduction?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveSelfAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  canUseTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: PortfolioDocumentTypeEnum;
  feedbackForm?: InputMaybe<Scalars['JSON']['input']>;
  form: Scalars['JSON']['input'];
  formType: Scalars['String']['input'];
  formTypeName: Scalars['String']['input'];
  /** @deprecated This field will be removed, remove this no earlier than the 11th of november 2024 */
  formVersion?: InputMaybe<Scalars['Int']['input']>;
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  isAvailableInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Freemium feature is being removed, remove this at the latest in november 2024 */
  isAvailableInFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatableBySupport?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  pluralName?: InputMaybe<Scalars['String']['input']>;
  portfolioFormatId: Scalars['ID']['input'];
  referrableFormTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredNumber?: InputMaybe<Scalars['Int']['input']>;
  showInMainCreateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  skillType?: InputMaybe<SkillTypeEnum>;
  skipSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorIsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorType: SupervisorTypeEnum;
  supportsInvite?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `ai_context` instead, remove this argument after 2026-12-01 */
  transcriptionPromptContext?: InputMaybe<Scalars['String']['input']>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreatePortfolioDocumentConfig. */
export interface CreatePortfolioDocumentConfigPayload {
  __typename: 'CreatePortfolioDocumentConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
}

/** Autogenerated input type of CreatePortfolioFormat */
export interface CreatePortfolioFormatInput {
  /** ID of the `DirectUpload` of the avatar */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the `PortfolioFormat` can have residencies */
  canHaveResidencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  educationDurationStartMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Guidelines code ID of the `PortfolioFormat` */
  guidelinesCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Language of the `PortfolioFormat` */
  language?: InputMaybe<LanguageEnum>;
  /** Target role type of the `PortfolioFormat` */
  mailingType: TargetRoleEnum;
  /** Name of the `PortfolioFormat` */
  name: Scalars['String']['input'];
  nominalDuration?: InputMaybe<Scalars['Int']['input']>;
  onboardingShowProfile?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingShowProfileGoals?: InputMaybe<Scalars['Boolean']['input']>;
  profileAllowCustom?: InputMaybe<Scalars['Boolean']['input']>;
  profiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the `Course` that acts as the root of the tree */
  rootCourseId?: InputMaybe<Scalars['ID']['input']>;
  /** Short name of the `PortfolioFormat` */
  shortName: Scalars['String']['input'];
  usesPortfolioNotes?: InputMaybe<Scalars['Boolean']['input']>;
  usesProfile?: InputMaybe<Scalars['Boolean']['input']>;
  usesProfileGoals?: InputMaybe<Scalars['Boolean']['input']>;
  usesStartEndDate?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreatePortfolioFormat. */
export interface CreatePortfolioFormatPayload {
  __typename: 'CreatePortfolioFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioFormat` that was created */
  portfolioFormat: Maybe<PortfolioFormat>;
}

/** Autogenerated input type of CreatePortfolioImport */
export interface CreatePortfolioImportInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` zip file */
  importFile: Scalars['String']['input'];
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePortfolioImport. */
export interface CreatePortfolioImportPayload {
  __typename: 'CreatePortfolioImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Import` from which we will create objects */
  portfolioImport: Maybe<PortfolioImport>;
}

/** Autogenerated input type of CreatePortfolio */
export interface CreatePortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort of the `Portfolio` */
  cohort?: InputMaybe<Scalars['String']['input']>;
  /** Custom settings for the `Portfolio` */
  customSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** `Date` the education period of the `Portfolio` has ended or will end */
  educationEndedOn?: InputMaybe<Scalars['Date']['input']>;
  /** `Date` the education period of the `Portfolio` starts */
  educationStartedOn?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `Organization` in which to place the new `Portfolio` */
  organizationId: Scalars['ID']['input'];
  /** ID of the `User` to which the `Portfolio` belongs */
  ownerId: Scalars['ID']['input'];
  /** ID of the `PortfolioFormat` of the new `Portfolio` */
  portfolioFormatId: Scalars['ID']['input'];
  /** Profile of the `Portfolio` */
  profile?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Do not send the normal emails if true */
  suppressMail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Multipurpose information field for the `Portfolio` */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated input type of CreatePortfolioNote */
export interface CreatePortfolioNoteInput {
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  noteJsonContent: Scalars['JSON']['input'];
  portfolioId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of CreatePortfolioNote. */
export interface CreatePortfolioNotePayload {
  __typename: 'CreatePortfolioNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioNote: Maybe<PortfolioNote>;
}

/** Autogenerated return type of CreatePortfolio. */
export interface CreatePortfolioPayload {
  __typename: 'CreatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of CreatePortfolioRemovalRequest */
export interface CreatePortfolioRemovalRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerPin: Scalars['String']['input'];
  /** ID of the `Portfolio` to removal */
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePortfolioRemovalRequest. */
export interface CreatePortfolioRemovalRequestPayload {
  __typename: 'CreatePortfolioRemovalRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of CreatePortfolioRoleSync */
export interface CreatePortfolioRoleSyncInput {
  /** active of the `PortfolioRoleSync` */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` the new `PortfolioRoleSync` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** `Program` that belongs to `PortfolioRoleSync` */
  programId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreatePortfolioRoleSync. */
export interface CreatePortfolioRoleSyncPayload {
  __typename: 'CreatePortfolioRoleSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRoleSync: Maybe<PortfolioRoleSync>;
}

/** Autogenerated input type of CreatePortfolioRoleSyncsForPrograms */
export interface CreatePortfolioRoleSyncsForProgramsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['ID']['input'];
  programIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of CreatePortfolioRoleSyncsForPrograms. */
export interface CreatePortfolioRoleSyncsForProgramsPayload {
  __typename: 'CreatePortfolioRoleSyncsForProgramsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of CreatePortfolioTransferRequest */
export interface CreatePortfolioTransferRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Organization` to transfer to */
  organizationId: Scalars['ID']['input'];
  /** ID of the `Portfolio` to transfer */
  portfolioId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  requestReason?: InputMaybe<Scalars['String']['input']>;
  /** `RoleFormat` this `PortfolioTransfer` is linked to. */
  roleFormatId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<PortfolioTransferStatusEnum>;
  /** ID of the `User` that decides on this request */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of CreatePortfolioTransferRequest. */
export interface CreatePortfolioTransferRequestPayload {
  __typename: 'CreatePortfolioTransferRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioTransferRequest: Maybe<PortfolioTransferRequest>;
}

/** Autogenerated input type of CreateProgram */
export interface CreateProgramInput {
  /** Boolean to check whether or not the PortfolioFormat is available */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Boolean to check whether or not a `Portfolio` of the `PortfolioFormat` is
   * creatable_without_invoice_plan. Can only be true if available is true.
   */
  creatableWithoutInvoicePlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` to link to the `Program` */
  organizationId: Scalars['ID']['input'];
  /** ID of the `PortfolioFormat` to link to the `Program` */
  portfolioFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateProgram. */
export interface CreateProgramPayload {
  __typename: 'CreateProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  program: Maybe<Program>;
}

/** Autogenerated input type of CreateProgramRole */
export interface CreateProgramRoleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Program` the new `ProgramRole` is attached to */
  programId: Scalars['ID']['input'];
  /** ID of the `RoleFormat` the new `ProgramRole` is attached to */
  roleFormatId: Scalars['ID']['input'];
  /** ID of the `User` the new `ProgramRole` is attached to */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateProgramRole. */
export interface CreateProgramRolePayload {
  __typename: 'CreateProgramRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  programRole: Maybe<ProgramRole>;
}

/** Autogenerated input type of CreateQualityInstrument */
export interface CreateQualityInstrumentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dashboardId: Scalars['ID']['input'];
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionTemplateJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateQualityInstrument. */
export interface CreateQualityInstrumentPayload {
  __typename: 'CreateQualityInstrumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  qualityInstrument: Maybe<QualityInstrument>;
}

/** Autogenerated input type of CreateRegistration */
export interface CreateRegistrationInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this activity was performed on */
  date: Scalars['Date']['input'];
  participationLevelFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** Super vision levels of individual parts of the operation */
  parts?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the `Portfolio`  this activity is attached to */
  portfolioDocumentConfigId: Scalars['ID']['input'];
  /** ID of the `Portfolio`  this activity is attached to */
  portfolioId: Scalars['ID']['input'];
  /** Quantity of the registration */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The level of independence according to <some standard> */
  supervisionLevel?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `User` that supervised this activity */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Title for this `Registration` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Freeform field for storing different topics */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateRegistration. */
export interface CreateRegistrationPayload {
  __typename: 'CreateRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  registration: Maybe<Registration>;
}

/** Autogenerated input type of CreateReminderNotification */
export interface CreateReminderNotificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Subject object of the to be created reminder `Notification` */
  subjectId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateReminderNotification. */
export interface CreateReminderNotificationPayload {
  __typename: 'CreateReminderNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  notification: Maybe<Notification>;
}

/** Autogenerated input type of CreateResidencyArchetype */
export interface CreateResidencyArchetypeInput {
  /** Specialized (advanced) or normal residency */
  advanced?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated maximum of needed months to complete this type of residency */
  monthsMax: Scalars['Int']['input'];
  /** Estimated minimum of needed months to complete this type of residency */
  monthsMin: Scalars['Int']['input'];
  /** Specified order of ResidencyArchetype */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** `PortfolioFormat` this archetype belongs to */
  portfolioFormatId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of this ResidencyArchetype */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateResidencyArchetype. */
export interface CreateResidencyArchetypePayload {
  __typename: 'CreateResidencyArchetypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  residencyArchetype: Maybe<ResidencyArchetype>;
}

/** Autogenerated input type of CreateResidency */
export interface CreateResidencyInput {
  /** True if the residency is advanced */
  advanced?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of the `User`s that are advanced supervisors of this `Residency` */
  advancedSupervisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `Residency` ends */
  endOn: Scalars['Date']['input'];
  /** IDs of the `Goals` for this `Residency` */
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** True if the residency is an intermission */
  intermission?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` for this `Residency` */
  organizationId: Scalars['ID']['input'];
  percentage?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `Portfolio` this `Residency` is attached to */
  portfolioId: Scalars['ID']['input'];
  /** Residency archetype which is to be used as template for this residency */
  residencyArchetypeId?: InputMaybe<Scalars['ID']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** `Date` this `Residency` starts */
  startOn: Scalars['Date']['input'];
  /** IDs of the `User`s that supervise this `Residency` */
  supervisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateResidency. */
export interface CreateResidencyPayload {
  __typename: 'CreateResidencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  residency: Maybe<Residency>;
}

/** Autogenerated input type of CreateRoleFormat */
export interface CreateRoleFormatInput {
  /** Whether the `RoleFormat` should automatically create a `PortfolioRole` or not. */
  automaticallyCreatePortfolioRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** BIG requirement of the `RoleFormat`. */
  big?: InputMaybe<RoleFormatBigEnum>;
  /** Whether the `RoleFormat` can add `CourseResult`s or not. */
  canAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can assess or not. */
  canAssess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can assign other supervisors or not. */
  canAssignOtherSupervisors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can authorize or not. */
  canAuthorize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether users with this `RoleFormat` can create their own `Portfolio`. */
  canCreateOwnPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can edit `Goal`s or not. */
  canEditGoals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can edit practical information or not. */
  canEditPracticalInformation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can manage `MultiSource`s or not. */
  canManageMultiSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can supervise residencies or not. */
  canSuperviseResidencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `RoleFormat`. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the `RoleFormat` is expected to have a `Portfolio` or not. */
  expectedToHavePortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /** `RoleFormat`s that can be upgraded by this `RoleFormat`. */
  mainRoleFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the `RoleFormat`. */
  name: Scalars['String']['input'];
  /** Order index number of the `RoleFormat`. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `PortfolioFormat` the new `RoleFormat` is attached to. */
  portfolioFormatId: Scalars['ID']['input'];
  /** Read access level of the `RoleFormat`. */
  readAccessLevel?: InputMaybe<ReadAccessLevelEnum>;
  requireInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Role type of the `RoleFormat`. */
  roleType: RoleTypeEnum;
  /** Whether the `RoleFormat` is selectable as main `RoleFormat` or not. */
  selectableAsMain?: InputMaybe<Scalars['Boolean']['input']>;
  /** Short name of the `RoleFormat`. */
  shortName: Scalars['String']['input'];
  /** `RoleFormat`s that can be an upgrade for this `RoleFormat`. */
  upgradeRoleFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of CreateRoleFormat. */
export interface CreateRoleFormatPayload {
  __typename: 'CreateRoleFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  roleFormat: Maybe<RoleFormat>;
}

/** Autogenerated input type of CreateRootSkillCategoryConfig */
export interface CreateRootSkillCategoryConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  composeInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The kind of level display for the `RootSkillCategoryConfig`. */
  levelDisplay?: InputMaybe<LevelDisplayEnum>;
  setLevelsInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  setRegistrationsInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showAverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the `SkillCategory` this `RootSkillCategoryConfig` is attached to. */
  skillCategoryId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateRootSkillCategoryConfig. */
export interface CreateRootSkillCategoryConfigPayload {
  __typename: 'CreateRootSkillCategoryConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
}

/** Autogenerated input type of CreateSecurityQuestion */
export interface CreateSecurityQuestionInput {
  /** Answer of this `SecurityQuestion` */
  answer: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Question of this `SecurityQuestion` */
  question: Scalars['String']['input'];
  /** Question of this `SecurityQuestion` */
  secondFactorId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateSecurityQuestion. */
export interface CreateSecurityQuestionPayload {
  __typename: 'CreateSecurityQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  securityQuestion: Maybe<SecurityQuestion>;
}

/** Autogenerated input type of CreateSelfAssessment */
export interface CreateSelfAssessmentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** General feedback */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `CompetenceCertificate` or `Interview` for this self-assessment */
  subjectId: Scalars['ID']['input'];
  /** Positive, neutral or negative response */
  thumbs?: InputMaybe<ThumbsEnum>;
  /** Feedback given on specific topics */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of CreateSelfAssessment. */
export interface CreateSelfAssessmentPayload {
  __typename: 'CreateSelfAssessmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The created `FeedbackRequest` */
  feedbackRequest: Maybe<FeedbackRequest>;
}

/** Autogenerated input type of CreateSkillCategory */
export interface CreateSkillCategoryInput {
  /** Allows custom skills to be added to the `SkillCategory` */
  allowCustomSkills?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `SkillCategory` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the `SkillCategory` */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order of the `SkillCategory` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** parent_id of the `SkillCategory` */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** portfolio_format_id of the `SkillCategory` */
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** selectable_skill_id of the `SkillCategory` */
  selectableSkillId?: InputMaybe<Scalars['ID']['input']>;
  /** skill_type of the `SkillCategory` */
  skillType?: InputMaybe<SkillTypeEnum>;
  /** sorted_by of the `SkillCategory` */
  sortedBy: SkillCategorySortedByEnum;
}

/** Autogenerated return type of CreateSkillCategory. */
export interface CreateSkillCategoryPayload {
  __typename: 'CreateSkillCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skillCategory: Maybe<SkillCategory>;
}

/** Autogenerated input type of CreateSkill */
export interface CreateSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `Skill` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation (in HTML) of the `Skill` */
  documentationHtml?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the `Skill` */
  fullName: Scalars['String']['input'];
  /** Guideline ID of the `Skill` */
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Boolean to check if it is a mandatory `Skill`. The skill will be automatically
   * linked to portfolios that are created after mandatory on the skill is marked as true
   */
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the `Skill` */
  name: Scalars['String']['input'];
  /** Order of the `Skill` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parts of the `Skill` */
  parts?: InputMaybe<Scalars['JSON']['input']>;
  /** Short name of the `Skill` */
  shortName: Scalars['String']['input'];
  /** Skill categories of the `Skill` */
  skillCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Skill type of the `Skill` */
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated input type of CreateSkillLevelFormat */
export interface CreateSkillLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Display value of the `SkillLevelFormat` */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  /** Label display of the `SkillLevelFormat` */
  label: Scalars['String']['input'];
  /** Number of the `SkillLevelFormat` */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the `RootSkillCategoryConfig` this `SkillLevelFormat` is attached to. */
  rootSkillCategoryConfigId: Scalars['ID']['input'];
  /** Status of the `SkillLevelFormat` */
  status?: InputMaybe<SkillLevelFormatStatusEnum>;
}

/** Autogenerated return type of CreateSkillLevelFormat. */
export interface CreateSkillLevelFormatPayload {
  __typename: 'CreateSkillLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skillLevelFormat: Maybe<SkillLevelFormat>;
}

/** Autogenerated return type of CreateSkill. */
export interface CreateSkillPayload {
  __typename: 'CreateSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of CreateSubDomain */
export interface CreateSubDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description for this `SubDomain` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Order number for this `SubDomain` */
  order: Scalars['Int']['input'];
  /** ID of the `ParentDomain` for this `SubDomain` */
  parentDomainId: Scalars['ID']['input'];
  /** Title for this `SubDomain` */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateSubDomain. */
export interface CreateSubDomainPayload {
  __typename: 'CreateSubDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  subDomain: Maybe<SubDomain>;
}

/** Autogenerated input type of CreateSubMultiSource */
export interface CreateSubMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user this sub-`MultiSource` will be send to */
  email: Scalars['String']['input'];
  /** ID of the `MultiSource` to attach this sub-`MultiSource` to */
  multiSourceId: Scalars['ID']['input'];
  /** The kind of respondent this survey is meant for */
  respondentType: RespondentTypeEnum;
}

/** Autogenerated return type of CreateSubMultiSource. */
export interface CreateSubMultiSourcePayload {
  __typename: 'CreateSubMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of CreateUsageStatistic */
export interface CreateUsageStatisticInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['ID']['input'];
  recordingStartedAt: Scalars['ISO8601DateTime']['input'];
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateUsageStatistic. */
export interface CreateUsageStatisticPayload {
  __typename: 'CreateUsageStatisticPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  usageStatistic: Maybe<UsageStatistic>;
}

/** Autogenerated input type of CreateUser */
export interface CreateUserInput {
  /** BIG number of the user */
  big?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custom settings for the user */
  customSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** First name of the user */
  firstName: Scalars['String']['input'];
  /** Insertion of the user (used for Dutch names) */
  insertion?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user */
  lastName: Scalars['String']['input'];
  /** Boolean to indicate if the user account is onboarded */
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** PIN number of the user */
  pin?: InputMaybe<Scalars['String']['input']>;
  portfolioEmailFrequency?: InputMaybe<PortfolioEmailFrequencyEnum>;
  /** The preferred language of the user */
  preferredLanguage?: InputMaybe<PreferredLanguageEnum>;
  /** Secondary email address of the user */
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  sendManageRolesNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Academic) title of the user */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Boolean to indicate if the user account is trusted */
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boolean to indicate if the big is verified */
  verifiedBig?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceEmailFrequency?: InputMaybe<WorkspaceEmailFrequencyEnum>;
}

/** Autogenerated return type of CreateUser. */
export interface CreateUserPayload {
  __typename: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of CreateUserWithProgramRole */
export interface CreateUserWithProgramRoleInput {
  big?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  insertion?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  preferredLanguage?: InputMaybe<PreferredLanguageEnum>;
  programId: Scalars['ID']['input'];
  roleFormatId: Scalars['ID']['input'];
  verifiedBig?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of CreateUserWithProgramRole. */
export interface CreateUserWithProgramRolePayload {
  __typename: 'CreateUserWithProgramRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of CreateWorkspace */
export interface CreateWorkspaceInput {
  /** `accreditation_end_date` of this `Workspace` */
  accreditationEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Alternative title of this `Workspace` */
  alternativeTitle?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `contact_email` of this `Workspace` */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** `contact_information` of this `Workspace` */
  contactInformation?: InputMaybe<Scalars['String']['input']>;
  /** `Dashboard` that is linked to this `Workspace` */
  dashboardId: Scalars['ID']['input'];
  /** Description of this `Workspace` */
  description?: InputMaybe<Scalars['String']['input']>;
  shareOnDashboard?: InputMaybe<WorkspaceDashboardShareOnDashboardEnum>;
  /** Title of this `Workspace` */
  title: Scalars['String']['input'];
}

/** Autogenerated return type of CreateWorkspace. */
export interface CreateWorkspacePayload {
  __typename: 'CreateWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  workspace: Maybe<Workspace>;
}

/** Autogenerated input type of CreateWorkspaceRole */
export interface CreateWorkspaceRoleInput {
  /** RoleType for this `WorkspaceRole` */
  accessLevel: WorkspaceRoleAccessLevelEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Title for this `WorkspaceRole` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `User` for this `WorkspaceRole` */
  userId: Scalars['ID']['input'];
  /** ID of the `Workspace` for this `WorkspaceRole` */
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of CreateWorkspaceRole. */
export interface CreateWorkspaceRolePayload {
  __typename: 'CreateWorkspaceRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  workspaceRole: Maybe<WorkspaceRole>;
}

export interface Dashboard extends Node, Timestamped {
  __typename: 'Dashboard';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboard_format (`WorkspaceDashboard::DashboardFormat`) that this `WorkspaceDashboard::Dashboard` belongs to */
  dashboardFormat: Maybe<DashboardFormat>;
  /** The dashboard_roles of this `WorkspaceDashboard::Dashboard`. */
  dashboardRoles: DashboardRoleConnection;
  /** The description of this `WorkspaceDashboard::Dashboard`. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Id of the workspace which should be considered featured, and shown first.
   * Please note that this not guaranteed either an existing or an accessible
   * workspace. It is the responsibility of the frontend to sort the existing
   * workspaces using this id.
   */
  featuredWorkspaceId: Maybe<Scalars['String']['output']>;
  /** Whether `WorkspaceDashboard::Dashboard` is has multiple workspaces. */
  hasMultipleWorkspaces: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The parent_domains of this `WorkspaceDashboard::Dashboard`. */
  parentDomains: ParentDomainConnection;
  /** The quality_instruments of this `WorkspaceDashboard::Dashboard`. */
  qualityInstruments: QualityInstrumentConnection;
  /** The secondary_workspaces of this `WorkspaceDashboard::Dashboard`. */
  secondaryWorkspaces: WorkspaceConnection;
  /** The title of this `WorkspaceDashboard::Dashboard`. */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether `WorkspaceDashboard::Dashboard` is use alternative title. */
  useAlternativeTitle: Scalars['Boolean']['output'];
  /** Whether `WorkspaceDashboard::Dashboard` is viewer can manage. */
  viewerCanManage: Scalars['Boolean']['output'];
  /** Whether `WorkspaceDashboard::Dashboard` is viewer can read. */
  viewerCanRead: Scalars['Boolean']['output'];
  /** The workspaces of this `WorkspaceDashboard::Dashboard`. */
  workspaces: WorkspaceConnection;
}

export interface DashboardDashboardRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DashboardRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface DashboardParentDomainsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface DashboardQualityInstrumentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface DashboardSecondaryWorkspacesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface DashboardWorkspacesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Dashboard. */
export interface DashboardConnection {
  __typename: 'DashboardConnection';
  /** A list of edges. */
  edges: Array<DashboardEdge>;
  /** A list of nodes. */
  nodes: Array<Dashboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface DashboardEdge {
  __typename: 'DashboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Dashboard>;
}

export interface DashboardFormat extends Node, Timestamped {
  __typename: 'DashboardFormat';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboards of this `WorkspaceDashboard::DashboardFormat`. */
  dashboards: DashboardConnection;
  /** The description of this `WorkspaceDashboard::DashboardFormat`. */
  description: Scalars['String']['output'];
  /**
   * The guideline_id of this `WorkspaceDashboard::DashboardFormat`.
   * @deprecated This field is deprecated and will be removed after 2025-06-01
   */
  guidelineId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The parent_domains of this `WorkspaceDashboard::DashboardFormat`. */
  parentDomains: ParentDomainConnection;
  /** The short_name of this `WorkspaceDashboard::DashboardFormat`. */
  shortName: Scalars['String']['output'];
  /** The title of this `WorkspaceDashboard::DashboardFormat`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface DashboardFormatDashboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface DashboardFormatParentDomainsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for DashboardFormat. */
export interface DashboardFormatConnection {
  __typename: 'DashboardFormatConnection';
  /** A list of edges. */
  edges: Array<DashboardFormatEdge>;
  /** A list of nodes. */
  nodes: Array<DashboardFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface DashboardFormatEdge {
  __typename: 'DashboardFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DashboardFormat>;
}

export interface DashboardRole extends Node, Timestamped {
  __typename: 'DashboardRole';
  /** The access_level of this `WorkspaceDashboard::DashboardRole`. */
  accessLevel: DashboardRoleAccessLevelEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboard (`WorkspaceDashboard::Dashboard`) that this `WorkspaceDashboard::DashboardRole` belongs to */
  dashboard: Dashboard;
  id: Scalars['ID']['output'];
  /** The title of this `WorkspaceDashboard::DashboardRole`. */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `WorkspaceDashboard::DashboardRole` belongs to */
  user: User;
}

export enum DashboardRoleAccessLevelEnum {
  /** The access_level of the `DashboardRole` is manage */
  MANAGE = 'MANAGE',
  /** The access_level of the `DashboardRole` is read */
  READ = 'READ',
}

/** The connection type for DashboardRole. */
export interface DashboardRoleConnection {
  __typename: 'DashboardRoleConnection';
  /** A list of edges. */
  edges: Array<DashboardRoleEdge>;
  /** A list of nodes. */
  nodes: Array<DashboardRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface DashboardRoleEdge {
  __typename: 'DashboardRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DashboardRole>;
}

/** Filter for `DashboardRoles` */
export interface DashboardRoleFilter {
  /** Only return objects with given access_levels */
  accessLevel?: InputMaybe<Array<DashboardRoleAccessLevelEnum>>;
}

export interface DashboardRoleInput {
  accessLevel: DashboardRoleAccessLevelEnum;
  dashboardId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of DeactivatePortfolioRole */
export interface DeactivatePortfolioRoleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioRole` to Deactivate */
  portfolioRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DeactivatePortfolioRole. */
export interface DeactivatePortfolioRolePayload {
  __typename: 'DeactivatePortfolioRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRole: Maybe<PortfolioRole>;
}

/** Autogenerated input type of DestroyAttachedFile */
export interface DestroyAttachedFileInput {
  /** ID of the `AttachedFile` that needs to be destroyed */
  attachedFileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyAttachedFile. */
export interface DestroyAttachedFilePayload {
  __typename: 'DestroyAttachedFilePayload';
  /** `AttachedFile` that was destroyed */
  attachedFile: Maybe<AttachedFile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyAudioTranscript */
export interface DestroyAudioTranscriptInput {
  /** ID of the `AudioTranscript` that needs to be destroyed */
  audioTranscriptId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyAudioTranscript. */
export interface DestroyAudioTranscriptPayload {
  __typename: 'DestroyAudioTranscriptPayload';
  /** `AudioTranscript` that was destroyed */
  audioTranscript: Maybe<AudioTranscript>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCardComment */
export interface DestroyCardCommentInput {
  /** ID of the `CardComment` that needs to be destroyed */
  cardCommentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyCardComment. */
export interface DestroyCardCommentPayload {
  __typename: 'DestroyCardCommentPayload';
  /** `CardComment` that was destroyed */
  cardComment: Maybe<CardComment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCardTask */
export interface DestroyCardTaskInput {
  /** ID of the `CardTask` to destroy */
  cardTaskId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyCardTask. */
export interface DestroyCardTaskPayload {
  __typename: 'DestroyCardTaskPayload';
  cardTask: Maybe<CardTask>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCccFormConfig */
export interface DestroyCccFormConfigInput {
  /** ID of the `CccFormConfig` that needs to be destroyed */
  cccFormConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyCccFormConfig. */
export interface DestroyCccFormConfigPayload {
  __typename: 'DestroyCccFormConfigPayload';
  /** `CccFormConfig` that was destroyed */
  cccFormConfig: Maybe<CccFormConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyClinicalCompetenceCommittee */
export interface DestroyClinicalCompetenceCommitteeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ClinicalCompetenceCommittee` that needs to be destroyed */
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyClinicalCompetenceCommittee. */
export interface DestroyClinicalCompetenceCommitteePayload {
  __typename: 'DestroyClinicalCompetenceCommitteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `ClinicalCompetenceCommittee` that was destroyed */
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyClinicalCompetenceCommitteeRespondent */
export interface DestroyClinicalCompetenceCommitteeRespondentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ClinicalCompetenceCommitteeRespondent` that needs to be destroyed */
  clinicalCompetenceCommitteeRespondentId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyClinicalCompetenceCommitteeRespondent. */
export interface DestroyClinicalCompetenceCommitteeRespondentPayload {
  __typename: 'DestroyClinicalCompetenceCommitteeRespondentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `ClinicalCompetenceCommitteeRespondent` that was destroyed */
  clinicalCompetenceCommitteeRespondent: Maybe<ClinicalCompetenceCommitteeRespondent>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCompetenceCertificate */
export interface DestroyCompetenceCertificateInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `CompetenceCertificate` that needs to be destroyed */
  competenceCertificateId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyCompetenceCertificate. */
export interface DestroyCompetenceCertificatePayload {
  __typename: 'DestroyCompetenceCertificatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `CompetenceCertificate` that was destroyed */
  competenceCertificate: Maybe<CompetenceCertificate>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCourse */
export interface DestroyCourseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Course` that needs to be destroyed */
  courseId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyCourse. */
export interface DestroyCoursePayload {
  __typename: 'DestroyCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `Course` that was destroyed */
  course: Maybe<Course>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCourseResult */
export interface DestroyCourseResultInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `CourseResult` that needs to be destroyed */
  courseResultId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyCourseResult. */
export interface DestroyCourseResultPayload {
  __typename: 'DestroyCourseResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `CourseResult` that was destroyed */
  courseResult: Maybe<CourseResult>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyCustomSkill */
export interface DestroyCustomSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Skill` that needs to be destroyed */
  skillId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyCustomSkill. */
export interface DestroyCustomSkillPayload {
  __typename: 'DestroyCustomSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Skill` that was destroyed */
  skill: Maybe<Skill>;
}

/** Autogenerated input type of DestroyDashboardFormat */
export interface DestroyDashboardFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardFormat` that needs to be destroyed */
  dashboardFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyDashboardFormat. */
export interface DestroyDashboardFormatPayload {
  __typename: 'DestroyDashboardFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `DashboardFormat` that was destroyed */
  dashboardFormat: Maybe<DashboardFormat>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyDashboard */
export interface DestroyDashboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Dashboard` that needs to be destroyed */
  dashboardId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyDashboard. */
export interface DestroyDashboardPayload {
  __typename: 'DestroyDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** `Dashboard` that was destroyed */
  dashboard: Maybe<Dashboard>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyDashboardRole */
export interface DestroyDashboardRoleInput {
  /** Also destroy this user's `WorkspaceRole`s in workspaces of this dashboard where the viewer has manage rights */
  alsoWorkspaceRolesWhereViewerCanManage?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardRole` that needs to be destroyed */
  dashboardRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyDashboardRole. */
export interface DestroyDashboardRolePayload {
  __typename: 'DestroyDashboardRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboardRole: Maybe<DashboardRole>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyEventCard */
export interface DestroyEventCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `EventCard` that needs to be destroyed */
  eventCardId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyEventCard. */
export interface DestroyEventCardPayload {
  __typename: 'DestroyEventCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `EventCard` that was destroyed */
  eventCard: Maybe<EventCard>;
}

/** Autogenerated input type of DestroyExternalOauthConnection */
export interface DestroyExternalOauthConnectionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ExternalOauthApplication` to find the `ExternalOauthAccessToken` */
  externalOauthApplicationId: Scalars['ID']['input'];
  /** ID of the `Portfolio` to find the `ExternalOauthAccessToken` */
  portfolioId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyExternalOauthConnection. */
export interface DestroyExternalOauthConnectionPayload {
  __typename: 'DestroyExternalOauthConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  externalOauthApplication: ExternalOauthApplication;
  portfolio: Portfolio;
}

/** Autogenerated input type of DestroyFeatureToggle */
export interface DestroyFeatureToggleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeatureToggle` that needs to be destroyed */
  featureToggleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyFeatureToggle. */
export interface DestroyFeatureTogglePayload {
  __typename: 'DestroyFeatureTogglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `FeatureToggle` that was destroyed */
  featureToggle: Maybe<FeatureToggle>;
}

/** Autogenerated input type of DestroyFeedbackRequest */
export interface DestroyFeedbackRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeedbackRequest` that needs to be destroyed */
  feedbackRequestId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyFeedbackRequest. */
export interface DestroyFeedbackRequestPayload {
  __typename: 'DestroyFeedbackRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `FeedbackRequest` that was destroyed */
  feedbackRequest: Maybe<FeedbackRequest>;
}

/** Autogenerated input type of DestroyGaiaFile */
export interface DestroyGaiaFileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of DestroyGaiaFile. */
export interface DestroyGaiaFilePayload {
  __typename: 'DestroyGaiaFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  gaiaActivities: Maybe<Array<GaiaActivity>>;
  gaiaFileSync: Maybe<GaiaFileSync>;
  gaiaTargets: Maybe<Array<GaiaTarget>>;
}

/** Autogenerated input type of DestroyGeneralFeedbackFormConfig */
export interface DestroyGeneralFeedbackFormConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `GeneralFeedbackFormConfig` that needs to be destroyed */
  generalFeedbackFormConfigId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyGeneralFeedbackFormConfig. */
export interface DestroyGeneralFeedbackFormConfigPayload {
  __typename: 'DestroyGeneralFeedbackFormConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `GeneralFeedbackFormConfig` that was destroyed */
  generalFeedbackFormConfig: Maybe<GeneralFeedbackFormConfig>;
}

/** Autogenerated input type of DestroyGeneralFeedback */
export interface DestroyGeneralFeedbackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `GeneralFeedback` that needs to be destroyed */
  generalFeedbackId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyGeneralFeedback. */
export interface DestroyGeneralFeedbackPayload {
  __typename: 'DestroyGeneralFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `GeneralFeedback` that was destroyed */
  generalFeedback: Maybe<GeneralFeedback>;
}

/** Autogenerated input type of DestroyGoalActivity */
export interface DestroyGoalActivityInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `GoalActivity` that needs to be destroyed */
  goalActivityId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyGoalActivity. */
export interface DestroyGoalActivityPayload {
  __typename: 'DestroyGoalActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `GoalActivity` that was destroyed */
  goalActivity: Maybe<GoalActivity>;
}

/** Autogenerated input type of DestroyGoalCard */
export interface DestroyGoalCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `GoalCard` that needs to be destroyed */
  goalCardId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyGoalCard. */
export interface DestroyGoalCardPayload {
  __typename: 'DestroyGoalCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `GoalCard` that was destroyed */
  goalCard: Maybe<GoalCard>;
}

/** Autogenerated input type of DestroyGoal */
export interface DestroyGoalInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Goal` that needs to be destroyed */
  goalId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyGoal. */
export interface DestroyGoalPayload {
  __typename: 'DestroyGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Goal` that was destroyed */
  goal: Maybe<Goal>;
}

/** Autogenerated input type of DestroyInterview */
export interface DestroyInterviewInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Interview` that needs to be destroyed */
  interviewId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyInterview. */
export interface DestroyInterviewPayload {
  __typename: 'DestroyInterviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Interview` that was destroyed */
  interview: Maybe<Interview>;
}

/** Autogenerated input type of DestroyInvoicePlan */
export interface DestroyInvoicePlanInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Billing::InvoicePlan` to destroy */
  invoicePlanId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyInvoicePlan. */
export interface DestroyInvoicePlanPayload {
  __typename: 'DestroyInvoicePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoicePlan: Maybe<InvoicePlan>;
}

/** Autogenerated input type of DestroyKPB */
export interface DestroyKpbInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `KPB` that needs to be destroyed */
  kpbId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyKPB. */
export interface DestroyKpbPayload {
  __typename: 'DestroyKPBPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `KPB` that was destroyed */
  kpb: Maybe<Kpb>;
}

/** Autogenerated input type of DestroyKPBSubSkillScore */
export interface DestroyKpbSubSkillScoreInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `KPBSubSkillScore` that needs to be destroyed */
  kpbSubSkillScoreId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyKPBSubSkillScore. */
export interface DestroyKpbSubSkillScorePayload {
  __typename: 'DestroyKPBSubSkillScorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `KPBSubSkillScore` that was destroyed */
  kpbSubSkillScore: Maybe<KpbSubSkillScore>;
}

/** Autogenerated input type of DestroyLearningResourceArticle */
export interface DestroyLearningResourceArticleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceArticle` that needs to be destroyed */
  learningResourceArticleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceArticle. */
export interface DestroyLearningResourceArticlePayload {
  __typename: 'DestroyLearningResourceArticlePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceArticle` that was destroyed */
  learningResourceArticle: Maybe<LearningResourceArticle>;
}

/** Autogenerated input type of DestroyLearningResourceFile */
export interface DestroyLearningResourceFileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceFile` that needs to be destroyed */
  learningResourceFileId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceFile. */
export interface DestroyLearningResourceFilePayload {
  __typename: 'DestroyLearningResourceFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceFile` that was destroyed */
  learningResourceFile: Maybe<LearningResourceFile>;
}

/** Autogenerated input type of DestroyLearningResourceGlobalCategory */
export interface DestroyLearningResourceGlobalCategoryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceGlobalCategory` that needs to be destroyed */
  learningResourceGlobalCategoryId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceGlobalCategory. */
export interface DestroyLearningResourceGlobalCategoryPayload {
  __typename: 'DestroyLearningResourceGlobalCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceGlobalCategory` that was destroyed */
  learningResourceGlobalCategory: Maybe<LearningResourceGlobalCategory>;
}

/** Autogenerated input type of DestroyLearningResourceLink */
export interface DestroyLearningResourceLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceLink` that needs to be destroyed */
  learningResourceLinkId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceLink. */
export interface DestroyLearningResourceLinkPayload {
  __typename: 'DestroyLearningResourceLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceLink` that was destroyed */
  learningResourceLink: Maybe<LearningResourceLink>;
}

/** Autogenerated input type of DestroyLearningResourceMicroLearning */
export interface DestroyLearningResourceMicroLearningInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceMicroLearning` that needs to be destroyed */
  learningResourceMicroLearningId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceMicroLearning. */
export interface DestroyLearningResourceMicroLearningPayload {
  __typename: 'DestroyLearningResourceMicroLearningPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceMicroLearning` that was destroyed */
  learningResourceMicroLearning: Maybe<LearningResourceMicroLearning>;
}

/** Autogenerated input type of DestroyLearningResourceMicroLearningStep */
export interface DestroyLearningResourceMicroLearningStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceMicroLearningStep` that needs to be destroyed */
  learningResourceMicroLearningStepId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceMicroLearningStep. */
export interface DestroyLearningResourceMicroLearningStepPayload {
  __typename: 'DestroyLearningResourceMicroLearningStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceMicroLearningStep` that was destroyed */
  learningResourceMicroLearningStep: Maybe<LearningResourceMicroLearningStep>;
}

/** Autogenerated input type of DestroyLearningResourceSet */
export interface DestroyLearningResourceSetInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `LearningResourceSet` that needs to be destroyed */
  learningResourceSetId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyLearningResourceSet. */
export interface DestroyLearningResourceSetPayload {
  __typename: 'DestroyLearningResourceSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `LearningResourceSet` that was destroyed */
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated input type of DestroyMemo */
export interface DestroyMemoInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Memo` that needs to be destroyed */
  memoId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyMemo. */
export interface DestroyMemoPayload {
  __typename: 'DestroyMemoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Memo` that was destroyed */
  memo: Maybe<Memo>;
}

/** Autogenerated input type of DestroyMultiSource */
export interface DestroyMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `MultiSource` that needs to be destroyed */
  multiSourceId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyMultiSource. */
export interface DestroyMultiSourcePayload {
  __typename: 'DestroyMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `MultiSource` that was destroyed */
  multiSource: Maybe<MultiSource>;
}

/** Autogenerated input type of DestroyNote */
export interface DestroyNoteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Note` that needs to be destroyed */
  noteId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyNote. */
export interface DestroyNotePayload {
  __typename: 'DestroyNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Note` that was destroyed */
  note: Maybe<Note>;
}

/** Autogenerated input type of DestroyNotification */
export interface DestroyNotificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Notification` that needs to be destroyed */
  notificationId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyNotification. */
export interface DestroyNotificationPayload {
  __typename: 'DestroyNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Notification` that was destroyed */
  notification: Maybe<Notification>;
}

/** Autogenerated input type of DestroyOIDC */
export interface DestroyOidcInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `OIDC` that needs to be destroyed */
  oidc: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyOIDC. */
export interface DestroyOidcPayload {
  __typename: 'DestroyOIDCPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `OIDC` that was destroyed */
  oidc: Maybe<Oidc>;
}

/** Autogenerated input type of DestroyOrganization */
export interface DestroyOrganizationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Organization` that needs to be destroyed */
  organizationId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyOrganization. */
export interface DestroyOrganizationPayload {
  __typename: 'DestroyOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Organization` that was destroyed */
  organization: Maybe<Organization>;
}

/** Autogenerated input type of DestroyOrganizationUserRole */
export interface DestroyOrganizationUserRoleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `OrganizationUserRole` that needs to be destroyed */
  organizationUserRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyOrganizationUserRole. */
export interface DestroyOrganizationUserRolePayload {
  __typename: 'DestroyOrganizationUserRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `OrganizationUserRole` that was destroyed */
  organizationUserRole: Maybe<OrganizationUserRole>;
}

/** Autogenerated input type of DestroyParentDomain */
export interface DestroyParentDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ParentDomain` that needs to be destroyed */
  parentDomainId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyParentDomain. */
export interface DestroyParentDomainPayload {
  __typename: 'DestroyParentDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `ParentDomain` that was destroyed */
  parentDomain: Maybe<ParentDomain>;
}

/** Autogenerated input type of DestroyParticipationLevelFormat */
export interface DestroyParticipationLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ParticipationLevelFormat` that needs to be destroyed */
  participationLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyParticipationLevelFormat. */
export interface DestroyParticipationLevelFormatPayload {
  __typename: 'DestroyParticipationLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `ParticipationLevelFormat` that was destroyed */
  participationLevelFormat: Maybe<ParticipationLevelFormat>;
}

/** Autogenerated input type of DestroyPendingAction */
export interface DestroyPendingActionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PendingAction` that needs to be destroyed */
  pendingActionId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPendingAction. */
export interface DestroyPendingActionPayload {
  __typename: 'DestroyPendingActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PendingAction` that was destroyed */
  pendingAction: Maybe<PendingAction>;
}

/** Autogenerated input type of DestroyPeriodFormat */
export interface DestroyPeriodFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PeriodFormat` that needs to be destroyed */
  periodFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPeriodFormat. */
export interface DestroyPeriodFormatPayload {
  __typename: 'DestroyPeriodFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PeriodFormat` that was destroyed */
  periodFormat: Maybe<PeriodFormat>;
}

/** Autogenerated input type of DestroyPeriodRequiredSkillLevel */
export interface DestroyPeriodRequiredSkillLevelInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PeriodRequiredSkillLevel` that needs to be destroyed */
  periodRequiredSkillLevelId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPeriodRequiredSkillLevel. */
export interface DestroyPeriodRequiredSkillLevelPayload {
  __typename: 'DestroyPeriodRequiredSkillLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PeriodRequiredSkillLevel` that was destroyed */
  periodRequiredSkillLevel: Maybe<PeriodRequiredSkillLevel>;
}

/** Autogenerated input type of DestroyPortfolioDocumentConfig */
export interface DestroyPortfolioDocumentConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioDocumentConfig` that needs to be destroyed */
  portfolioDocumentConfigId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPortfolioDocumentConfig. */
export interface DestroyPortfolioDocumentConfigPayload {
  __typename: 'DestroyPortfolioDocumentConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioDocumentConfig` that was destroyed */
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
}

/** Autogenerated input type of DestroyPortfolioFormat */
export interface DestroyPortfolioFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioFormat` to destroy */
  portfolioFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPortfolioFormat. */
export interface DestroyPortfolioFormatPayload {
  __typename: 'DestroyPortfolioFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioFormat` that was destroyed */
  portfolioFormat: Maybe<PortfolioFormat>;
}

/** Autogenerated input type of DestroyPortfolioNote */
export interface DestroyPortfolioNoteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioNote` that needs to be destroyed */
  portfolioNoteId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPortfolioNote. */
export interface DestroyPortfolioNotePayload {
  __typename: 'DestroyPortfolioNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioNote` that was destroyed */
  portfolioNote: Maybe<PortfolioNote>;
}

/** Autogenerated input type of DestroyPortfolioRoleSync */
export interface DestroyPortfolioRoleSyncInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioRoleSync` that needs to be destroyed */
  portfolioRoleSyncId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPortfolioRoleSync. */
export interface DestroyPortfolioRoleSyncPayload {
  __typename: 'DestroyPortfolioRoleSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioRoleSync` that was destroyed */
  portfolioRoleSync: Maybe<PortfolioRoleSync>;
}

/** Autogenerated input type of DestroyPortfolioTransferRequest */
export interface DestroyPortfolioTransferRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioTransferRequest` that needs to be destroyed */
  portfolioTransferRequestId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyPortfolioTransferRequest. */
export interface DestroyPortfolioTransferRequestPayload {
  __typename: 'DestroyPortfolioTransferRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioTransferRequest` that was destroyed */
  portfolioTransferRequest: Maybe<PortfolioTransferRequest>;
}

/** Autogenerated input type of DestroyProgram */
export interface DestroyProgramInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Program` to destroy */
  programId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyProgram. */
export interface DestroyProgramPayload {
  __typename: 'DestroyProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  program: Maybe<Program>;
}

/** Autogenerated input type of DestroyProgramRole */
export interface DestroyProgramRoleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ProgramRole` that needs to be destroyed */
  programRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyProgramRole. */
export interface DestroyProgramRolePayload {
  __typename: 'DestroyProgramRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `ProgramRole` that was destroyed */
  programRole: Maybe<ProgramRole>;
}

/** Autogenerated input type of DestroyProgramRolesBatch */
export interface DestroyProgramRolesBatchInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The status of the `ProgramRole` to be destroyed and the `Portfolio` to be archived or completed */
  destroyStatus: ProgramRoleDestroyStatusEnum;
  /** The IDs of the `ProgramRole` to destroy */
  programRoleIds: Array<Scalars['ID']['input']>;
  /** Pin of the logged-in `User` */
  userPin: Scalars['String']['input'];
}

/** Autogenerated return type of DestroyProgramRolesBatch. */
export interface DestroyProgramRolesBatchPayload {
  __typename: 'DestroyProgramRolesBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  programRoles: Maybe<Array<ProgramRole>>;
}

/** Autogenerated input type of DestroyQualityInstrument */
export interface DestroyQualityInstrumentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  qualityInstrumentId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyQualityInstrument. */
export interface DestroyQualityInstrumentPayload {
  __typename: 'DestroyQualityInstrumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  qualityInstrument: Maybe<QualityInstrument>;
}

/** Autogenerated input type of DestroyRegistration */
export interface DestroyRegistrationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Registration` that needs to be destroyed */
  registrationId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyRegistration. */
export interface DestroyRegistrationPayload {
  __typename: 'DestroyRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Registration` that was destroyed */
  registration: Maybe<Registration>;
}

/** Autogenerated input type of DestroyResidencyArchetype */
export interface DestroyResidencyArchetypeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ResidencyArchetype` that needs to be destroyed */
  residencyArchetypeId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyResidencyArchetype. */
export interface DestroyResidencyArchetypePayload {
  __typename: 'DestroyResidencyArchetypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `ResidencyArchetype` that was destroyed */
  residencyArchetype: Maybe<ResidencyArchetype>;
}

/** Autogenerated input type of DestroyResidency */
export interface DestroyResidencyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Residency` that needs to be destroyed */
  residencyId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyResidency. */
export interface DestroyResidencyPayload {
  __typename: 'DestroyResidencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Residency` that was destroyed */
  residency: Maybe<Residency>;
}

/** Autogenerated input type of DestroyRoleFormat */
export interface DestroyRoleFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `RoleFormat` that needs to be destroyed */
  roleFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyRoleFormat. */
export interface DestroyRoleFormatPayload {
  __typename: 'DestroyRoleFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `RoleFormat` that was destroyed */
  roleFormat: Maybe<RoleFormat>;
}

/** Autogenerated input type of DestroyRootSkillCategoryConfig */
export interface DestroyRootSkillCategoryConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the `RootSkillCategoryConfig` to destroy. */
  rootSkillCategoryConfigId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyRootSkillCategoryConfig. */
export interface DestroyRootSkillCategoryConfigPayload {
  __typename: 'DestroyRootSkillCategoryConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
}

/** Autogenerated input type of DestroySecurityQuestion */
export interface DestroySecurityQuestionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SecurityQuestion` that needs to be destroyed */
  securityQuestionId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySecurityQuestion. */
export interface DestroySecurityQuestionPayload {
  __typename: 'DestroySecurityQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `SecurityQuestion` that was destroyed */
  securityQuestion: Maybe<SecurityQuestion>;
}

/** Autogenerated input type of DestroySkillCategory */
export interface DestroySkillCategoryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SkillCategory` that needs to be destroyed */
  skillCategoryId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySkillCategory. */
export interface DestroySkillCategoryPayload {
  __typename: 'DestroySkillCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `SkillCategory` that was destroyed */
  skillCategory: Maybe<SkillCategory>;
}

/** Autogenerated input type of DestroySkill */
export interface DestroySkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Skill` that needs to be destroyed */
  skillId: Scalars['ID']['input'];
}

/** Autogenerated input type of DestroySkillLevelFormatDescription */
export interface DestroySkillLevelFormatDescriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SkillLevelFormatDescription` that needs to be destroyed */
  skillLevelFormatDescriptionId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySkillLevelFormatDescription. */
export interface DestroySkillLevelFormatDescriptionPayload {
  __typename: 'DestroySkillLevelFormatDescriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `SkillLevelFormatDescription` that was destroyed */
  skillLevelFormatDescription: Maybe<SkillLevelFormatDescription>;
}

/** Autogenerated input type of DestroySkillLevelFormat */
export interface DestroySkillLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SkillLevelFormat` that needs to be destroyed */
  skillLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySkillLevelFormat. */
export interface DestroySkillLevelFormatPayload {
  __typename: 'DestroySkillLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `SkillLevelFormat` that was destroyed */
  skillLevelFormat: Maybe<SkillLevelFormat>;
}

/** Autogenerated return type of DestroySkill. */
export interface DestroySkillPayload {
  __typename: 'DestroySkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Skill` that was destroyed */
  skill: Maybe<Skill>;
}

export enum DestroyStatusEnum {
  /** Do no destroy the ProgramRole */
  KEEP = 'KEEP',
  /** Destroy the ProgramRole, and archive the Portfolio */
  TO_BE_DESTROYED_WITH_ARCHIVED_PORTFOLIO = 'TO_BE_DESTROYED_WITH_ARCHIVED_PORTFOLIO',
  /** Destroy the ProgramRole, and complete the Portfolio */
  TO_BE_DESTROYED_WITH_COMPLETED_PORTFOLIO = 'TO_BE_DESTROYED_WITH_COMPLETED_PORTFOLIO',
  /** Destroy the ProgramRole, and keep the Portfolio */
  TO_BE_DESTROYED_WITH_KEEP_PORTFOLIO = 'TO_BE_DESTROYED_WITH_KEEP_PORTFOLIO',
}

/** Autogenerated input type of DestroySubDomain */
export interface DestroySubDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SubDomain` that needs to be destroyed */
  subDomainId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySubDomain. */
export interface DestroySubDomainPayload {
  __typename: 'DestroySubDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `SubDomain` that was destroyed */
  subDomain: Maybe<SubDomain>;
}

/** Autogenerated input type of DestroySubMultiSource */
export interface DestroySubMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Emailaddress for which to remove the sub-`MultiSource` */
  email: Scalars['String']['input'];
  /** ID of the `MultiSource` that the sub-`MultiSource` belongs to */
  multiSourceId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroySubMultiSource. */
export interface DestroySubMultiSourcePayload {
  __typename: 'DestroySubMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Email of the user the removed sub-`MultiSource` belongs to */
  email: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of DestroyUser */
export interface DestroyUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `User` that needs to be scrubbed and marked as deleted */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyUser. */
export interface DestroyUserPayload {
  __typename: 'DestroyUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `User` that was destroyed */
  user: Maybe<User>;
}

/** Autogenerated input type of DestroyWorkspace */
export interface DestroyWorkspaceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Workspace` that needs to be destroyed */
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyWorkspace. */
export interface DestroyWorkspacePayload {
  __typename: 'DestroyWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Workspace` that was destroyed */
  workspace: Maybe<Workspace>;
}

/** Autogenerated input type of DestroyWorkspaceRole */
export interface DestroyWorkspaceRoleInput {
  /**
   * Also destroy this user's `DashboardRole` and other `WorkspaceRole`s within the
   * same dashboard where the viewer has manage rights
   */
  alsoParentDashboardAndWorkspaceRolesWhereViewerCanManage?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `WorkspaceRole` to destroy */
  workspaceRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of DestroyWorkspaceRole. */
export interface DestroyWorkspaceRolePayload {
  __typename: 'DestroyWorkspaceRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  workspaceRole: Maybe<WorkspaceRole>;
}

export interface DirectUpload {
  __typename: 'DirectUpload';
  /** ID to be used when attaching pre-uploaded file to an object */
  signedId: Maybe<Scalars['String']['output']>;
  /** Headers for uploading the file to the upload URL */
  uploadHeaders: Maybe<Scalars['JSON']['output']>;
  /** URL to upload the file to */
  uploadUrl: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of DisableSecondFactorWithSecurityKey */
export interface DisableSecondFactorWithSecurityKeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the `User` of which the `SecondFactor` needs to be disabled. */
  email: Scalars['String']['input'];
  /** Password of the `User` of which the `SecondFactor` needs to be disabled. */
  password: Scalars['String']['input'];
  /** The security key of the `SecondFactor`. Needed if viewer is no an admin. */
  securityKey: Scalars['String']['input'];
}

/** Autogenerated return type of DisableSecondFactorWithSecurityKey. */
export interface DisableSecondFactorWithSecurityKeyPayload {
  __typename: 'DisableSecondFactorWithSecurityKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  errors: Array<Error>;
}

/** Autogenerated input type of DismissOnboardingStep */
export interface DismissOnboardingStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `OnboardingStep` to dismiss */
  onboardingStepId: Scalars['ID']['input'];
}

/** Autogenerated return type of DismissOnboardingStep. */
export interface DismissOnboardingStepPayload {
  __typename: 'DismissOnboardingStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  onboardingStep: Maybe<OnboardingStep>;
}

export interface Download extends Node, PortfolioItem, Timestamped {
  __typename: 'Download';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates the current status of this Download */
  downloadStatus: ImportStatusEnum;
  /** The expires at date of this `Download`. */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** Url to download export as long as it isn't expired */
  presignedUrl: Maybe<Scalars['String']['output']>;
  /** Optional ID of the `skill` on which the download is filtered */
  skillToFilterOn: Maybe<Skill>;
  /**
   * Indicates the current status of this Download
   * @deprecated Use `download_status` instead, remove this field after 2025-09-01
   */
  status: ImportStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface Draft extends Node, Timestamped {
  __typename: 'Draft';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The event of this `Draft`. */
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The object of this `Draft`. */
  object: Maybe<Scalars['JSON']['output']>;
  /** The record_id of this `Draft`. */
  recordId: Maybe<Scalars['ID']['output']>;
  /** The record_type of this `Draft`. */
  recordType: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of DuplicateEventCard */
export interface DuplicateEventCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventCardId: Scalars['ID']['input'];
}

/** Autogenerated return type of DuplicateEventCard. */
export interface DuplicateEventCardPayload {
  __typename: 'DuplicateEventCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventCard: Maybe<EventCard>;
}

/** Autogenerated input type of DuplicateGoalCard */
export interface DuplicateGoalCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  goalCardId: Scalars['ID']['input'];
}

/** Autogenerated return type of DuplicateGoalCard. */
export interface DuplicateGoalCardPayload {
  __typename: 'DuplicateGoalCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goalCard: Maybe<GoalCard>;
}

export interface EditRights {
  __typename: 'EditRights';
  /** Whether it can add `CourseResult`s or not. */
  canAddResults: Scalars['Boolean']['output'];
  /** Whether it can assess or not. */
  canAssess: Scalars['Boolean']['output'];
  /** Whether it can assign other supervisors or not. */
  canAssignOtherSupervisors: Scalars['Boolean']['output'];
  /** Whether it can authorize or not. */
  canAuthorize: Scalars['Boolean']['output'];
  /** Whether it can edit `Goal`s or not. */
  canEditGoals: Scalars['Boolean']['output'];
  /** Whether it can edit practical information or not. */
  canEditPracticalInformation: Scalars['Boolean']['output'];
  /** Whether it can manage `MultiSource`s or not. */
  canManageMultiSource: Scalars['Boolean']['output'];
  /** Whether it can supervise residencies or not. */
  canSuperviseResidencies: Scalars['Boolean']['output'];
}

/** Autogenerated input type of EnableSecondFactor */
export interface EnableSecondFactorInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current OTP to enable OTP as a second factor */
  otp?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of EnableSecondFactor. */
export interface EnableSecondFactorPayload {
  __typename: 'EnableSecondFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  secondFactor: Maybe<SecondFactor>;
}

/** A user-readable error */
export interface Error {
  __typename: 'Error';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path: Maybe<Array<Scalars['String']['output']>>;
}

export interface EventCard extends BaseCard, Node, Timestamped {
  __typename: 'EventCard';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Amount of attachments attached to this comments on this card */
  attachmentCount: Maybe<Scalars['Int']['output']>;
  /** The card_comments of this `WorkspaceDashboard::EventCard`. */
  cardComments: CardCommentConnection;
  /** The card_logs of this `WorkspaceDashboard::EventCard`. */
  cardLogs: CardLogConnection;
  /** The card_tasks of this `WorkspaceDashboard::EventCard`. */
  cardTasks: CardTaskConnection;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that is linked to this `EventCard` as it's creator */
  creator: User;
  /** @deprecated Use `description_json_content` instead. */
  description: Maybe<Scalars['String']['output']>;
  descriptionJsonContent: Maybe<Scalars['JSONContent']['output']>;
  endDate: Maybe<Scalars['Date']['output']>;
  /** Current status of this `EventCard` */
  eventCardStatus: EventCardStatusEnum;
  id: Scalars['ID']['output'];
  /** The linked_cards of this `WorkspaceDashboard::EventCard`. */
  linkedCards: Maybe<Array<LinkedCard>>;
  /** The quality_instrument (`WorkspaceDashboard::QualityInstrument`) that this `WorkspaceDashboard::EventCard` belongs to */
  qualityInstrument: Maybe<QualityInstrument>;
  startDate: Maybe<Scalars['Date']['output']>;
  /**
   * Current status of this `EventCard`
   * @deprecated Use `event_card_status` instead, remove this field after 2025-09-01
   */
  status: EventCardStatusEnum;
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The users of this `WorkspaceDashboard::EventCard`. */
  users: UserConnection;
  /** The workspace (`WorkspaceDashboard::Workspace`) that this `WorkspaceDashboard::EventCard` belongs to */
  workspace: Workspace;
}

export interface EventCardCardCommentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface EventCardCardLogsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface EventCardCardTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface EventCardUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for EventCard. */
export interface EventCardConnection {
  __typename: 'EventCardConnection';
  /** The total (unfiltered) amount of active `EventCard`s in this connection. */
  activeCardCount: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<EventCardEdge>;
  /** A list of nodes. */
  nodes: Array<EventCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface EventCardEdge {
  __typename: 'EventCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EventCard>;
}

/** Filter for `WorkspaceDashboard::EventCard` */
export interface EventCardFilter {
  /** Only return objects with given statuses */
  status?: InputMaybe<Array<EventCardStatusEnum>>;
}

export enum EventCardStatusEnum {
  /** The status of the `EventCard` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `EventCard` is completed */
  COMPLETED = 'COMPLETED',
  /** The status of the `EventCard` is planned */
  PLANNED = 'PLANNED',
}

export interface ExternalAccess extends Node, Timestamped {
  __typename: 'ExternalAccess';
  /** Date of when the status became active */
  activeAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date of when the status became closed */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The external_access_status of this `ExternalAccess`. */
  externalAccessStatus: ExternalAccessStatusEnum;
  /** Name of the third party of this `ExternalAccess` */
  externalApplicationName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** `Portfolio` that is linked to this `ExternalAccess` */
  portfolio: Maybe<Portfolio>;
  /** Date of when the status became refused */
  refusedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The status of this `ExternalAccess`.
   * @deprecated Use `external_access_status` instead, remove this field after 2025-09-01
   */
  status: ExternalAccessStatusEnum;
  /** Temp return token for testing */
  token: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that is linked to this `ExternalAccess` */
  user: User;
}

/** The connection type for ExternalAccess. */
export interface ExternalAccessConnection {
  __typename: 'ExternalAccessConnection';
  /** A list of edges. */
  edges: Array<ExternalAccessEdge>;
  /** A list of nodes. */
  nodes: Array<ExternalAccess>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ExternalAccessEdge {
  __typename: 'ExternalAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ExternalAccess>;
}

export enum ExternalAccessStatusEnum {
  /** This ExternalAccess is active */
  ACTIVE = 'ACTIVE',
  /** This ExternalAccess is closed */
  CLOSED = 'CLOSED',
  /** This ExternalAccess is refused */
  REFUSED = 'REFUSED',
  /** This ExternalAccess is requested */
  REQUESTED = 'REQUESTED',
}

export interface ExternalOauthApplication extends Node, Timestamped {
  __typename: 'ExternalOauthApplication';
  /** The authorize_uri of this `ExternalOauthApplication`. */
  authorizeUri: Scalars['String']['output'];
  /** The avatar_url of this `ExternalOauthApplication`. */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of this `ExternalOauthApplication`. */
  name: Scalars['String']['output'];
  /** The redirect_uri of this `ExternalOauthApplication`. */
  redirectUri: Scalars['String']['output'];
  /** The scopes of this `ExternalOauthApplication`. */
  scopes: Maybe<Scalars['String']['output']>;
  /** The send_data_uri of this `ExternalOauthApplication`. */
  sendDataUri: Scalars['String']['output'];
  /** The token_uri of this `ExternalOauthApplication`. */
  tokenUri: Scalars['String']['output'];
  /** The uid of this `ExternalOauthApplication`. */
  uid: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for ExternalOauthApplication. */
export interface ExternalOauthApplicationConnection {
  __typename: 'ExternalOauthApplicationConnection';
  /** A list of edges. */
  edges: Array<ExternalOauthApplicationEdge>;
  /** A list of nodes. */
  nodes: Array<ExternalOauthApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ExternalOauthApplicationEdge {
  __typename: 'ExternalOauthApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ExternalOauthApplication>;
}

export interface FeatureToggle extends Node, Timestamped {
  __typename: 'FeatureToggle';
  /** The date the feature toggle will be activated */
  activateOn: Maybe<Scalars['Date']['output']>;
  /** Whether `FeatureToggle` is active. */
  active: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The key of this `FeatureToggle`. */
  key: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for FeatureToggle. */
export interface FeatureToggleConnection {
  __typename: 'FeatureToggleConnection';
  /** A list of edges. */
  edges: Array<FeatureToggleEdge>;
  /** A list of nodes. */
  nodes: Array<FeatureToggle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface FeatureToggleEdge {
  __typename: 'FeatureToggleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FeatureToggle>;
}

export interface FeedbackRequest extends Accessible, Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'FeedbackRequest';
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** The time the corresponding `FeedbackRound` was closed. */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** General feedback */
  comments: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The `FeedbackRound` that this `Feedback` belongs to */
  feedbackRound: Maybe<FeedbackRound>;
  /** Current status of this `FeedbackRequest` */
  feedbackStatus: Maybe<SurveyStatusEnum>;
  id: Scalars['ID']['output'];
  /** Returns `true` if the feedback is given by the portfolio owner. */
  isSelfAssessment: Scalars['Boolean']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** Question from the requestor */
  request: Maybe<Scalars['String']['output']>;
  /** The requestee (`User`) that this `Feedback` belongs to */
  requestee: Maybe<User>;
  /**
   * Current status of this `FeedbackRequest`
   * @deprecated Use `feedback_status` instead, remove this field after 2025-09-01
   */
  status: Maybe<SurveyStatusEnum>;
  /** The subject of this `Feedback`. */
  subject: Maybe<FeedbackRoundSubject>;
  /** The supervisor of this `Feedback`. */
  supervisor: Maybe<User>;
  /** Whether `Feedback` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `Feedback` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** Overall positive, neutral or negative response (or not set, or not assessed) */
  thumbs: Maybe<ThumbsEnum>;
  /** Feedback given on specific topics */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface FeedbackRound extends Accessible, Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'FeedbackRound';
  /** The attached_files of this `FeedbackRound`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** The closed at date of this `FeedbackRound`. */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The comments of this `FeedbackRound`. */
  comments: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** `FeedbackRequests` for this `FeedbackRound` */
  feedbackRequests: Array<FeedbackRequest>;
  /** Status of `FeedbackRound` */
  feedbackRoundStatus: FeedbackRoundStatusEnum;
  /** The feedback_status_count of this `FeedbackRound`. */
  feedbackStatusCount: Maybe<FeedbackStatusCount>;
  id: Scalars['ID']['output'];
  /** Boolean that marks whether or not owner can view the gated_fields of the FeedbackRound */
  ownerCanViewAll: Scalars['Boolean']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /**
   * Status of `FeedbackRound`
   * @deprecated Use `feedback_round_status` instead, remove this field after 2025-09-01
   */
  status: FeedbackRoundStatusEnum;
  /** Subject of `FeedbackRound` */
  subject: Maybe<FeedbackRoundSubject>;
  /** The supervisor (`User`) that this `FeedbackRound` belongs to */
  supervisor: Maybe<User>;
  /** Whether `FeedbackRound` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `FeedbackRound` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** Title of `FeedbackRound` */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for FeedbackRound. */
export interface FeedbackRoundConnection {
  __typename: 'FeedbackRoundConnection';
  /** A list of edges. */
  edges: Array<FeedbackRoundEdge>;
  /** A list of nodes. */
  nodes: Array<FeedbackRound>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface FeedbackRoundEdge {
  __typename: 'FeedbackRoundEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FeedbackRound>;
}

export enum FeedbackRoundStatusEnum {
  /** This FeedbackRound is closed */
  CLOSED = 'CLOSED',
  /** This FeedbackRound is imported */
  IMPORTED = 'IMPORTED',
  /** This FeedbackRound is open */
  OPEN = 'OPEN',
}

/** Object which can be the subject of an `FeedbackRound` */
export type FeedbackRoundSubject = CompetenceCertificate | Interview;

export interface FeedbackStatusCount {
  __typename: 'FeedbackStatusCount';
  /** Number of closed `Feedbacks` */
  closed: Maybe<Scalars['Int']['output']>;
  /** Number of filled `Feedbacks` */
  filled: Maybe<Scalars['Int']['output']>;
  /** Number of open `Feedbacks` */
  open: Maybe<Scalars['Int']['output']>;
}

/** Autogenerated input type of FinalizeClinicalCompetenceCommittee */
export interface FinalizeClinicalCompetenceCommitteeInput {
  cccFormConfigSelectionResultsAttributes?: InputMaybe<Array<CccFormConfigSelectionResultInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
  /** @deprecated `closedAt` is no longer settable, it is always set to the current time when finalizing */
  closedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated `finalResponseJson` is no longer used, use `cccFormConfigSelectionResultsAttributes` instead */
  finalResponseJson?: InputMaybe<Scalars['JSON']['input']>;
  supervisorPin: Scalars['String']['input'];
  visibilityLevelOwner?: InputMaybe<ClinicalCompetenceCommitteeVisibilityLevelOwnerEnum>;
}

/** Autogenerated return type of FinalizeClinicalCompetenceCommittee. */
export interface FinalizeClinicalCompetenceCommitteePayload {
  __typename: 'FinalizeClinicalCompetenceCommitteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of FindOrCreateUserWithDashboardRoleAndWorkspaceRoles */
export interface FindOrCreateUserWithDashboardRoleAndWorkspaceRolesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dashboardRoleAttributes?: InputMaybe<DashboardRoleInput>;
  userAttributes: UserInput;
  workspaceRolesAttributes?: InputMaybe<Array<WorkspaceRoleInput>>;
}

/** Autogenerated return type of FindOrCreateUserWithDashboardRoleAndWorkspaceRoles. */
export interface FindOrCreateUserWithDashboardRoleAndWorkspaceRolesPayload {
  __typename: 'FindOrCreateUserWithDashboardRoleAndWorkspaceRolesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** A `Form`-like object with a type */
export interface Form {
  /** Type of this form */
  formType: Maybe<Scalars['String']['output']>;
  /** Version of this form */
  formVersion: Maybe<Scalars['String']['output']>;
}

export interface GaiaActivity extends Node, Timestamped {
  __typename: 'GaiaActivity';
  /** The category_id of this `GaiaActivity`. */
  categoryId: Maybe<Scalars['Int']['output']>;
  /** The category_name of this `GaiaActivity`. */
  categoryName: Maybe<Scalars['String']['output']>;
  /** The completed_on of this `GaiaActivity`. */
  completedOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** The conclusion of this `GaiaActivity`. */
  conclusion: GaiaActivityConclusionTypeEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The name of this `GaiaActivity`. */
  name: Maybe<Scalars['String']['output']>;
  /** The points of this `GaiaActivity`. */
  points: Scalars['Float']['output'];
  /** The subrule_id of this `GaiaActivity`. */
  subruleId: Maybe<Scalars['Int']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export enum GaiaActivityConclusionTypeEnum {
  APPROVED_BY_ASSOCIATION = 'APPROVED_BY_ASSOCIATION',
  APPROVED_BY_EDUCATOR = 'APPROVED_BY_EDUCATOR',
  APPROVED_BY_PROFESSIONAL = 'APPROVED_BY_PROFESSIONAL',
  DENIED_BY_ASSOCIATION = 'DENIED_BY_ASSOCIATION',
  DENIED_BY_EDUCATOR = 'DENIED_BY_EDUCATOR',
  UNKNOWN = 'UNKNOWN',
}

export enum GaiaCalendarRoleEnum {
  /** user has beta functionality */
  BETA = 'BETA',
  /** user has beta functionality and is a specialist */
  BETA_SPECIALIST = 'BETA_SPECIALIST',
  /** user does not have beta functionality */
  NON_BETA = 'NON_BETA',
}

export interface GaiaCategory extends Node, Timestamped {
  __typename: 'GaiaCategory';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The gaia_id of this `GaiaCategory`. */
  gaiaId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The name of this `GaiaCategory`. */
  name: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for GaiaCategory. */
export interface GaiaCategoryConnection {
  __typename: 'GaiaCategoryConnection';
  /** A list of edges. */
  edges: Array<GaiaCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<GaiaCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GaiaCategoryEdge {
  __typename: 'GaiaCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GaiaCategory>;
}

export interface GaiaFileSync extends Node {
  __typename: 'GaiaFileSync';
  id: Scalars['ID']['output'];
  /** Whether `GaiaFileSync` is synchronized. */
  synchronized: Scalars['Boolean']['output'];
  /** The synchronized at date of this `GaiaFileSync`. */
  synchronizedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export interface GaiaTarget extends Node, Timestamped {
  __typename: 'GaiaTarget';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End date of the `GaiaTarget` (inclusive) */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** Whether `GaiaTarget` is passed. */
  passed: Scalars['Boolean']['output'];
  /** Start date of the `GaiaTarget` */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** The subrules of this `GaiaTarget`. */
  subrules: Maybe<Array<GaiaTargetSubrule>>;
  /** Threshold value for this `Target` */
  threshold: Maybe<Scalars['Float']['output']>;
  /** Points currently counting towards this `Target` */
  totalPoints: Maybe<Scalars['Float']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface GaiaTargetSubrule {
  __typename: 'GaiaTargetSubrule';
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  passed: Maybe<Scalars['Boolean']['output']>;
  totalPoints: Maybe<Scalars['Float']['output']>;
}

export interface GeneralFeedback extends Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'GeneralFeedback';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The `GeneralFeedbackFormConfig` that this `GeneralFeedback` belongs to */
  generalFeedbackFormConfig: GeneralFeedbackFormConfig;
  id: Scalars['ID']['output'];
  /** The points_of_concern of this `GeneralFeedback`. */
  pointsOfConcern: Maybe<Scalars['String']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The positive_points of this `GeneralFeedback`. */
  positivePoints: Maybe<Scalars['String']['output']>;
  /** The title of this `GeneralFeedback`. */
  title: Maybe<Scalars['String']['output']>;
  /** The topics of this `GeneralFeedback`. */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for GeneralFeedback. */
export interface GeneralFeedbackConnection {
  __typename: 'GeneralFeedbackConnection';
  /** A list of edges. */
  edges: Array<GeneralFeedbackEdge>;
  /** A list of nodes. */
  nodes: Array<GeneralFeedback>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GeneralFeedbackEdge {
  __typename: 'GeneralFeedbackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GeneralFeedback>;
}

/** The configuration of a form for general feedback. */
export interface GeneralFeedbackFormConfig extends Node, Timestamped {
  __typename: 'GeneralFeedbackFormConfig';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `GeneralFeedbackFormConfig`. */
  description: Scalars['String']['output'];
  /** The form of this `GeneralFeedbackFormConfig`. */
  form: Scalars['JSON']['output'];
  /** The general_feedback_form_config_status of this `GeneralFeedbackFormConfig`. */
  generalFeedbackFormConfigStatus: GeneralFeedbackFormConfigStatusEnum;
  id: Scalars['ID']['output'];
  /** The name of this `GeneralFeedbackFormConfig`. */
  name: Scalars['String']['output'];
  /** The order of this `GeneralFeedbackFormConfig`. */
  order: Scalars['Int']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for GeneralFeedbackFormConfig. */
export interface GeneralFeedbackFormConfigConnection {
  __typename: 'GeneralFeedbackFormConfigConnection';
  /** A list of edges. */
  edges: Array<GeneralFeedbackFormConfigEdge>;
  /** A list of nodes. */
  nodes: Array<GeneralFeedbackFormConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GeneralFeedbackFormConfigEdge {
  __typename: 'GeneralFeedbackFormConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GeneralFeedbackFormConfig>;
}

export enum GeneralFeedbackFormConfigStatusEnum {
  /** The status of the `GeneralFeedbackFormConfig` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `GeneralFeedbackFormConfig` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `GeneralFeedbackFormConfig` is published */
  PUBLISHED = 'PUBLISHED',
}

/** Autogenerated input type of GenerateUserPushNotificationsExternalId */
export interface GenerateUserPushNotificationsExternalIdInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of GenerateUserPushNotificationsExternalId. */
export interface GenerateUserPushNotificationsExternalIdPayload {
  __typename: 'GenerateUserPushNotificationsExternalIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

export interface GeneratedReport extends Node, Timestamped {
  __typename: 'GeneratedReport';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The file_url of this `GeneratedReport`. */
  fileUrl: Maybe<Scalars['String']['output']>;
  /** The generated_report_status of this `GeneratedReport`. */
  generatedReportStatus: GeneratedReportStatusEnum;
  id: Scalars['ID']['output'];
  /** The `PortfolioFormat` that this `GeneratedReport` belongs to */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** The report_type of this `GeneratedReport`. */
  reportType: GeneratedReportTypeEnum;
  /** The requestor (`User`) that this `GeneratedReport` belongs to */
  requestor: User;
  /**
   * The status of this `GeneratedReport`.
   * @deprecated Use `generated_report_status` instead, remove this field after 2025-09-01
   */
  status: GeneratedReportStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for GeneratedReport. */
export interface GeneratedReportConnection {
  __typename: 'GeneratedReportConnection';
  /** A list of edges. */
  edges: Array<GeneratedReportEdge>;
  /** A list of nodes. */
  nodes: Array<GeneratedReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GeneratedReportEdge {
  __typename: 'GeneratedReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GeneratedReport>;
}

export enum GeneratedReportStatusEnum {
  /** The status of the `GeneratedReport` is created */
  CREATED = 'CREATED',
  /** The status of the `GeneratedReport` is failed */
  FAILED = 'FAILED',
  /** The status of the `GeneratedReport` is requested */
  REQUESTED = 'REQUESTED',
}

export enum GeneratedReportTypeEnum {
  /** The report_type of the `GeneratedReport` is ai_usage_statistics */
  AI_USAGE_STATISTICS = 'AI_USAGE_STATISTICS',
  /** The report_type of the `GeneratedReport` is anios_statistics */
  ANIOS_STATISTICS = 'ANIOS_STATISTICS',
  /** The report_type of the `GeneratedReport` is anios_user_list */
  ANIOS_USER_LIST = 'ANIOS_USER_LIST',
  /** The report_type of the `GeneratedReport` is empty */
  EMPTY = 'EMPTY',
  /** The report_type of the `GeneratedReport` is portfolio_format_activity */
  PORTFOLIO_FORMAT_ACTIVITY = 'PORTFOLIO_FORMAT_ACTIVITY',
}

export interface Goal extends Node, PortfolioItem, Timestamped {
  __typename: 'Goal';
  /** Timestamp that this `Goal` was marked achieved */
  achievedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp that this `Goal` was marked archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Canmeds tagged to this `Goal` */
  canmeds: Maybe<Array<Scalars['String']['output']>>;
  /** Category (variant) of `Goal` */
  category: GoalCategoryTypeEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `GoalActivities` attached to this `Goal` */
  goalActivities: Array<GoalActivity>;
  /** Current status of this `Goal` */
  goalStatus: GoalStatusEnum;
  id: Scalars['ID']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** `Residencies` tagged to this `Goal` */
  residencies: Array<Residency>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /**
   * Current status of this `Goal`
   * @deprecated Use `goal_status` instead, remove this field after 2025-09-01
   */
  status: GoalStatusEnum;
  /** The date at which the portfolio owner aims to achieve this `Goal` */
  targetDate: Maybe<Scalars['Date']['output']>;
  /** General description of this `Goal` */
  title: Scalars['String']['output'];
  /** Multiperpose description field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface GoalSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GoalActivity extends Node, Timestamped {
  __typename: 'GoalActivity';
  /** The attached_files of this `GoalActivity`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this `GoalActivity` */
  creator: Maybe<User>;
  /** Date of the `GoalActivity` */
  date: Maybe<Scalars['Date']['output']>;
  /** `Goal` this `GoalActivity` is attached to */
  goal: Maybe<Goal>;
  id: Scalars['ID']['output'];
  /** Object attached to this `GoalActivity` */
  subject: Maybe<CompetenceCertificate | CourseResult | Interview | Kpb | MultiSource | Registration>;
  /** Multipurpose description field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface GoalCard extends BaseCard, Node, Timestamped {
  __typename: 'GoalCard';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The attachment_count of this `WorkspaceDashboard::GoalCard`. */
  attachmentCount: Maybe<Scalars['Int']['output']>;
  /** The card_comments of this `WorkspaceDashboard::GoalCard`. */
  cardComments: CardCommentConnection;
  /** The card_logs of this `WorkspaceDashboard::GoalCard`. */
  cardLogs: CardLogConnection;
  /** The card_tasks of this `WorkspaceDashboard::GoalCard`. */
  cardTasks: CardTaskConnection;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The creator (`User`) that this `WorkspaceDashboard::GoalCard` belongs to */
  creator: User;
  /** @deprecated Use `description_json_content` instead. */
  description: Maybe<Scalars['String']['output']>;
  /**
   * The description_act of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `description_act_json_content` instead.
   */
  descriptionAct: Maybe<Scalars['String']['output']>;
  /** The description_act_json_content of this `WorkspaceDashboard::GoalCard`. */
  descriptionActJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /**
   * The description_check of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `description_check_json_content` instead.
   */
  descriptionCheck: Maybe<Scalars['String']['output']>;
  /**
   * The description_check_indicators of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `description_check_indicators_json_content` instead.
   */
  descriptionCheckIndicators: Maybe<Scalars['String']['output']>;
  /** The description_check_indicators_json_content of this `WorkspaceDashboard::GoalCard`. */
  descriptionCheckIndicatorsJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /** The description_check_json_content of this `WorkspaceDashboard::GoalCard`. */
  descriptionCheckJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /**
   * The description_do of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `description_do_json_content` instead.
   */
  descriptionDo: Maybe<Scalars['String']['output']>;
  /** The description_do_json_content of this `WorkspaceDashboard::GoalCard`. */
  descriptionDoJsonContent: Maybe<Scalars['JSONContent']['output']>;
  descriptionJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /**
   * The description_plan of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `description_plan_json_content` instead.
   */
  descriptionPlan: Maybe<Scalars['String']['output']>;
  /** The description_plan_json_content of this `WorkspaceDashboard::GoalCard`. */
  descriptionPlanJsonContent: Maybe<Scalars['JSONContent']['output']>;
  endDate: Maybe<Scalars['Date']['output']>;
  /** Whether `WorkspaceDashboard::GoalCard` is featured. */
  featured: Scalars['Boolean']['output'];
  /** The goal_card_status of this `WorkspaceDashboard::GoalCard`. */
  goalCardStatus: GoalCardStatusEnum;
  id: Scalars['ID']['output'];
  /** The linked_cards of this `WorkspaceDashboard::GoalCard`. */
  linkedCards: Maybe<Array<LinkedCard>>;
  /** The severity of this `WorkspaceDashboard::GoalCard`. */
  severity: Maybe<GoalCardSeverityEnum>;
  startDate: Maybe<Scalars['Date']['output']>;
  /**
   * The status of this `WorkspaceDashboard::GoalCard`.
   * @deprecated Use `goal_card_status` instead, remove this field after 2025-09-01
   */
  status: GoalCardStatusEnum;
  /** The sub_domain (`WorkspaceDashboard::SubDomain`) that this `WorkspaceDashboard::GoalCard` belongs to */
  subDomain: SubDomain;
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The users of this `WorkspaceDashboard::GoalCard`. */
  users: UserConnection;
  /** The workspace (`WorkspaceDashboard::Workspace`) that this `WorkspaceDashboard::GoalCard` belongs to */
  workspace: Workspace;
}

export interface GoalCardCardCommentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GoalCardCardLogsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GoalCardCardTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GoalCardUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for GoalCard. */
export interface GoalCardConnection {
  __typename: 'GoalCardConnection';
  /** The total (unfiltered) amount of active `GoalCard`s in this connection. */
  activeCardCount: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges: Array<GoalCardEdge>;
  /** A list of nodes. */
  nodes: Array<GoalCard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GoalCardEdge {
  __typename: 'GoalCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GoalCard>;
}

/** Filter for `WorkspaceDashboard::GoalCard` */
export interface GoalCardFilter {
  /** Only return objects with given featured */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return objects with given severities */
  severity?: InputMaybe<Array<GoalCardSeverityEnum>>;
  /** Only return objects with given statuses */
  status?: InputMaybe<Array<GoalCardStatusEnum>>;
  /** Only show the `GoalCard` for given `SubDomain`s */
  subDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `GoalCard` for given `Workspace`s */
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export enum GoalCardSeverityEnum {
  /** `GoalCard` severity is ambition */
  AMBITION = 'AMBITION',
  /** `GoalCard` severity is critical */
  CRITICAL = 'CRITICAL',
  /** `GoalCard` severity is improvement */
  IMPROVEMENT = 'IMPROVEMENT',
  /** `GoalCard` severity is no_weight */
  NO_WEIGHT = 'NO_WEIGHT',
  /** `GoalCard` severity is positive */
  POSITIVE = 'POSITIVE',
  /** `GoalCard` severity is severe */
  SEVERE = 'SEVERE',
}

export enum GoalCardStatusEnum {
  /** The status of the `GoalCard` is act */
  ACT = 'ACT',
  /** The status of the `GoalCard` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `GoalCard` is check */
  CHECK = 'CHECK',
  /** The status of the `GoalCard` is completed */
  COMPLETED = 'COMPLETED',
  /** The status of the `GoalCard` is do */
  DO = 'DO',
  /** The status of the `GoalCard` is future */
  FUTURE = 'FUTURE',
  /** The status of the `GoalCard` is plan */
  PLAN = 'PLAN',
}

export interface GoalCardSummary extends Node {
  __typename: 'GoalCardSummary';
  /** The completed_at of this `WorkspaceDashboard::GoalCardSummary`. */
  completedAt: Maybe<Scalars['Date']['output']>;
  /** The end_date of this `WorkspaceDashboard::GoalCardSummary`. */
  endDate: Maybe<Scalars['Date']['output']>;
  /** Whether `WorkspaceDashboard::GoalCardSummary` is featured. */
  featured: Scalars['Boolean']['output'];
  /** The goal_card_summary_status of this `WorkspaceDashboard::GoalCardSummary`. */
  goalCardSummaryStatus: GoalCardStatusEnum;
  id: Scalars['ID']['output'];
  /** The severity of this `WorkspaceDashboard::GoalCardSummary`. */
  severity: GoalCardSeverityEnum;
  /** The start_date of this `WorkspaceDashboard::GoalCardSummary`. */
  startDate: Maybe<Scalars['Date']['output']>;
  /**
   * The status of this `WorkspaceDashboard::GoalCardSummary`.
   * @deprecated Use `goal_card_summary_status` instead, remove this field after 2025-09-01
   */
  status: GoalCardStatusEnum;
  /** The title of this `WorkspaceDashboard::GoalCardSummary`. */
  title: Scalars['String']['output'];
}

/** The connection type for GoalCardSummary. */
export interface GoalCardSummaryConnection {
  __typename: 'GoalCardSummaryConnection';
  /** A list of edges. */
  edges: Array<GoalCardSummaryEdge>;
  /** A list of nodes. */
  nodes: Array<GoalCardSummary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GoalCardSummaryEdge {
  __typename: 'GoalCardSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GoalCardSummary>;
}

export enum GoalCategoryTypeEnum {
  /** This is a regular `Goal` */
  GOAL = 'GOAL',
  /** This is a profiling `Goal` */
  PROFILE = 'PROFILE',
}

/** The connection type for Goal. */
export interface GoalConnection {
  __typename: 'GoalConnection';
  /** A list of edges. */
  edges: Array<GoalEdge>;
  /** A list of nodes. */
  nodes: Array<Goal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GoalEdge {
  __typename: 'GoalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Goal>;
}

/** Filter for `Goal`s */
export interface GoalFilter {
  /** Only show objects related to this Canmed */
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show objects of these categories */
  categories?: InputMaybe<Array<GoalCategoryTypeEnum>>;
  /** Only show objects related to these `Residencies` */
  residencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects related to these `Skills` */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export enum GoalStatusEnum {
  /** Portfolio owner has achieved this `Goal` */
  ACHIEVED = 'ACHIEVED',
  /** This goal has been replaced or abandoned */
  ARCHIVED = 'ARCHIVED',
  /** Portfolio owner is working towards completing this `Goal` */
  STARTED = 'STARTED',
}

export interface Guideline extends Node, Timestamped {
  __typename: 'Guideline';
  /** The argumentation of this `Guideline`. */
  argumentation: Maybe<Scalars['String']['output']>;
  /** The body of this `Guideline`. */
  body: Maybe<Scalars['String']['output']>;
  /** The change_reason of this `Guideline`. */
  changeReason: Maybe<Scalars['String']['output']>;
  /** The child_display_type of this `Guideline`. */
  childDisplayType: Maybe<Scalars['String']['output']>;
  /** The code of this `Guideline`. */
  code: Maybe<Code>;
  /** The created at date of this `Guideline`. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The criteria of this `Guideline`. */
  criteria: Maybe<Scalars['JSON']['output']>;
  /** The guideline_attachments of this `Guideline`. */
  guidelineAttachments: Maybe<GuidelineAttachmentConnection>;
  /** The icpc of this `Guideline`. */
  icpc: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The legacy_id of this `Guideline`. */
  legacyId: Maybe<Scalars['ID']['output']>;
  /** The order of this `Guideline`. */
  order: Maybe<Scalars['Int']['output']>;
  /** The published at date of this `Guideline`. */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The synonyms of this `Guideline`. */
  synonyms: Maybe<Scalars['String']['output']>;
  /** The tags of this `Guideline`. */
  tags: Array<Scalars['String']['output']>;
  /** The title of this `Guideline`. */
  title: Scalars['String']['output'];
  /** The trashed at date of this `Guideline`. */
  trashedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The updated at date of this `Guideline`. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface GuidelineGuidelineAttachmentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GuidelineAttachment extends Node, Timestamped {
  __typename: 'GuidelineAttachment';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `GuidelineAttachment`. */
  description: Maybe<Scalars['String']['output']>;
  /** The guideline of this `GuidelineAttachment`. */
  guideline: Maybe<Guideline>;
  id: Scalars['ID']['output'];
  /** The published at date of this `GuidelineAttachment`. */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title of this `GuidelineAttachment`. */
  title: Scalars['String']['output'];
  /** The trashed at date of this `GuidelineAttachment`. */
  trashedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for GuidelineAttachment. */
export interface GuidelineAttachmentConnection {
  __typename: 'GuidelineAttachmentConnection';
  /** A list of edges. */
  edges: Array<GuidelineAttachmentEdge>;
  /** A list of nodes. */
  nodes: Array<GuidelineAttachment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GuidelineAttachmentEdge {
  __typename: 'GuidelineAttachmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<GuidelineAttachment>;
}

export interface HistogramBucket {
  __typename: 'HistogramBucket';
  /** Start of this bucket (inclusive) */
  begin: Maybe<Scalars['Float']['output']>;
  /** Bucket number */
  bucket: Maybe<Scalars['Int']['output']>;
  /** Number of elements in this bucket */
  count: Maybe<Scalars['Int']['output']>;
  /** End of this bucket (exclusive) */
  end: Maybe<Scalars['Float']['output']>;
}

/** Autogenerated input type of ImportPortfolioFormat */
export interface ImportPortfolioFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Export of the configuration of the portfolioformat. */
  configurationJson: Scalars['JSON']['input'];
}

/** Autogenerated return type of ImportPortfolioFormat. */
export interface ImportPortfolioFormatPayload {
  __typename: 'ImportPortfolioFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /**
   * `PortfolioFormat` that was created
   * @deprecated Mutation is now asynchronous, so no instantaneous result. Remove in october 2024
   */
  portfolioFormat: Maybe<PortfolioFormat>;
  successMessage: Maybe<Scalars['String']['output']>;
}

export enum ImportStatusEnum {
  /** This import/export has successfully been created */
  CREATED = 'CREATED',
  /** This import/export is no longer relevant */
  EXPIRED = 'EXPIRED',
  /** This import/export has failed in some way */
  FAILED = 'FAILED',
  /** This import/export could not be performed because the supplied data is invalid */
  NOT_VALID = 'NOT_VALID',
  /** This import/export has been requested */
  REQUESTED = 'REQUESTED',
}

export interface ImportantNotice extends Node, Timestamped {
  __typename: 'ImportantNotice';
  /** The application of this `ImportantNotice`. */
  application: ImportantNoticeApplicationEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The text of this `ImportantNotice`. */
  text: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export enum ImportantNoticeApplicationEnum {
  /** The application of the `ImportantNotice` is all_applications */
  ALL_APPLICATIONS = 'ALL_APPLICATIONS',
  /** The application of the `ImportantNotice` is portfolio */
  PORTFOLIO = 'PORTFOLIO',
  /** The application of the `ImportantNotice` is workspace_dashboard */
  WORKSPACE_DASHBOARD = 'WORKSPACE_DASHBOARD',
}

export interface Interview
  extends Accessible, Activities, Copyable, Creatable, Form, Node, PortfolioItem, SubjectOfFeedbackRound, Timestamped {
  __typename: 'Interview';
  /** The approved_by_owner_reason of this `Interview`. */
  approvedByOwnerReason: Maybe<Scalars['String']['output']>;
  /** The approved_by_supervisor_reason of this `Interview`. */
  approvedBySupervisorReason: Maybe<Scalars['String']['output']>;
  /** The approved_reason of this `Interview`. */
  approvedReason: Maybe<Scalars['String']['output']>;
  /** The attached_files of this `Interview`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** `ClinicalCompetenceCommittee`s this `Interview` is linked to */
  clinicalCompetenceCommittees: ClinicalCompetenceCommitteeConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The date of this `Interview`. */
  date: Maybe<Scalars['Date']['output']>;
  /** The end_on of this `Interview`. */
  endOn: Maybe<Scalars['Date']['output']>;
  /** `FeedbackRequest` for this subject belonging to the current user */
  feedbackRequest: Maybe<FeedbackRequest>;
  /** `FeedbackRound` for this subject belonging to the current user */
  feedbackRound: Maybe<FeedbackRound>;
  /** Type of this form */
  formType: Maybe<Scalars['String']['output']>;
  /** Version of this form */
  formVersion: Maybe<Scalars['String']['output']>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  id: Scalars['ID']['output'];
  /** Metadata from the import process */
  importMetaData: Scalars['JSON']['output'];
  /** The interview_status of this `Interview`. */
  interviewStatus: InterviewStatusEnum;
  /** Whether the `Interview` is a yearly assessment or not */
  isYearlyAssessment: Scalars['Boolean']['output'];
  /** The owner approved at date of this `Interview`. */
  ownerApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The owner voided at date of this `Interview`. */
  ownerVoidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `PortfolioDocumentConfig` that this `Interview` belongs to */
  portfolioDocumentConfig: PortfolioDocumentConfig;
  /** Reduction of the last approved `Interview` */
  previousReduction: Maybe<Scalars['Float']['output']>;
  /** Total reduction up to the approved_at date of this `Interview` */
  reduction: Maybe<Scalars['Float']['output']>;
  /** Delta of the reduction and the previous reduction makes the reduction given in this `Interview` */
  reductionDelta: Maybe<Scalars['Float']['output']>;
  /** The reduction_reason of this `Interview`. */
  reductionReason: Maybe<Scalars['String']['output']>;
  /** Other interviews that refer to this `Interview` */
  referredToByInterviews: Array<Interview>;
  /** Other interviews that this `Interview` refers to */
  refersToInterviews: Array<Interview>;
  /** The `Residency` that this `Interview` belongs to */
  residency: Maybe<Residency>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** Attributes of original object */
  sourceAttributes: Maybe<Scalars['JSON']['output']>;
  /** The start_on of this `Interview`. */
  startOn: Maybe<Scalars['Date']['output']>;
  /**
   * The status of this `Interview`.
   * @deprecated Use `interview_status` instead, remove this field after 2025-09-01
   */
  status: InterviewStatusEnum;
  /** The supervisor (`User`) that this `Interview` belongs to */
  supervisor: Maybe<User>;
  /** The supervisor approved at date of this `Interview`. */
  supervisorApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether `Interview` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `Interview` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** The supervisor voided at date of this `Interview`. */
  supervisorVoidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title of this `Interview`. */
  title: Maybe<Scalars['String']['output']>;
  /** The topics of this `Interview`. */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface InterviewClinicalCompetenceCommitteesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface InterviewSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Interview. */
export interface InterviewConnection {
  __typename: 'InterviewConnection';
  /** A list of edges. */
  edges: Array<InterviewEdge>;
  /** The counts of distinct filtered formType values. This is a JSON object with number values. */
  formTypeCounts: Maybe<Scalars['JSON']['output']>;
  /** A list of nodes. */
  nodes: Array<Interview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total filtered amount of items in this connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
}

/** An edge in a connection. */
export interface InterviewEdge {
  __typename: 'InterviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Interview>;
}

export enum InterviewStatusEnum {
  /** The status of the `Interview` is approved */
  APPROVED = 'APPROVED',
  /** The status of the `Interview` is approved_by_owner */
  APPROVED_BY_OWNER = 'APPROVED_BY_OWNER',
  /** The status of the `Interview` is approved_by_supervisor */
  APPROVED_BY_SUPERVISOR = 'APPROVED_BY_SUPERVISOR',
  /** The status of the `Interview` is copied */
  COPIED = 'COPIED',
  /** The status of the `Interview` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `Interview` is imported */
  IMPORTED = 'IMPORTED',
  /** The status of the `Interview` is rejected */
  REJECTED = 'REJECTED',
  /** The status of the `Interview` is voided */
  VOIDED = 'VOIDED',
}

export interface Invite extends Node, Timestamped {
  __typename: 'Invite';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Subject that this `Invite` is for */
  subject: Maybe<InviteSubject>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Invited `User` */
  user: Maybe<User>;
}

/** The connection type for Invite. */
export interface InviteConnection {
  __typename: 'InviteConnection';
  /** A list of edges. */
  edges: Array<InviteEdge>;
  /** A list of nodes. */
  nodes: Array<Invite>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface InviteEdge {
  __typename: 'InviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Invite>;
}

/** Object which can be the subject of a `Invite` */
export type InviteSubject = Kpb;

export interface Invoice extends Node, Timestamped {
  __typename: 'Invoice';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End date of the `Edition` (inclusive) */
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** `InvoicePlan` this `Invoice` belongs to */
  invoicePlan: InvoicePlan;
  /** `license_price` on the `Invoice` */
  licensePrice: Scalars['Float']['output'];
  /** Start date of the `Edition` */
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for Invoice. */
export interface InvoiceConnection {
  __typename: 'InvoiceConnection';
  /** A list of edges. */
  edges: Array<InvoiceEdge>;
  /** A list of nodes. */
  nodes: Array<Invoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface InvoiceEdge {
  __typename: 'InvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Invoice>;
}

export interface InvoicePlan extends Node, Timestamped {
  __typename: 'InvoicePlan';
  /** `Contact` this `InvoicePlan` applies to */
  contact: Contact;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** the invoice frequency of the `InvoicePlan` */
  invoiceFrequency: InvoicePlanFrequencyEnum;
  /** `Invoices` that belong to this `InvoicePlan` */
  invoices: InvoiceConnection;
  /** `LedgerAccount` this `InvoicePlan` applies to */
  ledgerAccount: Maybe<LedgerAccount>;
  /** `license_price` on the `InvoicePlan` */
  licensePrice: Scalars['Float']['output'];
  /** Whether to add a list of licenses (as PDF) as an attachment to an invoice in MoneyBird */
  moneybirdAttachSpecifications: Scalars['Boolean']['output'];
  /** The `Organization` this `InvoicePlan` applies to. */
  organization: Organization;
  /** `PortfolioFormat` this `InvoicePlan` applies to */
  portfolioFormat: PortfolioFormat;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface InvoicePlanInvoicesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for InvoicePlan. */
export interface InvoicePlanConnection {
  __typename: 'InvoicePlanConnection';
  /** A list of edges. */
  edges: Array<InvoicePlanEdge>;
  /** A list of nodes. */
  nodes: Array<InvoicePlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface InvoicePlanEdge {
  __typename: 'InvoicePlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<InvoicePlan>;
}

export enum InvoicePlanFrequencyEnum {
  /** InvoicePlan frequency is manual */
  MANUAL = 'MANUAL',
  /** InvoicePlan frequency is monthly */
  MONTHLY = 'MONTHLY',
  /** InvoicePlan frequency is quarterly */
  QUARTERLY = 'QUARTERLY',
}

export type Item =
  LearningResourceArticle | LearningResourceFile | LearningResourceLink | LearningResourceMicroLearning;

export interface Kpb extends Accessible, Activities, Copyable, Creatable, Form, Node, PortfolioItem, Timestamped {
  __typename: 'KPB';
  /** The approved_by_owner_reason of this `KPB`. */
  approvedByOwnerReason: Maybe<Scalars['String']['output']>;
  /** The approved_by_supervisor_reason of this `KPB`. */
  approvedBySupervisorReason: Maybe<Scalars['String']['output']>;
  /** The approved_reason of this `KPB`. */
  approvedReason: Maybe<Scalars['String']['output']>;
  /** The attached_files of this `KPB`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** Canmeds for this assessment */
  canmeds: Maybe<Canmeds>;
  /** Field for additional comments */
  comments: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** The date of this `KPB`. */
  date: Maybe<Scalars['Date']['output']>;
  /** Type of this form */
  formType: Maybe<Scalars['String']['output']>;
  /** Version of this form */
  formVersion: Maybe<Scalars['String']['output']>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  id: Scalars['ID']['output'];
  /** Metadata from the import process */
  importMetaData: Scalars['JSON']['output'];
  /** Invite of which this object is the subject */
  invites: Maybe<InviteConnection>;
  /** The kpb_status of this `KPB`. */
  kpbStatus: KpbStatusEnum;
  /** The kpb_sub_skill_scores of this `KPB`. */
  kpbSubSkillScores: KpbSubSkillScoreConnection;
  /** Relative level at which this activity was performed */
  level: Maybe<LevelEnum>;
  /** The owner rejected at date of this `KPB`. */
  ownerRejectedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The owner voided at date of this `KPB`. */
  ownerVoidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Things that need improvement */
  pointsOfConcern: Maybe<Scalars['String']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `PortfolioDocumentConfig` that this `KPB` belongs to */
  portfolioDocumentConfig: PortfolioDocumentConfig;
  /** Things that went well */
  positivePoints: Maybe<Scalars['String']['output']>;
  /** The rejection_reason of this `KPB`. */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** Attributes of original object */
  sourceAttributes: Maybe<Scalars['JSON']['output']>;
  /**
   * The status of this `KPB`.
   * @deprecated Use `kpb_status` instead, remove this field after 2025-09-01
   */
  status: KpbStatusEnum;
  /** The supervision_level of this `KPB`. */
  supervisionLevel: Maybe<Scalars['Int']['output']>;
  /** The supervisor (`User`) that this `KPB` belongs to */
  supervisor: Maybe<User>;
  /** The supervisor approved at date of this `KPB`. */
  supervisorApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether `KPB` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `KPB` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** The supervisor voided at date of this `KPB`. */
  supervisorVoidedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title of this `KPB`. */
  title: Maybe<Scalars['String']['output']>;
  /** Multipurpose feedback field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface KpbInvitesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface KpbKpbSubSkillScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<KpbSubSkillScoreFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface KpbSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for KPB. */
export interface KpbConnection {
  __typename: 'KPBConnection';
  /** A list of edges. */
  edges: Array<KpbEdge>;
  /** The counts of distinct filtered formType values. This is a JSON object with number values. */
  formTypeCounts: Maybe<Scalars['JSON']['output']>;
  /** A list of nodes. */
  nodes: Array<Kpb>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total filtered amount of items in this connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
}

/** An edge in a connection. */
export interface KpbEdge {
  __typename: 'KPBEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Kpb>;
}

export enum KpbStatusEnum {
  /** The status of the `KPB` is approved */
  APPROVED = 'APPROVED',
  /** The status of the `KPB` is approved_by_owner */
  APPROVED_BY_OWNER = 'APPROVED_BY_OWNER',
  /** The status of the `KPB` is copied */
  COPIED = 'COPIED',
  /** The status of the `KPB` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `KPB` is imported */
  IMPORTED = 'IMPORTED',
  /** The status of the `KPB` is rejected */
  REJECTED = 'REJECTED',
  /** The status of the `KPB` is voided */
  VOIDED = 'VOIDED',
}

export interface KpbSubSkillScore extends Node, Timestamped {
  __typename: 'KPBSubSkillScore';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `KPB` that this `KPBSubSkillScore` belongs to */
  kpb: Kpb;
  /** Score for the sub skill */
  kpbSubSkillScore: Scalars['Int']['output'];
  /** The skill of this `KPBSubSkillScore`. */
  skill: Skill;
  /**
   * The `SkillSubSkill` that this `KPBSubSkillScore` belongs to
   * @deprecated Use `skill` and `subSkill` fields instead. This field will be removed after the 1st of January 2025.
   */
  skillSubSkill: SkillSubSkill;
  /** The sub_skill of this `KPBSubSkillScore`. */
  subSkill: Skill;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for KPBSubSkillScore. */
export interface KpbSubSkillScoreConnection {
  __typename: 'KPBSubSkillScoreConnection';
  /** A list of edges. */
  edges: Array<KpbSubSkillScoreEdge>;
  /** A list of nodes. */
  nodes: Array<KpbSubSkillScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface KpbSubSkillScoreEdge {
  __typename: 'KPBSubSkillScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<KpbSubSkillScore>;
}

export interface KpbSubSkillScoreFilter {
  /** Only show the `KPBSubSkillScore`s for `Skill`s with given `subSkillIds` */
  subSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export enum LanguageEnum {
  /** English */
  EN = 'EN',
  /** Dutch */
  NL = 'NL',
  /** Not set */
  NOT_SET = 'NOT_SET',
}

export interface LearningContentCategory {
  __typename: 'LearningContentCategory';
  id: Scalars['ID']['output'];
  learningContentLinks: LearningContentLinkConnection;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  skill: Maybe<Skill>;
}

export interface LearningContentCategoryLearningContentLinksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for LearningContentCategory. */
export interface LearningContentCategoryConnection {
  __typename: 'LearningContentCategoryConnection';
  /** A list of edges. */
  edges: Array<LearningContentCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<LearningContentCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningContentCategoryEdge {
  __typename: 'LearningContentCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningContentCategory>;
}

export interface LearningContentLink {
  __typename: 'LearningContentLink';
  avatarUrl: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  duration: Maybe<Scalars['Int']['output']>;
  hasVideo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  learningContentCategory: Maybe<LearningContentCategory>;
  order: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  /** @deprecated Use `skill` field on `LearningContentCategory` */
  skill: Maybe<Skill>;
  skillLevelFormat: Maybe<SkillLevelFormat>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

/** The connection type for LearningContentLink. */
export interface LearningContentLinkConnection {
  __typename: 'LearningContentLinkConnection';
  /** A list of edges. */
  edges: Array<LearningContentLinkEdge>;
  /** A list of nodes. */
  nodes: Array<LearningContentLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningContentLinkEdge {
  __typename: 'LearningContentLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningContentLink>;
}

export interface LearningResourceAlertedSetItemForUser extends Node, Timestamped {
  __typename: 'LearningResourceAlertedSetItemForUser';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The learning_resource_item of this `LearningResource::AlertedSetItemForUser`. */
  learningResourceItem: Maybe<Item>;
  /** The learning_resource_set of this `LearningResource::AlertedSetItemForUser`. */
  learningResourceSet: Maybe<LearningResourceSet>;
  /** The read at date of this `LearningResource::AlertedSetItemForUser`. */
  readAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for LearningResourceAlertedSetItemForUser. */
export interface LearningResourceAlertedSetItemForUserConnection {
  __typename: 'LearningResourceAlertedSetItemForUserConnection';
  /** A list of edges. */
  edges: Array<LearningResourceAlertedSetItemForUserEdge>;
  /** A list of nodes. */
  nodes: Array<LearningResourceAlertedSetItemForUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningResourceAlertedSetItemForUserEdge {
  __typename: 'LearningResourceAlertedSetItemForUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningResourceAlertedSetItemForUser>;
}

export interface LearningResourceArticle extends Node, Timestamped {
  __typename: 'LearningResourceArticle';
  /** The content_json_content of this `LearningResource::Article`. */
  contentJsonContent: Scalars['JSONContent']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The image of this `LearningResource::Article`. */
  image: Maybe<AttachedFile>;
  /** The large_image of this `LearningResource::Article`. */
  largeImage: Maybe<AttachedFile>;
  /** The medium_image of this `LearningResource::Article`. */
  mediumImage: Maybe<AttachedFile>;
  /** The thumb_image of this `LearningResource::Article`. */
  thumbImage: Maybe<AttachedFile>;
  /** The title of this `LearningResource::Article`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface LearningResourceFile extends Node, Timestamped {
  __typename: 'LearningResourceFile';
  /** The content of this `LearningResource::File`. */
  content: AttachedFile;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `LearningResource::File`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The image of this `LearningResource::File`. */
  image: Maybe<AttachedFile>;
  /** The large_image of this `LearningResource::File`. */
  largeImage: Maybe<AttachedFile>;
  /** The medium_image of this `LearningResource::File`. */
  mediumImage: Maybe<AttachedFile>;
  /** The thumb_image of this `LearningResource::File`. */
  thumbImage: Maybe<AttachedFile>;
  /** The title of this `LearningResource::File`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface LearningResourceGlobalCategory extends Node, Timestamped {
  __typename: 'LearningResourceGlobalCategory';
  /** The application of this `LearningResource::GlobalCategory`. */
  application: ApplicationEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `LearningResource::GlobalCategory`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The language of this `LearningResource::GlobalCategory`. */
  language: LanguageEnum;
  /** The learning_resource_sets of this `LearningResource::GlobalCategory`. */
  learningResourceSets: LearningResourceSetConnection;
  /** The order of this `LearningResource::GlobalCategory`. */
  order: Scalars['Int']['output'];
  /** The short_name of this `LearningResource::GlobalCategory`. */
  shortName: Scalars['String']['output'];
  /** The title of this `LearningResource::GlobalCategory`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface LearningResourceGlobalCategoryLearningResourceSetsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for LearningResourceGlobalCategory. */
export interface LearningResourceGlobalCategoryConnection {
  __typename: 'LearningResourceGlobalCategoryConnection';
  /** A list of edges. */
  edges: Array<LearningResourceGlobalCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<LearningResourceGlobalCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningResourceGlobalCategoryEdge {
  __typename: 'LearningResourceGlobalCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningResourceGlobalCategory>;
}

export interface LearningResourceLink extends Node, Timestamped {
  __typename: 'LearningResourceLink';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `LearningResource::Link`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The image of this `LearningResource::Link`. */
  image: Maybe<AttachedFile>;
  /** The large_image of this `LearningResource::Link`. */
  largeImage: Maybe<AttachedFile>;
  /** The medium_image of this `LearningResource::Link`. */
  mediumImage: Maybe<AttachedFile>;
  /** The thumb_image of this `LearningResource::Link`. */
  thumbImage: Maybe<AttachedFile>;
  /**
   * The thumbnail_url of this `LearningResource::Link`.
   * @deprecated Use `image` instead.
   */
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** The title of this `LearningResource::Link`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The url of this `LearningResource::Link`. */
  url: Scalars['String']['output'];
}

export interface LearningResourceMicroLearning extends Node, Timestamped {
  __typename: 'LearningResourceMicroLearning';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `LearningResource::MicroLearning`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The image of this `LearningResource::MicroLearning`. */
  image: Maybe<AttachedFile>;
  /**
   * The image_url of this `LearningResource::MicroLearning`.
   * @deprecated Use `image` instead.
   */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** The large_image of this `LearningResource::MicroLearning`. */
  largeImage: Maybe<AttachedFile>;
  /**
   * The large_image_url of this `LearningResource::MicroLearning`.
   * @deprecated Use `image` instead.
   */
  largeImageUrl: Maybe<Scalars['String']['output']>;
  /** The medium_image of this `LearningResource::MicroLearning`. */
  mediumImage: Maybe<AttachedFile>;
  /**
   * The medium_image_url of this `LearningResource::MicroLearning`.
   * @deprecated Use `image` instead.
   */
  mediumImageUrl: Maybe<Scalars['String']['output']>;
  /** The micro_learning_status of this `LearningResource::MicroLearning`. */
  microLearningStatus: MicroLearningStatusEnum;
  /** The micro_learning_steps of this `LearningResource::MicroLearning`. */
  microLearningSteps: LearningResourceMicroLearningStepConnection;
  /** The thumb_image of this `LearningResource::MicroLearning`. */
  thumbImage: Maybe<AttachedFile>;
  /**
   * The thumb_image_url of this `LearningResource::MicroLearning`.
   * @deprecated Use `image` instead.
   */
  thumbImageUrl: Maybe<Scalars['String']['output']>;
  /** The title of this `LearningResource::MicroLearning`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface LearningResourceMicroLearningMicroLearningStepsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface LearningResourceMicroLearningStep extends Node, Timestamped {
  __typename: 'LearningResourceMicroLearningStep';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * The description of this `LearningResource::MicroLearningStep`.
   * @deprecated Use `description_json_content` instead.
   */
  description: Maybe<Scalars['String']['output']>;
  /** The description_json_content of this `LearningResource::MicroLearningStep`. */
  descriptionJsonContent: Maybe<Scalars['JSONContent']['output']>;
  id: Scalars['ID']['output'];
  /** The image of this `LearningResource::MicroLearningStep`. */
  image: Maybe<AttachedFile>;
  /**
   * The image_url of this `LearningResource::MicroLearningStep`.
   * @deprecated Use `image` instead.
   */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** The large_image of this `LearningResource::MicroLearningStep`. */
  largeImage: Maybe<AttachedFile>;
  /**
   * The large_image_url of this `LearningResource::MicroLearningStep`.
   * @deprecated Use `image` instead.
   */
  largeImageUrl: Maybe<Scalars['String']['output']>;
  /** The link of this `LearningResource::MicroLearningStep`. */
  link: Maybe<Scalars['String']['output']>;
  /** The link_button_text of this `LearningResource::MicroLearningStep`. */
  linkButtonText: Maybe<Scalars['String']['output']>;
  /** The medium_image of this `LearningResource::MicroLearningStep`. */
  mediumImage: Maybe<AttachedFile>;
  /**
   * The medium_image_url of this `LearningResource::MicroLearningStep`.
   * @deprecated Use `image` instead.
   */
  mediumImageUrl: Maybe<Scalars['String']['output']>;
  /** The micro_learning (`LearningResource::MicroLearning`) that this `LearningResource::MicroLearningStep` belongs to */
  microLearning: LearningResourceMicroLearning;
  /** The order of this `LearningResource::MicroLearningStep`. */
  order: Scalars['Int']['output'];
  /** The thumb_image of this `LearningResource::MicroLearningStep`. */
  thumbImage: Maybe<AttachedFile>;
  /**
   * The thumb_image_url of this `LearningResource::MicroLearningStep`.
   * @deprecated Use `image` instead.
   */
  thumbImageUrl: Maybe<Scalars['String']['output']>;
  /** The title of this `LearningResource::MicroLearningStep`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for LearningResourceMicroLearningStep. */
export interface LearningResourceMicroLearningStepConnection {
  __typename: 'LearningResourceMicroLearningStepConnection';
  /** A list of edges. */
  edges: Array<LearningResourceMicroLearningStepEdge>;
  /** A list of nodes. */
  nodes: Array<LearningResourceMicroLearningStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningResourceMicroLearningStepEdge {
  __typename: 'LearningResourceMicroLearningStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningResourceMicroLearningStep>;
}

export interface LearningResourceMicroLearningUserProgress extends Node, Timestamped {
  __typename: 'LearningResourceMicroLearningUserProgress';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * The current_micro_learning_step (`LearningResource::MicroLearningStep`) that
   * this `LearningResource::MicroLearningUserProgress` belongs to
   */
  currentMicroLearningStep: Maybe<LearningResourceMicroLearningStep>;
  id: Scalars['ID']['output'];
  /** The micro_learning (`LearningResource::MicroLearning`) that this `LearningResource::MicroLearningUserProgress` belongs to */
  microLearning: Maybe<LearningResourceMicroLearning>;
  /** The status of this `LearningResource::MicroLearningUserProgress`. */
  status: MicroLearningUserProgressStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `LearningResource::MicroLearningUserProgress` belongs to */
  user: Maybe<User>;
}

/** The connection type for LearningResourceMicroLearningUserProgress. */
export interface LearningResourceMicroLearningUserProgressConnection {
  __typename: 'LearningResourceMicroLearningUserProgressConnection';
  /** A list of edges. */
  edges: Array<LearningResourceMicroLearningUserProgressEdge>;
  /** A list of nodes. */
  nodes: Array<LearningResourceMicroLearningUserProgress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningResourceMicroLearningUserProgressEdge {
  __typename: 'LearningResourceMicroLearningUserProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningResourceMicroLearningUserProgress>;
}

export interface LearningResourceSet extends Node, Timestamped {
  __typename: 'LearningResourceSet';
  /** Whether `LearningResource::Set` is beta only. */
  betaOnly: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `LearningResource::Set`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The learning_resource_global_category (`LearningResource::GlobalCategory`) that this `LearningResource::Set` belongs to */
  learningResourceGlobalCategory: Maybe<LearningResourceGlobalCategory>;
  /** The learning_resource_items of this `LearningResource::Set`. */
  learningResourceItems: Maybe<SetItemsConnection>;
  /** The order of this `LearningResource::Set`. */
  order: Scalars['Int']['output'];
  /** The `PortfolioFormat` that this `LearningResource::Set` belongs to */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** The `Skill` that this `LearningResource::Set` belongs to */
  skill: Maybe<Skill>;
  /** The title of this `LearningResource::Set`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The visible_for_role_types of this `LearningResource::Set`. */
  visibleForRoleTypes: Maybe<Array<RoleTypeEnum>>;
}

export interface LearningResourceSetLearningResourceItemsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for LearningResourceSet. */
export interface LearningResourceSetConnection {
  __typename: 'LearningResourceSetConnection';
  /** A list of edges. */
  edges: Array<LearningResourceSetEdge>;
  /** A list of nodes. */
  nodes: Array<LearningResourceSet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LearningResourceSetEdge {
  __typename: 'LearningResourceSetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LearningResourceSet>;
}

export interface LedgerAccount extends Node, Timestamped {
  __typename: 'LedgerAccount';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The moneybird_id of this `Billing::LedgerAccount`. */
  moneybirdId: Maybe<Scalars['String']['output']>;
  /** The name of this `Billing::LedgerAccount`. */
  name: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for LedgerAccount. */
export interface LedgerAccountConnection {
  __typename: 'LedgerAccountConnection';
  /** A list of edges. */
  edges: Array<LedgerAccountEdge>;
  /** A list of nodes. */
  nodes: Array<LedgerAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LedgerAccountEdge {
  __typename: 'LedgerAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<LedgerAccount>;
}

export enum LevelDisplayEnum {
  /** Bar */
  BAR = 'BAR',
  /** No display */
  NO_DISPLAY = 'NO_DISPLAY',
  /** Triangle */
  TRIANGLE = 'TRIANGLE',
}

export enum LevelEnum {
  /** Activity performed above expected level */
  ABOVE_LEVEL = 'ABOVE_LEVEL',
  /** Activity performed at expected level */
  AT_LEVEL = 'AT_LEVEL',
  /** Activity performed below expected level */
  BELOW_LEVEL = 'BELOW_LEVEL',
  /** Activity performed just below expected level */
  JUST_BELOW_LEVEL = 'JUST_BELOW_LEVEL',
}

/** Card type which can be linked to other Card */
export type LinkedCard = EventCard | GoalCard;

export interface ManageRights {
  __typename: 'ManageRights';
  canManageRoles: Scalars['Boolean']['output'];
  canViewReports: Scalars['Boolean']['output'];
}

/** Autogenerated input type of MarkAlertedLearningResourceItemRead */
export interface MarkAlertedLearningResourceItemReadInput {
  /** ID of the `LearningResourceItem` for which the alert should be marked as read */
  alertedLearningResourceSetItemForUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of MarkAlertedLearningResourceItemRead. */
export interface MarkAlertedLearningResourceItemReadPayload {
  __typename: 'MarkAlertedLearningResourceItemReadPayload';
  alertedLearningResourceSetItemForUser: Maybe<LearningResourceAlertedSetItemForUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of MarkAllNotificationsAsRead */
export interface MarkAllNotificationsAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of MarkAllNotificationsAsRead. */
export interface MarkAllNotificationsAsReadPayload {
  __typename: 'MarkAllNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Notification`s that were marked as read */
  notifications: Maybe<Array<Notification>>;
}

/** Autogenerated input type of MarkImportantNoticeAsRead */
export interface MarkImportantNoticeAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  importantNoticeId: Scalars['ID']['input'];
}

/** Autogenerated return type of MarkImportantNoticeAsRead. */
export interface MarkImportantNoticeAsReadPayload {
  __typename: 'MarkImportantNoticeAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  importantNotice: Maybe<ImportantNotice>;
}

export interface Memo extends Node, Timestamped {
  __typename: 'Memo';
  /** The actual text of this `Memo` */
  content: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** This memo is a personal memo and not regarding a specific portfolio */
  isPersonal: Scalars['Boolean']['output'];
  /** User linked to this `Memo` */
  owner: Maybe<User>;
  /** Subject that this `Memo` is about */
  portfolio: Maybe<Portfolio>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of MergeUser */
export interface MergeUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `User` to merge from */
  sourceUserId: Scalars['ID']['input'];
  /** ID of the `User` to merge to */
  targetUserId: Scalars['ID']['input'];
  /** Pin of the logged-in `User` */
  userPin: Scalars['String']['input'];
}

/** Autogenerated return type of MergeUser. */
export interface MergeUserPayload {
  __typename: 'MergeUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

export enum MicroLearningStatusEnum {
  /** The status of the `MicroLearning` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `MicroLearning` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `MicroLearning` is published */
  PUBLISHED = 'PUBLISHED',
}

export enum MicroLearningUserProgressStatusEnum {
  /** The status of the `MicroLearningUserProgress` is completed */
  COMPLETED = 'COMPLETED',
  /** The status of the `MicroLearningUserProgress` is in_progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The status of the `MicroLearningUserProgress` is not_started */
  NOT_STARTED = 'NOT_STARTED',
}

export enum MostSevereSeverityEnum {
  /** Most severe severity for `Workspace` and `SubDomain` is adequate */
  ADEQUATE = 'ADEQUATE',
  /** Most severe severity for `Workspace` and `SubDomain` is ambition */
  AMBITION = 'AMBITION',
  /** Most severe severity for `Workspace` and `SubDomain` is critical */
  CRITICAL = 'CRITICAL',
  /** Most severe severity for `Workspace` and `SubDomain` is featured */
  FEATURED = 'FEATURED',
  /** Most severe severity for `Workspace` and `SubDomain` is improvement */
  IMPROVEMENT = 'IMPROVEMENT',
  /** Most severe severity for `Workspace` and `SubDomain` is not shared */
  NOT_SHARED = 'NOT_SHARED',
  /** Most severe severity for `Workspace` and `SubDomain` is no_weight */
  NO_WEIGHT = 'NO_WEIGHT',
  /** Most severe severity for `Workspace` and `SubDomain` is positive */
  POSITIVE = 'POSITIVE',
  /** Most severe severity for `Workspace` and `SubDomain` is severe */
  SEVERE = 'SEVERE',
}

export interface MultiSource extends Activities, Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'MultiSource';
  /** The closed at date of this `MultiSource`. */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The collaborator of this `MultiSource`. */
  collaborator: Maybe<Scalars['JSON']['output']>;
  /** The collaborator_score of this `MultiSource`. */
  collaboratorScore: Maybe<Scalars['Float']['output']>;
  /** General comments */
  comments: Maybe<Scalars['String']['output']>;
  /** The communicator of this `MultiSource`. */
  communicator: Maybe<Scalars['JSON']['output']>;
  /** The communicator_score of this `MultiSource`. */
  communicatorScore: Maybe<Scalars['Float']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** End date of period considered in this questionnaire */
  endOn: Scalars['Date']['output'];
  /** The filled at date of this `MultiSource`. */
  filledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  /** The health_advocate of this `MultiSource`. */
  healthAdvocate: Maybe<Scalars['JSON']['output']>;
  /** The health_advocate_score of this `MultiSource`. */
  healthAdvocateScore: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** The leader of this `MultiSource`. */
  leader: Maybe<Scalars['JSON']['output']>;
  /** The leader_score of this `MultiSource`. */
  leaderScore: Maybe<Scalars['Float']['output']>;
  /** Comments included in sent emails */
  mailComments: Maybe<Scalars['String']['output']>;
  /** The medical_expert of this `MultiSource`. */
  medicalExpert: Maybe<Scalars['JSON']['output']>;
  /** The medical_expert_score of this `MultiSource`. */
  medicalExpertScore: Maybe<Scalars['Float']['output']>;
  /** The multi_source_status of this `MultiSource`. */
  multiSourceStatus: MultiSourceStatusEnum;
  /** The points_of_concern of this `MultiSource`. */
  pointsOfConcern: Maybe<Scalars['String']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `PortfolioDocumentConfig` that this `MultiSource` belongs to */
  portfolioDocumentConfig: PortfolioDocumentConfig;
  /** The positive_points of this `MultiSource`. */
  positivePoints: Maybe<Scalars['String']['output']>;
  /** The professional of this `MultiSource`. */
  professional: Maybe<Scalars['JSON']['output']>;
  /** The professional_score of this `MultiSource`. */
  professionalScore: Maybe<Scalars['Float']['output']>;
  /** The reflection of this `MultiSource`. */
  reflection: Maybe<Scalars['String']['output']>;
  /** The scholar of this `MultiSource`. */
  scholar: Maybe<Scalars['JSON']['output']>;
  /** The scholar_score of this `MultiSource`. */
  scholarScore: Maybe<Scalars['Float']['output']>;
  /** Start date of period considered in this questionnaire */
  startOn: Scalars['Date']['output'];
  /**
   * The status of this `MultiSource`.
   * @deprecated Use `multi_source_status` instead, remove this field after 2025-09-01
   */
  status: MultiSourceStatusEnum;
  /** The sub_multi_sources of this `MultiSource`. */
  subMultiSources: SubMultiSourceConnection;
  /** Averaged survey scores */
  surveyCanmedScores: Maybe<MultiSourceCanmedScores>;
  /** Email addresses sub-surveys were sent to */
  surveyEmails: Maybe<MultiSourceResponse>;
  /** Email addresses that have yet to respond */
  surveyEmailsOutstanding: Maybe<MultiSourceResponse>;
  /** Email addresses that have already responded */
  surveyEmailsResponded: Maybe<MultiSourceResponse>;
  /** The surveys_responded_to of this `MultiSource`. */
  surveysRespondedTo: Maybe<MultiSourceCount>;
  /** The surveys_sent of this `MultiSource`. */
  surveysSent: Maybe<MultiSourceCount>;
  /** Multipurpose field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface MultiSourceSubMultiSourcesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Canmed responses for different respondent types */
export interface MultiSourceCanmedResponse {
  __typename: 'MultiSourceCanmedResponse';
  /** Medical survey canmed responses */
  medical: Maybe<Scalars['JSON']['output']>;
  /** Other survey canmed responses */
  other: Maybe<Scalars['JSON']['output']>;
  /** Paramedic survey canmed responses */
  paramedic: Maybe<Scalars['JSON']['output']>;
  /** Patient survey canmed responses */
  patient: Maybe<Scalars['JSON']['output']>;
  /** Combined survey canmed responses */
  total: Maybe<Scalars['JSON']['output']>;
}

/** Returns average survey scores for a `MultiSource` */
export interface MultiSourceCanmedScores {
  __typename: 'MultiSourceCanmedScores';
  /** Scores for Collaborator canmed */
  collaborator: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Communicator canmed */
  communicator: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Health Advocate canmed */
  healthAdvocate: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Leader canmed */
  leader: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Medical Expert canmed */
  medicalExpert: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Professional canmed */
  professional: Maybe<MultiSourceCanmedResponse>;
  /** Scores for Scholar canmed */
  scholar: Maybe<MultiSourceCanmedResponse>;
}

/** The connection type for MultiSource. */
export interface MultiSourceConnection {
  __typename: 'MultiSourceConnection';
  /** A list of edges. */
  edges: Array<MultiSourceEdge>;
  /** A list of nodes. */
  nodes: Array<MultiSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** Gives a count for surveys */
export interface MultiSourceCount {
  __typename: 'MultiSourceCount';
  /** Number of medical surveys */
  medical: Maybe<Scalars['Int']['output']>;
  /** Number of other surveys */
  other: Maybe<Scalars['Int']['output']>;
  /** Number of paramedic surveys */
  paramedic: Maybe<Scalars['Int']['output']>;
  /** Number of patient surveys */
  patient: Maybe<Scalars['Int']['output']>;
}

/** An edge in a connection. */
export interface MultiSourceEdge {
  __typename: 'MultiSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MultiSource>;
}

/** Gives responses for surveys */
export interface MultiSourceResponse {
  __typename: 'MultiSourceResponse';
  /** Medical survey responses */
  medical: Maybe<Array<Scalars['String']['output']>>;
  /** Other survey responses */
  other: Maybe<Array<Scalars['String']['output']>>;
  /** Paramedic survey responses */
  paramedic: Maybe<Array<Scalars['String']['output']>>;
  /** Patient survey responses */
  patient: Maybe<Array<Scalars['String']['output']>>;
}

export enum MultiSourceStatusEnum {
  /** Multi source has been closed */
  CLOSED = 'CLOSED',
  /** Multi source has been filled in */
  FILLED = 'FILLED',
  /** Multi source is still open */
  OPEN = 'OPEN',
}

/** The root mutation object */
export interface Mutation {
  __typename: 'Mutation';
  /** Create a new `KPB` for a given `Portfolio` */
  activateExternalOauthConnection: Maybe<ActivateExternalOauthConnectionPayload>;
  /** Select a `CccFormConfig` for a `ClinicalCompetenceCommittee` */
  addCccFormConfigSelection: Maybe<AddCccFormConfigSelectionPayload>;
  /** Add a set of CourseEditions to a `User`. */
  addCourseEditionsToUser: Maybe<AddCourseEditionsToUserPayload>;
  /** Add a set of Courses to a `User`. */
  addCoursesToUser: Maybe<AddCoursesToUserPayload>;
  addLearningResourceItemToSet: Maybe<AddLearningResourceItemToSetPayload>;
  /**
   * Add a mandatory `Skill` to all `Portfolio`s that arelinked through
   * `SkillCategory` and `PortfolioFormat`. This will be done in a job, so result
   * can have a delay.
   */
  addMandatorySkillToPortfolios: Maybe<AddMandatorySkillToPortfoliosPayload>;
  addRespondentToClinicalCompetenceCommittee: Maybe<AddRespondentToClinicalCompetenceCommitteePayload>;
  /** Add a set of skills to a `Portfolio`. */
  addSkillsToPortfolio: Maybe<AddSkillsToPortfolioPayload>;
  addSubSkillsToSkill: Maybe<AddSubSkillsToSkillPayload>;
  /** Add a `User` to a `SupportGroup` */
  addUserToSupportGroup: Maybe<AddUserToSupportGroupPayload>;
  /** Add a `Workspace` to a `SecondaryDashboard` */
  addWorkspaceToSecondaryDashboard: Maybe<AddWorkspaceToSecondaryDashboardPayload>;
  /** Disables `SecondFactor`. */
  adminDisableSecondFactor: Maybe<AdminDisableSecondFactorPayload>;
  /** Set a `Portfolio`s status to `ARCHIVED` */
  archivePortfolio: Maybe<ArchivePortfolioPayload>;
  /** Recalculate the `OnboardingStep`s of a `Portfolio` */
  calculateOnboardingSteps: Maybe<CalculateOnboardingStepsPayload>;
  /** Cancel a removal request of a `Portfolio` */
  cancelPortfolioRemovalRequest: Maybe<CancelPortfolioRemovalRequestPayload>;
  /** Copies object to another `Portfolio` */
  copyObjectToPortfolio: Maybe<CopyObjectToPortfolioPayload>;
  createAdminGroup: Maybe<CreateAdminGroupPayload>;
  createAudioTranscript: Maybe<CreateAudioTranscriptPayload>;
  /** Create a new `WorkspaceDashboard::CardComment` for a given `Card` */
  createCardComment: Maybe<CreateCardCommentPayload>;
  /** Create a new `WorkspaceDashboard::CardTask` for a given `Card` */
  createCardTask: Maybe<CreateCardTaskPayload>;
  /** Create a new `CccFormConfig`. */
  createCccFormConfig: Maybe<CreateCccFormConfigPayload>;
  /** Create a new `ClinicalCompetenceCommittee` for a given `Portfolio` */
  createClinicalCompetenceCommittee: Maybe<CreateClinicalCompetenceCommitteePayload>;
  createCode: Maybe<CreateCodePayload>;
  /** Create a new `CompetenceCertificate` for a given `Portfolio` */
  createCompetenceCertificate: Maybe<CreateCompetenceCertificatePayload>;
  /** Create a `Course` */
  createCourse: Maybe<CreateCoursePayload>;
  /** Create a new `CourseResult` for a given `Portfolio` */
  createCourseResult: Maybe<CreateCourseResultPayload>;
  /** Create a new `CourseResult` by big and `PortfolioFormat` short name */
  createCourseResultByBigAndShortName: Maybe<CreateCourseResultByBigAndShortNamePayload>;
  /** Create a new custom `Skill` */
  createCustomSkill: Maybe<CreateCustomSkillPayload>;
  /** Create a new `WorkspaceDashboard` */
  createDashboard: Maybe<CreateDashboardPayload>;
  /** Create a new `DashboardFormat` */
  createDashboardFormat: Maybe<CreateDashboardFormatPayload>;
  /** Create a new `DashboardRole` for an `User` and a `Dashboard` */
  createDashboardRole: Maybe<CreateDashboardRolePayload>;
  /** Create a new `DirectUpload` that can be used to upload new files */
  createDirectUpload: Maybe<CreateDirectUploadPayload>;
  createDraft: Maybe<CreateDraftPayload>;
  /** Create a new `WorkspaceDashboard::EventCard` for a given `Workspace` */
  createEventCard: Maybe<CreateEventCardPayload>;
  /** Ask a `User` for feedback */
  createFeedbackRequest: Maybe<CreateFeedbackRequestPayload>;
  /** Create a new `FeedbackRound` for a given subject */
  createFeedbackRound: Maybe<CreateFeedbackRoundPayload>;
  /** Create a new `GeneralFeedback` on a `Portfolio` */
  createGeneralFeedback: Maybe<CreateGeneralFeedbackPayload>;
  /** Create a new `GeneralFeedbackFormConfig`. */
  createGeneralFeedbackFormConfig: Maybe<CreateGeneralFeedbackFormConfigPayload>;
  /** Create a new `Goal` for a given `Portfolio` */
  createGoal: Maybe<CreateGoalPayload>;
  /** Create a new `GoalActivity` for a given `Goal` */
  createGoalActivity: Maybe<CreateGoalActivityPayload>;
  /** Create a new `WorkspaceDashboard::GoalCard` for a given `Workspace` */
  createGoalCard: Maybe<CreateGoalCardPayload>;
  createGuideline: Maybe<CreateGuidelinePayload>;
  createGuidelineAttachment: Maybe<CreateGuidelineAttachmentPayload>;
  /** Create a new `Interview` for a given `Portfolio` */
  createInterview: Maybe<CreateInterviewPayload>;
  createInvite: Maybe<CreateInvitePayload>;
  /** Create a new `InvoicePlan` for an `Organization` */
  createInvoicePlan: Maybe<CreateInvoicePlanPayload>;
  /** Create a new `KPB` for a given `Portfolio` */
  createKPB: Maybe<CreateKpbPayload>;
  createLearningResourceArticle: Maybe<CreateLearningResourceArticlePayload>;
  createLearningResourceFile: Maybe<CreateLearningResourceFilePayload>;
  createLearningResourceGlobalCategory: Maybe<CreateLearningResourceGlobalCategoryPayload>;
  createLearningResourceLink: Maybe<CreateLearningResourceLinkPayload>;
  createLearningResourceMicroLearning: Maybe<CreateLearningResourceMicroLearningPayload>;
  createLearningResourceMicroLearningStep: Maybe<CreateLearningResourceMicroLearningStepPayload>;
  createLearningResourceMicroLearningUserProgress: Maybe<CreateLearningResourceMicroLearningUserProgressPayload>;
  createLearningResourceSet: Maybe<CreateLearningResourceSetPayload>;
  /** Create a new `Memo` for the viewer */
  createMemo: Maybe<CreateMemoPayload>;
  /** Create a new `MultiSource` for a given `Portfolio` */
  createMultiSource: Maybe<CreateMultiSourcePayload>;
  /** Creates one or more new `CompetenceCertificate`s */
  createMultipleCompetenceCertificates: Maybe<CreateMultipleCompetenceCertificatesPayload>;
  /** Creates one or more new `Registration`s */
  createMultipleRegistrations: Maybe<CreateMultipleRegistrationsPayload>;
  /** Deprecated: use `createMemo` instead. Create a new `Note` for a given `User` */
  createNote: Maybe<CreateNotePayload>;
  createOrUpdateFeatureToggle: Maybe<CreateOrUpdateFeatureTogglePayload>;
  createOrUpdateKPBSubSkillScore: Maybe<CreateOrUpdateKpbSubSkillScorePayload>;
  /** Create or update the `PortfolioFormatSpecialtyConfig` of a `PortfolioFormat` */
  createOrUpdatePortfolioFormatSpecialtyConfig: Maybe<CreateOrUpdatePortfolioFormatSpecialtyConfigPayload>;
  /** Create a new `Terminology`. */
  createOrUpdatePortfolioFormatTerminology: Maybe<CreateOrUpdatePortfolioFormatTerminologyPayload>;
  /** Create a new `PortfolioRole` for a given `Portfolio` and `User` or update existing `PortfolioRole` */
  createOrUpdatePortfolioRole: Maybe<CreateOrUpdatePortfolioRolePayload>;
  /** Find or create a new `PortfolioRoleSync` for a given `Portfolio` */
  createOrUpdatePortfolioRoleSync: Maybe<CreateOrUpdatePortfolioRoleSyncPayload>;
  createOrUpdateSkillLevelFormatDescription: Maybe<CreateOrUpdateSkillLevelFormatDescriptionPayload>;
  /** Create a new `Organization`. */
  createOrganization: Maybe<CreateOrganizationPayload>;
  /** Create a new `OrganizationUserRole` */
  createOrganizationUserRole: Maybe<CreateOrganizationUserRolePayload>;
  /** Create a new `WorkspaceDashboard::ParentDomain` for a given `DashboardFormat` */
  createParentDomain: Maybe<CreateParentDomainPayload>;
  /** Create a `ParticipationLevelFormat` for given `RootSkillCategoryConfig` */
  createParticipationLevelFormat: Maybe<CreateParticipationLevelFormatPayload>;
  createPeriodFormat: Maybe<CreatePeriodFormatPayload>;
  createPeriodRequiredSkillLevel: Maybe<CreatePeriodRequiredSkillLevelPayload>;
  /** Create a new Portfolio within the specified Organization */
  createPortfolio: Maybe<CreatePortfolioPayload>;
  /** Create a new `PortfolioDocumentConfig`. */
  createPortfolioDocumentConfig: Maybe<CreatePortfolioDocumentConfigPayload>;
  /** Create a new `PortfolioFormat` */
  createPortfolioFormat: Maybe<CreatePortfolioFormatPayload>;
  /** Create a new `PortfolioImport` */
  createPortfolioImport: Maybe<CreatePortfolioImportPayload>;
  /** Create a new `PortfolioNote` for a given `Portfolio` */
  createPortfolioNote: Maybe<CreatePortfolioNotePayload>;
  /** Create a new removal request for a given `Portfolio` */
  createPortfolioRemovalRequest: Maybe<CreatePortfolioRemovalRequestPayload>;
  /** Create a new `PortfolioRoleSync` for a given `Portfolio` */
  createPortfolioRoleSync: Maybe<CreatePortfolioRoleSyncPayload>;
  /**
   * Activate the `PortfolioRoleSync` for each given `Program` and give its users
   * their default `PortfolioRole` on the `Portfolio`. Existing `PortfolioRole`s
   * are left untouched.
   */
  createPortfolioRoleSyncsForPrograms: Maybe<CreatePortfolioRoleSyncsForProgramsPayload>;
  /** Create a new transfer request for a given `Portfolio` */
  createPortfolioTransferRequest: Maybe<CreatePortfolioTransferRequestPayload>;
  /** Create a `Program` */
  createProgram: Maybe<CreateProgramPayload>;
  /** Create a new `ProgramRole` for a given `Program`, `User` and `RoleFormat` */
  createProgramRole: Maybe<CreateProgramRolePayload>;
  /** Create a new `QualityInstrument` */
  createQualityInstrument: Maybe<CreateQualityInstrumentPayload>;
  /** Create a new `Registration` of a specific `Operation` */
  createRegistration: Maybe<CreateRegistrationPayload>;
  createReminderNotification: Maybe<CreateReminderNotificationPayload>;
  /** Create a new `Residency` for a given `Portfolio` */
  createResidency: Maybe<CreateResidencyPayload>;
  /** Create a `ResidencyArchetype` */
  createResidencyArchetype: Maybe<CreateResidencyArchetypePayload>;
  /** Create a new `RoleFormat` for a given `PortfolioFormat`. */
  createRoleFormat: Maybe<CreateRoleFormatPayload>;
  /** Create a new `RootSkillCategoryConfig` for a given `SkillCategory` */
  createRootSkillCategoryConfig: Maybe<CreateRootSkillCategoryConfigPayload>;
  /** Create a new `SecurityQuestion` for a `User` */
  createSecurityQuestion: Maybe<CreateSecurityQuestionPayload>;
  /** Create a new self-assessment `FeedbackRequest` for a given subject */
  createSelfAssessment: Maybe<CreateSelfAssessmentPayload>;
  /** Create a new `Skill` */
  createSkill: Maybe<CreateSkillPayload>;
  /** Create a new `SkillCategory` */
  createSkillCategory: Maybe<CreateSkillCategoryPayload>;
  /** Create a `SkillLevelFormat` for given `RootSkillCategoryConfig` */
  createSkillLevelFormat: Maybe<CreateSkillLevelFormatPayload>;
  /** Create a new `WorkspaceDashboard::SubDomain` for a given `ParentDomain` */
  createSubDomain: Maybe<CreateSubDomainPayload>;
  /** Create a new sub-`MultiSource` */
  createSubMultiSource: Maybe<CreateSubMultiSourcePayload>;
  createUsageStatistic: Maybe<CreateUsageStatisticPayload>;
  /** Create a new User */
  createUser: Maybe<CreateUserPayload>;
  createUserWithProgramRole: Maybe<CreateUserWithProgramRolePayload>;
  /** Create a new `Workspace` */
  createWorkspace: Maybe<CreateWorkspacePayload>;
  /** Create a new `WorkspaceRole` for an `User` and a `Workspace` */
  createWorkspaceRole: Maybe<CreateWorkspaceRolePayload>;
  /** Deactivate a `PortfolioRole` */
  deactivatePortfolioRole: Maybe<DeactivatePortfolioRolePayload>;
  /** Destroy an `AttachedFile` */
  destroyAttachedFile: Maybe<DestroyAttachedFilePayload>;
  /** Destroy a `Ai::AudioTranscript` */
  destroyAudioTranscript: Maybe<DestroyAudioTranscriptPayload>;
  /** Destroy a `WorkspaceDashboard::CardComment` */
  destroyCardComment: Maybe<DestroyCardCommentPayload>;
  /** Destroy a `WorkspaceDashboard::CardTask` */
  destroyCardTask: Maybe<DestroyCardTaskPayload>;
  /** Destroy a `CccFormConfig` */
  destroyCccFormConfig: Maybe<DestroyCccFormConfigPayload>;
  /** Destroy a `ClinicalCompetenceCommittee` */
  destroyClinicalCompetenceCommittee: Maybe<DestroyClinicalCompetenceCommitteePayload>;
  /** Destroy a `ClinicalCompetenceCommitteeRespondent` */
  destroyClinicalCompetenceCommitteeRespondent: Maybe<DestroyClinicalCompetenceCommitteeRespondentPayload>;
  /** Destroy a `CompetenceCertificate` */
  destroyCompetenceCertificate: Maybe<DestroyCompetenceCertificatePayload>;
  /** Destroy a `Course` */
  destroyCourse: Maybe<DestroyCoursePayload>;
  /** Destroy a `CourseResult` */
  destroyCourseResult: Maybe<DestroyCourseResultPayload>;
  /** Destroy a `Skill` */
  destroyCustomSkill: Maybe<DestroyCustomSkillPayload>;
  /** Destroy a `WorkspaceDashboard::Dashboard` */
  destroyDashboard: Maybe<DestroyDashboardPayload>;
  /** Destroy a `WorkspaceDashboard::DashboardFormat` */
  destroyDashboardFormat: Maybe<DestroyDashboardFormatPayload>;
  /** Destroy a `WorkspaceDashboard::DashboardRole` */
  destroyDashboardRole: Maybe<DestroyDashboardRolePayload>;
  /** Destroy a `WorkspaceDashboard::EventCard` */
  destroyEventCard: Maybe<DestroyEventCardPayload>;
  /**
   * Destroy an `ExternalOauthConnection`, which is an
   * `ExternalOauthAccessToken`that can be found using a `Portfolio` and an
   * `ExternalOauthApplication`
   */
  destroyExternalOauthConnection: Maybe<DestroyExternalOauthConnectionPayload>;
  /** Destroy a `FeatureToggle` */
  destroyFeatureToggle: Maybe<DestroyFeatureTogglePayload>;
  /** Destroy a `FeedbackRequest` */
  destroyFeedbackRequest: Maybe<DestroyFeedbackRequestPayload>;
  /** Destroy the viewer's `GaiaFileSync`, and all related objects. */
  destroyGaiaFile: Maybe<DestroyGaiaFilePayload>;
  /** Destroy a `GeneralFeedback` */
  destroyGeneralFeedback: Maybe<DestroyGeneralFeedbackPayload>;
  /** Destroy a `GeneralFeedbackFormConfig` */
  destroyGeneralFeedbackFormConfig: Maybe<DestroyGeneralFeedbackFormConfigPayload>;
  /** Destroy a `Goal` */
  destroyGoal: Maybe<DestroyGoalPayload>;
  /** Destroy a `GoalActivity` */
  destroyGoalActivity: Maybe<DestroyGoalActivityPayload>;
  /** Destroy a `WorkspaceDashboard::GoalCard` */
  destroyGoalCard: Maybe<DestroyGoalCardPayload>;
  /** Destroy a `Interview` */
  destroyInterview: Maybe<DestroyInterviewPayload>;
  /** Destroy an InvoicePlan */
  destroyInvoicePlan: Maybe<DestroyInvoicePlanPayload>;
  /** Destroy a `KPB` */
  destroyKPB: Maybe<DestroyKpbPayload>;
  /** Destroy a `KPBSubSkillScore` */
  destroyKPBSubSkillScore: Maybe<DestroyKpbSubSkillScorePayload>;
  /** Destroy a `LearningResource::Article` */
  destroyLearningResourceArticle: Maybe<DestroyLearningResourceArticlePayload>;
  /** Destroy a `LearningResource::File` */
  destroyLearningResourceFile: Maybe<DestroyLearningResourceFilePayload>;
  /** Destroy a `LearningResource::GlobalCategory` */
  destroyLearningResourceGlobalCategory: Maybe<DestroyLearningResourceGlobalCategoryPayload>;
  /** Destroy a `LearningResource::Link` */
  destroyLearningResourceLink: Maybe<DestroyLearningResourceLinkPayload>;
  /** Destroy a `LearningResource::MicroLearning` */
  destroyLearningResourceMicroLearning: Maybe<DestroyLearningResourceMicroLearningPayload>;
  /** Destroy a `LearningResource::MicroLearningStep` */
  destroyLearningResourceMicroLearningStep: Maybe<DestroyLearningResourceMicroLearningStepPayload>;
  /** Destroy a `LearningResource::Set` */
  destroyLearningResourceSet: Maybe<DestroyLearningResourceSetPayload>;
  /** Destroy a `Memo` */
  destroyMemo: Maybe<DestroyMemoPayload>;
  /** Destroy a `MultiSource` */
  destroyMultiSource: Maybe<DestroyMultiSourcePayload>;
  /** Deprecated: use `destroyMemo` instead. Destroy a `Note` */
  destroyNote: Maybe<DestroyNotePayload>;
  /** Destroy a `Notification` */
  destroyNotification: Maybe<DestroyNotificationPayload>;
  /** Destroy an `OIDC` */
  destroyOidc: Maybe<DestroyOidcPayload>;
  /** Destroy a `Organization` */
  destroyOrganization: Maybe<DestroyOrganizationPayload>;
  /** Destroy a `OrganizationUserRole` */
  destroyOrganizationUserRole: Maybe<DestroyOrganizationUserRolePayload>;
  /** Destroy a `WorkspaceDashboard::ParentDomain` */
  destroyParentDomain: Maybe<DestroyParentDomainPayload>;
  /** Destroy a `ParticipationLevelFormat` */
  destroyParticipationLevelFormat: Maybe<DestroyParticipationLevelFormatPayload>;
  /** Destroy a `PendingAction` */
  destroyPendingAction: Maybe<DestroyPendingActionPayload>;
  /** Destroy a `PeriodFormat` */
  destroyPeriodFormat: Maybe<DestroyPeriodFormatPayload>;
  /** Destroy a `PeriodRequiredSkillLevel` */
  destroyPeriodRequiredSkillLevel: Maybe<DestroyPeriodRequiredSkillLevelPayload>;
  /** Destroy a `PortfolioDocumentConfig` */
  destroyPortfolioDocumentConfig: Maybe<DestroyPortfolioDocumentConfigPayload>;
  /** Destroy a `PortfolioFormat` */
  destroyPortfolioFormat: Maybe<DestroyPortfolioFormatPayload>;
  /** Destroy a `PortfolioNote` */
  destroyPortfolioNote: Maybe<DestroyPortfolioNotePayload>;
  /** Destroy a `PortfolioRoleSync` */
  destroyPortfolioRoleSync: Maybe<DestroyPortfolioRoleSyncPayload>;
  /** Destroy a `PortfolioTransferRequest` */
  destroyPortfolioTransferRequest: Maybe<DestroyPortfolioTransferRequestPayload>;
  /** Destroy a `Program` */
  destroyProgram: Maybe<DestroyProgramPayload>;
  /** Destroy a `ProgramRole` */
  destroyProgramRole: Maybe<DestroyProgramRolePayload>;
  destroyProgramRolesBatch: Maybe<DestroyProgramRolesBatchPayload>;
  /** Destroy a `QualityInstrument` */
  destroyQualityInstrument: Maybe<DestroyQualityInstrumentPayload>;
  /** Destroy a `Registration` */
  destroyRegistration: Maybe<DestroyRegistrationPayload>;
  /** Destroy a `Residency` */
  destroyResidency: Maybe<DestroyResidencyPayload>;
  /** Destroy a `ResidencyArchetype` */
  destroyResidencyArchetype: Maybe<DestroyResidencyArchetypePayload>;
  /** Destroy a `RoleFormat` */
  destroyRoleFormat: Maybe<DestroyRoleFormatPayload>;
  /** Destroy a `RootSkillCategoryConfig` */
  destroyRootSkillCategoryConfig: Maybe<DestroyRootSkillCategoryConfigPayload>;
  /** Destroy a `SecurityQuestion` */
  destroySecurityQuestion: Maybe<DestroySecurityQuestionPayload>;
  /** Destroy a `Skill` */
  destroySkill: Maybe<DestroySkillPayload>;
  /** Destroy a `SkillCategory` */
  destroySkillCategory: Maybe<DestroySkillCategoryPayload>;
  /** Destroy a `SkillLevelFormat` */
  destroySkillLevelFormat: Maybe<DestroySkillLevelFormatPayload>;
  /** Destroy a `SkillLevelFormatDescription` */
  destroySkillLevelFormatDescription: Maybe<DestroySkillLevelFormatDescriptionPayload>;
  /** Destroy a `WorkspaceDashboard::SubDomain` */
  destroySubDomain: Maybe<DestroySubDomainPayload>;
  /** Destroy a `SubMultiSource` */
  destroySubMultiSource: Maybe<DestroySubMultiSourcePayload>;
  /** Scrub and mark a `User` as deleted */
  destroyUser: Maybe<DestroyUserPayload>;
  /** Destroy a `WorkspaceDashboard::Workspace` */
  destroyWorkspace: Maybe<DestroyWorkspacePayload>;
  /** Destroy a `WorkspaceRole` */
  destroyWorkspaceRole: Maybe<DestroyWorkspaceRolePayload>;
  /** Disables the `SecondFactor` if password and security key are correct */
  disableSecondFactorWithSecurityKey: Maybe<DisableSecondFactorWithSecurityKeyPayload>;
  /** Dismiss an `OnboardingStep` */
  dismissOnboardingStep: Maybe<DismissOnboardingStepPayload>;
  /** Duplicate a given `WorkspaceDashboard::EventCard` */
  duplicateEventCard: Maybe<DuplicateEventCardPayload>;
  /** Duplicate a given `WorkspaceDashboard::GoalCard` */
  duplicateGoalCard: Maybe<DuplicateGoalCardPayload>;
  /** Enables a second factor authentication method. */
  enableSecondFactor: Maybe<EnableSecondFactorPayload>;
  finalizeClinicalCompetenceCommittee: Maybe<FinalizeClinicalCompetenceCommitteePayload>;
  /** Find or create a new `User` with optionally a `DashboardRole` and/or one or more `WorkspaceRole`s */
  findOrCreateUserWithDashboardRoleAndWorkspaceRoles: Maybe<FindOrCreateUserWithDashboardRoleAndWorkspaceRolesPayload>;
  /** Generates a push notifications external ID for a User. Does nothing if one already exists. */
  generateUserPushNotificationsExternalId: Maybe<GenerateUserPushNotificationsExternalIdPayload>;
  /** Import a `PortfolioFormat` */
  importPortfolioFormat: Maybe<ImportPortfolioFormatPayload>;
  markAlertedLearningResourceItemRead: Maybe<MarkAlertedLearningResourceItemReadPayload>;
  /** Mark all `Notification`s as read that aren't marked as read yet. */
  markAllNotificationsAsRead: Maybe<MarkAllNotificationsAsReadPayload>;
  /** Marks an `ImportantNotice` as read */
  markImportantNoticeAsRead: Maybe<MarkImportantNoticeAsReadPayload>;
  /** Merge an `User` with another `User` */
  mergeUser: Maybe<MergeUserPayload>;
  /** Pause the streak of the viewer for 4 weeks, including the current week */
  pauseStreak: Maybe<PauseStreakPayload>;
  /** Promote a `CccFormConfig`. */
  promoteCccFormConfig: Maybe<PromoteCccFormConfigPayload>;
  /** Promote a `GeneralFeedbackFormConfig`. */
  promoteGeneralFeedbackFormConfig: Maybe<PromoteGeneralFeedbackFormConfigPayload>;
  /** Promote a `PortfolioDocumentConfig`. */
  promotePortfolioDocumentConfig: Maybe<PromotePortfolioDocumentConfigPayload>;
  /** Remove a selected `CccFormConfig` from a `ClinicalCompetenceCommittee` */
  removeCccFormConfigSelection: Maybe<RemoveCccFormConfigSelectionPayload>;
  /** Remove a set of `CourseEdition`s from a `User`. */
  removeCourseEditionsFromUser: Maybe<RemoveCourseEditionsFromUserPayload>;
  /** Remove a set of `Course`s from a `User`. */
  removeCoursesFromUser: Maybe<RemoveCoursesFromUserPayload>;
  removeLearningResourceItemFromSet: Maybe<RemoveLearningResourceItemFromSetPayload>;
  /** Remove a set of skills from a `Portfolio`. */
  removeSkillsFromPortfolio: Maybe<RemoveSkillsFromPortfolioPayload>;
  removeSubSkillFromSkill: Maybe<RemoveSubSkillFromSkillPayload>;
  /** Remove a `User` from a `SupportGroup` */
  removeUserFromSupportGroup: Maybe<RemoveUserFromSupportGroupPayload>;
  /** Add a `Workspace` to a `SecondaryDashboard` */
  removeWorkspaceFromSecondaryDashboard: Maybe<RemoveWorkspaceFromSecondaryDashboardPayload>;
  requestGeneratedReport: Maybe<RequestGeneratedReportPayload>;
  /** Request a token to reset the password for a `User` */
  requestPasswordReset: Maybe<RequestPasswordResetPayload>;
  /** Request a new export for a `Portfolio` */
  requestPortfolioExport: Maybe<RequestPortfolioExportPayload>;
  /** Reset the password for a user */
  resetPassword: Maybe<ResetPasswordPayload>;
  /** Resets the second factor configuration, revealing a new OTP secret. */
  resetSecondFactor: Maybe<ResetSecondFactorPayload>;
  /** Send email reminding respondents to respond to a `ClinicalCompetenceCommittee` */
  sendClinicalCompetenceCommitteeReminderMails: Maybe<SendClinicalCompetenceCommitteeReminderMailsPayload>;
  /** Send email reminding people to fill in a `FeedbackRequest` */
  sendFeedbackRequestMails: Maybe<SendFeedbackRequestMailsPayload>;
  /** Send an email to Reconcept. */
  sendMailToReconcept: Maybe<SendMailToReconceptPayload>;
  /** Send email reminding people to fill in a sub-`MultiSource` survey */
  sendMultiSourceMails: Maybe<SendMultiSourceMailsPayload>;
  /** Send email to support to request a `SecondFactor` reset and a email to inform the `User` */
  sendSecondFactorResetRequest: Maybe<SendSecondFactorResetRequestPayload>;
  /** Send welcoming email including a token to reset the password for a `User` */
  sendWelcomeMail: Maybe<SendWelcomeMailPayload>;
  synchronizeContacts: Maybe<SynchronizeContactsPayload>;
  synchronizeGaiaFile: Maybe<SynchronizeGaiaFilePayload>;
  synchronizeLedgerAccounts: Maybe<SynchronizeLedgerAccountsPayload>;
  /** Unlock the `User`'s account with their pin */
  unlockWithPin: Maybe<UnlockWithPinPayload>;
  /** Unsubscribe a `User` from learning resource alert emails using an unsubscribe token */
  unsubscribeToLearningResourceAlertMails: Maybe<UnsubscribeToLearningResourceAlertMailsPayload>;
  /** Update the active field of all `PortfolioRole`s for a `PortfolioRoleSync` */
  updateActiveOnAllPortfolioRolesForSync: Maybe<UpdateActiveOnAllPortfolioRolesForSyncPayload>;
  updateAudioTranscript: Maybe<UpdateAudioTranscriptPayload>;
  /** Update the basic fields of an User */
  updateBasicUserFields: Maybe<UpdateBasicUserFieldsPayload>;
  /** Update a `WorkspaceDashboard::CardComment` */
  updateCardComment: Maybe<UpdateCardCommentPayload>;
  /** Update a `WorkspaceDashboard::CardTask` */
  updateCardTask: Maybe<UpdateCardTaskPayload>;
  /** Update a `CccFormConfig`. */
  updateCccFormConfig: Maybe<UpdateCccFormConfigPayload>;
  /** Update a `ClinicalCompetenceCommittee` */
  updateClinicalCompetenceCommittee: Maybe<UpdateClinicalCompetenceCommitteePayload>;
  updateClinicalCompetenceCommitteeRespondentResponse: Maybe<UpdateClinicalCompetenceCommitteeRespondentResponsePayload>;
  updateClinicalCompetenceCommitteeRespondentResults: Maybe<UpdateClinicalCompetenceCommitteeRespondentResultsPayload>;
  /** Update a `CompetenceCertificate` */
  updateCompetenceCertificate: Maybe<UpdateCompetenceCertificatePayload>;
  /**
   * Update the `status` of every `CompetenceCertificate` in a
   * `CompetenceCertificateBatch`, except ones that are already `approved` or `rejected`
   */
  updateCompetenceCertificatesInBatch: Maybe<UpdateCompetenceCertificatesInBatchPayload>;
  /** Update a `Course` */
  updateCourse: Maybe<UpdateCoursePayload>;
  /** Update a `CourseResult` for a given `Portfolio` */
  updateCourseResult: Maybe<UpdateCourseResultPayload>;
  /** Update a custom `Skill` */
  updateCustomSkill: Maybe<UpdateCustomSkillPayload>;
  /** Update a `WorkspaceDashboard` */
  updateDashboard: Maybe<UpdateDashboardPayload>;
  /** Create a new `DashboardFormat` */
  updateDashboardFormat: Maybe<UpdateDashboardFormatPayload>;
  /** Update a `DashboardRole` for an `User` and a `Dashboard` */
  updateDashboardRole: Maybe<UpdateDashboardRolePayload>;
  /** Update a `WorkspaceDashboard::EventCard` */
  updateEventCard: Maybe<UpdateEventCardPayload>;
  /** Update a `ExternalAccess` */
  updateExternalAccess: Maybe<UpdateExternalAccessPayload>;
  /** Update a `FeedbackRequest` */
  updateFeedbackRequest: Maybe<UpdateFeedbackRequestPayload>;
  /** Update a `FeedbackRound` */
  updateFeedbackRound: Maybe<UpdateFeedbackRoundPayload>;
  /** Update a `GeneralFeedback` */
  updateGeneralFeedback: Maybe<UpdateGeneralFeedbackPayload>;
  /** Update a `GeneralFeedbackFormConfig`. */
  updateGeneralFeedbackFormConfig: Maybe<UpdateGeneralFeedbackFormConfigPayload>;
  /** Update a `Goal` */
  updateGoal: Maybe<UpdateGoalPayload>;
  /** Update an `GoalActivity` */
  updateGoalActivity: Maybe<UpdateGoalActivityPayload>;
  /** Update a `WorkspaceDashboard::GoalCard` */
  updateGoalCard: Maybe<UpdateGoalCardPayload>;
  /** Update an `Interview` */
  updateInterview: Maybe<UpdateInterviewPayload>;
  /** Link interviews to an `Interview` */
  updateInterviewReferences: Maybe<UpdateInterviewReferencesPayload>;
  /** Update an InvoicePlan */
  updateInvoicePlan: Maybe<UpdateInvoicePlanPayload>;
  /** Update a `KPB` for a given `Portfolio` */
  updateKPB: Maybe<UpdateKpbPayload>;
  updateLearningResourceArticle: Maybe<UpdateLearningResourceArticlePayload>;
  updateLearningResourceFile: Maybe<UpdateLearningResourceFilePayload>;
  updateLearningResourceGlobalCategory: Maybe<UpdateLearningResourceGlobalCategoryPayload>;
  updateLearningResourceLink: Maybe<UpdateLearningResourceLinkPayload>;
  updateLearningResourceMicroLearning: Maybe<UpdateLearningResourceMicroLearningPayload>;
  updateLearningResourceMicroLearningStep: Maybe<UpdateLearningResourceMicroLearningStepPayload>;
  updateLearningResourceMicroLearningUserProgress: Maybe<UpdateLearningResourceMicroLearningUserProgressPayload>;
  updateLearningResourceSet: Maybe<UpdateLearningResourceSetPayload>;
  updateLearningResourceSetItem: Maybe<UpdateLearningResourceSetItemPayload>;
  /** Update a `WorkspaceDashboard::GoalCard` */
  updateLinkedCards: Maybe<UpdateLinkedCardsPayload>;
  /** Update a `Memo` */
  updateMemo: Maybe<UpdateMemoPayload>;
  /** Update a `MultiSource` for a given `Portfolio` */
  updateMultiSource: Maybe<UpdateMultiSourcePayload>;
  updateMultiSourceReflection: Maybe<UpdateMultiSourceReflectionPayload>;
  /** Deprecated: use `updateMemo` instead. Update a `Note` */
  updateNote: Maybe<UpdateNotePayload>;
  /** Update a `Notification` */
  updateNotification: Maybe<UpdateNotificationPayload>;
  /** Update an `Organization`. */
  updateOrganization: Maybe<UpdateOrganizationPayload>;
  /** Update an existing `OrganizationUserRole` */
  updateOrganizationUserRole: Maybe<UpdateOrganizationUserRolePayload>;
  /** Update a `WorkspaceDashboard::ParentDomain` */
  updateParentDomain: Maybe<UpdateParentDomainPayload>;
  /** Update a `ParticipationLevelFormat` */
  updateParticipationLevelFormat: Maybe<UpdateParticipationLevelFormatPayload>;
  /** Update a `Period` */
  updatePeriod: Maybe<UpdatePeriodPayload>;
  updatePeriodFormat: Maybe<UpdatePeriodFormatPayload>;
  updatePeriodRequiredSkillLevel: Maybe<UpdatePeriodRequiredSkillLevelPayload>;
  /** Update a Portfolio */
  updatePortfolio: Maybe<UpdatePortfolioPayload>;
  /** Update a `PortfolioDocumentConfig`. */
  updatePortfolioDocumentConfig: Maybe<UpdatePortfolioDocumentConfigPayload>;
  /** Update a `PortfolioFormat` */
  updatePortfolioFormat: Maybe<UpdatePortfolioFormatPayload>;
  /** Update an existing `PortfolioImport` */
  updatePortfolioImport: Maybe<UpdatePortfolioImportPayload>;
  /** Update a `PortfolioNote` */
  updatePortfolioNote: Maybe<UpdatePortfolioNotePayload>;
  /** Update a `PortfolioRole` */
  updatePortfolioRole: Maybe<UpdatePortfolioRolePayload>;
  /** Update a `PortfolioRoleSync` */
  updatePortfolioRoleSync: Maybe<UpdatePortfolioRoleSyncPayload>;
  /** Update the hidden field of a PortfolioSkill */
  updatePortfolioSkillHidden: Maybe<UpdatePortfolioSkillHiddenPayload>;
  /** Update a transfer request of a `Portfolio` */
  updatePortfolioTransferRequest: Maybe<UpdatePortfolioTransferRequestPayload>;
  /** Update a `Program` */
  updateProgram: Maybe<UpdateProgramPayload>;
  /** Update a `ProgramRole` */
  updateProgramRole: Maybe<UpdateProgramRolePayload>;
  /** Update the protected fields of an User */
  updateProtectedUserFields: Maybe<UpdateProtectedUserFieldsPayload>;
  /** Update a `QualityInstrument` */
  updateQualityInstrument: Maybe<UpdateQualityInstrumentPayload>;
  /** Update a `Registration` of a specific `Operation` */
  updateRegistration: Maybe<UpdateRegistrationPayload>;
  /** Update a `Residency` */
  updateResidency: Maybe<UpdateResidencyPayload>;
  /** Update a `ResidencyArchetype` */
  updateResidencyArchetype: Maybe<UpdateResidencyArchetypePayload>;
  /** Update a `RoleFormat`. */
  updateRoleFormat: Maybe<UpdateRoleFormatPayload>;
  /** Update a `RootSkillCategoryConfig` */
  updateRootSkillCategoryConfig: Maybe<UpdateRootSkillCategoryConfigPayload>;
  /** Update a `SecurityQuestion` */
  updateSecurityQuestion: Maybe<UpdateSecurityQuestionPayload>;
  /** Update a `Skill` */
  updateSkill: Maybe<UpdateSkillPayload>;
  /** Update a `SkillCategory` */
  updateSkillCategory: Maybe<UpdateSkillCategoryPayload>;
  /** Update a `SkillLevelFormat` */
  updateSkillLevelFormat: Maybe<UpdateSkillLevelFormatPayload>;
  updateSkillSubSkill: Maybe<UpdateSkillSubSkillPayload>;
  /** Update a `WorkspaceDashboard::SubDomain` */
  updateSubDomain: Maybe<UpdateSubDomainPayload>;
  /** Update a sub-`MultiSource` */
  updateSubMultiSource: Maybe<UpdateSubMultiSourcePayload>;
  /** Update a `SupportGroup` */
  updateSupportGroup: Maybe<UpdateSupportGroupPayload>;
  updateUsageStatistic: Maybe<UpdateUsageStatisticPayload>;
  /** Update the big fields of a  User */
  updateUserBigFields: Maybe<UpdateUserBigFieldsPayload>;
  /** Update a `Workspace` */
  updateWorkspace: Maybe<UpdateWorkspacePayload>;
  /** Update a `WorkspaceRole` for an `User` and a `Workspace` */
  updateWorkspaceRole: Maybe<UpdateWorkspaceRolePayload>;
}

/** The root mutation object */
export interface MutationActivateExternalOauthConnectionArgs {
  input: ActivateExternalOauthConnectionInput;
}

/** The root mutation object */
export interface MutationAddCccFormConfigSelectionArgs {
  input: AddCccFormConfigSelectionInput;
}

/** The root mutation object */
export interface MutationAddCourseEditionsToUserArgs {
  input: AddCourseEditionsToUserInput;
}

/** The root mutation object */
export interface MutationAddCoursesToUserArgs {
  input: AddCoursesToUserInput;
}

/** The root mutation object */
export interface MutationAddLearningResourceItemToSetArgs {
  input: AddLearningResourceItemToSetInput;
}

/** The root mutation object */
export interface MutationAddMandatorySkillToPortfoliosArgs {
  input: AddMandatorySkillToPortfoliosInput;
}

/** The root mutation object */
export interface MutationAddRespondentToClinicalCompetenceCommitteeArgs {
  input: AddRespondentToClinicalCompetenceCommitteeInput;
}

/** The root mutation object */
export interface MutationAddSkillsToPortfolioArgs {
  input: AddSkillsToPortfolioInput;
}

/** The root mutation object */
export interface MutationAddSubSkillsToSkillArgs {
  input: AddSubSkillsToSkillInput;
}

/** The root mutation object */
export interface MutationAddUserToSupportGroupArgs {
  input: AddUserToSupportGroupInput;
}

/** The root mutation object */
export interface MutationAddWorkspaceToSecondaryDashboardArgs {
  input: AddWorkspaceToSecondaryDashboardInput;
}

/** The root mutation object */
export interface MutationAdminDisableSecondFactorArgs {
  input: AdminDisableSecondFactorInput;
}

/** The root mutation object */
export interface MutationArchivePortfolioArgs {
  input: ArchivePortfolioInput;
}

/** The root mutation object */
export interface MutationCalculateOnboardingStepsArgs {
  input: CalculateOnboardingStepsInput;
}

/** The root mutation object */
export interface MutationCancelPortfolioRemovalRequestArgs {
  input: CancelPortfolioRemovalRequestInput;
}

/** The root mutation object */
export interface MutationCopyObjectToPortfolioArgs {
  input: CopyObjectToPortfolioInput;
}

/** The root mutation object */
export interface MutationCreateAdminGroupArgs {
  input: CreateAdminGroupInput;
}

/** The root mutation object */
export interface MutationCreateAudioTranscriptArgs {
  input: CreateAudioTranscriptInput;
}

/** The root mutation object */
export interface MutationCreateCardCommentArgs {
  input: CreateCardCommentInput;
}

/** The root mutation object */
export interface MutationCreateCardTaskArgs {
  input: CreateCardTaskInput;
}

/** The root mutation object */
export interface MutationCreateCccFormConfigArgs {
  input: CreateCccFormConfigInput;
}

/** The root mutation object */
export interface MutationCreateClinicalCompetenceCommitteeArgs {
  input: CreateClinicalCompetenceCommitteeInput;
}

/** The root mutation object */
export interface MutationCreateCodeArgs {
  input: CreateCodeInput;
}

/** The root mutation object */
export interface MutationCreateCompetenceCertificateArgs {
  input: CreateCompetenceCertificateInput;
}

/** The root mutation object */
export interface MutationCreateCourseArgs {
  input: CreateCourseInput;
}

/** The root mutation object */
export interface MutationCreateCourseResultArgs {
  input: CreateCourseResultInput;
}

/** The root mutation object */
export interface MutationCreateCourseResultByBigAndShortNameArgs {
  input: CreateCourseResultByBigAndShortNameInput;
}

/** The root mutation object */
export interface MutationCreateCustomSkillArgs {
  input: CreateCustomSkillInput;
}

/** The root mutation object */
export interface MutationCreateDashboardArgs {
  input: CreateDashboardInput;
}

/** The root mutation object */
export interface MutationCreateDashboardFormatArgs {
  input: CreateDashboardFormatInput;
}

/** The root mutation object */
export interface MutationCreateDashboardRoleArgs {
  input: CreateDashboardRoleInput;
}

/** The root mutation object */
export interface MutationCreateDirectUploadArgs {
  input: CreateDirectUploadInput;
}

/** The root mutation object */
export interface MutationCreateDraftArgs {
  input: CreateDraftInput;
}

/** The root mutation object */
export interface MutationCreateEventCardArgs {
  input: CreateEventCardInput;
}

/** The root mutation object */
export interface MutationCreateFeedbackRequestArgs {
  input: CreateFeedbackRequestInput;
}

/** The root mutation object */
export interface MutationCreateFeedbackRoundArgs {
  input: CreateFeedbackRoundInput;
}

/** The root mutation object */
export interface MutationCreateGeneralFeedbackArgs {
  input: CreateGeneralFeedbackInput;
}

/** The root mutation object */
export interface MutationCreateGeneralFeedbackFormConfigArgs {
  input: CreateGeneralFeedbackFormConfigInput;
}

/** The root mutation object */
export interface MutationCreateGoalArgs {
  input: CreateGoalInput;
}

/** The root mutation object */
export interface MutationCreateGoalActivityArgs {
  input: CreateGoalActivityInput;
}

/** The root mutation object */
export interface MutationCreateGoalCardArgs {
  input: CreateGoalCardInput;
}

/** The root mutation object */
export interface MutationCreateGuidelineArgs {
  input: CreateGuidelineInput;
}

/** The root mutation object */
export interface MutationCreateGuidelineAttachmentArgs {
  input: CreateGuidelineAttachmentInput;
}

/** The root mutation object */
export interface MutationCreateInterviewArgs {
  input: CreateInterviewInput;
}

/** The root mutation object */
export interface MutationCreateInviteArgs {
  input: CreateInviteInput;
}

/** The root mutation object */
export interface MutationCreateInvoicePlanArgs {
  input: CreateInvoicePlanInput;
}

/** The root mutation object */
export interface MutationCreateKpbArgs {
  input: CreateKpbInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceArticleArgs {
  input: CreateLearningResourceArticleInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceFileArgs {
  input: CreateLearningResourceFileInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceGlobalCategoryArgs {
  input: CreateLearningResourceGlobalCategoryInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceLinkArgs {
  input: CreateLearningResourceLinkInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceMicroLearningArgs {
  input: CreateLearningResourceMicroLearningInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceMicroLearningStepArgs {
  input: CreateLearningResourceMicroLearningStepInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceMicroLearningUserProgressArgs {
  input: CreateLearningResourceMicroLearningUserProgressInput;
}

/** The root mutation object */
export interface MutationCreateLearningResourceSetArgs {
  input: CreateLearningResourceSetInput;
}

/** The root mutation object */
export interface MutationCreateMemoArgs {
  input: CreateMemoInput;
}

/** The root mutation object */
export interface MutationCreateMultiSourceArgs {
  input: CreateMultiSourceInput;
}

/** The root mutation object */
export interface MutationCreateMultipleCompetenceCertificatesArgs {
  input: CreateMultipleCompetenceCertificatesInput;
}

/** The root mutation object */
export interface MutationCreateMultipleRegistrationsArgs {
  input: CreateMultipleRegistrationsInput;
}

/** The root mutation object */
export interface MutationCreateNoteArgs {
  input: CreateNoteInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdateFeatureToggleArgs {
  input: CreateOrUpdateFeatureToggleInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdateKpbSubSkillScoreArgs {
  input: CreateOrUpdateKpbSubSkillScoreInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdatePortfolioFormatSpecialtyConfigArgs {
  input: CreateOrUpdatePortfolioFormatSpecialtyConfigInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdatePortfolioFormatTerminologyArgs {
  input: CreateOrUpdatePortfolioFormatTerminologyInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdatePortfolioRoleArgs {
  input: CreateOrUpdatePortfolioRoleInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdatePortfolioRoleSyncArgs {
  input: CreateOrUpdatePortfolioRoleSyncInput;
}

/** The root mutation object */
export interface MutationCreateOrUpdateSkillLevelFormatDescriptionArgs {
  input: CreateOrUpdateSkillLevelFormatDescriptionInput;
}

/** The root mutation object */
export interface MutationCreateOrganizationArgs {
  input: CreateOrganizationInput;
}

/** The root mutation object */
export interface MutationCreateOrganizationUserRoleArgs {
  input: CreateOrganizationUserRoleInput;
}

/** The root mutation object */
export interface MutationCreateParentDomainArgs {
  input: CreateParentDomainInput;
}

/** The root mutation object */
export interface MutationCreateParticipationLevelFormatArgs {
  input: CreateParticipationLevelFormatInput;
}

/** The root mutation object */
export interface MutationCreatePeriodFormatArgs {
  input: CreatePeriodFormatInput;
}

/** The root mutation object */
export interface MutationCreatePeriodRequiredSkillLevelArgs {
  input: CreatePeriodRequiredSkillLevelInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioArgs {
  input: CreatePortfolioInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioDocumentConfigArgs {
  input: CreatePortfolioDocumentConfigInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioFormatArgs {
  input: CreatePortfolioFormatInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioImportArgs {
  input: CreatePortfolioImportInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioNoteArgs {
  input: CreatePortfolioNoteInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioRemovalRequestArgs {
  input: CreatePortfolioRemovalRequestInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioRoleSyncArgs {
  input: CreatePortfolioRoleSyncInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioRoleSyncsForProgramsArgs {
  input: CreatePortfolioRoleSyncsForProgramsInput;
}

/** The root mutation object */
export interface MutationCreatePortfolioTransferRequestArgs {
  input: CreatePortfolioTransferRequestInput;
}

/** The root mutation object */
export interface MutationCreateProgramArgs {
  input: CreateProgramInput;
}

/** The root mutation object */
export interface MutationCreateProgramRoleArgs {
  input: CreateProgramRoleInput;
}

/** The root mutation object */
export interface MutationCreateQualityInstrumentArgs {
  input: CreateQualityInstrumentInput;
}

/** The root mutation object */
export interface MutationCreateRegistrationArgs {
  input: CreateRegistrationInput;
}

/** The root mutation object */
export interface MutationCreateReminderNotificationArgs {
  input: CreateReminderNotificationInput;
}

/** The root mutation object */
export interface MutationCreateResidencyArgs {
  input: CreateResidencyInput;
}

/** The root mutation object */
export interface MutationCreateResidencyArchetypeArgs {
  input: CreateResidencyArchetypeInput;
}

/** The root mutation object */
export interface MutationCreateRoleFormatArgs {
  input: CreateRoleFormatInput;
}

/** The root mutation object */
export interface MutationCreateRootSkillCategoryConfigArgs {
  input: CreateRootSkillCategoryConfigInput;
}

/** The root mutation object */
export interface MutationCreateSecurityQuestionArgs {
  input: CreateSecurityQuestionInput;
}

/** The root mutation object */
export interface MutationCreateSelfAssessmentArgs {
  input: CreateSelfAssessmentInput;
}

/** The root mutation object */
export interface MutationCreateSkillArgs {
  input: CreateSkillInput;
}

/** The root mutation object */
export interface MutationCreateSkillCategoryArgs {
  input: CreateSkillCategoryInput;
}

/** The root mutation object */
export interface MutationCreateSkillLevelFormatArgs {
  input: CreateSkillLevelFormatInput;
}

/** The root mutation object */
export interface MutationCreateSubDomainArgs {
  input: CreateSubDomainInput;
}

/** The root mutation object */
export interface MutationCreateSubMultiSourceArgs {
  input: CreateSubMultiSourceInput;
}

/** The root mutation object */
export interface MutationCreateUsageStatisticArgs {
  input: CreateUsageStatisticInput;
}

/** The root mutation object */
export interface MutationCreateUserArgs {
  input: CreateUserInput;
}

/** The root mutation object */
export interface MutationCreateUserWithProgramRoleArgs {
  input: CreateUserWithProgramRoleInput;
}

/** The root mutation object */
export interface MutationCreateWorkspaceArgs {
  input: CreateWorkspaceInput;
}

/** The root mutation object */
export interface MutationCreateWorkspaceRoleArgs {
  input: CreateWorkspaceRoleInput;
}

/** The root mutation object */
export interface MutationDeactivatePortfolioRoleArgs {
  input: DeactivatePortfolioRoleInput;
}

/** The root mutation object */
export interface MutationDestroyAttachedFileArgs {
  input: DestroyAttachedFileInput;
}

/** The root mutation object */
export interface MutationDestroyAudioTranscriptArgs {
  input: DestroyAudioTranscriptInput;
}

/** The root mutation object */
export interface MutationDestroyCardCommentArgs {
  input: DestroyCardCommentInput;
}

/** The root mutation object */
export interface MutationDestroyCardTaskArgs {
  input: DestroyCardTaskInput;
}

/** The root mutation object */
export interface MutationDestroyCccFormConfigArgs {
  input: DestroyCccFormConfigInput;
}

/** The root mutation object */
export interface MutationDestroyClinicalCompetenceCommitteeArgs {
  input: DestroyClinicalCompetenceCommitteeInput;
}

/** The root mutation object */
export interface MutationDestroyClinicalCompetenceCommitteeRespondentArgs {
  input: DestroyClinicalCompetenceCommitteeRespondentInput;
}

/** The root mutation object */
export interface MutationDestroyCompetenceCertificateArgs {
  input: DestroyCompetenceCertificateInput;
}

/** The root mutation object */
export interface MutationDestroyCourseArgs {
  input: DestroyCourseInput;
}

/** The root mutation object */
export interface MutationDestroyCourseResultArgs {
  input: DestroyCourseResultInput;
}

/** The root mutation object */
export interface MutationDestroyCustomSkillArgs {
  input: DestroyCustomSkillInput;
}

/** The root mutation object */
export interface MutationDestroyDashboardArgs {
  input: DestroyDashboardInput;
}

/** The root mutation object */
export interface MutationDestroyDashboardFormatArgs {
  input: DestroyDashboardFormatInput;
}

/** The root mutation object */
export interface MutationDestroyDashboardRoleArgs {
  input: DestroyDashboardRoleInput;
}

/** The root mutation object */
export interface MutationDestroyEventCardArgs {
  input: DestroyEventCardInput;
}

/** The root mutation object */
export interface MutationDestroyExternalOauthConnectionArgs {
  input: DestroyExternalOauthConnectionInput;
}

/** The root mutation object */
export interface MutationDestroyFeatureToggleArgs {
  input: DestroyFeatureToggleInput;
}

/** The root mutation object */
export interface MutationDestroyFeedbackRequestArgs {
  input: DestroyFeedbackRequestInput;
}

/** The root mutation object */
export interface MutationDestroyGaiaFileArgs {
  input: DestroyGaiaFileInput;
}

/** The root mutation object */
export interface MutationDestroyGeneralFeedbackArgs {
  input: DestroyGeneralFeedbackInput;
}

/** The root mutation object */
export interface MutationDestroyGeneralFeedbackFormConfigArgs {
  input: DestroyGeneralFeedbackFormConfigInput;
}

/** The root mutation object */
export interface MutationDestroyGoalArgs {
  input: DestroyGoalInput;
}

/** The root mutation object */
export interface MutationDestroyGoalActivityArgs {
  input: DestroyGoalActivityInput;
}

/** The root mutation object */
export interface MutationDestroyGoalCardArgs {
  input: DestroyGoalCardInput;
}

/** The root mutation object */
export interface MutationDestroyInterviewArgs {
  input: DestroyInterviewInput;
}

/** The root mutation object */
export interface MutationDestroyInvoicePlanArgs {
  input: DestroyInvoicePlanInput;
}

/** The root mutation object */
export interface MutationDestroyKpbArgs {
  input: DestroyKpbInput;
}

/** The root mutation object */
export interface MutationDestroyKpbSubSkillScoreArgs {
  input: DestroyKpbSubSkillScoreInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceArticleArgs {
  input: DestroyLearningResourceArticleInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceFileArgs {
  input: DestroyLearningResourceFileInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceGlobalCategoryArgs {
  input: DestroyLearningResourceGlobalCategoryInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceLinkArgs {
  input: DestroyLearningResourceLinkInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceMicroLearningArgs {
  input: DestroyLearningResourceMicroLearningInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceMicroLearningStepArgs {
  input: DestroyLearningResourceMicroLearningStepInput;
}

/** The root mutation object */
export interface MutationDestroyLearningResourceSetArgs {
  input: DestroyLearningResourceSetInput;
}

/** The root mutation object */
export interface MutationDestroyMemoArgs {
  input: DestroyMemoInput;
}

/** The root mutation object */
export interface MutationDestroyMultiSourceArgs {
  input: DestroyMultiSourceInput;
}

/** The root mutation object */
export interface MutationDestroyNoteArgs {
  input: DestroyNoteInput;
}

/** The root mutation object */
export interface MutationDestroyNotificationArgs {
  input: DestroyNotificationInput;
}

/** The root mutation object */
export interface MutationDestroyOidcArgs {
  input: DestroyOidcInput;
}

/** The root mutation object */
export interface MutationDestroyOrganizationArgs {
  input: DestroyOrganizationInput;
}

/** The root mutation object */
export interface MutationDestroyOrganizationUserRoleArgs {
  input: DestroyOrganizationUserRoleInput;
}

/** The root mutation object */
export interface MutationDestroyParentDomainArgs {
  input: DestroyParentDomainInput;
}

/** The root mutation object */
export interface MutationDestroyParticipationLevelFormatArgs {
  input: DestroyParticipationLevelFormatInput;
}

/** The root mutation object */
export interface MutationDestroyPendingActionArgs {
  input: DestroyPendingActionInput;
}

/** The root mutation object */
export interface MutationDestroyPeriodFormatArgs {
  input: DestroyPeriodFormatInput;
}

/** The root mutation object */
export interface MutationDestroyPeriodRequiredSkillLevelArgs {
  input: DestroyPeriodRequiredSkillLevelInput;
}

/** The root mutation object */
export interface MutationDestroyPortfolioDocumentConfigArgs {
  input: DestroyPortfolioDocumentConfigInput;
}

/** The root mutation object */
export interface MutationDestroyPortfolioFormatArgs {
  input: DestroyPortfolioFormatInput;
}

/** The root mutation object */
export interface MutationDestroyPortfolioNoteArgs {
  input: DestroyPortfolioNoteInput;
}

/** The root mutation object */
export interface MutationDestroyPortfolioRoleSyncArgs {
  input: DestroyPortfolioRoleSyncInput;
}

/** The root mutation object */
export interface MutationDestroyPortfolioTransferRequestArgs {
  input: DestroyPortfolioTransferRequestInput;
}

/** The root mutation object */
export interface MutationDestroyProgramArgs {
  input: DestroyProgramInput;
}

/** The root mutation object */
export interface MutationDestroyProgramRoleArgs {
  input: DestroyProgramRoleInput;
}

/** The root mutation object */
export interface MutationDestroyProgramRolesBatchArgs {
  input: DestroyProgramRolesBatchInput;
}

/** The root mutation object */
export interface MutationDestroyQualityInstrumentArgs {
  input: DestroyQualityInstrumentInput;
}

/** The root mutation object */
export interface MutationDestroyRegistrationArgs {
  input: DestroyRegistrationInput;
}

/** The root mutation object */
export interface MutationDestroyResidencyArgs {
  input: DestroyResidencyInput;
}

/** The root mutation object */
export interface MutationDestroyResidencyArchetypeArgs {
  input: DestroyResidencyArchetypeInput;
}

/** The root mutation object */
export interface MutationDestroyRoleFormatArgs {
  input: DestroyRoleFormatInput;
}

/** The root mutation object */
export interface MutationDestroyRootSkillCategoryConfigArgs {
  input: DestroyRootSkillCategoryConfigInput;
}

/** The root mutation object */
export interface MutationDestroySecurityQuestionArgs {
  input: DestroySecurityQuestionInput;
}

/** The root mutation object */
export interface MutationDestroySkillArgs {
  input: DestroySkillInput;
}

/** The root mutation object */
export interface MutationDestroySkillCategoryArgs {
  input: DestroySkillCategoryInput;
}

/** The root mutation object */
export interface MutationDestroySkillLevelFormatArgs {
  input: DestroySkillLevelFormatInput;
}

/** The root mutation object */
export interface MutationDestroySkillLevelFormatDescriptionArgs {
  input: DestroySkillLevelFormatDescriptionInput;
}

/** The root mutation object */
export interface MutationDestroySubDomainArgs {
  input: DestroySubDomainInput;
}

/** The root mutation object */
export interface MutationDestroySubMultiSourceArgs {
  input: DestroySubMultiSourceInput;
}

/** The root mutation object */
export interface MutationDestroyUserArgs {
  input: DestroyUserInput;
}

/** The root mutation object */
export interface MutationDestroyWorkspaceArgs {
  input: DestroyWorkspaceInput;
}

/** The root mutation object */
export interface MutationDestroyWorkspaceRoleArgs {
  input: DestroyWorkspaceRoleInput;
}

/** The root mutation object */
export interface MutationDisableSecondFactorWithSecurityKeyArgs {
  input: DisableSecondFactorWithSecurityKeyInput;
}

/** The root mutation object */
export interface MutationDismissOnboardingStepArgs {
  input: DismissOnboardingStepInput;
}

/** The root mutation object */
export interface MutationDuplicateEventCardArgs {
  input: DuplicateEventCardInput;
}

/** The root mutation object */
export interface MutationDuplicateGoalCardArgs {
  input: DuplicateGoalCardInput;
}

/** The root mutation object */
export interface MutationEnableSecondFactorArgs {
  input: EnableSecondFactorInput;
}

/** The root mutation object */
export interface MutationFinalizeClinicalCompetenceCommitteeArgs {
  input: FinalizeClinicalCompetenceCommitteeInput;
}

/** The root mutation object */
export interface MutationFindOrCreateUserWithDashboardRoleAndWorkspaceRolesArgs {
  input: FindOrCreateUserWithDashboardRoleAndWorkspaceRolesInput;
}

/** The root mutation object */
export interface MutationGenerateUserPushNotificationsExternalIdArgs {
  input: GenerateUserPushNotificationsExternalIdInput;
}

/** The root mutation object */
export interface MutationImportPortfolioFormatArgs {
  input: ImportPortfolioFormatInput;
}

/** The root mutation object */
export interface MutationMarkAlertedLearningResourceItemReadArgs {
  input: MarkAlertedLearningResourceItemReadInput;
}

/** The root mutation object */
export interface MutationMarkAllNotificationsAsReadArgs {
  input: MarkAllNotificationsAsReadInput;
}

/** The root mutation object */
export interface MutationMarkImportantNoticeAsReadArgs {
  input: MarkImportantNoticeAsReadInput;
}

/** The root mutation object */
export interface MutationMergeUserArgs {
  input: MergeUserInput;
}

/** The root mutation object */
export interface MutationPauseStreakArgs {
  input: PauseStreakInput;
}

/** The root mutation object */
export interface MutationPromoteCccFormConfigArgs {
  input: PromoteCccFormConfigInput;
}

/** The root mutation object */
export interface MutationPromoteGeneralFeedbackFormConfigArgs {
  input: PromoteGeneralFeedbackFormConfigInput;
}

/** The root mutation object */
export interface MutationPromotePortfolioDocumentConfigArgs {
  input: PromotePortfolioDocumentConfigInput;
}

/** The root mutation object */
export interface MutationRemoveCccFormConfigSelectionArgs {
  input: RemoveCccFormConfigSelectionInput;
}

/** The root mutation object */
export interface MutationRemoveCourseEditionsFromUserArgs {
  input: RemoveCourseEditionsFromUserInput;
}

/** The root mutation object */
export interface MutationRemoveCoursesFromUserArgs {
  input: RemoveCoursesFromUserInput;
}

/** The root mutation object */
export interface MutationRemoveLearningResourceItemFromSetArgs {
  input: RemoveLearningResourceItemFromSetInput;
}

/** The root mutation object */
export interface MutationRemoveSkillsFromPortfolioArgs {
  input: RemoveSkillsFromPortfolioInput;
}

/** The root mutation object */
export interface MutationRemoveSubSkillFromSkillArgs {
  input: RemoveSubSkillFromSkillInput;
}

/** The root mutation object */
export interface MutationRemoveUserFromSupportGroupArgs {
  input: RemoveUserFromSupportGroupInput;
}

/** The root mutation object */
export interface MutationRemoveWorkspaceFromSecondaryDashboardArgs {
  input: RemoveWorkspaceFromSecondaryDashboardInput;
}

/** The root mutation object */
export interface MutationRequestGeneratedReportArgs {
  input: RequestGeneratedReportInput;
}

/** The root mutation object */
export interface MutationRequestPasswordResetArgs {
  input: RequestPasswordResetInput;
}

/** The root mutation object */
export interface MutationRequestPortfolioExportArgs {
  input: RequestPortfolioExportInput;
}

/** The root mutation object */
export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}

/** The root mutation object */
export interface MutationResetSecondFactorArgs {
  input: ResetSecondFactorInput;
}

/** The root mutation object */
export interface MutationSendClinicalCompetenceCommitteeReminderMailsArgs {
  input: SendClinicalCompetenceCommitteeReminderMailsInput;
}

/** The root mutation object */
export interface MutationSendFeedbackRequestMailsArgs {
  input: SendFeedbackRequestMailsInput;
}

/** The root mutation object */
export interface MutationSendMailToReconceptArgs {
  input: SendMailToReconceptInput;
}

/** The root mutation object */
export interface MutationSendMultiSourceMailsArgs {
  input: SendMultiSourceMailsInput;
}

/** The root mutation object */
export interface MutationSendSecondFactorResetRequestArgs {
  input: SendSecondFactorResetRequestInput;
}

/** The root mutation object */
export interface MutationSendWelcomeMailArgs {
  input: SendWelcomeMailInput;
}

/** The root mutation object */
export interface MutationSynchronizeContactsArgs {
  input: SynchronizeContactsInput;
}

/** The root mutation object */
export interface MutationSynchronizeGaiaFileArgs {
  input: SynchronizeGaiaFileInput;
}

/** The root mutation object */
export interface MutationSynchronizeLedgerAccountsArgs {
  input: SynchronizeLedgerAccountsInput;
}

/** The root mutation object */
export interface MutationUnlockWithPinArgs {
  input: UnlockWithPinInput;
}

/** The root mutation object */
export interface MutationUnsubscribeToLearningResourceAlertMailsArgs {
  input: UnsubscribeToLearningResourceAlertMailsInput;
}

/** The root mutation object */
export interface MutationUpdateActiveOnAllPortfolioRolesForSyncArgs {
  input: UpdateActiveOnAllPortfolioRolesForSyncInput;
}

/** The root mutation object */
export interface MutationUpdateAudioTranscriptArgs {
  input: UpdateAudioTranscriptInput;
}

/** The root mutation object */
export interface MutationUpdateBasicUserFieldsArgs {
  input: UpdateBasicUserFieldsInput;
}

/** The root mutation object */
export interface MutationUpdateCardCommentArgs {
  input: UpdateCardCommentInput;
}

/** The root mutation object */
export interface MutationUpdateCardTaskArgs {
  input: UpdateCardTaskInput;
}

/** The root mutation object */
export interface MutationUpdateCccFormConfigArgs {
  input: UpdateCccFormConfigInput;
}

/** The root mutation object */
export interface MutationUpdateClinicalCompetenceCommitteeArgs {
  input: UpdateClinicalCompetenceCommitteeInput;
}

/** The root mutation object */
export interface MutationUpdateClinicalCompetenceCommitteeRespondentResponseArgs {
  input: UpdateClinicalCompetenceCommitteeRespondentResponseInput;
}

/** The root mutation object */
export interface MutationUpdateClinicalCompetenceCommitteeRespondentResultsArgs {
  input: UpdateClinicalCompetenceCommitteeRespondentResultsInput;
}

/** The root mutation object */
export interface MutationUpdateCompetenceCertificateArgs {
  input: UpdateCompetenceCertificateInput;
}

/** The root mutation object */
export interface MutationUpdateCompetenceCertificatesInBatchArgs {
  input: UpdateCompetenceCertificatesInBatchInput;
}

/** The root mutation object */
export interface MutationUpdateCourseArgs {
  input: UpdateCourseInput;
}

/** The root mutation object */
export interface MutationUpdateCourseResultArgs {
  input: UpdateCourseResultInput;
}

/** The root mutation object */
export interface MutationUpdateCustomSkillArgs {
  input: UpdateCustomSkillInput;
}

/** The root mutation object */
export interface MutationUpdateDashboardArgs {
  input: UpdateDashboardInput;
}

/** The root mutation object */
export interface MutationUpdateDashboardFormatArgs {
  input: UpdateDashboardFormatInput;
}

/** The root mutation object */
export interface MutationUpdateDashboardRoleArgs {
  input: UpdateDashboardRoleInput;
}

/** The root mutation object */
export interface MutationUpdateEventCardArgs {
  input: UpdateEventCardInput;
}

/** The root mutation object */
export interface MutationUpdateExternalAccessArgs {
  input: UpdateExternalAccessInput;
}

/** The root mutation object */
export interface MutationUpdateFeedbackRequestArgs {
  input: UpdateFeedbackRequestInput;
}

/** The root mutation object */
export interface MutationUpdateFeedbackRoundArgs {
  input: UpdateFeedbackRoundInput;
}

/** The root mutation object */
export interface MutationUpdateGeneralFeedbackArgs {
  input: UpdateGeneralFeedbackInput;
}

/** The root mutation object */
export interface MutationUpdateGeneralFeedbackFormConfigArgs {
  input: UpdateGeneralFeedbackFormConfigInput;
}

/** The root mutation object */
export interface MutationUpdateGoalArgs {
  input: UpdateGoalInput;
}

/** The root mutation object */
export interface MutationUpdateGoalActivityArgs {
  input: UpdateGoalActivityInput;
}

/** The root mutation object */
export interface MutationUpdateGoalCardArgs {
  input: UpdateGoalCardInput;
}

/** The root mutation object */
export interface MutationUpdateInterviewArgs {
  input: UpdateInterviewInput;
}

/** The root mutation object */
export interface MutationUpdateInterviewReferencesArgs {
  input: UpdateInterviewReferencesInput;
}

/** The root mutation object */
export interface MutationUpdateInvoicePlanArgs {
  input: UpdateInvoicePlanInput;
}

/** The root mutation object */
export interface MutationUpdateKpbArgs {
  input: UpdateKpbInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceArticleArgs {
  input: UpdateLearningResourceArticleInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceFileArgs {
  input: UpdateLearningResourceFileInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceGlobalCategoryArgs {
  input: UpdateLearningResourceGlobalCategoryInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceLinkArgs {
  input: UpdateLearningResourceLinkInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceMicroLearningArgs {
  input: UpdateLearningResourceMicroLearningInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceMicroLearningStepArgs {
  input: UpdateLearningResourceMicroLearningStepInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceMicroLearningUserProgressArgs {
  input: UpdateLearningResourceMicroLearningUserProgressInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceSetArgs {
  input: UpdateLearningResourceSetInput;
}

/** The root mutation object */
export interface MutationUpdateLearningResourceSetItemArgs {
  input: UpdateLearningResourceSetItemInput;
}

/** The root mutation object */
export interface MutationUpdateLinkedCardsArgs {
  input: UpdateLinkedCardsInput;
}

/** The root mutation object */
export interface MutationUpdateMemoArgs {
  input: UpdateMemoInput;
}

/** The root mutation object */
export interface MutationUpdateMultiSourceArgs {
  input: UpdateMultiSourceInput;
}

/** The root mutation object */
export interface MutationUpdateMultiSourceReflectionArgs {
  input: UpdateMultiSourceReflectionInput;
}

/** The root mutation object */
export interface MutationUpdateNoteArgs {
  input: UpdateNoteInput;
}

/** The root mutation object */
export interface MutationUpdateNotificationArgs {
  input: UpdateNotificationInput;
}

/** The root mutation object */
export interface MutationUpdateOrganizationArgs {
  input: UpdateOrganizationInput;
}

/** The root mutation object */
export interface MutationUpdateOrganizationUserRoleArgs {
  input: UpdateOrganizationUserRoleInput;
}

/** The root mutation object */
export interface MutationUpdateParentDomainArgs {
  input: UpdateParentDomainInput;
}

/** The root mutation object */
export interface MutationUpdateParticipationLevelFormatArgs {
  input: UpdateParticipationLevelFormatInput;
}

/** The root mutation object */
export interface MutationUpdatePeriodArgs {
  input: UpdatePeriodInput;
}

/** The root mutation object */
export interface MutationUpdatePeriodFormatArgs {
  input: UpdatePeriodFormatInput;
}

/** The root mutation object */
export interface MutationUpdatePeriodRequiredSkillLevelArgs {
  input: UpdatePeriodRequiredSkillLevelInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioArgs {
  input: UpdatePortfolioInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioDocumentConfigArgs {
  input: UpdatePortfolioDocumentConfigInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioFormatArgs {
  input: UpdatePortfolioFormatInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioImportArgs {
  input: UpdatePortfolioImportInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioNoteArgs {
  input: UpdatePortfolioNoteInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioRoleArgs {
  input: UpdatePortfolioRoleInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioRoleSyncArgs {
  input: UpdatePortfolioRoleSyncInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioSkillHiddenArgs {
  input: UpdatePortfolioSkillHiddenInput;
}

/** The root mutation object */
export interface MutationUpdatePortfolioTransferRequestArgs {
  input: UpdatePortfolioTransferRequestInput;
}

/** The root mutation object */
export interface MutationUpdateProgramArgs {
  input: UpdateProgramInput;
}

/** The root mutation object */
export interface MutationUpdateProgramRoleArgs {
  input: UpdateProgramRoleInput;
}

/** The root mutation object */
export interface MutationUpdateProtectedUserFieldsArgs {
  input: UpdateProtectedUserFieldsInput;
}

/** The root mutation object */
export interface MutationUpdateQualityInstrumentArgs {
  input: UpdateQualityInstrumentInput;
}

/** The root mutation object */
export interface MutationUpdateRegistrationArgs {
  input: UpdateRegistrationInput;
}

/** The root mutation object */
export interface MutationUpdateResidencyArgs {
  input: UpdateResidencyInput;
}

/** The root mutation object */
export interface MutationUpdateResidencyArchetypeArgs {
  input: UpdateResidencyArchetypeInput;
}

/** The root mutation object */
export interface MutationUpdateRoleFormatArgs {
  input: UpdateRoleFormatInput;
}

/** The root mutation object */
export interface MutationUpdateRootSkillCategoryConfigArgs {
  input: UpdateRootSkillCategoryConfigInput;
}

/** The root mutation object */
export interface MutationUpdateSecurityQuestionArgs {
  input: UpdateSecurityQuestionInput;
}

/** The root mutation object */
export interface MutationUpdateSkillArgs {
  input: UpdateSkillInput;
}

/** The root mutation object */
export interface MutationUpdateSkillCategoryArgs {
  input: UpdateSkillCategoryInput;
}

/** The root mutation object */
export interface MutationUpdateSkillLevelFormatArgs {
  input: UpdateSkillLevelFormatInput;
}

/** The root mutation object */
export interface MutationUpdateSkillSubSkillArgs {
  input: UpdateSkillSubSkillInput;
}

/** The root mutation object */
export interface MutationUpdateSubDomainArgs {
  input: UpdateSubDomainInput;
}

/** The root mutation object */
export interface MutationUpdateSubMultiSourceArgs {
  input: UpdateSubMultiSourceInput;
}

/** The root mutation object */
export interface MutationUpdateSupportGroupArgs {
  input: UpdateSupportGroupInput;
}

/** The root mutation object */
export interface MutationUpdateUsageStatisticArgs {
  input: UpdateUsageStatisticInput;
}

/** The root mutation object */
export interface MutationUpdateUserBigFieldsArgs {
  input: UpdateUserBigFieldsInput;
}

/** The root mutation object */
export interface MutationUpdateWorkspaceArgs {
  input: UpdateWorkspaceInput;
}

/** The root mutation object */
export interface MutationUpdateWorkspaceRoleArgs {
  input: UpdateWorkspaceRoleInput;
}

/** An object with an ID. */
export interface Node {
  /** ID of the object. */
  id: Scalars['ID']['output'];
}

/** Deprecated: use `Memo` instead */
export interface Note extends Node, Timestamped {
  __typename: 'Note';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** This note is a personal note and not regarding a specific portfolio */
  isPersonal: Scalars['Boolean']['output'];
  /** The actual note of this 'Note' */
  noteText: Maybe<Scalars['String']['output']>;
  /** User linked to this 'Note' */
  owner: Maybe<User>;
  /** Subject that this `Note` is about */
  portfolio: Maybe<Portfolio>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface Notification extends Node, Timestamped {
  __typename: 'Notification';
  /** The user linked to this `Notification` because he/she caused this `Notification` */
  causeUser: Maybe<User>;
  /** Type of content for the `Notification` */
  contentType: NotificationContentTypeEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the `Notification` */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** `PendingAction` that created this `Notification`, if it's related to one */
  pendingAction: Maybe<PendingAction>;
  /** Date and time of when the `Notification` was read. */
  readAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Source of the `Notification` */
  source: Maybe<NotificationSourceEnum>;
  /** Subject that this `Notification` is about */
  subject: Maybe<
    | AdminGroup
    | AttachedFile
    | AudioTranscript
    | Badge
    | CardComment
    | CardLog
    | CardTask
    | CccFormConfig
    | CccFormConfigSelectionFinalReportResult
    | CccFormConfigSelectionResult
    | ClinicalCompetenceCommittee
    | ClinicalCompetenceCommitteeRespondent
    | Code
    | CompetenceCertificate
    | CompetenceCertificateBatch
    | CompetenceCertificateSubSkillScore
    | Contact
    | Course
    | CourseEdition
    | CourseEducator
    | CourseResult
    | Dashboard
    | DashboardFormat
    | DashboardRole
    | Download
    | Draft
    | EventCard
    | ExternalAccess
    | ExternalOauthApplication
    | FeatureToggle
    | FeedbackRequest
    | FeedbackRound
    | GaiaActivity
    | GaiaCategory
    | GaiaFileSync
    | GaiaTarget
    | GeneralFeedback
    | GeneralFeedbackFormConfig
    | GeneratedReport
    | Goal
    | GoalActivity
    | GoalCard
    | GoalCardSummary
    | Guideline
    | GuidelineAttachment
    | ImportantNotice
    | Interview
    | Invite
    | Invoice
    | InvoicePlan
    | Kpb
    | KpbSubSkillScore
    | LearningResourceAlertedSetItemForUser
    | LearningResourceArticle
    | LearningResourceFile
    | LearningResourceGlobalCategory
    | LearningResourceLink
    | LearningResourceMicroLearning
    | LearningResourceMicroLearningStep
    | LearningResourceMicroLearningUserProgress
    | LearningResourceSet
    | LedgerAccount
    | Memo
    | MultiSource
    | Note
    | Notification
    | Oidc
    | OnboardingStep
    | Organization
    | OrganizationUserRole
    | ParentDomain
    | ParticipationLevelFormat
    | PendingAction
    | Period
    | PeriodFormat
    | PeriodRequiredSkillLevel
    | Portfolio
    | PortfolioAssessment
    | PortfolioDocumentConfig
    | PortfolioEvent
    | PortfolioFormat
    | PortfolioFormatSpecialtyConfig
    | PortfolioFormatTerminology
    | PortfolioImport
    | PortfolioNote
    | PortfolioQualityCriterion
    | PortfolioRole
    | PortfolioRoleSync
    | PortfolioTransferRequest
    | Program
    | ProgramRole
    | QualityInstrument
    | Registration
    | Residency
    | ResidencyArchetype
    | RoleFormat
    | RootSkillCategoryConfig
    | SecondFactor
    | SecurityQuestion
    | Skill
    | SkillCategory
    | SkillLevelFormat
    | SkillLevelFormatDescription
    | SkillSubSkill
    | SkillSubSkillAutoScoreMapping
    | Streak
    | StreakWeek
    | SubDomain
    | SubMultiSource
    | SupportGroup
    | UsageStatistic
    | User
    | Workspace
    | WorkspaceRole
  >;
  /** Localized date and time the `Notification` was created */
  time: Maybe<Scalars['String']['output']>;
  /** Title line of the `Notification` */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for Notification. */
export interface NotificationConnection {
  __typename: 'NotificationConnection';
  /** A list of edges. */
  edges: Array<NotificationEdge>;
  /** A list of nodes. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export enum NotificationContentTypeEnum {
  /** The content_type of the `Notification` is access_management */
  ACCESS_MANAGEMENT = 'ACCESS_MANAGEMENT',
  /** The content_type of the `Notification` is resource */
  RESOURCE = 'RESOURCE',
}

/** An edge in a connection. */
export interface NotificationEdge {
  __typename: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Notification>;
}

export enum NotificationSourceEnum {
  /** The source of the `Notification` is portfolio */
  PORTFOLIO = 'PORTFOLIO',
  /** The source of the `Notification` is workspace_dashboard */
  WORKSPACE_DASHBOARD = 'WORKSPACE_DASHBOARD',
}

export interface Oidc extends Node, Timestamped {
  __typename: 'OIDC';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The expires at date of this `OIDCSubject`. */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The oidc_provider of this `OIDCSubject`. */
  oidcProvider: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The userinfo of this `OIDCSubject`. */
  userinfo: Maybe<Scalars['JSON']['output']>;
}

export interface OnboardingStep extends Node, PortfolioItem, Timestamped {
  __typename: 'OnboardingStep';
  /** The completed at date of this `OnboardingStep`. */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The onboarding_step_key of this `OnboardingStep`. */
  onboardingStepKey: OnboardingStepKeyEnum;
  /** The onboarding_step_status of this `OnboardingStep`. */
  onboardingStepStatus: OnboardingStepStatusEnum;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `RoleFormat` that this `OnboardingStep` belongs to */
  roleFormat: Maybe<RoleFormat>;
  /** The `SkillCategory` that this `OnboardingStep` belongs to */
  skillCategory: Maybe<SkillCategory>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for OnboardingStep. */
export interface OnboardingStepConnection {
  __typename: 'OnboardingStepConnection';
  /** A list of edges. */
  edges: Array<OnboardingStepEdge>;
  /** A list of nodes. */
  nodes: Array<OnboardingStep>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface OnboardingStepEdge {
  __typename: 'OnboardingStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OnboardingStep>;
}

export enum OnboardingStepKeyEnum {
  /** The onboarding_step_key of the `OnboardingStep` is add_contributors */
  ADD_CONTRIBUTORS = 'ADD_CONTRIBUTORS',
  /** The onboarding_step_key of the `OnboardingStep` is add_initial_levels */
  ADD_INITIAL_LEVELS = 'ADD_INITIAL_LEVELS',
  /** The onboarding_step_key of the `OnboardingStep` is add_personal_profiling */
  ADD_PERSONAL_PROFILING = 'ADD_PERSONAL_PROFILING',
  /** The onboarding_step_key of the `OnboardingStep` is add_previous_registrations */
  ADD_PREVIOUS_REGISTRATIONS = 'ADD_PREVIOUS_REGISTRATIONS',
  /** The onboarding_step_key of the `OnboardingStep` is add_profile_goal */
  ADD_PROFILE_GOAL = 'ADD_PROFILE_GOAL',
  /** The onboarding_step_key of the `OnboardingStep` is add_residency */
  ADD_RESIDENCY = 'ADD_RESIDENCY',
  /** The onboarding_step_key of the `OnboardingStep` is add_role */
  ADD_ROLE = 'ADD_ROLE',
  /** The onboarding_step_key of the `OnboardingStep` is add_skill */
  ADD_SKILL = 'ADD_SKILL',
  /** The onboarding_step_key of the `OnboardingStep` is add_start_and_end_date */
  ADD_START_AND_END_DATE = 'ADD_START_AND_END_DATE',
  /** The onboarding_step_key of the `OnboardingStep` is copy_from_other_portfolio */
  COPY_FROM_OTHER_PORTFOLIO = 'COPY_FROM_OTHER_PORTFOLIO',
}

export enum OnboardingStepStatusEnum {
  /** The onboarding_step_status of the `OnboardingStep` is closed */
  CLOSED = 'CLOSED',
  /** The onboarding_step_status of the `OnboardingStep` is dismissed */
  DISMISSED = 'DISMISSED',
  /** The onboarding_step_status of the `OnboardingStep` is open */
  OPEN = 'OPEN',
}

export enum OnboardingViewEnum {
  /** All onboarding steps are completed/dismissed, the last one less than a day ago */
  COMPLETED_ALL = 'COMPLETED_ALL',
  /** All onboarding steps are completed/dismissed, the last one a day ago or more */
  HIDDEN = 'HIDDEN',
  /** One or more onboarding steps are still open */
  OPEN = 'OPEN',
}

/** An organization within the Reconcept Portfolio. */
export interface Organization extends Node, Timestamped {
  __typename: 'Organization';
  /** The ancestor organizations of this `Organization` in top-down order. */
  ancestors: Maybe<Array<Organization>>;
  /** URL for the avatar of this `Organisation` */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** The children organizations of this `Organization` in alphabetical order. */
  children: Array<Organization>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The descendant organizations of this `Organization` (children, grand-children) in alphabetical order. */
  descendants: Maybe<Array<Organization>>;
  id: Scalars['ID']['output'];
  /** The invoice_plans of this `Organization`. */
  invoicePlans: Maybe<InvoicePlanConnection>;
  /** Whether this `Organization` is the root. */
  isRoot: Scalars['Boolean']['output'];
  /** The name of this `Organization`. */
  name: Scalars['String']['output'];
  /** `OrganizationUserRole`s of this `Organization`. */
  organizationUserRoles: OrganizationUserRoleConnection;
  /** The outstanding `PortfolioTransfer`s that are directly linked to this `Organization`. */
  outstandingPortfolioTransferRequests: Array<PortfolioTransferRequest>;
  /** The ID of the parent `Organization`. */
  parentId: Maybe<Scalars['ID']['output']>;
  /** The pending `PortfolioTransfer`s that are directly linked to this `Organization`. */
  pendingPortfolioTransferRequests: Array<PortfolioTransferRequest>;
  /** The `Program`s that are linked to this `Organization`. */
  programs: ProgramConnection;
  /** The statistics of this `Organization`. */
  statistics: Maybe<OrganizationStatistics>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** A collection of Booleans to define the management rights for the current viewer */
  viewerManageRights: Maybe<ManageRights>;
}

/** An organization within the Reconcept Portfolio. */
export interface OrganizationChildrenArgs {
  filter?: InputMaybe<OrganizationFilter>;
}

/** An organization within the Reconcept Portfolio. */
export interface OrganizationInvoicePlansArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** An organization within the Reconcept Portfolio. */
export interface OrganizationOrganizationUserRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationUserRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** An organization within the Reconcept Portfolio. */
export interface OrganizationProgramsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Organization. */
export interface OrganizationConnection {
  __typename: 'OrganizationConnection';
  /** A list of edges. */
  edges: Array<OrganizationEdge>;
  /** A list of nodes. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface OrganizationEdge {
  __typename: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Organization>;
}

/** Filter organizations */
export interface OrganizationFilter {
  /** Only show the billable `Organization`s for the given `PortfolioFormat` (by `shortName`). */
  billableForPortfolioFormat?: InputMaybe<Scalars['String']['input']>;
  /** Only show the `Organization`s that are linked (through `Program`) to `PortfolioFormat` (by `shortName`). */
  portfolioFormatShortName?: InputMaybe<Scalars['String']['input']>;
}

export interface OrganizationStatistics {
  __typename: 'OrganizationStatistics';
  portfolioCounts: Maybe<Scalars['Int']['output']>;
}

export interface OrganizationStatisticsPortfolioCountsArgs {
  portfolioFormatShortName?: InputMaybe<Scalars['String']['input']>;
}

export interface OrganizationUserRole extends Node, Timestamped {
  __typename: 'OrganizationUserRole';
  /** The can_manage_roles of this `OrganizationUserRole`. */
  canManageRoles: Scalars['Boolean']['output'];
  /** The can_view_reports of this `OrganizationUserRole`. */
  canViewReports: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `Organization` that this `OrganizationUserRole` belongs to */
  organization: Organization;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `OrganizationUserRole` belongs to */
  user: User;
}

/** The connection type for OrganizationUserRole. */
export interface OrganizationUserRoleConnection {
  __typename: 'OrganizationUserRoleConnection';
  /** A list of edges. */
  edges: Array<OrganizationUserRoleEdge>;
  /** A list of nodes. */
  nodes: Array<OrganizationUserRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface OrganizationUserRoleEdge {
  __typename: 'OrganizationUserRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OrganizationUserRole>;
}

/** Filter `OrganizationUserRoles` */
export interface OrganizationUserRoleFilter {
  /** Only show the `OrganizationUserRoles` that can (not) manage roles. */
  canManageRoles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `OrganizationUserRoles` that can (not) view reports. */
  canViewReports?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Information about pagination in a connection. */
export interface PageInfo {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
}

export interface ParentDomain extends BaseDomain, Node, Timestamped {
  __typename: 'ParentDomain';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboard_format (`WorkspaceDashboard::DashboardFormat`) that this `WorkspaceDashboard::ParentDomain` belongs to */
  dashboardFormat: DashboardFormat;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  /** The sub_domains of this `WorkspaceDashboard::ParentDomain`. */
  subDomains: SubDomainConnection;
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface ParentDomainSubDomainsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for ParentDomain. */
export interface ParentDomainConnection {
  __typename: 'ParentDomainConnection';
  /** A list of edges. */
  edges: Array<ParentDomainEdge>;
  /** A list of nodes. */
  nodes: Array<ParentDomain>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ParentDomainEdge {
  __typename: 'ParentDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ParentDomain>;
}

export interface ParticipationLevelFormat extends Node, Timestamped {
  __typename: 'ParticipationLevelFormat';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The display_value of this `ParticipationLevelFormat`. */
  displayValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The label of this `ParticipationLevelFormat`. */
  label: Scalars['String']['output'];
  /** The level of this `ParticipationLevelFormat`. */
  level: Maybe<Scalars['Int']['output']>;
  /** The `RootSkillCategoryConfig` that this `ParticipationLevelFormat` belongs to */
  rootSkillCategoryConfig: RootSkillCategoryConfig;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for ParticipationLevelFormat. */
export interface ParticipationLevelFormatConnection {
  __typename: 'ParticipationLevelFormatConnection';
  /** A list of edges. */
  edges: Array<ParticipationLevelFormatEdge>;
  /** A list of nodes. */
  nodes: Array<ParticipationLevelFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ParticipationLevelFormatEdge {
  __typename: 'ParticipationLevelFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ParticipationLevelFormat>;
}

/** Autogenerated input type of PauseStreak */
export interface PauseStreakInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of PauseStreak. */
export interface PauseStreakPayload {
  __typename: 'PauseStreakPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The viewer, whose streak is paused */
  user: Maybe<User>;
}

export interface PendingAction extends Node, Timestamped {
  __typename: 'PendingAction';
  /** The kind of action this `PendingAction` represents for the viewer */
  actionType: Maybe<ActionTypeEnum>;
  /** The `User` that needs to perform an action on the subject */
  actor: Maybe<User>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `User` that is waiting on an action being taken */
  observer: Maybe<User>;
  /** Portfolio which the subject of this action is part of */
  portfolio: Maybe<Portfolio>;
  /** Item for which the actor needs to perform an action */
  subject: Maybe<PendingActionSubject>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for PendingAction. */
export interface PendingActionConnection {
  __typename: 'PendingActionConnection';
  /** A list of edges. */
  edges: Array<PendingActionEdge>;
  /** A list of nodes. */
  nodes: Array<PendingAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PendingActionEdge {
  __typename: 'PendingActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PendingAction>;
}

/** Object which can be the subject of a `PendingAction` */
export type PendingActionSubject =
  | ClinicalCompetenceCommittee
  | ClinicalCompetenceCommitteeRespondent
  | CompetenceCertificate
  | CompetenceCertificateBatch
  | FeedbackRequest
  | FeedbackRound
  | Interview
  | Kpb
  | MultiSource
  | PortfolioTransferRequest;

export interface Period extends Node, Timestamped {
  __typename: 'Period';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The label of this `Period`. */
  label: Scalars['String']['output'];
  /** The period_end_date of this `Period`. */
  periodEndDate: Scalars['Date']['output'];
  /** The `PeriodFormat` that this `Period` belongs to */
  periodFormat: PeriodFormat;
  /**
   * Required skill levels for the `Period`. If PeriodFormat does not have a
   * required skill level of the previous PeriodFormats in the same PortfolioFormat is returned.
   */
  periodRequiredSkillLevels: PeriodRequiredSkillLevelConnection;
  /** The period_start_date of this `Period`. */
  periodStartDate: Scalars['Date']['output'];
  /** The `Portfolio` that this `Period` belongs to */
  portfolio: Portfolio;
  /**
   * The rotation_end_date of this `Period`.
   * @deprecated Use the `periodEndDate` field
   */
  rotationEndDate: Scalars['Date']['output'];
  /**
   * Always returns an empty array.
   * @deprecated Use the `periodRequiredSkillLevels` field
   */
  rotationRequiredSkillLevels: PeriodRequiredSkillLevelConnection;
  /**
   * The rotation_start_date of this `Period`.
   * @deprecated Use the `periodStartDate` field
   */
  rotationStartDate: Scalars['Date']['output'];
  /** The short_label of this `Period`. */
  shortLabel: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface PeriodPeriodRequiredSkillLevelsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PeriodRequiredSkillLevelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PeriodRotationRequiredSkillLevelsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RotationRequiredSkillLevelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Period. */
export interface PeriodConnection {
  __typename: 'PeriodConnection';
  /** A list of edges. */
  edges: Array<PeriodEdge>;
  /** A list of nodes. */
  nodes: Array<Period>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PeriodEdge {
  __typename: 'PeriodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Period>;
}

export interface PeriodFormat extends Node, Timestamped {
  __typename: 'PeriodFormat';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The label of this `PeriodFormat`. */
  label: Scalars['String']['output'];
  /** The month_duration of this `PeriodFormat`. */
  monthDuration: Scalars['Int']['output'];
  /** The order of this `PeriodFormat`. */
  order: Scalars['Int']['output'];
  /** The period_required_skill_levels of this `PeriodFormat`. */
  periodRequiredSkillLevels: PeriodRequiredSkillLevelConnection;
  /** The periods of this `PeriodFormat`. */
  periods: PeriodConnection;
  /** The `PortfolioFormat` that this `PeriodFormat` belongs to */
  portfolioFormat: PortfolioFormat;
  /** The short_label of this `PeriodFormat`. */
  shortLabel: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface PeriodFormatPeriodRequiredSkillLevelsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PeriodRequiredSkillLevelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PeriodFormatPeriodsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for PeriodFormat. */
export interface PeriodFormatConnection {
  __typename: 'PeriodFormatConnection';
  /** A list of edges. */
  edges: Array<PeriodFormatEdge>;
  /** A list of nodes. */
  nodes: Array<PeriodFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PeriodFormatEdge {
  __typename: 'PeriodFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PeriodFormat>;
}

export interface PeriodRequiredSkillLevel extends Node, Timestamped {
  __typename: 'PeriodRequiredSkillLevel';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `PeriodFormat` that this `PeriodRequiredSkillLevel` belongs to */
  periodFormat: PeriodFormat;
  /**
   * The `PeriodFormat` that this `PeriodRequiredSkillLevel` belongs to
   * @deprecated Use the `periodFormat` field
   */
  rotationFormat: PeriodFormat;
  /** The `Skill` that this `PeriodRequiredSkillLevel` belongs to */
  skill: Skill;
  /** The `SkillLevelFormat` that this `PeriodRequiredSkillLevel` belongs to */
  skillLevelFormat: SkillLevelFormat;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for PeriodRequiredSkillLevel. */
export interface PeriodRequiredSkillLevelConnection {
  __typename: 'PeriodRequiredSkillLevelConnection';
  /** A list of edges. */
  edges: Array<PeriodRequiredSkillLevelEdge>;
  /** A list of nodes. */
  nodes: Array<PeriodRequiredSkillLevel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PeriodRequiredSkillLevelEdge {
  __typename: 'PeriodRequiredSkillLevelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PeriodRequiredSkillLevel>;
}

export interface PeriodRequiredSkillLevelFilter {
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `PeriodRequiredSkillLevel`s with `Skill`s with given skill_types */
  skillTypes?: InputMaybe<Array<SkillTypeEnum>>;
}

/** One of the portfolios of a particular user */
export interface Portfolio extends Accessible, Node, Timestamped {
  __typename: 'Portfolio';
  /** Time the `Portfolio` was archived */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** Retrieve `CanmedScores` for this `Portfolio` */
  canmedScores: Maybe<Array<CanmedScore>>;
  /** Retrieve `CanmedScores` for a specific `Skill` */
  canmedScoresForSkill: Maybe<Array<CanmedScore>>;
  /** The clinical_competence_committees of this `Portfolio`. */
  clinicalCompetenceCommittees: ClinicalCompetenceCommitteeConnection;
  /** The cohort of the `Portfolio`. */
  cohort: Maybe<Scalars['String']['output']>;
  /** All `CompetenceCertificates` attached to this `Portfolio` */
  competenceCertificates: CompetenceCertificateConnection;
  /** Time the `Portfolio` was completed */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of 30-day months the portfolio owner has currently effectively worked on the `Residencies` of this `Portfolio` */
  completedDuration: Maybe<Scalars['Float']['output']>;
  /** Distinct `Course` short names of the `CourseResult`s in this `Portfolio` */
  courseResultDocumentTypes: Maybe<Array<Scalars['String']['output']>>;
  /** Results for the courses associated with this portfolio */
  courseResults: CourseResultConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The current_period of this `Portfolio`. */
  currentPeriod: Maybe<Period>;
  /**
   * Always returns null
   * @deprecated Use the `currentPeriod` field
   */
  currentRotation: Maybe<Period>;
  /** Custom settings for the `Portfolio` */
  customSettings: Maybe<Scalars['JSON']['output']>;
  /** The `Download`s linked to this `Portfolio` */
  downloads: Array<Download>;
  /** Date that the user's education ended or will end */
  educationEndedOn: Maybe<Scalars['Date']['output']>;
  /** Date that the user's education started */
  educationStartedOn: Maybe<Scalars['Date']['output']>;
  /** Number of 30-day months the portfolio owner effectively works on the `Residencies` of this `Portfolio` */
  effectiveDuration: Maybe<Scalars['Float']['output']>;
  /** `PortfolioEvents` for this `Portfolio` */
  events: PortfolioEventConnection;
  /** All `ExternalAccess`s linked to this `Portfolio` */
  externalAccesses: ExternalAccessConnection;
  /** All `ExternalOauthApplication`s linked to this `Portfolio` */
  externalOauthApplicationsWithActiveConnection: Maybe<ExternalOauthApplicationConnection>;
  /** All `FeedbackRound`s attached to this `Portfolio` */
  feedbackRounds: FeedbackRoundConnection;
  /** The general_feedbacks of this `Portfolio`. */
  generalFeedbacks: GeneralFeedbackConnection;
  /** All `Goals` attached to this `Portfolio` */
  goals: GoalConnection;
  id: Scalars['ID']['output'];
  /** All `Interviews` attached to this `Portfolio` */
  interviews: InterviewConnection;
  /** All `KPBs` attached to this `Portfolio` */
  kpbs: KpbConnection;
  /** The `Memo`s of which this `Portfolio` is the subject */
  memos: Array<Memo>;
  /** All `CompetenceCertificates` attached to this `Portfolio` */
  multiSources: MultiSourceConnection;
  /**
   * The `Note`s of which this `Portfolio` is the subject
   * @deprecated Use `memos` instead
   */
  notes: Array<Note>;
  /** The onboarding_steps of this `Portfolio`. */
  onboardingSteps: OnboardingStepConnection;
  /** The onboarding_view of this `Portfolio`. */
  onboardingView: OnboardingViewEnum;
  /** `Organization` that manages this `Portfolio` */
  organization: Maybe<Organization>;
  /** The owner of the `Portfolio` */
  owner: Maybe<User>;
  /** The pending_actions of this `Portfolio`. */
  pendingActions: Maybe<PendingActionConnection>;
  /** `Periods` the portfolio owner follows in the educational context of this `Portfolio` */
  periods: PeriodConnection;
  /** All `PortfolioAssessment`s attached to this `Portfolio` */
  portfolioAssessments: PortfolioAssessmentConnection;
  /** Format for this `Portfolio` */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** The portfolio_import of this `Portfolio`. */
  portfolioImport: Maybe<PortfolioImport>;
  /** The portfolio_notes of this `Portfolio`. */
  portfolioNotes: PortfolioNoteConnection;
  /** `PortfolioRoleSync`s that belong to this `Portfolio` */
  portfolioRoleSyncs: PortfolioRoleSyncConnection;
  /** `PortfolioRole`s that belong to this `Portfolio` */
  portfolioRoles: PortfolioRoleConnection;
  /** Statistics for `Skill` and (sub-)`Skill` combinations in this portfolio */
  portfolioSkillSubSkillStatistics: Maybe<PortfolioSkillSubSkillStatisticsConnection>;
  /** Returns the current status of the `Portfolio` */
  portfolioStatus: Maybe<PortfolioStatusEnum>;
  /** Profile of the `Portfolio` */
  profile: Maybe<Scalars['String']['output']>;
  /** The quality_criteria of this `Portfolio`. */
  qualityCriteria: PortfolioQualityCriterionConnection;
  /** Number of months the education period was shortened compared to normal */
  reduction: Maybe<Scalars['Float']['output']>;
  /** All `Registrations` attached to this `Portfolio` */
  registrations: RegistrationConnection;
  /** `Residencies` the portfolio owner follows in the educational context of this `Portfolio` */
  residencies: ResidencyConnection;
  /**
   * Always returns an empty array
   * @deprecated Use the `periods` field
   */
  rotations: PeriodConnection;
  /** The set of `Skill`s this `Portfolio` is linked to. */
  skills: PortfolioSkillsConnection;
  /** Assessment statistics for this portfolio */
  statistics: Maybe<PortfolioStatistics>;
  /**
   * Returns the current status of the `Portfolio`
   * @deprecated Use `portfolio_status` instead, remove this field after 2025-09-01
   */
  status: Maybe<PortfolioStatusEnum>;
  /** The sub_skills of this `Portfolio`. */
  subSkills: PortfolioSubSkillsConnection;
  /** The to be removed at date of this `Portfolio`. */
  toBeRemovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Multipurpose information field for the `Portfolio` */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Retrieve `PortfolioTransferRequests` for this `Portfolio` */
  transferRequests: PortfolioTransferRequestConnection;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Collection of Booleans to indicate the permissions of the current viewer for this `Portfolio` */
  viewerPortfolioPermissions: Maybe<ViewerPortfolioPermissions>;
}

/** One of the portfolios of a particular user */
export interface PortfolioCanmedScoresForSkillArgs {
  skillId: Scalars['ID']['input'];
}

/** One of the portfolios of a particular user */
export interface PortfolioClinicalCompetenceCommitteesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioCompetenceCertificatesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioCourseResultsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CourseResultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioEventsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioExternalAccessesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioExternalOauthApplicationsWithActiveConnectionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioFeedbackRoundsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioGeneralFeedbacksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioGoalsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioInterviewsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioKpbsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioMultiSourcesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioOnboardingStepsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPendingActionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPeriodsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPortfolioAssessmentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PortfolioAssessmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPortfolioNotesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPortfolioRoleSyncsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PortfolioRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioPortfolioSkillSubSkillStatisticsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skillsByTypeForSubSkillsFilter?: InputMaybe<SkillsByTypeForSubSkillsFilterInput>;
  subSkillsByTypeForSkillsFilter?: InputMaybe<SubSkillsByTypeForSkillsFilterInput>;
}

/** One of the portfolios of a particular user */
export interface PortfolioQualityCriteriaArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioRegistrationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegistrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioResidenciesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioRotationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioStatisticsArgs {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioSubSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** One of the portfolios of a particular user */
export interface PortfolioTransferRequestsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/**
 * PortfolioAssessment is an extra link between a portfolio and an assessment in
 *                   order to make it possible to query all of the portfolios assessments at once.
 */
export interface PortfolioAssessment extends Node, PortfolioItem {
  __typename: 'PortfolioAssessment';
  id: Scalars['ID']['output'];
  /** Portfolio of the `PortfolioAssessment` */
  portfolio: Portfolio;
  /** Date on which the `PortfolioAssessment`s can be sorted */
  sortDate: Maybe<Scalars['Date']['output']>;
  /** Subject of the `PortfolioAssessment` */
  subject: PortfolioAssessmentSubject;
}

/** The connection type for PortfolioAssessment. */
export interface PortfolioAssessmentConnection {
  __typename: 'PortfolioAssessmentConnection';
  /** A list of edges. */
  edges: Array<PortfolioAssessmentEdge>;
  /** The counts of distinct filtered formType values. This is a JSON object with number values. */
  formTypeCounts: Maybe<Scalars['JSON']['output']>;
  /** A list of nodes. */
  nodes: Array<PortfolioAssessment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The counts of distinct filtered subjectType values. This is a JSON object with number values. */
  subjectTypeCounts: Maybe<Scalars['JSON']['output']>;
  /** The total filtered amount of items in this connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
}

/** An edge in a connection. */
export interface PortfolioAssessmentEdge {
  __typename: 'PortfolioAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioAssessment>;
}

/** Filter for `PortfolioAssessments` */
export interface PortfolioAssessmentFilter {
  /** Only show objects that occur before this date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only return objects with this form type */
  formType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show objects related to these `Goals` */
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects related to these `Skills` */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects related to these `Skills` or `SubSkills` */
  skillIdsOrSubSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show objects that occur after this date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only return objects with this status */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show objects related to these `SubSkills` */
  subSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only return objects with this subject type */
  subjectType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show objects supervised by these `Users` */
  supervisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Object which can be the subject of a PortfolioAssessment */
export type PortfolioAssessmentSubject =
  CompetenceCertificate | CourseResult | GeneralFeedback | Interview | Kpb | MultiSource | Registration;

/** The connection type for Portfolio. */
export interface PortfolioConnection {
  __typename: 'PortfolioConnection';
  /** A list of edges. */
  edges: Array<PortfolioEdge>;
  /** A list of nodes. */
  nodes: Array<Portfolio>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** The configuration of a form for a portfolio format. */
export interface PortfolioDocumentConfig extends Node, Timestamped {
  __typename: 'PortfolioDocumentConfig';
  /** The ai_context of this `PortfolioDocumentConfig`. */
  aiContext: Maybe<Scalars['String']['output']>;
  /** Whether `PortfolioDocumentConfig` is allow batch. */
  allowBatch: Scalars['Boolean']['output'];
  /**
   * Whether `PortfolioDocumentConfig` is attachment is essential.
   * @deprecated This field will be removed, all documents can have attachments. remove after 2024-08-01
   */
  attachmentIsEssential: Scalars['Boolean']['output'];
  /**
   * Whether `PortfolioDocumentConfig` is can have attached files.
   * @deprecated This field will be removed, all documents can have attachments. remove after 2024-08-01
   */
  canHaveAttachedFiles: Scalars['Boolean']['output'];
  /** Whether `PortfolioDocumentConfig` is can have feedback round. */
  canHaveFeedbackRound: Scalars['Boolean']['output'];
  /**
   * Whether `PortfolioDocumentConfig` is can have goal activities.
   * @deprecated This field will be removed, all document will be connectable to goals
   */
  canHaveGoalActivities: Scalars['Boolean']['output'];
  /**
   * Whether `PortfolioDocumentConfig` is can have profile goal activities.
   * @deprecated This field will be removed, all document will be connectable to goals
   */
  canHaveProfileGoalActivities: Scalars['Boolean']['output'];
  /** Whether `PortfolioDocumentConfig` is can have reduction. */
  canHaveReduction: Scalars['Boolean']['output'];
  /** Whether `PortfolioDocumentConfig` is can have self assessment. */
  canHaveSelfAssessment: Scalars['Boolean']['output'];
  /** Whether `PortfolioDocumentConfig` is can use transcription. */
  canUseTranscription: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `PortfolioDocumentConfig`. */
  description: Maybe<Scalars['String']['output']>;
  /** The document_type of this `PortfolioDocumentConfig`. */
  documentType: PortfolioDocumentTypeEnum;
  /**
   * Whether `PortfolioDocumentConfig` is early request approval allowed.
   * @deprecated This field will be removed, it should always be true. Can be removed after august 12th, 2024.
   */
  earlyRequestApprovalAllowed: Scalars['Boolean']['output'];
  /** The feedback_form of this `PortfolioDocumentConfig`. */
  feedbackForm: Maybe<Scalars['JSON']['output']>;
  /** The form of this `PortfolioDocumentConfig`. */
  form: Scalars['JSON']['output'];
  /** The form_type of this `PortfolioDocumentConfig`. */
  formType: Scalars['String']['output'];
  /** The form_type_name of this `PortfolioDocumentConfig`. */
  formTypeName: Scalars['String']['output'];
  /**
   * The form_version of this `PortfolioDocumentConfig`.
   * @deprecated This field will be removed, it will currently return the numerical ID. Remove this no earlier than the 11th of november 2024.
   */
  formVersion: Scalars['Int']['output'];
  /** The form_with_only_ai_fields of this `PortfolioDocumentConfig`. */
  formWithOnlyAiFields: Scalars['JSON']['output'];
  /** The guideline_id of this `PortfolioDocumentConfig`. */
  guidelineId: Maybe<Scalars['String']['output']>;
  /** Whether `PortfolioDocumentConfig` is has supervision level. */
  hasSupervisionLevel: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether `PortfolioDocumentConfig` is available in app. */
  isAvailableInApp: Scalars['Boolean']['output'];
  /**
   * Whether `PortfolioDocumentConfig` is available in freemium.
   * @deprecated Freemium feature is being removed, remove this at the latest in november 2024
   */
  isAvailableInFreemium: Scalars['Boolean']['output'];
  /** Whether `PortfolioDocumentConfig` is creatable by support. */
  isCreatableBySupport: Scalars['Boolean']['output'];
  /** The name of this `PortfolioDocumentConfig`. */
  name: Scalars['String']['output'];
  /** The order of this `PortfolioDocumentConfig`. */
  order: Scalars['Int']['output'];
  /** The plural_name of this `PortfolioDocumentConfig`. */
  pluralName: Maybe<Scalars['String']['output']>;
  /** The portfolio_document_config_status of this `PortfolioDocumentConfig`. */
  portfolioDocumentConfigStatus: PortfolioDocumentConfigStatusEnum;
  /** The `PortfolioFormat` that this `PortfolioDocumentConfig` belongs to */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** The referrable_form_types of this `PortfolioDocumentConfig`. */
  referrableFormTypes: Array<Scalars['String']['output']>;
  /** The required_number of this `PortfolioDocumentConfig`. */
  requiredNumber: Maybe<Scalars['Int']['output']>;
  /** Whether `PortfolioDocumentConfig` is show in main create menu. */
  showInMainCreateMenu: Scalars['Boolean']['output'];
  /** The skill_type of this `PortfolioDocumentConfig`. */
  skillType: SkillTypeEnum;
  /** Whether `PortfolioDocumentConfig` is skip supervisor. */
  skipSupervisor: Scalars['Boolean']['output'];
  /**
   * The status of this `PortfolioDocumentConfig`.
   * @deprecated Use `portfolio_document_config_status` instead, remove this field after 2025-09-01
   */
  status: PortfolioDocumentConfigStatusEnum;
  /** Whether `PortfolioDocumentConfig` is supervisor is optional. */
  supervisorIsOptional: Scalars['Boolean']['output'];
  /** The supervisor_type of this `PortfolioDocumentConfig`. */
  supervisorType: SupervisorTypeEnum;
  /** Whether `PortfolioDocumentConfig` is supports invite. */
  supportsInvite: Scalars['Boolean']['output'];
  /**
   * The transcription_prompt_context of this `PortfolioDocumentConfig`.
   * @deprecated Use `ai_context` instead, remove this field after 2026-12-01
   */
  transcriptionPromptContext: Maybe<Scalars['String']['output']>;
  /** Whether `PortfolioDocumentConfig` is unlisted. */
  unlisted: Scalars['Boolean']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for PortfolioDocumentConfig. */
export interface PortfolioDocumentConfigConnection {
  __typename: 'PortfolioDocumentConfigConnection';
  /** A list of edges. */
  edges: Array<PortfolioDocumentConfigEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioDocumentConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioDocumentConfigEdge {
  __typename: 'PortfolioDocumentConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioDocumentConfig>;
}

export interface PortfolioDocumentConfigFilter {
  canUseTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  documentTypes?: InputMaybe<Array<PortfolioDocumentTypeEnum>>;
  formTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  skillType?: InputMaybe<SkillTypeEnum>;
  status?: InputMaybe<PortfolioDocumentConfigStatusEnum>;
}

export enum PortfolioDocumentConfigStatusEnum {
  /** The status of the `PortfolioDocumentConfig` is archived */
  ARCHIVED = 'ARCHIVED',
  /** The status of the `PortfolioDocumentConfig` is draft */
  DRAFT = 'DRAFT',
  /** The status of the `PortfolioDocumentConfig` is published */
  PUBLISHED = 'PUBLISHED',
}

export enum PortfolioDocumentTypeEnum {
  /** The document_type of the `PortfolioDocumentConfig` is assessment */
  ASSESSMENT = 'ASSESSMENT',
  /** The document_type of the `PortfolioDocumentConfig` is competence_certificate */
  COMPETENCE_CERTIFICATE = 'COMPETENCE_CERTIFICATE',
  /** The document_type of the `PortfolioDocumentConfig` is course_result */
  COURSE_RESULT = 'COURSE_RESULT',
  /** The document_type of the `PortfolioDocumentConfig` is interview */
  INTERVIEW = 'INTERVIEW',
  /** The document_type of the `PortfolioDocumentConfig` is iop */
  IOP = 'IOP',
  /** The document_type of the `PortfolioDocumentConfig` is multi_source */
  MULTI_SOURCE = 'MULTI_SOURCE',
  /** The document_type of the `PortfolioDocumentConfig` is registration */
  REGISTRATION = 'REGISTRATION',
  /** The document_type of the `PortfolioDocumentConfig` is self_reflection */
  SELF_REFLECTION = 'SELF_REFLECTION',
}

/** An edge in a connection. */
export interface PortfolioEdge {
  __typename: 'PortfolioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Portfolio>;
}

export enum PortfolioEmailFrequencyEnum {
  /** The portfolio_email_frequency of the `User` is daily */
  DAILY = 'DAILY',
  /** The portfolio_email_frequency of the `User` is instant */
  INSTANT = 'INSTANT',
  /** The portfolio_email_frequency of the `User` is never */
  NEVER = 'NEVER',
}

export interface PortfolioEvent extends Node, PortfolioItem, Timestamped {
  __typename: 'PortfolioEvent';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Event type of this `PortfolioEvent` */
  event: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * True if this event was performed automatically
   * @deprecated No event ever is automatic, but this was set to true for migrated eveent
   */
  isAutomatic: Scalars['Boolean']['output'];
  /** Free form metadata */
  metadata: Maybe<Scalars['JSON']['output']>;
  /**
   * Moment in time this event occurred
   * @deprecated Use `created_at` instead
   */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Organization in which this event occurred */
  organization: Maybe<Organization>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User that performed the action that resulted in this event */
  user: Maybe<User>;
}

/** The connection type for PortfolioEvent. */
export interface PortfolioEventConnection {
  __typename: 'PortfolioEventConnection';
  /** A list of edges. */
  edges: Array<PortfolioEventEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioEventEdge {
  __typename: 'PortfolioEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioEvent>;
}

/** Filter for `Portfolios` */
export interface PortfolioFilter {
  /** Show/hide `Portfolios` that are archived */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Show `Portfolios` of which the viewer has an active `PortfolioRole` with
   * can_assess active_role_format or can_assign_other_supervisors
   */
  canAssessOrCanAssignOtherSupervisors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show `Portfolios` with the given cohorts */
  cohorts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Show `Portfolios` that have `Periods` with given `PeriodFormat`s */
  periodFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Show `Portfolios` from the `PortfolioFormat` with the given short name */
  portfolioFormat?: InputMaybe<Scalars['String']['input']>;
  /** Show `Portfolios` from the `PortfolioFormat`s with the given short name */
  portfolioFormats?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Show `Portfolios` of which the viewer has an active `PortfolioRole` with given read_access_level or higher */
  readAccessLevel?: InputMaybe<ReadAccessLevelEnum>;
  /** Show `Portfolios` of which the viewer has an active `PortfolioRole` with given `RoleFormat`s */
  roleFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface PortfolioFormat extends Node, Timestamped {
  __typename: 'PortfolioFormat';
  /** URL for the avatar of this `PortfolioFormat` */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Whether the `PortfolioFormat` can have residencies */
  canHaveResidencies: Scalars['Boolean']['output'];
  /** `CccFormConfig`s that are available for CCCs. Sorted by `order` ascending. */
  cccFormConfigs: CccFormConfigConnection;
  /** Configuration placeholder for the frontend. Filled client side. needed for the generation */
  config: Maybe<Scalars['JSON']['output']>;
  /** Export of the configuration of the portfolioformat. This can be imported on another environment */
  configurationJsonExport: Maybe<Scalars['JSON']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Configures the start month of the education (where 1 is January) */
  educationDurationStartMonth: Maybe<Scalars['Int']['output']>;
  /** `GeneralFeedbackFormConfig`s for general feedback. Sorted by `order` ascending. */
  generalFeedbackFormConfigs: GeneralFeedbackFormConfigConnection;
  /** Guidelines code ID of the `PortfolioFormat` */
  guidelinesCodeId: Maybe<Scalars['String']['output']>;
  /**
   * Whether `PortfolioFormat` is has learning content links.
   * @deprecated LearningMaterial is replaced by LearningResources
   */
  hasLearningContentLinks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Language of the `PortfolioFormat` */
  language: LanguageEnum;
  /** The learning_resource_sets of this `PortfolioFormat`. */
  learningResourceSets: LearningResourceSetConnection;
  /** Target role type of the `PortfolioFormat` */
  mailingType: Maybe<TargetRoleEnum>;
  /** Full name of the `PortfolioFormat` */
  name: Scalars['String']['output'];
  /** Configures the nominal (official) duration of the education in months */
  nominalDuration: Maybe<Scalars['Int']['output']>;
  /** Configures whether the profile is shown in the onboarding */
  onboardingShowProfile: Scalars['Boolean']['output'];
  /** Configures whether the profile goals can be customized in the onboarding */
  onboardingShowProfileGoals: Scalars['Boolean']['output'];
  /** The period_formats of this `PortfolioFormat`. */
  periodFormats: PeriodFormatConnection;
  /** The portfolio_document_configs of this `PortfolioFormat`. */
  portfolioDocumentConfigs: PortfolioDocumentConfigConnection;
  /** Configures whether users are allowed to customize their profiles */
  profileAllowCustom: Scalars['Boolean']['output'];
  /** Configures profiles */
  profiles: Array<Scalars['String']['output']>;
  /** `Program`s that are linked for this `PortfolioFormat` */
  programs: ProgramConnection;
  /** Available residency archetypes for this format */
  residencyArchetypes: Array<ResidencyArchetype>;
  /** `RoleFormat`s that are linked for this `PortfolioFormat` */
  roleFormats: RoleFormatConnection;
  /** The root `Course` of this `PortfolioFormat` */
  rootCourse: Maybe<Course>;
  /** The root `Organization`s that are relevant for this portfolio format. */
  rootOrganizations: Maybe<OrganizationConnection>;
  /**
   * Always returns an empty array.
   * @deprecated Use the `periodFormats` field
   */
  rotationFormats: PeriodFormatConnection;
  /** Unique name using only lowercase letters and hyphens */
  shortName: Scalars['String']['output'];
  /** SkillCategories linked to PortfolioFormat */
  skillCategories: SkillCategoryConnection;
  /** The skill_competence_certificate_statistics of this `PortfolioFormat`. */
  skillCompetenceCertificateStatistics: Array<SkillCompetenceCertificateStatistics>;
  /** The specialty_config of this `PortfolioFormat`. */
  specialtyConfig: Maybe<PortfolioFormatSpecialtyConfig>;
  /** The statistics of this `PortfolioFormat`. */
  statistics: Maybe<PortfolioFormatStatistics>;
  /** `SupportGroups` that can support this `PortfolioFormat` */
  supportGroups: Array<SupportGroup>;
  /** The terminology of this `PortfolioFormat`. */
  terminology: Maybe<PortfolioFormatTerminology>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Configures whether portfolios use portfolio notes */
  usesPortfolioNotes: Scalars['Boolean']['output'];
  /** Configures whether portfolios use a profile */
  usesProfile: Scalars['Boolean']['output'];
  /** Configures whether portfolios use profile goals */
  usesProfileGoals: Scalars['Boolean']['output'];
  /** Configures whether portfolios use a start and end date */
  usesStartEndDate: Scalars['Boolean']['output'];
}

export interface PortfolioFormatCccFormConfigsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatGeneralFeedbackFormConfigsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatLearningResourceSetsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatPeriodFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatPortfolioDocumentConfigsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PortfolioDocumentConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatProgramsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatRoleFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RoleFormatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatRootOrganizationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatRotationFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatSkillCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioFormatSkillCompetenceCertificateStatisticsArgs {
  periodFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skillTypes?: InputMaybe<Array<SkillTypeEnum>>;
}

/** The connection type for PortfolioFormat. */
export interface PortfolioFormatConnection {
  __typename: 'PortfolioFormatConnection';
  /** A list of edges. */
  edges: Array<PortfolioFormatEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioFormatEdge {
  __typename: 'PortfolioFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioFormat>;
}

export interface PortfolioFormatSpecialtyConfig extends Node, Timestamped {
  __typename: 'PortfolioFormatSpecialtyConfig';
  /** `GaiaCategory`s of the specialty in the CPD calendar, selected by default */
  cpdCalendarGaiaCategories: GaiaCategoryConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `PortfolioFormat` that this `PortfolioFormatSpecialtyConfig` belongs to */
  portfolioFormat: PortfolioFormat;
  /** Specialty used in the CPD calendar url, e.g. `pulmonology` */
  specialty: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether `PortfolioFormatSpecialtyConfig` is uses cpd calendar. */
  usesCpdCalendar: Scalars['Boolean']['output'];
}

export interface PortfolioFormatSpecialtyConfigCpdCalendarGaiaCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for PortfolioFormatSpecialtyConfig. */
export interface PortfolioFormatSpecialtyConfigConnection {
  __typename: 'PortfolioFormatSpecialtyConfigConnection';
  /** A list of edges. */
  edges: Array<PortfolioFormatSpecialtyConfigEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioFormatSpecialtyConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioFormatSpecialtyConfigEdge {
  __typename: 'PortfolioFormatSpecialtyConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioFormatSpecialtyConfig>;
}

export interface PortfolioFormatStatistics {
  __typename: 'PortfolioFormatStatistics';
  portfolioCounts: Maybe<Scalars['Int']['output']>;
}

export interface PortfolioFormatTerminology extends Node {
  __typename: 'PortfolioFormatTerminology';
  advancedResidencySupervisors: Maybe<Scalars['String']['output']>;
  competenceCertificate: Maybe<Scalars['String']['output']>;
  competenceCertificateLevel: Maybe<Scalars['String']['output']>;
  competenceCertificateLevels: Maybe<Scalars['String']['output']>;
  competenceCertificates: Maybe<Scalars['String']['output']>;
  /**
   * The course_results_epa_detail_table_title of this `PortfolioFormatTerminology`.
   * @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025
   */
  courseResultsEpaDetailTableTitle: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  educationView: Maybe<Scalars['String']['output']>;
  epa: Maybe<Scalars['String']['output']>;
  epas: Maybe<Scalars['String']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  feedbackPlural: Maybe<Scalars['String']['output']>;
  feedbackRound: Maybe<Scalars['String']['output']>;
  generalSkill: Maybe<Scalars['String']['output']>;
  generalSkills: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** iop refers to the actual IOP form (type) */
  iop: Maybe<Scalars['String']['output']>;
  medicalTheme: Maybe<Scalars['String']['output']>;
  medicalThemes: Maybe<Scalars['String']['output']>;
  operation: Maybe<Scalars['String']['output']>;
  operations: Maybe<Scalars['String']['output']>;
  operationsView: Maybe<Scalars['String']['output']>;
  /** personalProfiling refers to the collection of settings related to personalisation of the educational program */
  personalProfiling: Maybe<Scalars['String']['output']>;
  /** planningView refers to the main menu item that includes timeline, personal profiling and IOP */
  planningView: Maybe<Scalars['String']['output']>;
  pointsOfConcern: Maybe<Scalars['String']['output']>;
  portfolioOwner: Maybe<Scalars['String']['output']>;
  /** portfolioProfile is the label for the single property portfolio.profile, a string value */
  portfolioProfile: Maybe<Scalars['String']['output']>;
  positivePoints: Maybe<Scalars['String']['output']>;
  principal: Maybe<Scalars['String']['output']>;
  principals: Maybe<Scalars['String']['output']>;
  /**
   * profileGoal is the label for dynamic goal objects that can be used to define
   * multiple differentiating subjects in a portfolio
   */
  profileGoal: Maybe<Scalars['String']['output']>;
  profileGoals: Maybe<Scalars['String']['output']>;
  residencies: Maybe<Scalars['String']['output']>;
  residency: Maybe<Scalars['String']['output']>;
  residencySupervisors: Maybe<Scalars['String']['output']>;
  /**
   * The supervisor of this `PortfolioFormatTerminology`.
   * @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025
   */
  supervisor: Maybe<Scalars['String']['output']>;
  /**
   * The supervisors of this `PortfolioFormatTerminology`.
   * @deprecated This terminology is not used in the application. Can be removed after the 20th of May 2025
   */
  supervisors: Maybe<Scalars['String']['output']>;
  timeline: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export interface PortfolioImport extends Node, Timestamped {
  __typename: 'PortfolioImport';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Uploaded zip-file */
  importFile: Maybe<AttachedFile>;
  /** The `Portfolio` that this `PortfolioImport` belongs to */
  portfolio: Portfolio;
  /** Current status of this PortfolioImport */
  portfolioImportStatus: ImportStatusEnum;
  /**
   * Current status of this PortfolioImport
   * @deprecated Use `portfolio_import_status` instead, remove this field after 2025-09-01
   */
  status: ImportStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** An object that belongs to a certain `Portfolio` */
export interface PortfolioItem {
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
}

export interface PortfolioNote extends Node, Timestamped {
  __typename: 'PortfolioNote';
  /** The attached_files of this `PortfolioNote`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The goals of this `PortfolioNote`. */
  goals: GoalConnection;
  id: Scalars['ID']['output'];
  /** The note_json_content of this `PortfolioNote`. */
  noteJsonContent: Scalars['JSON']['output'];
  /** The `Portfolio` that this `PortfolioNote` belongs to */
  portfolio: Portfolio;
  /** The skills of this `PortfolioNote`. */
  skills: SkillConnection;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface PortfolioNoteGoalsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GoalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioNoteSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for PortfolioNote. */
export interface PortfolioNoteConnection {
  __typename: 'PortfolioNoteConnection';
  /** A list of edges. */
  edges: Array<PortfolioNoteEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioNote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioNoteEdge {
  __typename: 'PortfolioNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioNote>;
}

export interface PortfolioQualityCriterion extends Node, Timestamped {
  __typename: 'PortfolioQualityCriterion';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `PortfolioQualityCriterion`. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The title of this `PortfolioQualityCriterion`. */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The weight of this `PortfolioQualityCriterion`. */
  weight: PortfolioQualityCriterionWeightEnum;
}

/** The connection type for PortfolioQualityCriterion. */
export interface PortfolioQualityCriterionConnection {
  __typename: 'PortfolioQualityCriterionConnection';
  /** A list of edges. */
  edges: Array<PortfolioQualityCriterionEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioQualityCriterion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioQualityCriterionEdge {
  __typename: 'PortfolioQualityCriterionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioQualityCriterion>;
}

export enum PortfolioQualityCriterionWeightEnum {
  /** Above expected level */
  ABOVE = 'ABOVE',
  /** Below expected level */
  BELOW = 'BELOW',
  /** At expected level */
  NEUTRAL = 'NEUTRAL',
}

export interface PortfolioRole extends Node, Timestamped {
  __typename: 'PortfolioRole';
  /** Boolean to indicate if the `PortfolioRole` is active */
  active: Scalars['Boolean']['output'];
  /** Active `RoleFormat` that this `PortfolioRole` belongs to */
  activeRoleFormat: Maybe<RoleFormat>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A collection of Booleans to define the edit rights */
  editRights: Maybe<EditRights>;
  /** The excluding_end_date to indicate until when the `PortfolioRole` is active. */
  excludingEndDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The including_start_date to indicate from when the `PortfolioRole` is active. */
  includingStartDate: Maybe<Scalars['Date']['output']>;
  /** Main `RoleFormat` that this `PortfolioRole` belongs to */
  mainRoleFormat: Maybe<RoleFormat>;
  /** name of the `PortfolioRole` */
  name: Maybe<Scalars['String']['output']>;
  /** `Portfolio` that this `PortfolioRole` belongs to */
  portfolio: Maybe<Portfolio>;
  /** `ProgramRole` that this `PortfolioRole` belongs to */
  programRole: Maybe<ProgramRole>;
  /** read_access_level of the `PortfolioRole` */
  readAccessLevel: ReadAccessLevelEnum;
  /** read_access_level of the `PortfolioRole` is customized */
  readAccessLevelCustomized: Scalars['Boolean']['output'];
  /** role_type of the `PortfolioRole` */
  roleType: Maybe<RoleTypeEnum>;
  /** short_name of the `PortfolioRole` */
  shortName: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that this `PortfolioRole` belongs to */
  user: Maybe<User>;
}

/** The connection type for PortfolioRole. */
export interface PortfolioRoleConnection {
  __typename: 'PortfolioRoleConnection';
  /** A list of edges. */
  edges: Array<PortfolioRoleEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioRoleEdge {
  __typename: 'PortfolioRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioRole>;
}

/** Filter `PortfolioRoles`. */
export interface PortfolioRoleFilter {
  /** Only show the (in)active `PortfolioRole`s. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `PortfolioRole`s of which the *active* `RoleFormat` can (not) assess. */
  canAssess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `PortfolioRole`s of which the *active* `RoleFormat` can (not) authorize. */
  canAuthorize?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show the `PortfolioRole`s with the given `Program`s. It returns
   * `PortfolioRoles` that are not linked to a `ProgramRole` if an empty array is given.
   */
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `PortfolioRole`s of which the *active* `RoleFormat` has one of the role types. */
  roleTypes?: InputMaybe<Array<RoleTypeEnum>>;
  /** Only show the `PortfolioRole`s of which the *active* `RoleFormat` has one of the short names. */
  shortNames?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface PortfolioRoleSync extends Node, Timestamped {
  __typename: 'PortfolioRoleSync';
  /** Boolean to indicate if the `PortfolioRoleSync` is active */
  active: Scalars['Boolean']['output'];
  /** Count of the active `PortfolioRoles` linked to this `PortfolioRoleSync` */
  activePortfolioRolesCount: Scalars['Int']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** `Portfolio` that this `PortfolioRoleSync` belongs to */
  portfolio: Maybe<Portfolio>;
  /** `PortfolioRole`s that are linked to this `PortfolioRoleSync` */
  portfolioRoles: PortfolioRoleConnection;
  /** `Program` that this `PortfolioRoleSync` belongs to */
  program: Maybe<Program>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface PortfolioRoleSyncPortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for PortfolioRoleSync. */
export interface PortfolioRoleSyncConnection {
  __typename: 'PortfolioRoleSyncConnection';
  /** A list of edges. */
  edges: Array<PortfolioRoleSyncEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioRoleSync>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioRoleSyncEdge {
  __typename: 'PortfolioRoleSyncEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioRoleSync>;
}

export interface PortfolioSkillSubSkillStatistics {
  __typename: 'PortfolioSkillSubSkillStatistics';
  assessmentsCount: Scalars['Int']['output'];
  avgScore: Maybe<Scalars['Float']['output']>;
  /** Retrieve the `CompetenceCertificate`'s Skill `SkillScore` for this `Portfolio` */
  competenceCertificateSkillScore: Maybe<SkillScore>;
  /** Retrieve the `CompetenceCertificate`'s SubSkill `SkillScore` for this `Portfolio` */
  competenceCertificateSubSkillScore: Maybe<SkillScore>;
  countsPerScore: Array<SkillLevelFormatCount>;
  id: Scalars['ID']['output'];
  mostRecentScore: Maybe<Scalars['Int']['output']>;
  portfolio: Portfolio;
  skill: Skill;
  subSkill: Skill;
}

/** The connection type for PortfolioSkillSubSkillStatistics. */
export interface PortfolioSkillSubSkillStatisticsConnection {
  __typename: 'PortfolioSkillSubSkillStatisticsConnection';
  /** A list of edges. */
  edges: Array<PortfolioSkillSubSkillStatisticsEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioSkillSubSkillStatistics>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioSkillSubSkillStatisticsEdge {
  __typename: 'PortfolioSkillSubSkillStatisticsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioSkillSubSkillStatistics>;
}

/** The connection type for Skill. */
export interface PortfolioSkillsConnection {
  __typename: 'PortfolioSkillsConnection';
  /** A list of edges. */
  edges: Array<PortfolioSkillsEdge>;
  /** A list of nodes. */
  nodes: Array<Skill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioSkillsEdge {
  __typename: 'PortfolioSkillsEdge';
  currentCompetenceCertificateLevel: Maybe<CompetenceCertificateLevel>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Skill>;
  /** Retrieve the `CompetenceCertificate`'s `SkillScore` for this `Portfolio` */
  skillScore: Maybe<SkillScore>;
}

export interface PortfolioStatistics {
  __typename: 'PortfolioStatistics';
  /** Assessment statistics of the portfolio */
  assessments: Maybe<Array<AssessmentsStatistics>>;
}

export enum PortfolioStatusEnum {
  /** `Portfolio` is active */
  ACTIVE = 'ACTIVE',
  /** `Portfolio` was archived */
  ARCHIVED = 'ARCHIVED',
  /** `Portfolio` was archived and marked as completed */
  COMPLETED = 'COMPLETED',
  /**
   * `Portfolio` was created, but not onboarded
   * @deprecated Use `ACTIVE` instead
   */
  CREATED = 'CREATED',
  /**
   * `Portfolio` is active and onboarded
   * @deprecated Use `ACTIVE` instead
   */
  ONBOARDED = 'ONBOARDED',
}

/** The connection type for Skill. */
export interface PortfolioSubSkillsConnection {
  __typename: 'PortfolioSubSkillsConnection';
  /** A list of edges. */
  edges: Array<PortfolioSubSkillsEdge>;
  /** A list of nodes. */
  nodes: Array<Skill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioSubSkillsEdge {
  __typename: 'PortfolioSubSkillsEdge';
  currentCompetenceCertificateLevel: Maybe<CompetenceCertificateLevel>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Skill>;
  /**
   * Always returns an empty array
   * @deprecated Sub-skill auto-scoring has been removed
   */
  portfolioCurrentSubSkillCompetenceCertificateScores: Maybe<CompetenceCertificateSubSkillScoreConnection>;
  /** The amount of assessments for this sub `Skill` in the context a `Portfolio`. */
  portfolioSkillAssessmentCount: Scalars['Int']['output'];
  /** The average assessment score for this sub `Skill` in the context a `Portfolio`. */
  portfolioSkillAverageAssessmentScore: Maybe<Scalars['Float']['output']>;
  /**
   * Always returns null
   * @deprecated Sub-skill auto-scoring has been removed
   */
  portfolioSubSkillLevel: Maybe<CompetenceCertificateSubSkillScore>;
  /** Retrieve the `CompetenceCertificate`'s `SkillScore` for this `Portfolio` */
  skillScore: Maybe<SkillScore>;
}

/** An edge in a connection. */
export interface PortfolioSubSkillsEdgePortfolioCurrentSubSkillCompetenceCertificateScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PortfolioTransferRequest extends Node, PortfolioItem, Timestamped {
  __typename: 'PortfolioTransferRequest';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `Organization` that this `PortfolioTransfer` belongs to */
  organization: Maybe<Organization>;
  /** The owner approved at date of this `PortfolioTransfer`. */
  ownerApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The owner rejected at date of this `PortfolioTransfer`. */
  ownerRejectedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The portfolio_transfer_status of this `PortfolioTransfer`. */
  portfolioTransferStatus: PortfolioTransferStatusEnum;
  /** The previous_organization (`Organization`) that this `PortfolioTransfer` belongs to */
  previousOrganization: Maybe<Organization>;
  /** The rejection_reason of this `PortfolioTransfer`. */
  rejectionReason: Maybe<Scalars['String']['output']>;
  /** The request_reason of this `PortfolioTransfer`. */
  requestReason: Maybe<Scalars['String']['output']>;
  /** The requestor (`User`) that this `PortfolioTransfer` belongs to */
  requestor: Maybe<User>;
  /** `RoleFormat` that this `PortfolioTransfer` belongs_to */
  roleFormat: Maybe<RoleFormat>;
  /**
   * The status of this `PortfolioTransfer`.
   * @deprecated Use `portfolio_transfer_status` instead, remove this field after 2025-09-01
   */
  status: PortfolioTransferStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for PortfolioTransferRequest. */
export interface PortfolioTransferRequestConnection {
  __typename: 'PortfolioTransferRequestConnection';
  /** A list of edges. */
  edges: Array<PortfolioTransferRequestEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioTransferRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PortfolioTransferRequestEdge {
  __typename: 'PortfolioTransferRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PortfolioTransferRequest>;
}

export enum PortfolioTransferStatusEnum {
  /** Transfer request was approved by owner */
  APPROVED = 'APPROVED',
  /** Transfer request was created */
  CREATED = 'CREATED',
  /** Transfer request was rejected by owner */
  REJECTED = 'REJECTED',
}

export enum PreferredLanguageEnum {
  /** English */
  EN = 'EN',
  /** Dutch */
  NL = 'NL',
}

export interface Program extends Node, Timestamped {
  __typename: 'Program';
  /** The active_portfolios of this `Program`. */
  activePortfolios: PortfolioConnection;
  /** Boolean to check whether or not the PortfolioFormat is available */
  available: Scalars['Boolean']['output'];
  /**
   * Boolean to check if the `Program` is billable. So if there's an `InvoicePlan`
   * for this `PortfolioFormat` and the `Organization` or on of its
   * (grand)parents..
   */
  billable: Scalars['Boolean']['output'];
  /** Boolean to check if the `Program` is creatable. So if it available and billable or creatable without `InvoicePlan`. */
  creatable: Scalars['Boolean']['output'];
  /** Boolean to check whether or not a `Portfolio` of the `PortfolioFormat` is creatable_without_invoice_plan */
  creatableWithoutInvoicePlan: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * `InvoicePlan`s for this `Program`. So `InvoicePlan`s for this
   * `PortfolioFormat` and the `Organization` or on of its (grand)parents..
   */
  invoicePlans: Maybe<InvoicePlanConnection>;
  /** `Organization` that is linked to this `Program` */
  organization: Organization;
  /** `PortfolioFormat` that is linked to this `Program` */
  portfolioFormat: PortfolioFormat;
  /** `PortfolioRoleSync`s that belong to this `Program` */
  portfolioRoleSyncs: PortfolioRoleSyncConnection;
  /** `ProgramRole`s that belong to this `Program`. */
  programRoles: ProgramRoleConnection;
  /** The statistics of this `Program`. */
  statistics: Maybe<ProgramStatistics>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface ProgramActivePortfoliosArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProgramInvoicePlansArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProgramPortfolioRoleSyncsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProgramProgramRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Program. */
export interface ProgramConnection {
  __typename: 'ProgramConnection';
  /** A list of edges. */
  edges: Array<ProgramEdge>;
  /** A list of nodes. */
  nodes: Array<Program>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ProgramEdge {
  __typename: 'ProgramEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Program>;
}

export enum ProgramFilterEnum {
  /** `Program`s where available is true */
  AVAILABLE = 'AVAILABLE',
  /** `Program`that have an `InvoicePlan` for it's PortfolioFormat and for the `Organization` or on of its (grand)parents. */
  BILLABLE = 'BILLABLE',
  /** `Program`s that are available and are either billable or creatable_without_invoice_plan */
  CREATABLE = 'CREATABLE',
}

export interface ProgramRole extends Node, Timestamped {
  __typename: 'ProgramRole';
  /** automatically_create_portfolio_role of the `ProgramRole` */
  automaticallyCreatePortfolioRole: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** the destroy_status of the `ProgramRole` */
  destroyStatus: Maybe<DestroyStatusEnum>;
  /** A collection of Booleans to define the edit rights */
  editRights: Maybe<EditRights>;
  id: Scalars['ID']['output'];
  /** name of the `ProgramRole` */
  name: Maybe<Scalars['String']['output']>;
  /** `PortfolioRole`s that belong to this `ProgramRole` */
  portfolioRoles: PortfolioRoleConnection;
  /** The `Program` that this `ProgramRole` belongs to */
  program: Maybe<Program>;
  /** read_access_level of the `ProgramRole` */
  readAccessLevel: Maybe<ReadAccessLevelEnum>;
  /** The `RoleFormat` that this `ProgramRole` belongs to */
  roleFormat: Maybe<RoleFormat>;
  /** role_type of the `ProgramRole` */
  roleType: Maybe<RoleTypeEnum>;
  /** short_name of the `ProgramRole` */
  shortName: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `ProgramRole` belongs to */
  user: Maybe<User>;
}

export interface ProgramRolePortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for ProgramRole. */
export interface ProgramRoleConnection {
  __typename: 'ProgramRoleConnection';
  /** A list of edges. */
  edges: Array<ProgramRoleEdge>;
  /** A list of nodes. */
  nodes: Array<ProgramRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export enum ProgramRoleDestroyStatusEnum {
  /** The destroy_status of the `ProgramRole` is keep */
  KEEP = 'KEEP',
  /** The destroy_status of the `ProgramRole` is to_be_destroyed_with_archived_portfolio */
  TO_BE_DESTROYED_WITH_ARCHIVED_PORTFOLIO = 'TO_BE_DESTROYED_WITH_ARCHIVED_PORTFOLIO',
  /** The destroy_status of the `ProgramRole` is to_be_destroyed_with_completed_portfolio */
  TO_BE_DESTROYED_WITH_COMPLETED_PORTFOLIO = 'TO_BE_DESTROYED_WITH_COMPLETED_PORTFOLIO',
  /** The destroy_status of the `ProgramRole` is to_be_destroyed_with_keep_portfolio */
  TO_BE_DESTROYED_WITH_KEEP_PORTFOLIO = 'TO_BE_DESTROYED_WITH_KEEP_PORTFOLIO',
}

/** An edge in a connection. */
export interface ProgramRoleEdge {
  __typename: 'ProgramRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ProgramRole>;
}

/** Filter `ProgramRoles` */
export interface ProgramRoleFilter {
  /** Only show the `ProgramRole`s that can (not) assess. */
  canAssess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `ProgramRole`s that can (not) assign other supervisors. */
  canAssignOtherSupervisors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `ProgramRole`s that can (not) authorize. */
  canAuthorize?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show the `ProgramRole`s of which the `RoleFormat` can supervise
   * residencies. Only true will be used, false will ignore this filter.
   */
  isOrUpgradableToCanSuperviseResidencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `ProgramRole`s of which the `RoleFormat` has one of the short names. */
  isOrUpgradableToShortName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only show the `ProgramRole`s of which the `RoleFormat` has one of the role types */
  roleTypes?: InputMaybe<Array<RoleTypeEnum>>;
  /** Only show the `ProgramRole`s of which the `RoleFormat` has one of the short name. */
  shortNames?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface ProgramStatistics {
  __typename: 'ProgramStatistics';
  portfolioCounts: Maybe<Scalars['Int']['output']>;
  supervisors: Maybe<Array<ProgramSupervisorStatistics>>;
}

export interface ProgramStatisticsSupervisorsArgs {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}

export interface ProgramSupervisorStatistics {
  __typename: 'ProgramSupervisorStatistics';
  assessments: Maybe<Array<AssessmentsStatistics>>;
  supervisor: Maybe<User>;
}

/** Autogenerated input type of PromoteCccFormConfig */
export interface PromoteCccFormConfigInput {
  cccFormConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: CccFormConfigStatusEnum;
}

/** Autogenerated return type of PromoteCccFormConfig. */
export interface PromoteCccFormConfigPayload {
  __typename: 'PromoteCccFormConfigPayload';
  cccFormConfig: Maybe<CccFormConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of PromoteGeneralFeedbackFormConfig */
export interface PromoteGeneralFeedbackFormConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalFeedbackFormConfigId: Scalars['ID']['input'];
  status: GeneralFeedbackFormConfigStatusEnum;
}

/** Autogenerated return type of PromoteGeneralFeedbackFormConfig. */
export interface PromoteGeneralFeedbackFormConfigPayload {
  __typename: 'PromoteGeneralFeedbackFormConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generalFeedbackFormConfig: Maybe<GeneralFeedbackFormConfig>;
}

/** Autogenerated input type of PromotePortfolioDocumentConfig */
export interface PromotePortfolioDocumentConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  status: PortfolioDocumentConfigStatusEnum;
}

/** Autogenerated return type of PromotePortfolioDocumentConfig. */
export interface PromotePortfolioDocumentConfigPayload {
  __typename: 'PromotePortfolioDocumentConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
}

export interface QualityInstrument extends Node, Timestamped {
  __typename: 'QualityInstrument';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboard (`WorkspaceDashboard::Dashboard`) that this `WorkspaceDashboard::QualityInstrument` belongs to */
  dashboard: Dashboard;
  /** The description_json_content of this `WorkspaceDashboard::QualityInstrument`. */
  descriptionJsonContent: Maybe<Scalars['JSONContent']['output']>;
  /** The description_template_json_content of this `WorkspaceDashboard::QualityInstrument`. */
  descriptionTemplateJsonContent: Maybe<Scalars['JSONContent']['output']>;
  id: Scalars['ID']['output'];
  /** The order of this `WorkspaceDashboard::QualityInstrument`. */
  order: Scalars['Int']['output'];
  /** The title of this `WorkspaceDashboard::QualityInstrument`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for QualityInstrument. */
export interface QualityInstrumentConnection {
  __typename: 'QualityInstrumentConnection';
  /** A list of edges. */
  edges: Array<QualityInstrumentEdge>;
  /** A list of nodes. */
  nodes: Array<QualityInstrument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface QualityInstrumentEdge {
  __typename: 'QualityInstrumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<QualityInstrument>;
}

/** The root query object */
export interface Query {
  __typename: 'Query';
  cardLogs: Maybe<CardLogConnection>;
  cardTasks: Maybe<CardTaskConnection>;
  contacts: Maybe<ContactConnection>;
  /** Get `Course` by shortName */
  course: Maybe<Course>;
  /** List all (matching) `CourseEdition`s */
  courseEditions: Maybe<CourseEditionConnection>;
  /** List all (matching) `Course`s */
  courses: Maybe<CourseConnection>;
  /** `PortfolioFormatSpecialtyConfig`s of the specialties with a CPD calendar, sorted by specialty */
  cpdCalendarSpecialtyConfigs: Maybe<PortfolioFormatSpecialtyConfigConnection>;
  dashboardFormats: Maybe<DashboardFormatConnection>;
  dashboards: Maybe<DashboardConnection>;
  eventCards: Maybe<EventCardConnection>;
  /** List all `ExternalOauthApplication`s */
  externalOauthApplications: Maybe<ExternalOauthApplicationConnection>;
  /** List all `FeatureToggle`s. */
  featureToggles: FeatureToggleConnection;
  /** All categories as seen in `CourseAccreditation` and in `GaiaActivity`. */
  gaiaCategories: Maybe<GaiaCategoryConnection>;
  /** List all root `GeneratedReports`s. */
  generatedReports: GeneratedReportConnection;
  goalCards: Maybe<GoalCardConnection>;
  /** Get `Invite` by token */
  inviteByToken: Maybe<Invite>;
  learningResourceGlobalCategories: Maybe<LearningResourceGlobalCategoryConnection>;
  ledgerAccounts: Maybe<LedgerAccountConnection>;
  /** Fetches an object given its ID. */
  node: Maybe<
    | AdminGroup
    | AttachedFile
    | AudioTranscript
    | Badge
    | CardComment
    | CardLog
    | CardTask
    | CccFormConfig
    | CccFormConfigSelectionFinalReportResult
    | CccFormConfigSelectionResult
    | ClinicalCompetenceCommittee
    | ClinicalCompetenceCommitteeRespondent
    | Code
    | CompetenceCertificate
    | CompetenceCertificateBatch
    | CompetenceCertificateSubSkillScore
    | Contact
    | Course
    | CourseEdition
    | CourseEducator
    | CourseResult
    | Dashboard
    | DashboardFormat
    | DashboardRole
    | Download
    | Draft
    | EventCard
    | ExternalAccess
    | ExternalOauthApplication
    | FeatureToggle
    | FeedbackRequest
    | FeedbackRound
    | GaiaActivity
    | GaiaCategory
    | GaiaFileSync
    | GaiaTarget
    | GeneralFeedback
    | GeneralFeedbackFormConfig
    | GeneratedReport
    | Goal
    | GoalActivity
    | GoalCard
    | GoalCardSummary
    | Guideline
    | GuidelineAttachment
    | ImportantNotice
    | Interview
    | Invite
    | Invoice
    | InvoicePlan
    | Kpb
    | KpbSubSkillScore
    | LearningResourceAlertedSetItemForUser
    | LearningResourceArticle
    | LearningResourceFile
    | LearningResourceGlobalCategory
    | LearningResourceLink
    | LearningResourceMicroLearning
    | LearningResourceMicroLearningStep
    | LearningResourceMicroLearningUserProgress
    | LearningResourceSet
    | LedgerAccount
    | Memo
    | MultiSource
    | Note
    | Notification
    | Oidc
    | OnboardingStep
    | Organization
    | OrganizationUserRole
    | ParentDomain
    | ParticipationLevelFormat
    | PendingAction
    | Period
    | PeriodFormat
    | PeriodRequiredSkillLevel
    | Portfolio
    | PortfolioAssessment
    | PortfolioDocumentConfig
    | PortfolioEvent
    | PortfolioFormat
    | PortfolioFormatSpecialtyConfig
    | PortfolioFormatTerminology
    | PortfolioImport
    | PortfolioNote
    | PortfolioQualityCriterion
    | PortfolioRole
    | PortfolioRoleSync
    | PortfolioTransferRequest
    | Program
    | ProgramRole
    | QualityInstrument
    | Registration
    | Residency
    | ResidencyArchetype
    | RoleFormat
    | RootSkillCategoryConfig
    | SecondFactor
    | SecurityQuestion
    | Skill
    | SkillCategory
    | SkillLevelFormat
    | SkillLevelFormatDescription
    | SkillSubSkill
    | SkillSubSkillAutoScoreMapping
    | Streak
    | StreakWeek
    | SubDomain
    | SubMultiSource
    | SupportGroup
    | UsageStatistic
    | User
    | Workspace
    | WorkspaceRole
  >;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<
    Maybe<
      | AdminGroup
      | AttachedFile
      | AudioTranscript
      | Badge
      | CardComment
      | CardLog
      | CardTask
      | CccFormConfig
      | CccFormConfigSelectionFinalReportResult
      | CccFormConfigSelectionResult
      | ClinicalCompetenceCommittee
      | ClinicalCompetenceCommitteeRespondent
      | Code
      | CompetenceCertificate
      | CompetenceCertificateBatch
      | CompetenceCertificateSubSkillScore
      | Contact
      | Course
      | CourseEdition
      | CourseEducator
      | CourseResult
      | Dashboard
      | DashboardFormat
      | DashboardRole
      | Download
      | Draft
      | EventCard
      | ExternalAccess
      | ExternalOauthApplication
      | FeatureToggle
      | FeedbackRequest
      | FeedbackRound
      | GaiaActivity
      | GaiaCategory
      | GaiaFileSync
      | GaiaTarget
      | GeneralFeedback
      | GeneralFeedbackFormConfig
      | GeneratedReport
      | Goal
      | GoalActivity
      | GoalCard
      | GoalCardSummary
      | Guideline
      | GuidelineAttachment
      | ImportantNotice
      | Interview
      | Invite
      | Invoice
      | InvoicePlan
      | Kpb
      | KpbSubSkillScore
      | LearningResourceAlertedSetItemForUser
      | LearningResourceArticle
      | LearningResourceFile
      | LearningResourceGlobalCategory
      | LearningResourceLink
      | LearningResourceMicroLearning
      | LearningResourceMicroLearningStep
      | LearningResourceMicroLearningUserProgress
      | LearningResourceSet
      | LedgerAccount
      | Memo
      | MultiSource
      | Note
      | Notification
      | Oidc
      | OnboardingStep
      | Organization
      | OrganizationUserRole
      | ParentDomain
      | ParticipationLevelFormat
      | PendingAction
      | Period
      | PeriodFormat
      | PeriodRequiredSkillLevel
      | Portfolio
      | PortfolioAssessment
      | PortfolioDocumentConfig
      | PortfolioEvent
      | PortfolioFormat
      | PortfolioFormatSpecialtyConfig
      | PortfolioFormatTerminology
      | PortfolioImport
      | PortfolioNote
      | PortfolioQualityCriterion
      | PortfolioRole
      | PortfolioRoleSync
      | PortfolioTransferRequest
      | Program
      | ProgramRole
      | QualityInstrument
      | Registration
      | Residency
      | ResidencyArchetype
      | RoleFormat
      | RootSkillCategoryConfig
      | SecondFactor
      | SecurityQuestion
      | Skill
      | SkillCategory
      | SkillLevelFormat
      | SkillLevelFormatDescription
      | SkillSubSkill
      | SkillSubSkillAutoScoreMapping
      | Streak
      | StreakWeek
      | SubDomain
      | SubMultiSource
      | SupportGroup
      | UsageStatistic
      | User
      | Workspace
      | WorkspaceRole
    >
  >;
  /** Notifications for the viewer */
  notifications: NotificationConnection;
  /** Show the `Organization`s that are linked (through `Program`) to `PortfolioFormat` (by `shortName`). */
  organizationsWithPortfolioFormatShortName: OrganizationConnection;
  /** Pending Actions for the viewer */
  pendingActions: Maybe<PendingActionConnection>;
  /** Get `PortfolioFormat` by shortName */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** List all portfolio types */
  portfolioFormats: Maybe<PortfolioFormatConnection>;
  /** List visible `Portfolios` */
  portfolios: Maybe<PortfolioConnection>;
  /** List all root `Organizations`s. */
  rootOrganizations: OrganizationConnection;
  /** Search `Users` */
  searchUsers: UserSearchResponse;
  /** Search `Users` by name, big or email */
  searchUsersByText: Maybe<Array<User>>;
  /** Get sub-`MultiSource` by token */
  subMultiSourceByToken: Maybe<SubMultiSource>;
  /** List all support groups */
  supportGroups: Maybe<SupportGroupConnection>;
  /** Get `User` by email */
  userByEmail: Maybe<User>;
  /** Logged in `User` */
  viewer: Maybe<User>;
  workspaces: Maybe<WorkspaceConnection>;
}

/** The root query object */
export interface QueryCardLogsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventCardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalCardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryCardTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventCardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  goalCardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<CardTaskStatusEnum>>;
}

/** The root query object */
export interface QueryContactsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryCourseArgs {
  shortName: Scalars['String']['input'];
}

/** The root query object */
export interface QueryCourseEditionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  beginsAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  beginsBefore?: InputMaybe<Scalars['ISO8601Date']['input']>;
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  topicsReviewed?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The root query object */
export interface QueryCoursesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learningEnvironment?: InputMaybe<Array<CourseLearningEnvironmentTypeEnum>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

/** The root query object */
export interface QueryCpdCalendarSpecialtyConfigsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
}

/** The root query object */
export interface QueryDashboardFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryDashboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryEventCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<EventCardStatusEnum>>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** The root query object */
export interface QueryExternalOauthApplicationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryFeatureTogglesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The root query object */
export interface QueryGaiaCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gaiaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

/** The root query object */
export interface QueryGeneratedReportsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryGoalCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  parentDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  severity?: InputMaybe<Array<GoalCardSeverityEnum>>;
  status?: InputMaybe<Array<GoalCardStatusEnum>>;
  subDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** The root query object */
export interface QueryInviteByTokenArgs {
  token: Scalars['String']['input'];
}

/** The root query object */
export interface QueryLearningResourceGlobalCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<ApplicationEnum>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<LanguageEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryLedgerAccountsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryNodeArgs {
  id: Scalars['ID']['input'];
}

/** The root query object */
export interface QueryNodesArgs {
  ids: Array<Scalars['ID']['input']>;
}

/** The root query object */
export interface QueryNotificationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<NotificationContentTypeEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Array<NotificationSourceEnum>>;
}

/** The root query object */
export interface QueryOrganizationsWithPortfolioFormatShortNameArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billableForPortfolioFormat: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioFormatShortName: Scalars['String']['input'];
}

/** The root query object */
export interface QueryPendingActionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryPortfolioFormatArgs {
  shortName: Scalars['String']['input'];
}

/** The root query object */
export interface QueryPortfolioFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryPortfoliosArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PortfolioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryRootOrganizationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QuerySearchUsersArgs {
  filter: UserSearchFilter;
}

/** The root query object */
export interface QuerySearchUsersByTextArgs {
  text: Scalars['String']['input'];
}

/** The root query object */
export interface QuerySubMultiSourceByTokenArgs {
  token: Scalars['String']['input'];
}

/** The root query object */
export interface QuerySupportGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The root query object */
export interface QueryUserByEmailArgs {
  email: Scalars['String']['input'];
}

/** The root query object */
export interface QueryWorkspacesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export enum ReadAccessLevelEnum {
  /** Read acces level limited to overview */
  OVERVIEW = 'OVERVIEW',
  /** Read acces level limited to own contributions */
  OWN_CONTRIBUTIONS = 'OWN_CONTRIBUTIONS',
  /** Read acces level limited to practical information */
  PRACTICAL_INFORMATION = 'PRACTICAL_INFORMATION',
  /** Read acces level all */
  READ_ALL = 'READ_ALL',
}

export interface Registration extends Accessible, Activities, Creatable, Form, Node, PortfolioItem, Timestamped {
  __typename: 'Registration';
  /** The attached_files of this `Registration`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** Details if this objects is accessible to the current user */
  canAccess: Scalars['Boolean']['output'];
  /** The comments of this `Registration`. */
  comments: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** Date this activity was performed */
  date: Maybe<Scalars['Date']['output']>;
  /** Type of this form */
  formType: Maybe<Scalars['String']['output']>;
  /** Version of this form */
  formVersion: Maybe<Scalars['String']['output']>;
  /** `GoalActivities` attached to this object */
  goalActivities: Array<GoalActivity>;
  id: Scalars['ID']['output'];
  /** Metadata from the import process */
  importMetaData: Scalars['JSON']['output'];
  /** Frozen snapshot of the participation level at the time of the last save */
  participationLevelData: Maybe<Scalars['JSON']['output']>;
  /** The `ParticipationLevelFormat` that this `Registration` belongs to */
  participationLevelFormat: Maybe<ParticipationLevelFormat>;
  /** Additional information about the sub parts of this activity */
  parts: Maybe<Scalars['JSON']['output']>;
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** The `PortfolioDocumentConfig` that this `Registration` belongs to */
  portfolioDocumentConfig: PortfolioDocumentConfig;
  /** Quantity */
  quantity: Maybe<Scalars['Float']['output']>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** Supervision level of the activity */
  supervisionLevel: Maybe<Scalars['Int']['output']>;
  /** The supervisor (`User`) that this `Registration` belongs to */
  supervisor: Maybe<User>;
  /** Whether `Registration` is supervisor can access. */
  supervisorCanAccess: Scalars['Boolean']['output'];
  /** Whether `Registration` is supervisor can update. */
  supervisorCanUpdate: Scalars['Boolean']['output'];
  /** Title for this `Registration` */
  title: Maybe<Scalars['String']['output']>;
  /** General comments */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface RegistrationSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RegistrationAttributes {
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  participationLevelFormatId?: InputMaybe<Scalars['ID']['input']>;
  parts?: InputMaybe<Scalars['JSON']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  supervisionLevel?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** The connection type for Registration. */
export interface RegistrationConnection {
  __typename: 'RegistrationConnection';
  /** A list of edges. */
  edges: Array<RegistrationEdge>;
  /** A list of nodes. */
  nodes: Array<Registration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** @deprecated never used */
  sumQuantityGroupedByFormType: Maybe<Scalars['JSON']['output']>;
  /** The sum of quantity (filtered). */
  sumTotalQuantity: Maybe<Scalars['Float']['output']>;
  /** The total filtered amount of items in this connection. */
  totalCount: Maybe<Scalars['Int']['output']>;
}

export interface RegistrationCount {
  __typename: 'RegistrationCount';
  /**
   * Total number of registrations for the `Operation`
   * @deprecated Use `sumTotalQuantity` instead. This field will be corrected to the actual count of registration objects after 2026-03-09.
   */
  count: Maybe<Scalars['Int']['output']>;
  /** Registration counts per supervision level, per `Operation` part */
  parts: Maybe<Scalars['JSON']['output']>;
  /** Total quantity of all registrations for the `Operation` */
  sumTotalQuantity: Maybe<Scalars['Float']['output']>;
  /** Registration counts per supervision level */
  supervisionLevels: Maybe<Scalars['JSON']['output']>;
}

/** An edge in a connection. */
export interface RegistrationEdge {
  __typename: 'RegistrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Registration>;
}

export interface RegistrationFilter {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  formTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  participationLevelFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  supervisionLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
}

/** Autogenerated input type of RemoveCccFormConfigSelection */
export interface RemoveCccFormConfigSelectionInput {
  cccFormConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveCccFormConfigSelection. */
export interface RemoveCccFormConfigSelectionPayload {
  __typename: 'RemoveCccFormConfigSelectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of RemoveCourseEditionsFromUser */
export interface RemoveCourseEditionsFromUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `CourseEdition`s to remove from the `User` */
  courseEditionIds: Array<Scalars['ID']['input']>;
  /** ID of the `User` to remove the `CourseEdition`s from */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveCourseEditionsFromUser. */
export interface RemoveCourseEditionsFromUserPayload {
  __typename: 'RemoveCourseEditionsFromUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of RemoveCoursesFromUser */
export interface RemoveCoursesFromUserInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Course`s to remove from the `User` */
  courseIds: Array<Scalars['ID']['input']>;
  /** ID of the `User` to remove the `Course`s from */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveCoursesFromUser. */
export interface RemoveCoursesFromUserPayload {
  __typename: 'RemoveCoursesFromUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of RemoveLearningResourceItemFromSet */
export interface RemoveLearningResourceItemFromSetInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  learningResourceItemId: Scalars['ID']['input'];
  learningResourceSetId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveLearningResourceItemFromSet. */
export interface RemoveLearningResourceItemFromSetPayload {
  __typename: 'RemoveLearningResourceItemFromSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated input type of RemoveSkillsFromPortfolio */
export interface RemoveSkillsFromPortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` to remove skills from. */
  portfolioId: Scalars['ID']['input'];
  skillIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of RemoveSkillsFromPortfolio. */
export interface RemoveSkillsFromPortfolioPayload {
  __typename: 'RemoveSkillsFromPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of RemoveSubSkillFromSkill */
export interface RemoveSubSkillFromSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  skillId: Scalars['ID']['input'];
  subSkillId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveSubSkillFromSkill. */
export interface RemoveSubSkillFromSkillPayload {
  __typename: 'RemoveSubSkillFromSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of RemoveUserFromSupportGroup */
export interface RemoveUserFromSupportGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SupportGroup` */
  supportGroupId: Scalars['ID']['input'];
  /** ID of the `User` */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveUserFromSupportGroup. */
export interface RemoveUserFromSupportGroupPayload {
  __typename: 'RemoveUserFromSupportGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  supportGroup: Maybe<SupportGroup>;
}

/** Autogenerated input type of RemoveWorkspaceFromSecondaryDashboard */
export interface RemoveWorkspaceFromSecondaryDashboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dashboardId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of RemoveWorkspaceFromSecondaryDashboard. */
export interface RemoveWorkspaceFromSecondaryDashboardPayload {
  __typename: 'RemoveWorkspaceFromSecondaryDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboard: Maybe<Dashboard>;
  errors: Array<Error>;
}

/** Autogenerated input type of RequestGeneratedReport */
export interface RequestGeneratedReportInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
  reportType: GeneratedReportTypeEnum;
}

/** Autogenerated return type of RequestGeneratedReport. */
export interface RequestGeneratedReportPayload {
  __typename: 'RequestGeneratedReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generatedReport: Maybe<GeneratedReport>;
}

/** Autogenerated input type of RequestPasswordReset */
export interface RequestPasswordResetInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the `User` for whom the password needs to be reset. */
  email: Scalars['String']['input'];
  /** The source to bind the reset token to. Options are: 'portfolio' or 'workspace_dashboard'. */
  source?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of RequestPasswordReset. */
export interface RequestPasswordResetPayload {
  __typename: 'RequestPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The email address of the `User` for whom the password needs to be reset. */
  email: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of RequestPortfolioExport */
export interface RequestPortfolioExportInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Portfolio` */
  portfolioId: Scalars['ID']['input'];
  /** Optional ID of the `skill` to filter on */
  skillToFilterOnId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of RequestPortfolioExport. */
export interface RequestPortfolioExportPayload {
  __typename: 'RequestPortfolioExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Portfolio` which will be exported */
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of ResetPassword */
export interface ResetPasswordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** Confirmation of the new password */
  passwordConfirmation: Scalars['String']['input'];
  /** Password reset token */
  token: Scalars['String']['input'];
}

/** Autogenerated return type of ResetPassword. */
export interface ResetPasswordPayload {
  __typename: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Email address of the `User` whose password was changed */
  email: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The reset token's source */
  source: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of ResetSecondFactor */
export interface ResetSecondFactorInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current password of the viewer */
  currentPassword: Scalars['String']['input'];
}

/** Autogenerated return type of ResetSecondFactor. */
export interface ResetSecondFactorPayload {
  __typename: 'ResetSecondFactorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  otpSecret: Maybe<Scalars['String']['output']>;
}

export interface Residency extends Creatable, Node, PortfolioItem, Timestamped {
  __typename: 'Residency';
  /** True if the residency is advanced */
  advanced: Scalars['Boolean']['output'];
  /** `Users` that will be advanced supervisors to this `Residency` */
  advancedSupervisors: Array<User>;
  /** Number of 30-day months the portfolio owner has currently effectively worked on this `Residency` */
  completedDuration: Maybe<Scalars['Float']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `User` that created this object */
  creator: Maybe<User>;
  /** Number of 30-day months this residency lasts */
  duration: Maybe<Scalars['Float']['output']>;
  /** Number of 30-day months the portfolio owner effectively works on this `Residency` */
  effectiveDuration: Maybe<Scalars['Float']['output']>;
  /** Date the `Residency` ended or will end */
  endOn: Maybe<Scalars['Date']['output']>;
  /** `Goals` that will be focussed on in this `Residency` */
  goals: Array<Goal>;
  id: Scalars['ID']['output'];
  /** True if the residency is an intermission */
  intermission: Scalars['Boolean']['output'];
  /** The `Organization` at which this `Residency` will take place */
  organization: Maybe<Organization>;
  /** Percentage of time the portfolio owner will actually work on this `Residency` */
  percentage: Scalars['Int']['output'];
  /** `Portfolio` this object belongs to */
  portfolio: Maybe<Portfolio>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** Date the `Residency` started or will start */
  startOn: Maybe<Scalars['Date']['output']>;
  /** The `Users` that will supervise this `Residency` */
  supervisors: Array<User>;
  /** Title of the `Residency` */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface ResidencySkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface ResidencyArchetype extends Node, Timestamped {
  __typename: 'ResidencyArchetype';
  /** Specialized (advanced) or normal residency */
  advanced: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Estimated maximum of needed months to complete this type of residency */
  monthsMax: Maybe<Scalars['Int']['output']>;
  /** Estimated minimum of needed months to complete this type of residency */
  monthsMin: Maybe<Scalars['Int']['output']>;
  /** Specified order of archetype */
  order: Maybe<Scalars['Int']['output']>;
  /** `PortfolioFormat` this archetype belongs to */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** `Skill`s that belong to this object */
  skills: SkillConnection;
  /** Name of this archetype */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface ResidencyArchetypeSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Residency. */
export interface ResidencyConnection {
  __typename: 'ResidencyConnection';
  /** A list of edges. */
  edges: Array<ResidencyEdge>;
  /** A list of nodes. */
  nodes: Array<Residency>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ResidencyEdge {
  __typename: 'ResidencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Residency>;
}

export enum RespondentTypeEnum {
  /** `MultiSource` questionnaire for medical personnel */
  MEDICAL = 'MEDICAL',
  /** `MultiSource` questionnaire for other categories */
  OTHER = 'OTHER',
  /** this type is used to ask questions to the PortfolioOwner, and the answers are stored in the parent MultiSource (edited) */
  OWNER = 'OWNER',
  /** `MultiSource` questionnaire for paramedics */
  PARAMEDIC = 'PARAMEDIC',
  /** `MultiSource` questionnaire for patients */
  PATIENT = 'PATIENT',
}

export interface RoleFormat extends Node, Timestamped {
  __typename: 'RoleFormat';
  /** `PortfolioRole`s that belong to this `RoleFormat` as active_role_format */
  activePortfolioRoles: PortfolioRoleConnection;
  /** The automatically_create_portfolio_role of this `RoleFormat`. */
  automaticallyCreatePortfolioRole: Scalars['Boolean']['output'];
  /**
   * big of the `RoleFormat`
   * @deprecated Use `big_requirement` instead, remove this field after 2025-07-01
   */
  big: RoleFormatBigEnum;
  /** The big_requirement of this `RoleFormat`. */
  bigRequirement: RoleFormatBigEnum;
  /** The can_create_own_portfolio of this `RoleFormat`. */
  canCreateOwnPortfolio: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of this `RoleFormat`. */
  description: Maybe<Scalars['String']['output']>;
  /** A collection of Booleans to define the edit rights */
  editRights: Maybe<EditRights>;
  /** The expected_to_have_portfolio of this `RoleFormat`. */
  expectedToHavePortfolio: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** `PortfolioRole`s that belong to this `RoleFormat` as main_role_format */
  mainPortfolioRoles: PortfolioRoleConnection;
  /** `RoleFormat`s that can upgraded by this `RoleFormat` */
  mainRoleFormats: RoleFormatConnection;
  /** The name of this `RoleFormat`. */
  name: Scalars['String']['output'];
  /** The order of this `RoleFormat`. */
  order: Maybe<Scalars['Int']['output']>;
  /** `PortfolioFormat` that this `RoleFormat` belongs to */
  portfolioFormat: Maybe<PortfolioFormat>;
  /** `ProgramRole`s that belong to this `RoleFormat` */
  programRoles: ProgramRoleConnection;
  /** read_access_level of the `RoleFormat` */
  readAccessLevel: ReadAccessLevelEnum;
  /** The require_in_onboarding of this `RoleFormat`. */
  requireInOnboarding: Scalars['Boolean']['output'];
  /** role_type of the `RoleFormat` */
  roleType: RoleTypeEnum;
  /** The selectable_as_main of this `RoleFormat`. */
  selectableAsMain: Scalars['Boolean']['output'];
  /** The short_name of this `RoleFormat`. */
  shortName: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** `RoleFormat`s that can be an upgrade for this `RoleFormat` */
  upgradeRoleFormats: RoleFormatConnection;
}

export interface RoleFormatActivePortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RoleFormatMainPortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RoleFormatMainRoleFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RoleFormatProgramRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RoleFormatUpgradeRoleFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export enum RoleFormatBigEnum {
  /** AIOS */
  MANDATORY = 'MANDATORY',
  /** Medical specialist */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  /** dfs */
  OPTIONAL = 'OPTIONAL',
}

/** The connection type for RoleFormat. */
export interface RoleFormatConnection {
  __typename: 'RoleFormatConnection';
  /** A list of edges. */
  edges: Array<RoleFormatEdge>;
  /** A list of nodes. */
  nodes: Array<RoleFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface RoleFormatEdge {
  __typename: 'RoleFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<RoleFormat>;
}

/** Filter RoleFormats */
export interface RoleFormatFilter {
  /** Only show the `RoleFormat`s that are either selectable_as_main (true) or not (false) */
  selectableAsMain?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum RoleTypeEnum {
  /** Principal */
  PRINCIPAL = 'PRINCIPAL',
  /** Student */
  STUDENT = 'STUDENT',
  /** User with support or administration role */
  SUPPORT = 'SUPPORT',
  /** Teacher */
  TEACHER = 'TEACHER',
}

export interface RootSkillCategoryConfig extends Node, Timestamped {
  __typename: 'RootSkillCategoryConfig';
  /** The compose_in_onboarding of this `RootSkillCategoryConfig`. */
  composeInOnboarding: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Level display of the `RootSkillCategoryConfig` */
  levelDisplay: LevelDisplayEnum;
  /** ParticipationLevelFormats of the `RootSkillCategoryConfig` */
  participationLevelFormats: ParticipationLevelFormatConnection;
  /** The set_levels_in_onboarding of this `RootSkillCategoryConfig`. */
  setLevelsInOnboarding: Scalars['Boolean']['output'];
  /** The set_registrations_in_onboarding of this `RootSkillCategoryConfig`. */
  setRegistrationsInOnboarding: Scalars['Boolean']['output'];
  /** Whether the ratings for `Skill`'s within a `RootSkillCategoryConfig` should be shown as average */
  showAverage: Scalars['Boolean']['output'];
  /** RootSkillCategoryConfig of the `SkillLevelFormat` */
  skillCategory: Maybe<SkillCategory>;
  /** RootSkillCategoryConfig of the `SkillLevelFormat` */
  skillLevelFormats: SkillLevelFormatConnection;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Always returns false
   * @deprecated Sub-skill auto-scoring has been removed
   */
  useAutoScoring: Scalars['Boolean']['output'];
}

export interface RootSkillCategoryConfigParticipationLevelFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RootSkillCategoryConfigSkillLevelFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RotationRequiredSkillLevelFilter {
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `PeriodRequiredSkillLevel`s with `Skill`s with given skill_types */
  skillTypes?: InputMaybe<Array<SkillTypeEnum>>;
}

export interface ScoreAggregation {
  __typename: 'ScoreAggregation';
  /** Average */
  avg: Maybe<Scalars['Float']['output']>;
  /** Maximum */
  max: Maybe<Scalars['Float']['output']>;
  /** Minimum */
  min: Maybe<Scalars['Float']['output']>;
}

export enum SearchStatusEnum {
  /** Search failed */
  FAILED = 'FAILED',
  /** Could not perform search because of incomplete parameters */
  INCOMPLETE = 'INCOMPLETE',
  /** Search query performed successfully */
  OK = 'OK',
}

/** Current second factor authentication configuration for a user. */
export interface SecondFactor extends Node, Timestamped {
  __typename: 'SecondFactor';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether OTP is currently configured as a `SecondFactor` */
  otp: Scalars['Boolean']['output'];
  /** Security key generated for this `SecondFactor` */
  securityKey: Maybe<Scalars['String']['output']>;
  /** All `SecurityQuestions` of the `SecondFactor` */
  securityQuestions: Array<SecurityQuestion>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface SecurityQuestion extends Node, Timestamped {
  __typename: 'SecurityQuestion';
  /** Answer of this `SecurityQuestion` */
  answer: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Question of this `SecurityQuestion` */
  question: Maybe<Scalars['String']['output']>;
  /** `SecondFactor` linked to this 'SecurityQuestion' */
  secondFactor: Maybe<SecondFactor>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of SendClinicalCompetenceCommitteeReminderMails */
export interface SendClinicalCompetenceCommitteeReminderMailsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
  /** Optional respondents to limit the reminder to */
  onlyClinicalCompetenceCommitteeRespondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of SendClinicalCompetenceCommitteeReminderMails. */
export interface SendClinicalCompetenceCommitteeReminderMailsPayload {
  __typename: 'SendClinicalCompetenceCommitteeReminderMailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  emailsSent: Maybe<Scalars['Int']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of SendFeedbackRequestMails */
export interface SendFeedbackRequestMailsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeedbackRound` for which to resend sub-survey emails */
  feedbackRoundId: Scalars['ID']['input'];
}

/** Autogenerated return type of SendFeedbackRequestMails. */
export interface SendFeedbackRequestMailsPayload {
  __typename: 'SendFeedbackRequestMailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of emails resent */
  emailsSent: Maybe<Scalars['Int']['output']>;
  errors: Array<Error>;
  /** The `FeedbackRound` for which emails were sent */
  feedbackRound: Maybe<FeedbackRound>;
}

/** Autogenerated input type of SendMailToReconcept */
export interface SendMailToReconceptInput {
  /** Body of the email. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Where to send the email to. Only info@reconcept.nl, support@reconcept.nl, and
   * support@kwaliteitsdashboard.app will accepted.
   */
  emailAddresses: Array<Scalars['String']['input']>;
  /** Subject of the email. */
  subject: Scalars['String']['input'];
}

/** Autogenerated return type of SendMailToReconcept. */
export interface SendMailToReconceptPayload {
  __typename: 'SendMailToReconceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** List of email_addresses that are valid and the email was sent to. */
  emailAddresses: Maybe<Array<Scalars['String']['output']>>;
  errors: Array<Error>;
}

/** Autogenerated input type of SendMultiSourceMails */
export interface SendMultiSourceMailsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `MultiSource` for which to resend sub-survey emails */
  multiSourceId: Scalars['ID']['input'];
}

/** Autogenerated return type of SendMultiSourceMails. */
export interface SendMultiSourceMailsPayload {
  __typename: 'SendMultiSourceMailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Number of emails resent */
  emailsSent: Maybe<Scalars['Int']['output']>;
  errors: Array<Error>;
  /** The `MultiSource` for which emails were sent */
  multiSource: Maybe<MultiSource>;
}

/** Autogenerated input type of SendSecondFactorResetRequest */
export interface SendSecondFactorResetRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the `User` that requests the `SecondFactor` reset */
  name: Scalars['String']['input'];
  /** Phone number of the `User` that requests the `SecondFactor` reset */
  phoneNumber: Scalars['String']['input'];
  /** ID of the `User` that requests the `SecondFactor` reset */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of SendSecondFactorResetRequest. */
export interface SendSecondFactorResetRequestPayload {
  __typename: 'SendSecondFactorResetRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Whether or not the emails are sent */
  emailsSent: Scalars['Boolean']['output'];
  errors: Array<Error>;
}

/** Autogenerated input type of SendWelcomeMail */
export interface SendWelcomeMailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the `User` for whom the password needs to be changed */
  email: Scalars['String']['input'];
  /** The source to bind the reset token to and select which email should be send */
  source?: InputMaybe<WelcomeMailSourceEnum>;
}

/** Autogenerated return type of SendWelcomeMail. */
export interface SendWelcomeMailPayload {
  __typename: 'SendWelcomeMailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Email address of the `User` if request is successful */
  email: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** The connection type for Item. */
export interface SetItemsConnection {
  __typename: 'SetItemsConnection';
  /** A list of edges. */
  edges: Array<SetItemsEdge>;
  /** A list of nodes. */
  nodes: Array<Item>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SetItemsEdge {
  __typename: 'SetItemsEdge';
  alertAfterDays: Maybe<Scalars['Int']['output']>;
  alertExpiresAfterDays: Maybe<Scalars['Int']['output']>;
  alertSendMail: Scalars['Boolean']['output'];
  alertedRoleTypes: Maybe<Array<RoleTypeEnum>>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Item>;
  order: Scalars['Int']['output'];
}

export interface Skill extends Node, Timestamped {
  __typename: 'Skill';
  /** Whether the `Skill` is archived or not. */
  archived: Scalars['Boolean']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Boolean to check if it is a custom `Skill` */
  custom: Scalars['Boolean']['output'];
  /** Description of the `Skill` */
  description: Maybe<Scalars['String']['output']>;
  /** Documentation (in HTML) of the `Skill` */
  documentationHtml: Maybe<Scalars['String']['output']>;
  /** Full name of the `Skill` */
  fullName: Scalars['String']['output'];
  /** Guideline ID of the `Skill` */
  guidelineId: Maybe<Scalars['String']['output']>;
  /** Whether `Skill` is has learning resource sets. */
  hasLearningResourceSets: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * The learning_content_categories of this `Skill`.
   * @deprecated Use `LearningMaterial` is replaced by `LearningResources`
   */
  learningContentCategories: LearningContentCategoryConnection;
  /**
   * The learning_content_links of this `Skill`.
   * @deprecated Use `learningContentLinks` on `LearningContentCategory`
   */
  learningContentLinks: LearningContentLinkConnection;
  /** The learning_resource_sets of this `Skill`. */
  learningResourceSets: LearningResourceSetConnection;
  /** Boolean to check if it is a mandatory `Skill` */
  mandatory: Scalars['Boolean']['output'];
  /** Name of the `Skill` */
  name: Scalars['String']['output'];
  /** Order of the `Skill` */
  order: Maybe<Scalars['Int']['output']>;
  /** Pars of the `Skill` */
  parts: Maybe<Scalars['JSON']['output']>;
  /** The period_required_skill_levels of this `Skill`. */
  periodRequiredSkillLevels: PeriodRequiredSkillLevelConnection;
  /** Portfolio of the `Skill` */
  portfolio: Maybe<Portfolio>;
  /** Portfolios of the `Skill` */
  portfolios: Maybe<PortfolioConnection>;
  /** The root_skill_category_config of this `Skill`. */
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
  /**
   * Always returns an empty array
   * @deprecated Use the `periodRequiredSkillLevels` field
   */
  rotationRequiredSkillLevels: PeriodRequiredSkillLevelConnection;
  /** Selectable SkillCategories of the `Skill` */
  selectableSkillCategories: SkillCategoryConnection;
  /** Short name of the `Skill` */
  shortName: Scalars['String']['output'];
  /** Skill categories of the `Skill` */
  skillCategories: SkillCategoryConnection;
  /** The skill_level_format_descriptions of this `Skill`. */
  skillLevelFormatDescriptions: SkillLevelFormatDescriptionConnection;
  /**
   * The skill_sub_skills of this `Skill`.
   * @deprecated Use `subSkills` instead, can be removed in april 2026 (if not used in the FE)
   */
  skillSubSkills: SkillSubSkillConnection;
  /** Skill type of the `Skill` */
  skillType: SkillTypeEnum;
  /** The sub_skills of this `Skill`. */
  subSkills: SubSkillConnection;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface SkillLearningContentCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillLearningContentLinksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillLearningResourceSetsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillPeriodRequiredSkillLevelsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillPortfoliosArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillRotationRequiredSkillLevelsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillSelectableSkillCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillSkillCategoriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillSkillLevelFormatDescriptionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillSkillSubSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillSubSkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillCategory extends Node, Timestamped {
  __typename: 'SkillCategory';
  /** Allows adding custom skills to this `SkillCategory` */
  allowCustomSkills: Scalars['Boolean']['output'];
  /** Sub-categories of the `SkillCategory` */
  children: SkillCategoryConnection;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the `SkillCategory` */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the `SkillCategory` */
  name: Maybe<Scalars['String']['output']>;
  /** Order of the `SkillCategory` */
  order: Scalars['Int']['output'];
  /** Parent of the `SkillCategory` */
  parent: Maybe<SkillCategory>;
  /** `PortfolioFormat of the `SkillCategory` */
  portfolioFormat: Maybe<PortfolioFormat>;
  /**
   * Config of the root `SkillCategory`.         It returns the config of the root
   * SkillCategory of the current         SkillCategory if the current
   * SkillCategory is a child SkillCategory.
   */
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
  /** Selectable skill of the `SkillCategory` */
  selectableSkill: Maybe<Skill>;
  /** Skill type of the `SkillCategory` */
  skillType: SkillTypeEnum;
  /** Skills of the `SkillCategory` */
  skills: SkillConnection;
  /** Sorted_by of the `Skills` of the `SkillCategory` */
  sortedBy: SkillCategorySortedByEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface SkillCategoryChildrenArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SkillCategorySkillsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SkillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for SkillCategory. */
export interface SkillCategoryConnection {
  __typename: 'SkillCategoryConnection';
  /** A list of edges. */
  edges: Array<SkillCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<SkillCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SkillCategoryEdge {
  __typename: 'SkillCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SkillCategory>;
}

/** Filter for `SkillCategory` */
export interface SkillCategoryFilter {
  /** Only show the `SkillCategory`s with given id`s */
  skillCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `SkillCategory`s with given skill_types */
  skillType?: InputMaybe<Array<SkillTypeEnum>>;
}

export enum SkillCategorySortedByEnum {
  /** The sorted_by is alphabetical */
  ALPHABETICAL = 'ALPHABETICAL',
  /** The sorted_by is numerical */
  NUMERICAL = 'NUMERICAL',
}

export interface SkillCompetenceCertificateStatistics {
  __typename: 'SkillCompetenceCertificateStatistics';
  percentagePortfolioAchievedRequiredLevel: Scalars['Float']['output'];
  periodFormat: PeriodFormat;
  periodRequiredSkillLevel: Maybe<PeriodRequiredSkillLevel>;
  portfolioCount: Scalars['Int']['output'];
  skill: Skill;
}

/** The connection type for Skill. */
export interface SkillConnection {
  __typename: 'SkillConnection';
  /** A list of edges. */
  edges: Array<SkillEdge>;
  /** A list of nodes. */
  nodes: Array<Skill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SkillEdge {
  __typename: 'SkillEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Skill>;
}

/** Filter for `Skill` */
export interface SkillFilter {
  /** Only show the `Skill`s with given custom boolean */
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only show the `Skill`s with given skill_types */
  skillType?: InputMaybe<Array<SkillTypeEnum>>;
  /** Only show the `Skill`s with given id`s */
  skills?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface SkillLevelFormat extends Node, Timestamped {
  __typename: 'SkillLevelFormat';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Shorthand symbol for the `SkillLevelFormat`, used for badges among others */
  displayValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Label display of the `SkillLevelFormat` */
  label: Scalars['String']['output'];
  /** Number of the `SkillLevelFormat` */
  number: Maybe<Scalars['Int']['output']>;
  /** RootSkillCategoryConfig of the `SkillLevelFormat` */
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
  /** The skill_level_format_descriptions of this `SkillLevelFormat`. */
  skillLevelFormatDescriptions: SkillLevelFormatDescriptionConnection;
  /** Status of the `SkillLevelFormat` */
  skillLevelFormatStatus: SkillLevelFormatStatusEnum;
  /**
   * Status of the `SkillLevelFormat`
   * @deprecated Use `skill_level_format_status` instead, remove this field after 2025-09-01
   */
  status: SkillLevelFormatStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface SkillLevelFormatSkillLevelFormatDescriptionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for SkillLevelFormat. */
export interface SkillLevelFormatConnection {
  __typename: 'SkillLevelFormatConnection';
  /** A list of edges. */
  edges: Array<SkillLevelFormatEdge>;
  /** A list of nodes. */
  nodes: Array<SkillLevelFormat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export interface SkillLevelFormatCount {
  __typename: 'SkillLevelFormatCount';
  scoreCount: Scalars['Int']['output'];
  skillLevelFormat: SkillLevelFormat;
}

export interface SkillLevelFormatDescription extends Node, Timestamped {
  __typename: 'SkillLevelFormatDescription';
  /** The content of this `SkillLevelFormatDescription`. */
  content: Scalars['String']['output'];
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `Skill` that this `SkillLevelFormatDescription` belongs to */
  skill: Maybe<Skill>;
  /** The `SkillLevelFormat` that this `SkillLevelFormatDescription` belongs to */
  skillLevelFormat: Maybe<SkillLevelFormat>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for SkillLevelFormatDescription. */
export interface SkillLevelFormatDescriptionConnection {
  __typename: 'SkillLevelFormatDescriptionConnection';
  /** A list of edges. */
  edges: Array<SkillLevelFormatDescriptionEdge>;
  /** A list of nodes. */
  nodes: Array<SkillLevelFormatDescription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SkillLevelFormatDescriptionEdge {
  __typename: 'SkillLevelFormatDescriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SkillLevelFormatDescription>;
}

/** An edge in a connection. */
export interface SkillLevelFormatEdge {
  __typename: 'SkillLevelFormatEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SkillLevelFormat>;
}

export enum SkillLevelFormatStatusEnum {
  /** The status of the SkillLevelFormat is done */
  DONE = 'DONE',
  /** The status of the SkillLevelFormat is open */
  OPEN = 'OPEN',
  /** The status of the SkillLevelFormat is progress */
  PROGRESS = 'PROGRESS',
}

export interface SkillScore {
  __typename: 'SkillScore';
  competenceCertificate: Maybe<CompetenceCertificate>;
  /** Total number of assessments for this `Skill` */
  count: Maybe<Scalars['Int']['output']>;
  firstCompetenceCertificateOfCurrentLevel: Maybe<CompetenceCertificate>;
  /** Current competence level for this `Skill` */
  level: Maybe<Scalars['Int']['output']>;
  /** Registration totals for this `Skill` */
  registrations: Maybe<RegistrationCount>;
  skill: Maybe<Skill>;
  supervisorApprovedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export interface SkillSubSkill extends Node, Timestamped {
  __typename: 'SkillSubSkill';
  /** The archived at date of this `SkillSubSkill`. */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The order of this `SkillSubSkill`. */
  order: Scalars['Int']['output'];
  /** The `Skill` that this `SkillSubSkill` belongs to */
  skill: Skill;
  /** The sub_skill (`Skill`) that this `SkillSubSkill` belongs to */
  subSkill: Skill;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export interface SkillSubSkillAutoScoreMapping extends Node, Timestamped {
  __typename: 'SkillSubSkillAutoScoreMapping';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Sub-skill auto-scoring has been removed */
  skill: Maybe<Skill>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  skillLevelFormat: Maybe<SkillLevelFormat>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  subSkill: Maybe<Skill>;
  /** @deprecated Sub-skill auto-scoring has been removed */
  subSkillLevelFormat: Maybe<SkillLevelFormat>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for SkillSubSkillAutoScoreMapping. */
export interface SkillSubSkillAutoScoreMappingConnection {
  __typename: 'SkillSubSkillAutoScoreMappingConnection';
  /** A list of edges. */
  edges: Array<SkillSubSkillAutoScoreMappingEdge>;
  /** A list of nodes. */
  nodes: Array<SkillSubSkillAutoScoreMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SkillSubSkillAutoScoreMappingEdge {
  __typename: 'SkillSubSkillAutoScoreMappingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SkillSubSkillAutoScoreMapping>;
}

/** The connection type for SkillSubSkill. */
export interface SkillSubSkillConnection {
  __typename: 'SkillSubSkillConnection';
  /** A list of edges. */
  edges: Array<SkillSubSkillEdge>;
  /** A list of nodes. */
  nodes: Array<SkillSubSkill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SkillSubSkillEdge {
  __typename: 'SkillSubSkillEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SkillSubSkill>;
}

export enum SkillTypeEnum {
  /** The skill_type is epa */
  EPA = 'EPA',
  /** The skill_type is general_skill */
  GENERAL_SKILL = 'GENERAL_SKILL',
  /** The skill_type is medical_theme */
  MEDICAL_THEME = 'MEDICAL_THEME',
  /** The skill_type is not applicable */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  /** The skill_type is operation */
  OPERATION = 'OPERATION',
  /** The skill_type is rockbone */
  ROCKBONE = 'ROCKBONE',
  /** The skill_type is situation */
  SITUATION = 'SITUATION',
  /** The skill_type is sub_competence */
  SUB_COMPETENCE = 'SUB_COMPETENCE',
  /**
   * The skill_type is system which is used for categories that need not be visible
   * in the frontend, for example to make extra categorizations for related skills
   */
  SYSTEM = 'SYSTEM',
}

export interface SkillsByTypeForSubSkillsFilterInput {
  subSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  superSkillSkillTypes?: InputMaybe<Array<SkillTypeEnum>>;
}

export interface Streak extends Node {
  __typename: 'Streak';
  /** The current_status of this `Streak`. */
  currentStatus: StreakWeekStatusEnum;
  /** The future_statuses of this `Streak`. */
  futureStatuses: Array<StreakWeekStatusEnum>;
  id: Scalars['ID']['output'];
  /** The length of this `Streak`. */
  length: Scalars['Int']['output'];
  /** The paused until date of this `Streak`. */
  pausedUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The previous_statuses of this `Streak`. */
  previousStatuses: Array<StreakWeekStatusEnum>;
}

/** Autogenerated return type of StreakChanged. */
export interface StreakChangedPayload {
  __typename: 'StreakChangedPayload';
  updatedStreak: Maybe<Streak>;
}

export interface StreakWeek extends Node, Timestamped {
  __typename: 'StreakWeek';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The streak_week_status of this `StreakWeek`. */
  streakWeekStatus: StreakWeekStatusEnum;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The week_date of this `StreakWeek`. */
  weekDate: Scalars['ISO8601Date']['output'];
}

export enum StreakWeekStatusEnum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Missed */
  MISSED = 'MISSED',
  /** None */
  NONE = 'NONE',
  /** Paused */
  PAUSED = 'PAUSED',
}

export interface SubCourseResultAggregation {
  __typename: 'SubCourseResultAggregation';
  /** Aggregation information about sub scores for course these results */
  score: Maybe<ScoreAggregation>;
  /** Short name of the `Course` subpart */
  shortName: Maybe<Scalars['String']['output']>;
}

export interface SubDomain extends BaseDomain, Node, Timestamped {
  __typename: 'SubDomain';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** The goal_cards of this `WorkspaceDashboard::SubDomain`. */
  goalCards: GoalCardConnection;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  /** The parent_domain (`WorkspaceDashboard::ParentDomain`) that this `WorkspaceDashboard::SubDomain` belongs to */
  parentDomain: ParentDomain;
  /** The secondary_workspaces of this `WorkspaceDashboard::SubDomain`. */
  secondaryWorkspaces: SubDomainToWorkspaceConnection;
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The workspaces of this `WorkspaceDashboard::SubDomain`. */
  workspaces: SubDomainToWorkspaceConnection;
}

export interface SubDomainGoalCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GoalCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SubDomainSecondaryWorkspacesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SubDomainWorkspacesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkspaceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for SubDomain. */
export interface SubDomainConnection {
  __typename: 'SubDomainConnection';
  /** A list of edges. */
  edges: Array<SubDomainEdge>;
  /** A list of nodes. */
  nodes: Array<SubDomain>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SubDomainEdge {
  __typename: 'SubDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SubDomain>;
}

/** The connection type for Workspace. */
export interface SubDomainToWorkspaceConnection {
  __typename: 'SubDomainToWorkspaceConnection';
  /** A list of edges. */
  edges: Array<SubDomainToWorkspaceConnectionEdge>;
  /** A list of nodes. */
  nodes: Array<Workspace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SubDomainToWorkspaceConnectionEdge {
  __typename: 'SubDomainToWorkspaceConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  goalCardSummaries: GoalCardSummaryConnection;
  /** The most severe severity of this `Workspace` and `SubDomain` */
  mostSevereSeverity: Maybe<MostSevereSeverityEnum>;
  /** The item at the end of the edge. */
  node: Maybe<Workspace>;
}

/** An edge in a connection. */
export interface SubDomainToWorkspaceConnectionEdgeGoalCardSummariesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SubMultiSource extends Node, Timestamped {
  __typename: 'SubMultiSource';
  /** The collaborator of this `SubMultiSource`. */
  collaborator: Maybe<Scalars['JSON']['output']>;
  /** The comments of this `SubMultiSource`. */
  comments: Maybe<Scalars['String']['output']>;
  /** The communicator of this `SubMultiSource`. */
  communicator: Maybe<Scalars['JSON']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date of this `SubMultiSource`. */
  date: Maybe<Scalars['Date']['output']>;
  /** The end_on of this `SubMultiSource`. */
  endOn: Maybe<Scalars['Date']['output']>;
  /** The health_advocate of this `SubMultiSource`. */
  healthAdvocate: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** The leader of this `SubMultiSource`. */
  leader: Maybe<Scalars['JSON']['output']>;
  /** The mail_comments of this `SubMultiSource`. */
  mailComments: Maybe<Scalars['String']['output']>;
  /** The medical_expert of this `SubMultiSource`. */
  medicalExpert: Maybe<Scalars['JSON']['output']>;
  /** The `Organization` of the resident. */
  organization: Maybe<Organization>;
  /** The points_of_concern of this `SubMultiSource`. */
  pointsOfConcern: Maybe<Scalars['String']['output']>;
  /** The `PortfolioDocumentConfig` of the parent `MultiSource` */
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
  /** Short name of the `PortfolioFormat` for this survey */
  portfolioFormatShortName: Maybe<Scalars['String']['output']>;
  /** The positive_points of this `SubMultiSource`. */
  positivePoints: Maybe<Scalars['String']['output']>;
  /** The professional of this `SubMultiSource`. */
  professional: Maybe<Scalars['JSON']['output']>;
  /** Full name of the resident */
  residentFullName: Maybe<Scalars['String']['output']>;
  /** The kind of respondent this survey is meant for */
  respondentType: RespondentTypeEnum;
  /** The scholar of this `SubMultiSource`. */
  scholar: Maybe<Scalars['JSON']['output']>;
  /** The start_on of this `SubMultiSource`. */
  startOn: Maybe<Scalars['Date']['output']>;
  /**
   * The status of this `SubMultiSource`.
   * @deprecated Use `sub_multi_source_status` instead, remove this field after 2025-09-01
   */
  status: MultiSourceStatusEnum;
  /** The sub_multi_source_status of this `SubMultiSource`. */
  subMultiSourceStatus: MultiSourceStatusEnum;
  /** Multipurpose field */
  topics: Maybe<Scalars['JSON']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for SubMultiSource. */
export interface SubMultiSourceConnection {
  __typename: 'SubMultiSourceConnection';
  /** A list of edges. */
  edges: Array<SubMultiSourceEdge>;
  /** A list of nodes. */
  nodes: Array<SubMultiSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SubMultiSourceEdge {
  __typename: 'SubMultiSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SubMultiSource>;
}

/** The connection type for Skill. */
export interface SubSkillConnection {
  __typename: 'SubSkillConnection';
  /** A list of edges. */
  edges: Array<SubSkillEdge>;
  /** A list of nodes. */
  nodes: Array<Skill>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SubSkillEdge {
  __typename: 'SubSkillEdge';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Skill>;
  order: Scalars['Int']['output'];
  /**
   * Always returns an empty array
   * @deprecated Sub-skill auto-scoring has been removed
   */
  skillSubSkillAutoScoreMappings: SkillSubSkillAutoScoreMappingConnection;
}

/** An edge in a connection. */
export interface SubSkillEdgeSkillSubSkillAutoScoreMappingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface SubSkillsByTypeForSkillsFilterInput {
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subSkillSkillTypes?: InputMaybe<Array<SkillTypeEnum>>;
}

/** Object that can be the subject of a `FeedbackRound` */
export interface SubjectOfFeedbackRound {
  /** `FeedbackRequest` for this subject belonging to the current user */
  feedbackRequest: Maybe<FeedbackRequest>;
  /** `FeedbackRound` for this subject belonging to the current user */
  feedbackRound: Maybe<FeedbackRound>;
}

/** The root subscription object */
export interface Subscription {
  __typename: 'Subscription';
  /** Events that indicate a badge (belonging to the viewer) has been updated */
  badgeChanged: BadgeChangedPayload;
  /** Events that indicate the streak (belonging to the viewer) has been updated */
  streakChanged: StreakChangedPayload;
}

export enum SupervisorTypeEnum {
  /** The supervisor_type of the `PortfolioDocumentConfig` is self */
  SELF = 'SELF',
  /** The supervisor_type of the `PortfolioDocumentConfig` is user_can_assess */
  USER_CAN_ASSESS = 'USER_CAN_ASSESS',
  /** The supervisor_type of the `PortfolioDocumentConfig` is user_can_authorize */
  USER_CAN_AUTHORIZE = 'USER_CAN_AUTHORIZE',
  /** The supervisor_type of the `PortfolioDocumentConfig` is user_is_principal_like */
  USER_IS_PRINCIPAL_LIKE = 'USER_IS_PRINCIPAL_LIKE',
  /** The supervisor_type of the `PortfolioDocumentConfig` is user_is_supervisor_like */
  USER_IS_SUPERVISOR_LIKE = 'USER_IS_SUPERVISOR_LIKE',
}

/** A support organization within the Reconcept Portfolio */
export interface SupportGroup extends Node, Timestamped {
  __typename: 'SupportGroup';
  /** URL for the avatar of this group */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `Courses` that this organization has created */
  createdCourses: Array<Course>;
  /** Short description for this organization */
  description: Maybe<Scalars['String']['output']>;
  /** Email address for users to contact this organization */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Name of this organization */
  name: Scalars['String']['output'];
  /** `PortfolioFormats` that this organization can support */
  portfolioFormats: Maybe<Array<PortfolioFormat>>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** `Users` that can act for this group */
  users: Array<User>;
}

/** The connection type for SupportGroup. */
export interface SupportGroupConnection {
  __typename: 'SupportGroupConnection';
  /** A list of edges. */
  edges: Array<SupportGroupEdge>;
  /** A list of nodes. */
  nodes: Array<SupportGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SupportGroupEdge {
  __typename: 'SupportGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupportGroup>;
}

export enum SurveyStatusEnum {
  /** This survey has been closed and cannot be updated */
  CLOSED = 'CLOSED',
  /** This survey has been filled */
  FILLED = 'FILLED',
  /** This survey can be updated */
  OPEN = 'OPEN',
}

/** Autogenerated input type of SynchronizeContacts */
export interface SynchronizeContactsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of SynchronizeContacts. */
export interface SynchronizeContactsPayload {
  __typename: 'SynchronizeContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  created: Maybe<Array<Contact>>;
  destroyed: Maybe<Array<Contact>>;
  errors: Array<Error>;
  updated: Maybe<Array<Contact>>;
}

/** Autogenerated input type of SynchronizeGaiaFile */
export interface SynchronizeGaiaFileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of SynchronizeGaiaFile. */
export interface SynchronizeGaiaFilePayload {
  __typename: 'SynchronizeGaiaFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  gaiaFileSync: Maybe<GaiaFileSync>;
}

/** Autogenerated input type of SynchronizeLedgerAccounts */
export interface SynchronizeLedgerAccountsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of SynchronizeLedgerAccounts. */
export interface SynchronizeLedgerAccountsPayload {
  __typename: 'SynchronizeLedgerAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  created: Maybe<Array<LedgerAccount>>;
  destroyed: Maybe<Array<LedgerAccount>>;
  errors: Array<Error>;
  updated: Maybe<Array<LedgerAccount>>;
}

export enum TargetRoleEnum {
  /** This `PortfolioFormat` is meant for AIOSes */
  AIOS = 'AIOS',
  /** This `PortfolioFormat` is meant for ANIOSes */
  ANIOS = 'ANIOS',
  /** This `PortfolioFormat` is meant for interns */
  INTERN = 'INTERN',
  /** This `PortfolioFormat` is meant for nurses */
  NURSE = 'NURSE',
  /** This `PortfolioFormat` is meant for specialists */
  SPECIALIST = 'SPECIALIST',
}

export enum ThumbsEnum {
  /** A negative response */
  NEGATIVE = 'NEGATIVE',
  /** A neutral response */
  NEUTRAL = 'NEUTRAL',
  /** The assessor has decided not to give an assessment */
  NOT_ASSESSED = 'NOT_ASSESSED',
  /** Nothing has been filled in yet */
  NOT_SET = 'NOT_SET',
  /** A positive response */
  POSITIVE = 'POSITIVE',
}

/** An object that stores the time it was created and updated */
export interface Timestamped {
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** Autogenerated input type of UnlockWithPin */
export interface UnlockWithPinInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Pin of `User` */
  pin: Scalars['String']['input'];
}

/** Autogenerated return type of UnlockWithPin. */
export interface UnlockWithPinPayload {
  __typename: 'UnlockWithPinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** Returns `true` if the account was unlocked successfully */
  success: Scalars['Boolean']['output'];
}

/** Autogenerated input type of UnsubscribeToLearningResourceAlertMails */
export interface UnsubscribeToLearningResourceAlertMailsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unsubscribe token from the email */
  token: Scalars['String']['input'];
}

/** Autogenerated return type of UnsubscribeToLearningResourceAlertMails. */
export interface UnsubscribeToLearningResourceAlertMailsPayload {
  __typename: 'UnsubscribeToLearningResourceAlertMailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateActiveOnAllPortfolioRolesForSync */
export interface UpdateActiveOnAllPortfolioRolesForSyncInput {
  /** Boolean to set active on the `PortfolioRole` to true or false */
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioRoleSync` */
  portfolioRoleSyncId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateActiveOnAllPortfolioRolesForSync. */
export interface UpdateActiveOnAllPortfolioRolesForSyncPayload {
  __typename: 'UpdateActiveOnAllPortfolioRolesForSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRoleSync: Maybe<PortfolioRoleSync>;
}

/** Autogenerated input type of UpdateAudioTranscript */
export interface UpdateAudioTranscriptInput {
  audioTranscriptId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId?: InputMaybe<Scalars['ID']['input']>;
  suggestions?: InputMaybe<Scalars['JSON']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateAudioTranscript. */
export interface UpdateAudioTranscriptPayload {
  __typename: 'UpdateAudioTranscriptPayload';
  audioTranscript: Maybe<AudioTranscript>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateBasicUserFields */
export interface UpdateBasicUserFieldsInput {
  acceptedPrivacyPolicyAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  badgesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  badgesSendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custom settings of the user */
  customSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** The first name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The insertion of the user */
  insertion?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user is onboarded */
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** The `DirectUpload` picture ID of the user */
  picture?: InputMaybe<Scalars['ID']['input']>;
  /** The PIN (personal identification number) of the user */
  pin?: InputMaybe<Scalars['String']['input']>;
  portfolioEmailFrequency?: InputMaybe<PortfolioEmailFrequencyEnum>;
  /** The preferred language of the user */
  preferredLanguage?: InputMaybe<PreferredLanguageEnum>;
  sendLearningResourceAlertMails?: InputMaybe<Scalars['Boolean']['input']>;
  sendManageRolesNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  streakEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  streakSendEndingReminders?: InputMaybe<Scalars['Boolean']['input']>;
  streakSendGeneralReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** The (academic) title of the user */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account of the user is trusted */
  trusted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user to update */
  userId: Scalars['ID']['input'];
  workspaceEmailFrequency?: InputMaybe<WorkspaceEmailFrequencyEnum>;
}

/** Autogenerated return type of UpdateBasicUserFields. */
export interface UpdateBasicUserFieldsPayload {
  __typename: 'UpdateBasicUserFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The updated user */
  user: Maybe<User>;
}

/** Autogenerated input type of UpdateCardComment */
export interface UpdateCardCommentInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the `CardComment` to update */
  cardCommentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Comment for this `CardComment`
   * @deprecated Use `commentJsonContent` instead.
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Rich-text content for this `CardComment` */
  commentJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** Status of this `CardComment` */
  status?: InputMaybe<CardCommentStatusEnum>;
}

/** Autogenerated return type of UpdateCardComment. */
export interface UpdateCardCommentPayload {
  __typename: 'UpdateCardCommentPayload';
  cardComment: Maybe<CardComment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCardTask */
export interface UpdateCardTaskInput {
  /** ID of the `CardTask` to update */
  cardTaskId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End date for this `CardTask` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Order number for this `CardTask` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Status for this `CardTask` */
  status?: InputMaybe<CardTaskStatusEnum>;
  /** Title for this `CardTask` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `User`s for this `CardTask` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of UpdateCardTask. */
export interface UpdateCardTaskPayload {
  __typename: 'UpdateCardTaskPayload';
  cardTask: Maybe<CardTask>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCccFormConfig */
export interface UpdateCccFormConfigInput {
  cccFormConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['JSON']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated return type of UpdateCccFormConfig. */
export interface UpdateCccFormConfigPayload {
  __typename: 'UpdateCccFormConfigPayload';
  cccFormConfig: Maybe<CccFormConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateClinicalCompetenceCommittee */
export interface UpdateClinicalCompetenceCommitteeInput {
  cccFormConfigSelectionResultsAttributes?: InputMaybe<Array<CccFormConfigSelectionResultInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated `finalResponseJson` is no longer used, use `cccFormConfigSelectionResultsAttributes` instead */
  finalResponseJson?: InputMaybe<Scalars['JSON']['input']>;
  instructionsJsonContent?: InputMaybe<Scalars['JSON']['input']>;
  interviewIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ClinicalCompetenceCommitteeStatusEnum>;
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibilityLevelOwner?: InputMaybe<ClinicalCompetenceCommitteeVisibilityLevelOwnerEnum>;
}

/** Autogenerated return type of UpdateClinicalCompetenceCommittee. */
export interface UpdateClinicalCompetenceCommitteePayload {
  __typename: 'UpdateClinicalCompetenceCommitteePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommittee: Maybe<ClinicalCompetenceCommittee>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateClinicalCompetenceCommitteeRespondentResponse */
export interface UpdateClinicalCompetenceCommitteeRespondentResponseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeRespondentId: Scalars['ID']['input'];
  /** @deprecated Use `UpdateClinicalCompetenceCommitteeRespondentResults` instead */
  responseJson?: InputMaybe<Scalars['JSON']['input']>;
  submittedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** Autogenerated return type of UpdateClinicalCompetenceCommitteeRespondentResponse. */
export interface UpdateClinicalCompetenceCommitteeRespondentResponsePayload {
  __typename: 'UpdateClinicalCompetenceCommitteeRespondentResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommitteeRespondent: Maybe<ClinicalCompetenceCommitteeRespondent>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateClinicalCompetenceCommitteeRespondentResults */
export interface UpdateClinicalCompetenceCommitteeRespondentResultsInput {
  cccFormConfigSelectionResultsAttributes?: InputMaybe<Array<CccFormConfigSelectionResultInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalCompetenceCommitteeRespondentId: Scalars['ID']['input'];
  submittedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** Autogenerated return type of UpdateClinicalCompetenceCommitteeRespondentResults. */
export interface UpdateClinicalCompetenceCommitteeRespondentResultsPayload {
  __typename: 'UpdateClinicalCompetenceCommitteeRespondentResultsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  clinicalCompetenceCommitteeRespondent: Maybe<ClinicalCompetenceCommitteeRespondent>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCompetenceCertificate */
export interface UpdateCompetenceCertificateInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `CompetenceCertificate` to modify */
  competenceCertificateId: Scalars['ID']['input'];
  /** @deprecated Temporary flag to prevent creating notifications/pending actions for this `CompetenceCertificate` */
  createdInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  denialReason?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Skill` this `CompetenceCertificate` should linked to. */
  skillId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CompetenceCertificateStatusEnum>;
  /** ID of the `User` that issues this `CompetenceCertificate` */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
  withdrawalReason?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateCompetenceCertificate. */
export interface UpdateCompetenceCertificatePayload {
  __typename: 'UpdateCompetenceCertificatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  competenceCertificate: Maybe<CompetenceCertificate>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCompetenceCertificatesInBatch */
export interface UpdateCompetenceCertificatesInBatchInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `CompetenceCertificateBatch` to modify */
  competenceCertificateBatchId: Scalars['ID']['input'];
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  status: CompetenceCertificateStatusEnum;
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateCompetenceCertificatesInBatch. */
export interface UpdateCompetenceCertificatesInBatchPayload {
  __typename: 'UpdateCompetenceCertificatesInBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  competenceCertificateBatch: Maybe<CompetenceCertificateBatch>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCourse */
export interface UpdateCourseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohorts to group the `CourseResults` for this `Course` by */
  cohorts?: InputMaybe<Array<CourseCohortInput>>;
  /** ID of the `Course` to update */
  courseId: Scalars['ID']['input'];
  /** A description for this `Course` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Guideline ID of the `Course` */
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  /** A flag if one can achieve a score for this `Course` */
  hasScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to indicate overall results can be viewed */
  hasViewableOverallResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag if the `Course` with potential sub `Course`s with centrally uploaded results */
  isCentralUploadCategory?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if results for the `Course` can also be registered by the manager */
  isCreatableByManager?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if results for the `Course` can only be registered automatically or also by the owner */
  isCreatableByOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** A flag if the `Course` can be passed or not */
  isPassable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum score for this `Course` */
  maxScore?: InputMaybe<Scalars['Float']['input']>;
  /** Order to sort this `Course` among its sibling sub `Course`s */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** An optional parent `Course` this `Course` falls under */
  parentCourse?: InputMaybe<Scalars['ID']['input']>;
  /** The short title of this `Course` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The title of this `Course` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateCourse. */
export interface UpdateCoursePayload {
  __typename: 'UpdateCoursePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  course: Maybe<Course>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCourseResult */
export interface UpdateCourseResultInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** BIG of the `User` this `CourseResult` is attached to */
  big?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort to group this `CourseResult` with */
  cohort?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Course` for this `CourseResult` */
  courseId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the `CourseResult` to update */
  courseResultId: Scalars['ID']['input'];
  /** The date at which this result was achieved */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** The description of this result */
  description?: InputMaybe<Scalars['String']['input']>;
  /** True if the result is a passed result */
  passed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The score associated with this result */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** JSON schema of what scores look like */
  scoreDetail?: InputMaybe<Scalars['JSON']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of time spent to achieve this result */
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
  /** The title of this result */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateCourseResult. */
export interface UpdateCourseResultPayload {
  __typename: 'UpdateCourseResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  courseResult: Maybe<CourseResult>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateCustomSkill */
export interface UpdateCustomSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the custom `Skill` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the custom `Skill` */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the custom `Skill` */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order of the custom `Skill` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Short name of the custom `Skill` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Skill categories of the custom `Skill` */
  skillCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Id of the custom `Skill` */
  skillId: Scalars['ID']['input'];
  /** Skill type of the custom `Skill` */
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated return type of UpdateCustomSkill. */
export interface UpdateCustomSkillPayload {
  __typename: 'UpdateCustomSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of UpdateDashboardFormat */
export interface UpdateDashboardFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Dashboard` to update */
  dashboardFormatId: Scalars['ID']['input'];
  /** Description of this `Dashboard` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This field is deprecated and will be removed after 2025-06-01 */
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  /** shortName of this `Dashboard` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Title of this `Dashboard` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateDashboardFormat. */
export interface UpdateDashboardFormatPayload {
  __typename: 'UpdateDashboardFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboardFormat: Maybe<DashboardFormat>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateDashboard */
export interface UpdateDashboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Dashboard` to update */
  dashboardId: Scalars['ID']['input'];
  /** Description for this `Dashboard` */
  description?: InputMaybe<Scalars['String']['input']>;
  featuredWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  /** Title for this `Dashboard` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** `use_alternative_title` boolean of this `Dashboard` */
  useAlternativeTitle?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateDashboard. */
export interface UpdateDashboardPayload {
  __typename: 'UpdateDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboard: Maybe<Dashboard>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateDashboardRole */
export interface UpdateDashboardRoleInput {
  /** access_level for this `DashboardRole` */
  accessLevel?: InputMaybe<DashboardRoleAccessLevelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardRole` to update */
  dashboardRoleId: Scalars['ID']['input'];
  /** Title for this `DashboardRole` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateDashboardRole. */
export interface UpdateDashboardRolePayload {
  __typename: 'UpdateDashboardRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  dashboardRole: Maybe<DashboardRole>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateEventCard */
export interface UpdateEventCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description for this `EventCard`
   * @deprecated Use `descriptionJsonContent` instead.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** End date for this `EventCard` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `EventCard` to update */
  eventCardId: Scalars['ID']['input'];
  qualityInstrumentId?: InputMaybe<Scalars['ID']['input']>;
  /** Start date for this `EventCard` */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Status for this `EventCard` */
  status?: InputMaybe<EventCardStatusEnum>;
  /** Title for this `EventCard` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `User`s for this `EventCard` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of UpdateEventCard. */
export interface UpdateEventCardPayload {
  __typename: 'UpdateEventCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventCard: Maybe<EventCard>;
}

/** Autogenerated input type of UpdateExternalAccess */
export interface UpdateExternalAccessInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ExternalAccess` to update */
  externalAccessId: Scalars['ID']['input'];
  /** ID of the `Portfolio` that is linked to this `ExternalAccess` */
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  /** Status of this `ExternalAccess` */
  status?: InputMaybe<ExternalAccessStatusEnum>;
}

/** Autogenerated return type of UpdateExternalAccess. */
export interface UpdateExternalAccessPayload {
  __typename: 'UpdateExternalAccessPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  externalAccess: Maybe<ExternalAccess>;
}

/** Autogenerated input type of UpdateFeedbackRequest */
export interface UpdateFeedbackRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** General feedback */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeedbackRequest` to update */
  feedbackRequestId: Scalars['ID']['input'];
  /** not_set, not_assessed, positive, neutral or negative response */
  thumbs?: InputMaybe<ThumbsEnum>;
  /** Feedback given on specific topics */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateFeedbackRequest. */
export interface UpdateFeedbackRequestPayload {
  __typename: 'UpdateFeedbackRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The updated `FeedbackRequest` */
  feedbackRequest: Maybe<FeedbackRequest>;
}

/** Autogenerated input type of UpdateFeedbackRound */
export interface UpdateFeedbackRoundInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Not null of the `FeedbackRound` was closed */
  closedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Comments and questions for the people giving feedback */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `FeedbackRound` to update */
  feedbackRoundId: Scalars['ID']['input'];
  /** Boolean that marks whether or not owner can view the gated_fields of the `FeedbackRound` */
  ownerCanViewAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of the `FeedbackRound` */
  status?: InputMaybe<FeedbackRoundStatusEnum>;
  /** Title of the `FeedbackRound` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateFeedbackRound. */
export interface UpdateFeedbackRoundPayload {
  __typename: 'UpdateFeedbackRoundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The updated `FeedbackRound` */
  feedbackRound: Maybe<FeedbackRound>;
}

/** Autogenerated input type of UpdateGeneralFeedbackFormConfig */
export interface UpdateGeneralFeedbackFormConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<Scalars['JSON']['input']>;
  generalFeedbackFormConfigId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of UpdateGeneralFeedbackFormConfig. */
export interface UpdateGeneralFeedbackFormConfigPayload {
  __typename: 'UpdateGeneralFeedbackFormConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generalFeedbackFormConfig: Maybe<GeneralFeedbackFormConfig>;
}

/** Autogenerated input type of UpdateGeneralFeedback */
export interface UpdateGeneralFeedbackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generalFeedbackId: Scalars['ID']['input'];
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateGeneralFeedback. */
export interface UpdateGeneralFeedbackPayload {
  __typename: 'UpdateGeneralFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  generalFeedback: Maybe<GeneralFeedback>;
}

/** Autogenerated input type of UpdateGoalActivity */
export interface UpdateGoalActivityInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this activity was performed */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `GoalActivity` */
  goalActivityId: Scalars['ID']['input'];
  /** ID of the subject attached to this `GoalActivity` */
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  /** Mutlipurpose description field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateGoalActivity. */
export interface UpdateGoalActivityPayload {
  __typename: 'UpdateGoalActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goalActivity: Maybe<GoalActivity>;
}

/** Autogenerated input type of UpdateGoalCard */
export interface UpdateGoalCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description for this `GoalCard`
   * @deprecated Use `descriptionJsonContent` instead.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `descriptionActJsonContent` instead. */
  descriptionAct?: InputMaybe<Scalars['String']['input']>;
  descriptionActJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionCheckJsonContent` instead. */
  descriptionCheck?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `descriptionCheckIndicatorsJsonContent` instead. */
  descriptionCheckIndicators?: InputMaybe<Scalars['String']['input']>;
  descriptionCheckIndicatorsJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionCheckJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionDoJsonContent` instead. */
  descriptionDo?: InputMaybe<Scalars['String']['input']>;
  descriptionDoJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** @deprecated Use `descriptionPlanJsonContent` instead. */
  descriptionPlan?: InputMaybe<Scalars['String']['input']>;
  descriptionPlanJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** End date for this `GoalCard` */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** This `GoalCard` is featured */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `GoalCard` to update */
  goalCardId: Scalars['ID']['input'];
  /** Severity for this `GoalCard` */
  severity?: InputMaybe<GoalCardSeverityEnum>;
  /** Start date for this `GoalCard` */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Status for this `GoalCard` */
  status?: InputMaybe<GoalCardStatusEnum>;
  /** ID of the `Subdomain` for this `GoalCard` */
  subDomainId?: InputMaybe<Scalars['ID']['input']>;
  /** Title for this `GoalCard` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `User`s for this `GoalCard` */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of UpdateGoalCard. */
export interface UpdateGoalCardPayload {
  __typename: 'UpdateGoalCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goalCard: Maybe<GoalCard>;
}

/** Autogenerated input type of UpdateGoal */
export interface UpdateGoalInput {
  /** Canmeds for this `Goal` */
  canmeds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Category (variant) of this `Goal` */
  category?: InputMaybe<GoalCategoryTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Goal` */
  goalId: Scalars['ID']['input'];
  /** IDs of the `Residencies` for this `Goals` */
  residencyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Current status of this `Goal` */
  status?: InputMaybe<GoalStatusEnum>;
  /** `Date` that the portfolio owner aims to achieve this goal */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  /** General description of this `Goal` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Mutlipurpose description field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateGoal. */
export interface UpdateGoalPayload {
  __typename: 'UpdateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  goal: Maybe<Goal>;
}

/** Autogenerated input type of UpdateInterview */
export interface UpdateInterviewInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `Interview` was performed */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** End date of the period considered in this `Interview` */
  endOn?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `Interview` to update */
  interviewId: Scalars['ID']['input'];
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  /** Total reduction in months */
  reduction?: InputMaybe<Scalars['Float']['input']>;
  /** Reason for (changing) the reduction */
  reductionReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the other interviews that this `Interview` refers to */
  refersToInterviewIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional ID of the `Residency` this `Interview` belongs to */
  residencyId?: InputMaybe<Scalars['ID']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the period considered in this `Interview` */
  startOn?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<InterviewStatusEnum>;
  /** ID of the `User` that supervised this `Interview` */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateInterview. */
export interface UpdateInterviewPayload {
  __typename: 'UpdateInterviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  interview: Maybe<Interview>;
}

/** Autogenerated input type of UpdateInterviewReferences */
export interface UpdateInterviewReferencesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Interview` to refer from */
  interviewId: Scalars['ID']['input'];
  /** IDs of the other interviews that this `Interview` refers to */
  refersToInterviewIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateInterviewReferences. */
export interface UpdateInterviewReferencesPayload {
  __typename: 'UpdateInterviewReferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  interview: Maybe<Interview>;
}

/** Autogenerated input type of UpdateInvoicePlan */
export interface UpdateInvoicePlanInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Contact` for this `InvoicePlan` */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** the invoice frequency of the `InvoicePlan` */
  invoiceFrequency?: InputMaybe<InvoicePlanFrequencyEnum>;
  /** ID of the `Billing::InvoicePlan` to update */
  invoicePlanId: Scalars['ID']['input'];
  /** ID of the `LedgerAccount` for this `InvoicePlan` */
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** License price for this `InvoicePlan` */
  licensePrice?: InputMaybe<Scalars['Float']['input']>;
  /** Whether to add a list of licenses (as PDF) as an attachment to an invoice in MoneyBird */
  moneybirdAttachSpecifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` for this `InvoicePlan` */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the `PortfolioFormat` for this `InvoicePlan` */
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateInvoicePlan. */
export interface UpdateInvoicePlanPayload {
  __typename: 'UpdateInvoicePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoicePlan: Maybe<InvoicePlan>;
}

/** Autogenerated input type of UpdateKPB */
export interface UpdateKpbInput {
  approvedByOwnerReason?: InputMaybe<Scalars['String']['input']>;
  approvedBySupervisorReason?: InputMaybe<Scalars['String']['input']>;
  approvedReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  canmeds?: InputMaybe<CanmedsInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `KPB` was performed */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `KPB` to update */
  kpbId: Scalars['ID']['input'];
  level?: InputMaybe<LevelEnum>;
  /** Pin of the `Portfolio` owner */
  ownerPin?: InputMaybe<Scalars['String']['input']>;
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<KpbStatusEnum>;
  supervisionLevel?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `User` that supervised this `KPB` */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Pin of the supervisor */
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateKPB. */
export interface UpdateKpbPayload {
  __typename: 'UpdateKPBPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  kpb: Maybe<Kpb>;
}

/** Autogenerated input type of UpdateLearningResourceArticle */
export interface UpdateLearningResourceArticleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceArticleId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceArticle. */
export interface UpdateLearningResourceArticlePayload {
  __typename: 'UpdateLearningResourceArticlePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceArticle: Maybe<LearningResourceArticle>;
}

/** Autogenerated input type of UpdateLearningResourceFile */
export interface UpdateLearningResourceFileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the content */
  content?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceFileId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceFile. */
export interface UpdateLearningResourceFilePayload {
  __typename: 'UpdateLearningResourceFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceFile: Maybe<LearningResourceFile>;
}

/** Autogenerated input type of UpdateLearningResourceGlobalCategory */
export interface UpdateLearningResourceGlobalCategoryInput {
  application?: InputMaybe<ApplicationEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  learningResourceGlobalCategoryId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceGlobalCategory. */
export interface UpdateLearningResourceGlobalCategoryPayload {
  __typename: 'UpdateLearningResourceGlobalCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceGlobalCategory: Maybe<LearningResourceGlobalCategory>;
}

/** Autogenerated input type of UpdateLearningResourceLink */
export interface UpdateLearningResourceLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceLinkId: Scalars['ID']['input'];
  /**
   * ID of the `DirectUpload` of the thumbnail
   * @deprecated Use `image` instead
   */
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceLink. */
export interface UpdateLearningResourceLinkPayload {
  __typename: 'UpdateLearningResourceLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceLink: Maybe<LearningResourceLink>;
}

/** Autogenerated input type of UpdateLearningResourceMicroLearning */
export interface UpdateLearningResourceMicroLearningInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` of the avatar */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceMicroLearningId: Scalars['ID']['input'];
  status?: InputMaybe<MicroLearningStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceMicroLearning. */
export interface UpdateLearningResourceMicroLearningPayload {
  __typename: 'UpdateLearningResourceMicroLearningPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearning: Maybe<LearningResourceMicroLearning>;
}

/** Autogenerated input type of UpdateLearningResourceMicroLearningStep */
export interface UpdateLearningResourceMicroLearningStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `description_json_content` instead. */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  /** ID of the `DirectUpload` of the image */
  image?: InputMaybe<Scalars['ID']['input']>;
  learningResourceMicroLearningStepId: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  linkButtonText?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceMicroLearningStep. */
export interface UpdateLearningResourceMicroLearningStepPayload {
  __typename: 'UpdateLearningResourceMicroLearningStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearningStep: Maybe<LearningResourceMicroLearningStep>;
}

/** Autogenerated input type of UpdateLearningResourceMicroLearningUserProgress */
export interface UpdateLearningResourceMicroLearningUserProgressInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentMicroLearningStepId?: InputMaybe<Scalars['ID']['input']>;
  learningResourceMicroLearningUserProgressId: Scalars['ID']['input'];
  status?: InputMaybe<MicroLearningUserProgressStatusEnum>;
}

/** Autogenerated return type of UpdateLearningResourceMicroLearningUserProgress. */
export interface UpdateLearningResourceMicroLearningUserProgressPayload {
  __typename: 'UpdateLearningResourceMicroLearningUserProgressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceMicroLearningUserProgress: Maybe<LearningResourceMicroLearningUserProgress>;
}

/** Autogenerated input type of UpdateLearningResourceSet */
export interface UpdateLearningResourceSetInput {
  betaOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibleForRoleTypes?: InputMaybe<Array<RoleTypeEnum>>;
}

/** Autogenerated input type of UpdateLearningResourceSetItem */
export interface UpdateLearningResourceSetItemInput {
  alertAfterDays?: InputMaybe<Scalars['Int']['input']>;
  alertExpiresAfterDays?: InputMaybe<Scalars['Int']['input']>;
  alertSendMail?: InputMaybe<Scalars['Boolean']['input']>;
  alertedRoleTypes?: InputMaybe<Array<RoleTypeEnum>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  learningResourceItemId: Scalars['ID']['input'];
  learningResourceSetId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  targetLearningResourceSetId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateLearningResourceSetItem. */
export interface UpdateLearningResourceSetItemPayload {
  __typename: 'UpdateLearningResourceSetItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated return type of UpdateLearningResourceSet. */
export interface UpdateLearningResourceSetPayload {
  __typename: 'UpdateLearningResourceSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  learningResourceSet: Maybe<LearningResourceSet>;
}

/** Autogenerated input type of UpdateLinkedCards */
export interface UpdateLinkedCardsInput {
  /** ID of the `Card` to update linked_cards on */
  cardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Cards`s that will be linked to this `Card` */
  linkedCardIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateLinkedCards. */
export interface UpdateLinkedCardsPayload {
  __typename: 'UpdateLinkedCardsPayload';
  card: Maybe<LinkedCard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
}

/** Autogenerated input type of UpdateMemo */
export interface UpdateMemoInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Actual text of the `Memo` */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Memo` to update */
  memoId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateMemo. */
export interface UpdateMemoPayload {
  __typename: 'UpdateMemoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  memo: Maybe<Memo>;
}

/** Autogenerated input type of UpdateMultiSource */
export interface UpdateMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp this `MultiSource` was closed by the creator */
  closedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  collaborator?: InputMaybe<Scalars['JSON']['input']>;
  /** General commentary */
  comments?: InputMaybe<Scalars['String']['input']>;
  communicator?: InputMaybe<Scalars['JSON']['input']>;
  /** End date of the period this `MultiSource` describes */
  endOn?: InputMaybe<Scalars['Date']['input']>;
  healthAdvocate?: InputMaybe<Scalars['JSON']['input']>;
  leader?: InputMaybe<Scalars['JSON']['input']>;
  /** Extra commentary to include in E-mails */
  mailComments?: InputMaybe<Scalars['String']['input']>;
  medicalExpert?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the `MultiSource` to update */
  multiSourceId: Scalars['ID']['input'];
  /** Things the resident needs to improve upon */
  pointsOfConcern?: InputMaybe<Scalars['String']['input']>;
  /** Things the resident did well */
  positivePoints?: InputMaybe<Scalars['String']['input']>;
  professional?: InputMaybe<Scalars['JSON']['input']>;
  scholar?: InputMaybe<Scalars['JSON']['input']>;
  /** Start date of the period this `MultiSource` describes */
  startOn?: InputMaybe<Scalars['Date']['input']>;
  /** Current status of this `MultiSource` */
  status: MultiSourceStatusEnum;
  /** Multipurpose field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateMultiSource. */
export interface UpdateMultiSourcePayload {
  __typename: 'UpdateMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  multiSource: Maybe<MultiSource>;
}

/** Autogenerated input type of UpdateMultiSourceReflection */
export interface UpdateMultiSourceReflectionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  multiSourceId: Scalars['ID']['input'];
  reflection: Scalars['String']['input'];
}

/** Autogenerated return type of UpdateMultiSourceReflection. */
export interface UpdateMultiSourceReflectionPayload {
  __typename: 'UpdateMultiSourceReflectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  multiSource: Maybe<MultiSource>;
}

/** Autogenerated input type of UpdateNote */
export interface UpdateNoteInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Note` to update */
  noteId: Scalars['ID']['input'];
  /** Actual note of the `Note` */
  noteText?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateNote. */
export interface UpdateNotePayload {
  __typename: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  note: Maybe<Note>;
}

/** Autogenerated input type of UpdateNotification */
export interface UpdateNotificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `Notification` to modify */
  notificationId: Scalars['ID']['input'];
  /** Date and time of when the `Notification` was read. */
  readAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** Autogenerated return type of UpdateNotification. */
export interface UpdateNotificationPayload {
  __typename: 'UpdateNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  notification: Maybe<Notification>;
}

/** Autogenerated input type of UpdateOrganization */
export interface UpdateOrganizationInput {
  /** ID of the `DirectUpload` of the avatar */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateOrganization. */
export interface UpdateOrganizationPayload {
  __typename: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization: Maybe<Organization>;
}

/** Autogenerated input type of UpdateOrganizationUserRole */
export interface UpdateOrganizationUserRoleInput {
  canManageRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canViewReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationUserRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateOrganizationUserRole. */
export interface UpdateOrganizationUserRolePayload {
  __typename: 'UpdateOrganizationUserRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationUserRole: Maybe<OrganizationUserRole>;
}

/** Autogenerated input type of UpdateParentDomain */
export interface UpdateParentDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DashboardFormat` for this `ParentDomain` */
  dashboardFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** Description for this `ParentDomain` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Order number for this `ParentDomain` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `ParentDomain` to update */
  parentDomainId: Scalars['ID']['input'];
  /** ID's of the `SubDomain`s for this `ParentDomain` */
  subDomainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Title for this `ParentDomain` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateParentDomain. */
export interface UpdateParentDomainPayload {
  __typename: 'UpdateParentDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  parentDomain: Maybe<ParentDomain>;
}

/** Autogenerated input type of UpdateParticipationLevelFormat */
export interface UpdateParticipationLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  participationLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateParticipationLevelFormat. */
export interface UpdateParticipationLevelFormatPayload {
  __typename: 'UpdateParticipationLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  participationLevelFormat: Maybe<ParticipationLevelFormat>;
}

/** Autogenerated input type of UpdatePeriodFormat */
export interface UpdatePeriodFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  monthDuration?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  periodFormatId: Scalars['ID']['input'];
  shortLabel?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdatePeriodFormat. */
export interface UpdatePeriodFormatPayload {
  __typename: 'UpdatePeriodFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  periodFormat: Maybe<PeriodFormat>;
}

/** Autogenerated input type of UpdatePeriod */
export interface UpdatePeriodInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New end date of the `Period` */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** ID of the `Period` to update */
  periodId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdatePeriod. */
export interface UpdatePeriodPayload {
  __typename: 'UpdatePeriodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  period: Maybe<Period>;
}

/** Autogenerated input type of UpdatePeriodRequiredSkillLevel */
export interface UpdatePeriodRequiredSkillLevelInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  periodRequiredSkillLevelId: Scalars['ID']['input'];
  skillLevelFormatId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdatePeriodRequiredSkillLevel. */
export interface UpdatePeriodRequiredSkillLevelPayload {
  __typename: 'UpdatePeriodRequiredSkillLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  periodRequiredSkillLevel: Maybe<PeriodRequiredSkillLevel>;
}

/** Autogenerated input type of UpdatePortfolioDocumentConfig */
export interface UpdatePortfolioDocumentConfigInput {
  aiContext?: InputMaybe<Scalars['String']['input']>;
  allowBatch?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentIsEssential?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveAttachedFiles?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveFeedbackRound?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, all document will be connectable to goals */
  canHaveGoalActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, all document will be connectable to profile goals */
  canHaveProfileGoalActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated This field will be removed, reduction will be determined by the presence of REDUCTION group, november 2024 */
  canHaveReduction?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveSelfAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  canUseTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<PortfolioDocumentTypeEnum>;
  feedbackForm?: InputMaybe<Scalars['JSON']['input']>;
  form?: InputMaybe<Scalars['JSON']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  formTypeName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This field will be removed, remove this no earlier than the 11th of november 2024 */
  formVersion?: InputMaybe<Scalars['Int']['input']>;
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  isAvailableInApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Freemium feature is being removed, remove this at the latest in november 2024 */
  isAvailableInFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatableBySupport?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pluralName?: InputMaybe<Scalars['String']['input']>;
  portfolioDocumentConfigId: Scalars['ID']['input'];
  referrableFormTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredNumber?: InputMaybe<Scalars['Int']['input']>;
  showInMainCreateMenu?: InputMaybe<Scalars['Boolean']['input']>;
  skillType?: InputMaybe<SkillTypeEnum>;
  skipSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorIsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  supervisorType?: InputMaybe<SupervisorTypeEnum>;
  supportsInvite?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `ai_context` instead, remove this argument after 2026-12-01 */
  transcriptionPromptContext?: InputMaybe<Scalars['String']['input']>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdatePortfolioDocumentConfig. */
export interface UpdatePortfolioDocumentConfigPayload {
  __typename: 'UpdatePortfolioDocumentConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioDocumentConfig: Maybe<PortfolioDocumentConfig>;
}

/** Autogenerated input type of UpdatePortfolioFormat */
export interface UpdatePortfolioFormatInput {
  /** ID of the `DirectUpload` of the avatar */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the `PortfolioFormat` can have residencies */
  canHaveResidencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  educationDurationStartMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Guidelines code ID of the `PortfolioFormat` */
  guidelinesCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Language of the `PortfolioFormat` */
  language?: InputMaybe<LanguageEnum>;
  /** Target role type of the `PortfolioFormat` */
  mailingType?: InputMaybe<TargetRoleEnum>;
  /** Name of the `PortfolioFormat` */
  name?: InputMaybe<Scalars['String']['input']>;
  nominalDuration?: InputMaybe<Scalars['Int']['input']>;
  onboardingShowProfile?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingShowProfileGoals?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `PortfolioFormat` to update */
  portfolioFormatId: Scalars['ID']['input'];
  profileAllowCustom?: InputMaybe<Scalars['Boolean']['input']>;
  profiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the `Course` that acts as the root of the tree */
  rootCourseId?: InputMaybe<Scalars['ID']['input']>;
  /** Short name of the `PortfolioFormat` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  usesPortfolioNotes?: InputMaybe<Scalars['Boolean']['input']>;
  usesProfile?: InputMaybe<Scalars['Boolean']['input']>;
  usesProfileGoals?: InputMaybe<Scalars['Boolean']['input']>;
  usesStartEndDate?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdatePortfolioFormat. */
export interface UpdatePortfolioFormatPayload {
  __typename: 'UpdatePortfolioFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioFormat` that was updated */
  portfolioFormat: Maybe<PortfolioFormat>;
}

/** Autogenerated input type of UpdatePortfolioImport */
export interface UpdatePortfolioImportInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `DirectUpload` zip file */
  importFile: Scalars['String']['input'];
  /** ID of the `PortfolioImport` update */
  portfolioImportId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdatePortfolioImport. */
export interface UpdatePortfolioImportPayload {
  __typename: 'UpdatePortfolioImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `PortfolioImport` from which we will create objects */
  portfolioImport: Maybe<PortfolioImport>;
}

/** Autogenerated input type of UpdatePortfolio */
export interface UpdatePortfolioInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Cohort of the `Portfolio` */
  cohort?: InputMaybe<Scalars['String']['input']>;
  /** Custom settings for the `Portfolio` */
  customSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** `Date` the education period of the `Portfolio` has ended or will end */
  educationEndedOn?: InputMaybe<Scalars['Date']['input']>;
  /** `Date` the education period of the `Portfolio` starts */
  educationStartedOn?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `Portfolio` to update */
  portfolioId: Scalars['ID']['input'];
  /** Profile of the `Portfolio` */
  profile?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Multipurpose information field for the `Portfolio` */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated input type of UpdatePortfolioNote */
export interface UpdatePortfolioNoteInput {
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  noteJsonContent?: InputMaybe<Scalars['JSON']['input']>;
  portfolioNoteId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of UpdatePortfolioNote. */
export interface UpdatePortfolioNotePayload {
  __typename: 'UpdatePortfolioNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioNote: Maybe<PortfolioNote>;
}

/** Autogenerated return type of UpdatePortfolio. */
export interface UpdatePortfolioPayload {
  __typename: 'UpdatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolio: Maybe<Portfolio>;
}

/** Autogenerated input type of UpdatePortfolioRole */
export interface UpdatePortfolioRoleInput {
  /** active of the `PortfolioRole` */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** `RoleFormat` that is the active Roleformat for the `PortfolioRole` */
  activeRoleFormatId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The excluding_end_date to indicate until when the `PortfolioRole` is active. */
  excludingEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** The including_start_date to indicate from when the `PortfolioRole` is active. */
  includingStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the `PortfolioRole` to update */
  portfolioRoleId: Scalars['ID']['input'];
  /** read_access_level of the `PortfolioRole` */
  readAccessLevel?: InputMaybe<ReadAccessLevelEnum>;
  /**
   * whether the read_access_level of the PortfolioRole is customized. If passed in
   * as false read_access_level should be omitted.
   */
  readAccessLevelCustomized?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdatePortfolioRole. */
export interface UpdatePortfolioRolePayload {
  __typename: 'UpdatePortfolioRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRole: Maybe<PortfolioRole>;
}

/** Autogenerated input type of UpdatePortfolioRoleSync */
export interface UpdatePortfolioRoleSyncInput {
  /** active of the `PortfolioRoleSync` */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `PortfolioRoleSync` to update */
  portfolioRoleSyncId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdatePortfolioRoleSync. */
export interface UpdatePortfolioRoleSyncPayload {
  __typename: 'UpdatePortfolioRoleSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioRoleSync: Maybe<PortfolioRoleSync>;
}

/** Autogenerated input type of UpdatePortfolioSkillHidden */
export interface UpdatePortfolioSkillHiddenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Boolean to indicate if the portfolio skill is hidden */
  hidden: Scalars['Boolean']['input'];
  /** ID of the `Portfolio` */
  portfolioId: Scalars['ID']['input'];
  /** ID of the `Skill` */
  skillId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdatePortfolioSkillHidden. */
export interface UpdatePortfolioSkillHiddenPayload {
  __typename: 'UpdatePortfolioSkillHiddenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
}

/** Autogenerated input type of UpdatePortfolioTransferRequest */
export interface UpdatePortfolioTransferRequestInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the transfer request */
  portfolioTransferRequestId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PortfolioTransferStatusEnum>;
  /** ID of the `User` that decides on this request */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  supervisorPin?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdatePortfolioTransferRequest. */
export interface UpdatePortfolioTransferRequestPayload {
  __typename: 'UpdatePortfolioTransferRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  portfolioTransferRequest: Maybe<PortfolioTransferRequest>;
}

/** Autogenerated input type of UpdateProgram */
export interface UpdateProgramInput {
  /** Boolean to check whether or not the PortfolioFormat is available */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Boolean to check whether or not a `Portfolio` of the `PortfolioFormat` is creatable_without_invoice_plan */
  creatableWithoutInvoicePlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` to link to the `Program` */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the `PortfolioFormat` to link to the `Program` */
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the `Program` to update */
  programId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateProgram. */
export interface UpdateProgramPayload {
  __typename: 'UpdateProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  program: Maybe<Program>;
}

/** Autogenerated input type of UpdateProgramRole */
export interface UpdateProgramRoleInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `ProgramRole` to update */
  programRoleId: Scalars['ID']['input'];
  /** ID of the `RoleFormat` the `ProgramRole` is attached to */
  roleFormatId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of UpdateProgramRole. */
export interface UpdateProgramRolePayload {
  __typename: 'UpdateProgramRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  programRole: Maybe<ProgramRole>;
}

/** Autogenerated input type of UpdateProtectedUserFields */
export interface UpdateProtectedUserFieldsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The current password of the viewer */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  /** The primary email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The new password of the user */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The secondary email address of the user */
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to update */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateProtectedUserFields. */
export interface UpdateProtectedUserFieldsPayload {
  __typename: 'UpdateProtectedUserFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** The updated user */
  user: Maybe<User>;
}

/** Autogenerated input type of UpdateQualityInstrument */
export interface UpdateQualityInstrumentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptionJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  descriptionTemplateJsonContent?: InputMaybe<Scalars['JSONContent']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  qualityInstrumentId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateQualityInstrument. */
export interface UpdateQualityInstrumentPayload {
  __typename: 'UpdateQualityInstrumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  qualityInstrument: Maybe<QualityInstrument>;
}

/** Autogenerated input type of UpdateRegistration */
export interface UpdateRegistrationInput {
  /** IDs of preuploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this activity was performed */
  date?: InputMaybe<Scalars['Date']['input']>;
  participationLevelFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** Supervision levels of individual parts of the `Operation` */
  parts?: InputMaybe<Scalars['JSON']['input']>;
  /** Quantity of the registration */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the `Registration` that will be updated */
  registrationId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The level of independence according to <some standard> */
  supervisionLevel?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `User` that supervised this activity */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Title for this `Registration` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Freeform field for storing different topics */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateRegistration. */
export interface UpdateRegistrationPayload {
  __typename: 'UpdateRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  /** `Registration` that was updated */
  registration: Maybe<Registration>;
}

/** Autogenerated input type of UpdateResidencyArchetype */
export interface UpdateResidencyArchetypeInput {
  /** Specialized (advanced) or normal residency */
  advanced?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated maximum of needed months to complete this type of residency */
  monthsMax: Scalars['Int']['input'];
  /** Estimated minimum of needed months to complete this type of residency */
  monthsMin: Scalars['Int']['input'];
  /** Specified order of `ResidencyArchetype` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** ID of this `ResidencyArchetype` */
  residencyArchetypeId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of this `ResidencyArchetype` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateResidencyArchetype. */
export interface UpdateResidencyArchetypePayload {
  __typename: 'UpdateResidencyArchetypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  residencyArchetype: Maybe<ResidencyArchetype>;
}

/** Autogenerated input type of UpdateResidency */
export interface UpdateResidencyInput {
  /** True if the residency is advanced */
  advanced?: InputMaybe<Scalars['Boolean']['input']>;
  /** IDs of the `User`s that are advanced supervisors of this `Residency` */
  advancedSupervisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `Date` this `Residency` ends */
  endOn?: InputMaybe<Scalars['Date']['input']>;
  /** IDs of the `Goals` for this `Residency` */
  goalIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** True if the residency is an intermission */
  intermission?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `Organization` for this `Residency` */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `Residency` */
  residencyId: Scalars['ID']['input'];
  /** IDs of the `Skill`s to link to this object's owner. */
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** `Date` this `Residency` starts */
  startOn?: InputMaybe<Scalars['Date']['input']>;
  /** IDs of the `User`s that supervise this `Residency` */
  supervisorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateResidency. */
export interface UpdateResidencyPayload {
  __typename: 'UpdateResidencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  residency: Maybe<Residency>;
}

/** Autogenerated input type of UpdateRoleFormat */
export interface UpdateRoleFormatInput {
  /** Whether the `RoleFormat` should automatically create a `PortfolioRole` or not. */
  automaticallyCreatePortfolioRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** BIG requirement of the `RoleFormat`. */
  big?: InputMaybe<RoleFormatBigEnum>;
  /** Whether the `RoleFormat` can add `CourseResult`s or not. */
  canAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can assess or not. */
  canAssess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can assign other supervisors or not. */
  canAssignOtherSupervisors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can authorize or not. */
  canAuthorize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether users with this `RoleFormat` can create their own `Portfolio`. */
  canCreateOwnPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can edit `Goal`s or not. */
  canEditGoals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can edit practical information or not. */
  canEditPracticalInformation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can manage `MultiSource`s or not. */
  canManageMultiSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the `RoleFormat` can supervise residencies or not. */
  canSuperviseResidencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `RoleFormat`. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the `RoleFormat` is expected to have a `Portfolio` or not. */
  expectedToHavePortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /** `RoleFormat`s that can be upgraded by this `RoleFormat`. */
  mainRoleFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the `RoleFormat`. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order index number of the `RoleFormat`. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `PortfolioFormat` the `RoleFormat` is attached to. */
  portfolioFormatId?: InputMaybe<Scalars['ID']['input']>;
  /** Read access level of the `RoleFormat`. */
  readAccessLevel?: InputMaybe<ReadAccessLevelEnum>;
  requireInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the `RoleFormat` to update. */
  roleFormatId: Scalars['ID']['input'];
  /** Role type of the `RoleFormat`. */
  roleType?: InputMaybe<RoleTypeEnum>;
  /** Whether the `RoleFormat` is selectable as main `RoleFormat` or not. */
  selectableAsMain?: InputMaybe<Scalars['Boolean']['input']>;
  /** Short name of the `RoleFormat`. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** `RoleFormat`s that can be an upgrade for this `RoleFormat`. */
  upgradeRoleFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** Autogenerated return type of UpdateRoleFormat. */
export interface UpdateRoleFormatPayload {
  __typename: 'UpdateRoleFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  roleFormat: Maybe<RoleFormat>;
}

/** Autogenerated input type of UpdateRootSkillCategoryConfig */
export interface UpdateRootSkillCategoryConfigInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  composeInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The kind of level display for the `RootSkillCategoryConfig`. */
  levelDisplay?: InputMaybe<LevelDisplayEnum>;
  /** The ID of the `RootSkillCategoryConfig` to update. */
  rootSkillCategoryConfigId: Scalars['ID']['input'];
  setLevelsInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  setRegistrationsInOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showAverage?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of UpdateRootSkillCategoryConfig. */
export interface UpdateRootSkillCategoryConfigPayload {
  __typename: 'UpdateRootSkillCategoryConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  rootSkillCategoryConfig: Maybe<RootSkillCategoryConfig>;
}

/** Autogenerated input type of UpdateSecurityQuestion */
export interface UpdateSecurityQuestionInput {
  /** Answer of this `SecurityQuestion` */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Question of this `SecurityQuestion` */
  question?: InputMaybe<Scalars['String']['input']>;
  /** ID of this `SecurityQuestion` to update */
  securityQuestionId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateSecurityQuestion. */
export interface UpdateSecurityQuestionPayload {
  __typename: 'UpdateSecurityQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  securityQuestion: Maybe<SecurityQuestion>;
}

/** Autogenerated input type of UpdateSkillCategory */
export interface UpdateSkillCategoryInput {
  /** Allows custom skills to be added to the `SkillCategory` */
  allowCustomSkills?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `SkillCategory` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the `SkillCategory` */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order of the `SkillCategory` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** parent_id of the `SkillCategory` */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** selectable_skill_id of the `SkillCategory` */
  selectableSkillId?: InputMaybe<Scalars['ID']['input']>;
  /** Id of the `SkillCategory` */
  skillCategoryId: Scalars['ID']['input'];
  /** skill_type of the `SkillCategory` */
  skillType?: InputMaybe<SkillTypeEnum>;
  /** sorted_by of the `SkillCategory` */
  sortedBy?: InputMaybe<SkillCategorySortedByEnum>;
}

/** Autogenerated return type of UpdateSkillCategory. */
export interface UpdateSkillCategoryPayload {
  __typename: 'UpdateSkillCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skillCategory: Maybe<SkillCategory>;
}

/** Autogenerated input type of UpdateSkill */
export interface UpdateSkillInput {
  /** Whether the `Skill` is archived or not. The skill can't also be mandatory. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description of the `Skill` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation (in HTML) of the `Skill` */
  documentationHtml?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the `Skill` */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** The GuidelineId that matches the documentation for this skill in Guidelines */
  guidelineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Boolean to check if it is a mandatory `Skill`. The skill will be automatically
   * linked to portfolios that are created after mandatory on the skill is marked as true
   */
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the `Skill` */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order of the `Skill` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parts of the `Skill` */
  parts?: InputMaybe<Scalars['JSON']['input']>;
  /** Short name of the `Skill` */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Skill categories of the `Skill` */
  skillCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Id of the `Skill` */
  skillId: Scalars['ID']['input'];
  /** Skill type of the `Skill` */
  skillType?: InputMaybe<SkillTypeEnum>;
}

/** Autogenerated input type of UpdateSkillLevelFormat */
export interface UpdateSkillLevelFormatInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Display value of the `SkillLevelFormat` */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  /** Label display of the `SkillLevelFormat` */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Number of the `SkillLevelFormat` */
  number?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the `SkillLevelFormat` to update. */
  skillLevelFormatId: Scalars['ID']['input'];
  /** Status of the `SkillLevelFormat` */
  status?: InputMaybe<SkillLevelFormatStatusEnum>;
}

/** Autogenerated return type of UpdateSkillLevelFormat. */
export interface UpdateSkillLevelFormatPayload {
  __typename: 'UpdateSkillLevelFormatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skillLevelFormat: Maybe<SkillLevelFormat>;
}

/** Autogenerated return type of UpdateSkill. */
export interface UpdateSkillPayload {
  __typename: 'UpdateSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of UpdateSkillSubSkill */
export interface UpdateSkillSubSkillInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  skillId: Scalars['ID']['input'];
  subSkillId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateSkillSubSkill. */
export interface UpdateSkillSubSkillPayload {
  __typename: 'UpdateSkillSubSkillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  skill: Maybe<Skill>;
}

/** Autogenerated input type of UpdateSubDomain */
export interface UpdateSubDomainInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Description for this `SubDomain` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Order number for this `SubDomain` */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the `ParentDomain` for this `SubDomain` */
  parentDomainId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the `SubDomain` to update */
  subDomainId: Scalars['ID']['input'];
  /** Title for this `SubDomain` */
  title?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UpdateSubDomain. */
export interface UpdateSubDomainPayload {
  __typename: 'UpdateSubDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  subDomain: Maybe<SubDomain>;
}

/** Autogenerated input type of UpdateSubMultiSource */
export interface UpdateSubMultiSourceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collaborator?: InputMaybe<Scalars['JSON']['input']>;
  /** General commentary */
  comments?: InputMaybe<Scalars['String']['input']>;
  communicator?: InputMaybe<Scalars['JSON']['input']>;
  healthAdvocate?: InputMaybe<Scalars['JSON']['input']>;
  leader?: InputMaybe<Scalars['JSON']['input']>;
  medicalExpert?: InputMaybe<Scalars['JSON']['input']>;
  /** Things the resident needs to improve upon */
  pointsOfConcern: Scalars['String']['input'];
  /** Things the resident did well */
  positivePoints: Scalars['String']['input'];
  professional?: InputMaybe<Scalars['JSON']['input']>;
  scholar?: InputMaybe<Scalars['JSON']['input']>;
  /** Current status of this `MultiSource` */
  status: MultiSourceStatusEnum;
  /** Token of the sub-`MultiSource` to update */
  subMultiSourceToken: Scalars['String']['input'];
  /** Multipurpose field */
  topics?: InputMaybe<Scalars['JSON']['input']>;
}

/** Autogenerated return type of UpdateSubMultiSource. */
export interface UpdateSubMultiSourcePayload {
  __typename: 'UpdateSubMultiSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  subMultiSource: Maybe<SubMultiSource>;
}

/** Autogenerated input type of UpdateSupportGroup */
export interface UpdateSupportGroupInput {
  /** ID of the `DirectUpload` of the avatar */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short description of the group */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the group */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name of the group */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `SupportGroup` to update */
  supportGroupId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateSupportGroup. */
export interface UpdateSupportGroupPayload {
  __typename: 'UpdateSupportGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  supportGroup: Maybe<SupportGroup>;
}

/** Autogenerated input type of UpdateUsageStatistic */
export interface UpdateUsageStatisticInput {
  audioDurationMs?: InputMaybe<Scalars['Int']['input']>;
  audioFileByteSize?: InputMaybe<Scalars['Int']['input']>;
  audioMimeType?: InputMaybe<Scalars['String']['input']>;
  audioTranscriptId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kpbId?: InputMaybe<Scalars['ID']['input']>;
  speakerCount?: InputMaybe<Scalars['Int']['input']>;
  suggestionsCount?: InputMaybe<Scalars['Int']['input']>;
  transcriptionStatus?: InputMaybe<UsageStatisticTranscriptionStatusEnum>;
  usageStatisticId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateUsageStatistic. */
export interface UpdateUsageStatisticPayload {
  __typename: 'UpdateUsageStatisticPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  usageStatistic: Maybe<UsageStatistic>;
}

/** Autogenerated input type of UpdateUserBigFields */
export interface UpdateUserBigFieldsInput {
  /** BIG number of the user */
  big: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `User` to update */
  userId: Scalars['ID']['input'];
  /** Boolean to indicate if the big is verified */
  verifiedBig: Scalars['Boolean']['input'];
}

/** Autogenerated return type of UpdateUserBigFields. */
export interface UpdateUserBigFieldsPayload {
  __typename: 'UpdateUserBigFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user: Maybe<User>;
}

/** Autogenerated input type of UpdateWorkspace */
export interface UpdateWorkspaceInput {
  /** `accreditation_end_date` of this `Workspace` */
  accreditationEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Alternative title of this `Workspace` */
  alternativeTitle?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of pre-uploaded files */
  attachFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `contact_email` of this `Workspace` */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** `contact_information` of this `Workspace` */
  contactInformation?: InputMaybe<Scalars['String']['input']>;
  /** Description of this `Workspace` */
  description?: InputMaybe<Scalars['String']['input']>;
  shareOnDashboard?: InputMaybe<WorkspaceDashboardShareOnDashboardEnum>;
  /** Title of this `Workspace` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** `ID` of the `Workspace` to update */
  workspaceId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateWorkspace. */
export interface UpdateWorkspacePayload {
  __typename: 'UpdateWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  workspace: Maybe<Workspace>;
}

/** Autogenerated input type of UpdateWorkspaceRole */
export interface UpdateWorkspaceRoleInput {
  /** RoleType for this `WorkspaceDashboardRole` */
  accessLevel?: InputMaybe<WorkspaceRoleAccessLevelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Title for this `WorkspaceDashboardRole` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the `WorkspaceDashboardRole` to update */
  workspaceRoleId: Scalars['ID']['input'];
}

/** Autogenerated return type of UpdateWorkspaceRole. */
export interface UpdateWorkspaceRolePayload {
  __typename: 'UpdateWorkspaceRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  workspaceRole: Maybe<WorkspaceRole>;
}

export interface UsageStatistic extends Node, Timestamped {
  __typename: 'UsageStatistic';
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

export enum UsageStatisticTranscriptionStatusEnum {
  /** The transcription_status of the `UsageStatistic` is empty */
  EMPTY = 'EMPTY',
  /** The transcription_status of the `UsageStatistic` is error */
  ERROR = 'ERROR',
  /** The transcription_status of the `UsageStatistic` is success */
  SUCCESS = 'SUCCESS',
}

export interface User extends Node, Timestamped {
  __typename: 'User';
  /** The accepted_privacy_policy_at of this `User`. */
  acceptedPrivacyPolicyAt: Maybe<Scalars['Date']['output']>;
  /** Location of the user's avatar */
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** Number of completed `Badges` of the `User`, only available for admin and own user */
  badgeCount: Maybe<Scalars['Int']['output']>;
  /** The badges of this `User`. */
  badges: BadgeConnection;
  /** Whether the `User` has `Badges` enabled */
  badgesEnabled: Scalars['Boolean']['output'];
  /** Whether the `User` wants to receive notifications about `Badges` */
  badgesSendNotifications: Scalars['Boolean']['output'];
  /** BIG number of the user; Dutch medical registration number */
  big: Maybe<Scalars['String']['output']>;
  /**
   * whether this user has any organization user roles with manage roles
   * permission. Always returns false when user is not the viewer!
   */
  canManageAnyRoles: Scalars['Boolean']['output'];
  /** Returns `true` if `User` can use beta features */
  canUseBetaFeatures: Scalars['Boolean']['output'];
  /** `CardTask`s that are linked to this `User` */
  cardTasks: CardTaskConnection;
  /** `Card`s that are linked to this `User` */
  cards: CardConnection;
  /** All CourseEditions linked to user */
  courseEditions: Array<CourseEdition>;
  /** All Courses linked to user */
  courses: Array<Course>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** `CardComment`s that are created by this `User` */
  createdCardComments: CardCommentConnection;
  /** `CardTask`s that are created by this `User` */
  createdCardTasks: CardTaskConnection;
  /** `Card`s that are created by this `User` */
  createdCards: CardConnection;
  /** Custom user settings */
  customSettings: Maybe<Scalars['JSON']['output']>;
  /** Email address of the user */
  email: Maybe<Scalars['String']['output']>;
  /** All `ExternalAccess`s that are to this `User` */
  externalAccesses: ExternalAccessConnection;
  /** Amount of failed login attempts on account */
  failedAttempts: Maybe<Scalars['Int']['output']>;
  /** All CourseEditions the user marked as favourite */
  favouriteCourseEditions: Array<CourseEdition>;
  /** The first_name of this `User`. */
  firstName: Scalars['String']['output'];
  /** Full name of the user */
  fullName: Scalars['String']['output'];
  /** Location of the user's full size avatar, only available for admin and own user */
  fullSizeAvatarUrl: Maybe<Scalars['String']['output']>;
  /** The gaia_activities of this `User`. */
  gaiaActivities: Maybe<Array<GaiaActivity>>;
  /** The gaia_file_sync of this `User`. */
  gaiaFileSync: Maybe<GaiaFileSync>;
  /** The gaia_targets of this `User`. */
  gaiaTargets: Array<GaiaTarget>;
  /** Returns true if `User` has anything to do with the Portfolio application (Portfolio/ProgramRole) */
  hasPortfolioApplication: Scalars['Boolean']['output'];
  /** Returns `true` if `User` has set up their pin */
  hasValidPin: Scalars['Boolean']['output'];
  /** Returns true if `User` has anything to do with the WorkspaceDashboard application (DashboardRole/WorkspaceRole) */
  hasWorkspaceDashboardApplication: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** All `ImportantNotice`s that are linked to this `User` */
  importantNotices: Array<ImportantNotice>;
  /** The insertion of this `User`. */
  insertion: Maybe<Scalars['String']['output']>;
  /** The `Invite`s that are linked to this `User` */
  invites: Array<Invite>;
  /** Whether `User` is admin. */
  isAdmin: Scalars['Boolean']['output'];
  /** Whether `User` is eligible for anios promo tile. */
  isEligibleForAniosPromoTile: Scalars['Boolean']['output'];
  /** Indicates if a user has a locked account */
  isLocked: Scalars['Boolean']['output'];
  /** Returns `true` if the object is the current user */
  isMe: Scalars['Boolean']['output'];
  /** Indicates if a user is onboarded */
  isOnboarded: Scalars['Boolean']['output'];
  /** Whether `User` is super admin. */
  isSuperAdmin: Scalars['Boolean']['output'];
  /** Indicates if a user has a trusted account */
  isTrusted: Scalars['Boolean']['output'];
  /** Indicates if a user's email and big were verified by Reconcept */
  isVerified: Scalars['Boolean']['output'];
  /** The last_name of this `User`. */
  lastName: Scalars['String']['output'];
  /** All organizations the user has an organization_role on, including the entire subtree (flattened) */
  managedOrganizations: Maybe<Array<Organization>>;
  /** The `Memo`s that are linked to this `User` */
  memos: Array<Memo>;
  /** Attributes of `User`s merged into this `User` */
  mergedUserAttributes: Maybe<Scalars['JSON']['output']>;
  /** The micro_learning_user_progresses of this `User`. */
  microLearningUserProgresses: LearningResourceMicroLearningUserProgressConnection;
  /**
   * The `Note`s that are linked to this `User`
   * @deprecated Use `memos` instead
   */
  notes: Array<Note>;
  /** The `User`'s bound OpenID Connect identities */
  oidc: Maybe<Array<Oidc>>;
  /** The onboarded at date of this `User`. */
  onboardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** `OrganizationUserRole`s of this `User` */
  organizationUserRoles: OrganizationUserRoleConnection;
  /** The portfolio_email_frequency of this `User`. */
  portfolioEmailFrequency: PortfolioEmailFrequencyEnum;
  /** `PortfolioRole`s that belong to this `User` */
  portfolioRoles: PortfolioRoleConnection;
  /** All visible `Portfolios` of the `User` */
  portfolios: Array<Portfolio>;
  /** The preferred language of the user */
  preferredLanguage: PreferredLanguageEnum;
  /** `ProgramRole`s of this `User` */
  programRoles: ProgramRoleConnection;
  /** External ID used to send push notifications to the user's device */
  pushNotificationsExternalId: Maybe<Scalars['String']['output']>;
  /** Relevant portfolio formats */
  relevantPortfolioFormats: Maybe<PortfolioFormatConnection>;
  /** The `User`'s second authentication factor configurations */
  secondFactor: Maybe<SecondFactor>;
  /** Secondary email address of the user */
  secondaryEmail: Maybe<Scalars['String']['output']>;
  /** Whether `User` is send learning resource alert mails. */
  sendLearningResourceAlertMails: Maybe<Scalars['Boolean']['output']>;
  /** Whether `User` is send manage roles notifications. */
  sendManageRolesNotifications: Maybe<Scalars['Boolean']['output']>;
  /** CPD calendar specialties of the `PortfolioFormat`s the `User` has a `ProgramRole` in */
  specialties: Array<Scalars['String']['output']>;
  /** The `User`'s activity `Streak` */
  streak: Streak;
  /** Whether the `User` wants to engage with `Streak` at all */
  streakEnabled: Scalars['Boolean']['output'];
  /** Whether the `User` wants to be reminded when their `Streak` is about to end. */
  streakSendEndingReminders: Scalars['Boolean']['output'];
  /** Whether the `User` wants to be reminded weekly of their `Streak`. */
  streakSendGeneralReminders: Scalars['Boolean']['output'];
  /** All `SupportGroups` this user is a part of */
  supportGroups: Array<SupportGroup>;
  /** Location of the user's thumbnail */
  thumbUrl: Maybe<Scalars['String']['output']>;
  /** The title of this `User`. */
  title: Maybe<Scalars['String']['output']>;
  /** The unread_alerted_learning_resource_items of this `User`. */
  unreadAlertedLearningResourceItems: LearningResourceAlertedSetItemForUserConnection;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user_login_information of this `User`. */
  userLoginInformation: Maybe<UserLoginInformation>;
  /** Indicates if a user's big was verified by Reconcept */
  verifiedBig: Scalars['Boolean']['output'];
  /** Indicates if a user's email was verified by Reconcept */
  verifiedEmail: Scalars['Boolean']['output'];
  /** temporary: Whether the user can view the Gaia calendar */
  viewGaiaCalendarRole: GaiaCalendarRoleEnum;
  /** The `User`'s `Portfolio`s with a published feedback form that the viewer may give general feedback on */
  viewerAccessiblePortfoliosForGeneralFeedback: Maybe<PortfolioConnection>;
  /** All visible workspace dashboard roles of the user */
  workspaceDashboardRoles: Maybe<WorkspaceDashboardRoleConnection>;
  /** The workspace_email_frequency of this `User`. */
  workspaceEmailFrequency: WorkspaceEmailFrequencyEnum;
}

export interface UserBadgesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCardTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCreatedCardCommentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCreatedCardTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserCreatedCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserExternalAccessesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserGaiaActivitiesArgs {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subruleId?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserMicroLearningUserProgressesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserOrganizationUserRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationUserRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserPortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserProgramRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProgramRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserRelevantPortfolioFormatsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserUnreadAlertedLearningResourceItemsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserViewerAccessiblePortfoliosForGeneralFeedbackArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface UserWorkspaceDashboardRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for User. */
export interface UserConnection {
  __typename: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UserEdge {
  __typename: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
}

export interface UserInput {
  big?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  insertion?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  preferredLanguage?: InputMaybe<PreferredLanguageEnum>;
  verifiedBig?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UserLoginInformation {
  __typename: 'UserLoginInformation';
  /** This user uses multi factor authentication */
  hasSecondFactor: Scalars['Boolean']['output'];
  /** This user had used SSO to login */
  hasUsedSingleSignOn: Scalars['Boolean']['output'];
}

/** Filter for searching users from the central registry */
export interface UserSearchFilter {
  big?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  professionalGroup?: InputMaybe<Scalars['String']['input']>;
}

export interface UserSearchResponse {
  __typename: 'UserSearchResponse';
  /** Any errors that occurred during the search */
  errors: Array<Scalars['String']['output']>;
  /** Results from the search */
  results: Maybe<Array<UserSearchResult>>;
  /**
   * Indicates if the search failed or succeeded
   * @deprecated Use `user_search_response_status` instead, remove this field after 2025-09-01
   */
  status: SearchStatusEnum;
  /** Indicates if the search failed or succeeded */
  userSearchResponseStatus: SearchStatusEnum;
}

export interface UserSearchResult {
  __typename: 'UserSearchResult';
  /** BIG number of the user as found in registry */
  big: Maybe<Scalars['String']['output']>;
  /** Full name of the user as found in registry */
  fullName: Maybe<Scalars['String']['output']>;
  /** Gender of the user as found in registry */
  gender: Maybe<Scalars['String']['output']>;
  /** Initials of the user as found in registry */
  initials: Maybe<Scalars['String']['output']>;
  /** Returns the `User` if they are already using ReconceptPortfolio */
  internalUser: Maybe<User>;
  /** Last name of the user as found in registry */
  lastName: Maybe<Scalars['String']['output']>;
}

export enum UsersCourseEditionCategoryTypeEnum {
  /** `CourseEdition` marked as favourite */
  FAVOURITE = 'FAVOURITE',
}

export interface ViewerPortfolioPermissions {
  __typename: 'ViewerPortfolioPermissions';
  /** Active `PortfolioRole`s for viewer on this `Portfolio` */
  activePortfolioRoles: Maybe<PortfolioRoleConnection>;
  /** Whether viewer can cancel a removal according to the policy */
  canCancelRemoval: Scalars['Boolean']['output'];
  /** True if the viewer is owner, admin or can manage `Organization` of the `Portfolio` */
  canManage: Scalars['Boolean']['output'];
  /** A collection of booleans to define the edit rights */
  editRights: Maybe<EditRights>;
  /** Read access level of the viewer for the `Portfolio` */
  readAccessLevel: Maybe<ReadAccessLevelEnum>;
}

export interface ViewerPortfolioPermissionsActivePortfolioRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export enum WelcomeMailSourceEnum {
  /** The type of the `WelcomeMail` is portfolio */
  PORTFOLIO = 'portfolio',
  /** The type of the `WelcomeMail` is workspace_dashboard */
  WORKSPACE_DASHBOARD = 'workspace_dashboard',
}

export interface Workspace extends Node, Timestamped {
  __typename: 'Workspace';
  /** The accreditation_end_date of this `WorkspaceDashboard::Workspace`. */
  accreditationEndDate: Maybe<Scalars['Date']['output']>;
  /** The alternative_title of this `WorkspaceDashboard::Workspace`. */
  alternativeTitle: Maybe<Scalars['String']['output']>;
  /** The attached_files of this `WorkspaceDashboard::Workspace`. */
  attachedFiles: Maybe<Array<AttachedFile>>;
  /** The card_count of this `WorkspaceDashboard::Workspace`. */
  cardCount: Maybe<Scalars['Int']['output']>;
  /** The contact_email of this `WorkspaceDashboard::Workspace`. */
  contactEmail: Maybe<Scalars['String']['output']>;
  /** The contact_information of this `WorkspaceDashboard::Workspace`. */
  contactInformation: Maybe<Scalars['String']['output']>;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The dashboard (`WorkspaceDashboard::Dashboard`) that this `WorkspaceDashboard::Workspace` belongs to */
  dashboard: Maybe<Dashboard>;
  /** The description of this `WorkspaceDashboard::Workspace`. */
  description: Maybe<Scalars['String']['output']>;
  /** The event_cards of this `WorkspaceDashboard::Workspace`. */
  eventCards: EventCardConnection;
  /** The goal_cards of this `WorkspaceDashboard::Workspace`. */
  goalCards: GoalCardConnection;
  id: Scalars['ID']['output'];
  /** The quality_instruments of this `WorkspaceDashboard::Workspace`. */
  qualityInstruments: Maybe<WorkspaceQualityInstrumentConnection>;
  /** The secondary_dashboards of this `WorkspaceDashboard::Workspace`. */
  secondaryDashboards: DashboardConnection;
  /** The share_on_dashboard of this `WorkspaceDashboard::Workspace`. */
  shareOnDashboard: WorkspaceDashboardShareOnDashboardEnum;
  /** The title of this `WorkspaceDashboard::Workspace`. */
  title: Scalars['String']['output'];
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether `WorkspaceDashboard::Workspace` is viewer can contribute. */
  viewerCanContribute: Scalars['Boolean']['output'];
  /** Whether `WorkspaceDashboard::Workspace` is viewer can manage. */
  viewerCanManage: Scalars['Boolean']['output'];
  /** Whether `WorkspaceDashboard::Workspace` is viewer can read. */
  viewerCanRead: Scalars['Boolean']['output'];
  /** The workspace_roles of this `WorkspaceDashboard::Workspace`. */
  workspaceRoles: WorkspaceRoleConnection;
}

export interface WorkspaceEventCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceGoalCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GoalCardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceQualityInstrumentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceSecondaryDashboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface WorkspaceWorkspaceRolesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkspaceRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Workspace. */
export interface WorkspaceConnection {
  __typename: 'WorkspaceConnection';
  /** A list of edges. */
  edges: Array<WorkspaceEdge>;
  /** A list of nodes. */
  nodes: Array<Workspace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export type WorkspaceDashboardRole = DashboardRole | WorkspaceRole;

/** The connection type for WorkspaceDashboardRole. */
export interface WorkspaceDashboardRoleConnection {
  __typename: 'WorkspaceDashboardRoleConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WorkspaceDashboardRoleEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<WorkspaceDashboardRole>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface WorkspaceDashboardRoleEdge {
  __typename: 'WorkspaceDashboardRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WorkspaceDashboardRole>;
}

export enum WorkspaceDashboardShareOnDashboardEnum {
  /** The share_on_dashboard of the `Workspace` is nothing */
  NOTHING = 'NOTHING',
  /** The share_on_dashboard of the `Workspace` is severity */
  SEVERITY = 'SEVERITY',
  /** The share_on_dashboard of the `Workspace` is summary */
  SUMMARY = 'SUMMARY',
}

/** An edge in a connection. */
export interface WorkspaceEdge {
  __typename: 'WorkspaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Workspace>;
}

export enum WorkspaceEmailFrequencyEnum {
  /** The workspace_email_frequency of the `User` is daily */
  DAILY = 'DAILY',
  /** The workspace_email_frequency of the `User` is instant */
  INSTANT = 'INSTANT',
  /** The workspace_email_frequency of the `User` is never */
  NEVER = 'NEVER',
}

/** Filter for `Workspaces` */
export interface WorkspaceFilter {
  /** Only show the `Workspace`s linked to `Dashboard`s with given id`s */
  dashboardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `Workspace`s linked to `Dashboard`s as secondary with given IDs */
  secondaryDashboardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only show the `Workspace`s with given id`s */
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

/** The connection type for QualityInstrument. */
export interface WorkspaceQualityInstrumentConnection {
  __typename: 'WorkspaceQualityInstrumentConnection';
  /** A list of edges. */
  edges: Array<WorkspaceQualityInstrumentEdge>;
  /** A list of nodes. */
  nodes: Array<QualityInstrument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface WorkspaceQualityInstrumentEdge {
  __typename: 'WorkspaceQualityInstrumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  firstUpcomingEventCard: Maybe<EventCard>;
  mostRecentEventCard: Maybe<EventCard>;
  /** The item at the end of the edge. */
  node: Maybe<QualityInstrument>;
}

export interface WorkspaceRole extends Node, Timestamped {
  __typename: 'WorkspaceRole';
  /** The access_level of this `WorkspaceDashboard::WorkspaceRole`. */
  accessLevel: WorkspaceRoleAccessLevelEnum;
  /** Time the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The title of this `WorkspaceDashboard::WorkspaceRole`. */
  title: Maybe<Scalars['String']['output']>;
  /** Time the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The `User` that this `WorkspaceDashboard::WorkspaceRole` belongs to */
  user: User;
  /** The workspace (`WorkspaceDashboard::Workspace`) that this `WorkspaceDashboard::WorkspaceRole` belongs to */
  workspace: Workspace;
}

export enum WorkspaceRoleAccessLevelEnum {
  /** The access_level of the `WorkspaceRole` is contribute */
  CONTRIBUTE = 'CONTRIBUTE',
  /** The access_level of the `WorkspaceRole` is manage */
  MANAGE = 'MANAGE',
  /** The access_level of the `WorkspaceRole` is read */
  READ = 'READ',
}

/** The connection type for WorkspaceRole. */
export interface WorkspaceRoleConnection {
  __typename: 'WorkspaceRoleConnection';
  /** A list of edges. */
  edges: Array<WorkspaceRoleEdge>;
  /** A list of nodes. */
  nodes: Array<WorkspaceRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface WorkspaceRoleEdge {
  __typename: 'WorkspaceRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<WorkspaceRole>;
}

/** Filter for `WorkspaceRoles` */
export interface WorkspaceRoleFilter {
  /** Only return objects with given access_levels */
  accessLevel?: InputMaybe<Array<WorkspaceRoleAccessLevelEnum>>;
}

export interface WorkspaceRoleInput {
  accessLevel: WorkspaceRoleAccessLevelEnum;
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
}
